/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type CommunityPillarTypeDto = "service" | "maintenance" | "community";

export type TicketCategoryNodeTypeDto =
  | "root"
  | "branch"
  | "leaf"
  | "leafOther";

export type ReplyTypeDto =
  | "systemCreation"
  | "systemUserAdded"
  | "systemUserLeft"
  | "systemUserRemoved"
  | "systemGroupNameChanged"
  | "systemGroupImageChanged"
  | "memberMessage"
  | "memberAudio"
  | "memberVideo";

export type RegistrationConnectStateDto =
  | "success"
  | "unknownLocation"
  | "locationUserLimitReached";

export type RecurrenceDto = "daily" | "weekly" | "biweekly" | "monthly";

export type LocationCodeInputDto =
  | "unknown"
  | "manual"
  | "navigationLinkApp"
  | "navigationLinkEmail"
  | "noInput";

export type EventAnalyticsRecurrenceFrequencyDto =
  | "daily"
  | "weekly"
  | "biweekly"
  | "monthly";

export type EventAnalyticsRecurrenceDto =
  | "oneOff"
  | "daily"
  | "weekly"
  | "biweekly"
  | "monthly";

export type CommunityFeedSelectableAudienceTypeV2Dto =
  | "project"
  | "projectConnection";

export type ClosePostReasonV2Dto =
  | "undefined"
  | "mistake"
  | "solvedNotDetailed"
  | "irrelevant"
  | "noResponse"
  | "solvedOther"
  | "solvedHelpInsideCommunity"
  | "marketplaceSoldInsideCommunity"
  | "marketplaceSoldOutsideCommunity"
  | "marketplaceBorrowed"
  | "codeOfConductViolation"
  | "other";

export type ChatTypeDto = "single" | "group";

export type BookingAnalyticsWeekdayDto =
  | "sunday"
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday";

export type BookingAnalyticsTimeOfDayDto =
  | "morning"
  | "afternoon"
  | "evening"
  | "overnight";

export type AudienceMessageTypeFilterDto =
  | "announcement"
  | "post"
  | "announcementOrPost";

export type AppointmentPreparationDto = "quick" | "extended";

export type WunderbricksTicketStateDto =
  | "notStarted"
  | "sent"
  | "failed"
  | "cancelled";

export type WidgetDataTypeDto =
  | "ticketRating"
  | "ticketSolvingTime"
  | "engagement"
  | "contribution";

export type UserStatusDto = "deleted" | "invited" | "onboarded";

export type UserSortablePropertiesDto =
  | "app"
  | "dashboard"
  | "id"
  | "avatarFirstName"
  | "firstName"
  | "lastName"
  | "address"
  | "company"
  | "invitedAt"
  | "registeredAt";

export type UserRoleTypeDto =
  | "readOnly"
  | "resident"
  | "projectAdmin"
  | "maintenance"
  | "caretaker"
  | "servicePartner"
  | "projectOwner";

export type UserMutationSourceDto = "areaOfPeople" | "rems";

export type UserListTabDto = "residents" | "admins";

export type UptimeStatusDto =
  | "operational"
  | "degraded"
  | "critical"
  | "maintenance"
  | "unknown";

export type UpdateIssueReasonDto = "userHasNotBeenHelped";

export type UnitTypeDto = "electricity" | "gas" | "water";

export type TranslationClientTypeDto =
  | "dashboard"
  | "mobile"
  | "email"
  | "legacy"
  | "mobileV3";

export type TimePeriodDto = "weekly" | "monthly";

export type TicketVisibilityDto =
  | "sharedWithBuilding"
  | "sharedWithCommunity"
  | "private";

export type TicketStatusTypeDto =
  | "new"
  | "inProgress"
  | "closed"
  | "rated"
  | "rejected"
  | "autoClosed";

export type TicketStatusFilterTypeDto =
  | "open"
  | "closed"
  | "recent"
  | "newAndInProgress";

export type TicketSortingDto = "default" | "postedAt";

export type TicketSortablePropertiesDto =
  | "unread"
  | "newest"
  | "oldest"
  | "leastRecentActivity"
  | "mostRecentActivity"
  | "leastRecentResidentActivity"
  | "mostRecentResidentActivity"
  | "mostRecentReminder";

export type TicketRequestOriginDto = "app" | "web";

export type TicketHistoryTypeDto = "users" | "addresses";

export type TicketFilterTypeDto = "both" | "onlyCollective" | "onlyPrivate";

export type TicketDefaultStatus =
  | "new"
  | "inProgress"
  | "closed"
  | "rated"
  | "rejected"
  | "autoClosed";

export type TicketCommentVisibility = "public" | "internal";

export type TicketCategoryTypeDto = "single" | "tree";

export type TicketCategoryTreeNodeLocationTypeDto =
  | "inside"
  | "outside"
  | "insideOrOutside";

export type TicketCategoryNotificationTypeDto =
  | "canBeCollective"
  | "alwaysPrivate";

export type TicketCategoryNodeIconDto =
  | "structure"
  | "waterAndDrainage"
  | "electricity"
  | "climateVentilationAndHeating"
  | "other"
  | "rooms"
  | "buildingExterior"
  | "outdoorSpaces"
  | "communalAreas";

export type TicketCategoryLocationTypeDto = "inside" | "outside";

export type TicketAssigneeFilterModeDto = "include" | "exclude";

export type TicketAppointmentStateDto =
  | "notStarted"
  | "submitted"
  | "fetchingAppointments"
  | "awaitingResidentSelection"
  | "confirmed"
  | "appointmentChanged"
  | "manualFollowUp"
  | "failed";

export type TicketAnalyticsVisibilityDto = "private" | "collective";

export type TicketAnalyticsStatusDto = "new" | "inProgress" | "closed";

export type SurveyTypeDto = "survey" | "poll";

export type SurveyStatusDto = "running" | "upcoming" | "finished";

export type SurveyScope = "project" | "automated";

export type SurveyFollowUpSuggestionAction =
  | "createPost"
  | "createSurvey"
  | "createService"
  | "createBookableAsset"
  | "createDocument"
  | "createEvent";

export type SurveyCategoryDto = "other" | "feelAtHome";

export type StreamedChunkType =
  | "messageStart"
  | "textContent"
  | "toolCall"
  | "toolResult"
  | "messageEnd"
  | "error"
  | "blockOpen"
  | "blockPatch"
  | "blockClose"
  | "streamingStart"
  | "conversation"
  | "statusUpdate"
  | "followUpSuggestions";

/** Enum representing the status of the instruction. */
export type Status = "acc" | "afh" | "ger";

export type SortByDto = "id" | "name";

export type ServicePartnerPageTypeDto =
  | "general"
  | "iqbi"
  | "myPup"
  | "bringme";

export type ServicePartnerPageIqbiStatusDto =
  | "contactSupport"
  | "noConsent"
  | "waitingForConsentApproval"
  | "notVerified"
  | "ready";

export type SelfDeleteReasonDto = "other" | "moving" | "appMalfunctioning";

export type SelectedSplashScreenLogoDto = "light" | "dark" | "none";

export type ResponsibilitySuggestionRatingDto = "notRated" | "good" | "bad";

export type ResponsibilityAssigneeDto = "tenant" | "landlord";

export type ResidentTimeEngagementTypeDto =
  | "lastMonth"
  | "last7Days"
  | "last24Hours";

export type ResidentRoleVariantDto = "housemate";

export type ReopenPolicyDto = "unlimited" | "oneWithinFourteenDays" | "never";

export type RemsVersionDto = "v1" | "v2";

export type RemsTicketStateDto =
  | "notStarted"
  | "pending"
  | "ready"
  | "synchronized"
  | "synchronizedAutoClosed"
  | "errorGeneric"
  | "errorNoUserFound"
  | "errorNoContracts";

export type ReminderStateDto =
  | "reminderOne"
  | "reminderTwo"
  | "reminderThree"
  | "initialInvite";

export type RegistrationVersionDto = "v1" | "v2";

export type RegistrationCodeType = "address" | "company";

export type ReactionTypeDto = "like" | "love" | "laugh" | "sad" | "wow";

export type QuestionTypeDto =
  | "multipleChoice"
  | "yesNo"
  | "open"
  | "rating"
  | "ranking";

export type QuestionGroupTypeDto =
  | "other"
  | "community"
  | "service"
  | "building"
  | "feelAtHome";

export type QuestionGroupType =
  | "other"
  | "community"
  | "service"
  | "building"
  | "feelAtHome";

export type ProjectTypeDto = "addressBased" | "companyBased";

export type ProjectActiveStateDto =
  | "unknown"
  | "active"
  | "closed"
  | "test"
  | "demo";

export type ProcessingStatusDto = "skipped" | "processing" | "processed";

export type PostingLevelDto =
  | "project"
  | "projectConnection"
  | "projectAndProjectConnection";

export type PartnerCategoryDto =
  | "unknown"
  | "areaOfPeople"
  | "maintenance"
  | "realEstate"
  | "servicePartner"
  | "servicePartnerOnSite"
  | "utilities"
  | "safety"
  | "residents";

export type NotificationTimedValueDto =
  | "never"
  | "everyHour"
  | "everyThreeHours"
  | "everyDay"
  | "everyMonth"
  | "everyWeek"
  | "everyTwoWeeks";

export type NewConnectionStatus = "firstConnection" | "newConnection" | "none";

export type MessageTypeDto =
  | "undefined"
  | "announcement"
  | "announcementReadOnly";

export type MessageStatusDto = "archived" | "deleted";

export type MessageReportReasonDto =
  | "other"
  | "explicitLanguage"
  | "spam"
  | "sexuallyExplicit"
  | "discrimination"
  | "bullying"
  | "impersonating"
  | "promotingViolence";

export type MessageLabelDto = "askHelp" | "inform" | "sellItem";

export type MessageCommentSortablePropertiesDto = "none" | "postedAt";

export type MentionTargetTypeDto = "user" | "company";

export type LanguageIdDto =
  | "nl"
  | "en"
  | "de"
  | "pt"
  | "es"
  | "pl"
  | "fr"
  | "it"
  | "tr"
  | "bg"
  | "hu"
  | "uk"
  | "ro"
  | "dutch"
  | "english"
  | "german";

export type JansenHuybregtsTicketStateDto =
  | "notStarted"
  | "submitted"
  | "fetchingAppointments"
  | "awaitingResidentSelection"
  | "confirmed"
  | "appointmentChanged"
  | "manualFollowUp"
  | "failed";

export type IssueStatusDto =
  | "open"
  | "helpRequestedAgain"
  | "solved"
  | "sold"
  | "other";

export type IntegrationReconciliationRowStatusDto =
  | "ready"
  | "updated"
  | "unchanged"
  | "warning"
  | "failed";

export type IntegrationReconciliationOriginDto =
  | "bulkUpload"
  | "bulkCreate"
  | "synchronization";

export type IntegrationReconciliationDataTypeDto = "addresses" | "residents";

export type IntegrationPartnerDto =
  | "woonbedrijf"
  | "rems"
  | "locoia"
  | "officeRnd"
  | "hubSpot"
  | "tobias365"
  | "wunderbricks";

export type ILoqKeyStatusDto =
  | "disabled"
  | "notStarted"
  | "completed"
  | "returned"
  | "ineligible";

export type HomeDnaTicketStateDto =
  | "notStarted"
  | "sent"
  | "failed"
  | "accepted"
  | "planned"
  | "finished";

export type FeelingAtHomeDistributionTypeDto =
  | "community"
  | "services"
  | "building";

export type FeelingAtHomeDataStatusDto = "notStarted" | "started";

export type FeedbackLabelDto =
  | "solutionQuality"
  | "friendliness"
  | "responseTime"
  | "resolutionTime"
  | "clarityOfInfo"
  | "easeOfReporting"
  | "updates";

export type FastMenuActionItemUseTypeDto = "webPage" | "ticketFlow";

export type FastMenuActionItemTypeDto =
  | "createInform"
  | "createHelp"
  | "createMarketplace"
  | "createEvent"
  | "bookAsset"
  | "createTicket"
  | "createServiceRequest"
  | "openZiezodan"
  | "openExternalUrl"
  | "openDynamicExternalUrl";

export type FastMenuActionItemDynamicUrlTypeDto = "healthDistrict";

export type ExternalSyncStatusDto = "unknown" | "green" | "failed";

export type ExternalBookingProviderDto = "none" | "outlook" | "jim";

export type EventTypeDto = "common" | "announcement" | "external";

export type EventTimeFrameDto = "future" | "past" | "soon" | "all";

export type EventExternalPartyDto = "swoogo";

export type EventCategoryTypeDto =
  | "unknown"
  | "maintenance"
  | "social"
  | "sport";

export type EventAnalyticsStatusDto = "active" | "completed";

export type EventAnalyticsOriginDto = "internal" | "external";

export type EventAnalyticsEventTypeDto = "regular" | "announcement";

export type EventAnalyticsAudienceScopeTypeDto =
  | "projectOnly"
  | "projectConnection";

export type DocumentsItemTypeDto = "folder" | "image" | "document" | "link";

export type DicoTicketStateDto = "notStarted" | "sent" | "failed" | "cancelled";

export type DevicePlatformDto = "android" | "iOS";

export type DevelopmentTypeDto = "existingProperty" | "newDevelopment";

export type DefaultPostingAudienceDto = "project" | "projectConnection";

export type DayDto =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export type DateRangeDto = "last6Months" | "lastYear" | "lastMonth";

export type DashboardNotificationEntityTypeDto =
  | "event"
  | "repairRequest"
  | "message"
  | "survey"
  | "repairReaction"
  | "poll"
  | "repairStatusChange"
  | "informative"
  | "pollV2"
  | "assetBooking"
  | "adminTicket"
  | "integrationMyPupReadyForPickUp"
  | "integrationMyPupReadyForDropOff"
  | "messageCloseReminder"
  | "postDeleted"
  | "commentDeleted"
  | "integrationBringmeDeposit"
  | "integrationBringmePickUp";

export type CustomIconDto =
  | "stadstuin"
  | "bAmsterdam"
  | "bundleDomijn"
  | "ekpDenBosch";

export type CreateSurveyBulkItemStatusDto = "success" | "error";

export type CopilotToneOfVoiceDto = "professional" | "neutral" | "playful";

export type CopilotPromptTypeDto = "community" | "ticket";

export type CopilotOptionsDto =
  | "makeUnderstandable"
  | "makeShorter"
  | "makeMorePositive";

export type ConstraintTagTypeDto = "building" | "floor" | "apartmentType";

export type CompanySortablePropertiesDto =
  | "name"
  | "activatedUsers"
  | "notActivatedUsers";

export type CommunityPostEventTypeDto = "announcement" | "common";

export type CommunityGroupTypeDto = "interest" | "helpCategory" | "realEstate";

export type CommunityGroupType = "interest" | "helpCategory" | "realEstate";

export type CommunityGroupIconDto =
  | "announcement"
  | "asterisk"
  | "batteryMid"
  | "bellRinging"
  | "bicycle"
  | "bookOpen"
  | "building01"
  | "building02"
  | "car"
  | "carrot"
  | "coffee"
  | "compass"
  | "cursorClick"
  | "dice"
  | "dog"
  | "faceHappy"
  | "factory"
  | "forkAndKnife"
  | "gamingPad"
  | "gift"
  | "handshake"
  | "imageUserCheck"
  | "lightBulb"
  | "mailbox"
  | "map"
  | "markerPin"
  | "medicalSquare"
  | "messageChatSquare"
  | "messageDotsSquare"
  | "musicNote"
  | "network"
  | "package"
  | "plant"
  | "search"
  | "shoppingCart"
  | "sport"
  | "target"
  | "tool"
  | "users"
  | "wifi"
  | "wineGlass";

export type CommunityFeedType = "messages" | "surveys" | "polls";

export type CommunityFeedTabsDto =
  | "all"
  | "announcements"
  | "own"
  | "myFeed"
  | "question"
  | "scheduled"
  | "deleted";

export type CommunityFeedSelectableAudienceTypeDto =
  | "project"
  | "projectConnection";

export type CommunityFeedItemTypeDto = "message" | "survey" | "poll";

export type CommunityFeedConnectionFilterDto = "excluded" | "only" | "included";

export type CommunityFeedAnalyticsStatusDto =
  | "published"
  | "archived"
  | "open"
  | "closed";

export type CommunityFeedAnalyticsOriginDto =
  | "projectOnly"
  | "projectConnection";

export type CommunityFeedAnalyticsGroupTypeDto =
  | "general"
  | "interest"
  | "helpCategory"
  | "realEstate";

export type CommunityFeedAnalyticsContentTypeDto =
  | "post"
  | "announcement"
  | "poll";

export type CommunityFeedAnalyticsAuthorTypeDto = "resident" | "projectTeam";

export type CommunityFeedAnalyticsAudienceScopeTypeDto =
  | "projectOnly"
  | "projectConnection";

export type ClosePostReasonDto =
  | "undefined"
  | "solvedHelpInsideCommunity"
  | "solvedHelpOutsideCommunity"
  | "solvedProblemIrrelevant"
  | "solvedOther"
  | "marketplaceSoldInsideCommunity"
  | "marketplaceSoldOutsideCommunity"
  | "marketplaceNoInterest"
  | "marketplaceBorrowed"
  | "mistake"
  | "other";

export type ChatPermission = "disabled" | "sendOnly" | "enabled";

export type ChatMessageRole = "user" | "bot";

export type CanRespondStatusDto =
  | "yes"
  | "notAllowed"
  | "notStarted"
  | "ended"
  | "alreadyAnswered";

export type CancellationReasonDto =
  | "cancelled"
  | "assetDeleted"
  | "assetUnpublished"
  | "assetUpdated"
  | "cancelledExternally";

export type CalendarVisibilityDto = "none" | "events" | "reservations" | "all";

export type CalendarItemType = "event" | "booking";

export type BrandedAppStoreDto = "apple" | "google";

export type BrandedAppPromptDto = "optional" | "mandatory";

export type BookingsTimeFrameDto = "all" | "futureOrToday" | "past";

export type BookingAnalyticsStatusDto = "upcoming" | "completed" | "cancelled";

export type BookingAnalyticsOriginDto = "projectOnly" | "projectConnection";

export type BookingAnalyticsAudienceScopeTypeDto =
  | "projectOnly"
  | "projectConnection";

export type BookableTimeslotDto =
  | "fifteenMinutes"
  | "thirtyMinutes"
  | "oneHour"
  | "twoHours"
  | "threeHours"
  | "fourHours"
  | "allDay"
  | "thirtyFiveMinutes"
  | "custom";

export type BookableAssetSlotStateDto = "available" | "booked" | "unavailable";

export type BenchmarkPeriodDto =
  | "zeroToOneMonth"
  | "twoToFourMonths"
  | "fourToSixMonths"
  | "sixToNineMonths"
  | "nineToTwelveMonths"
  | "twelveToEighteenMonths"
  | "eighteenToTwentyFourMonths"
  | "twoPlusYears";

export type AssistantThinkingLevel = "low" | "medium" | "high";

export type AssistantPageViewRequest = "list" | "detail";

export type AssistantPageScopeRequest = "project" | "portfolio";

export type AssistantChatMessageRoleDto = "user" | "assistant" | "tool";

export type AppNotificationGroupSettingStatusDto =
  | "off"
  | "newPostsOnly"
  | "newPostsAndComments";

export type AppBrandingDto =
  | "areaOfPeople"
  | "bpd"
  | "healthDistrict"
  | "app1828"
  | "kennisparkTwente"
  | "moes"
  | "sierraBreda"
  | "orchard"
  | "woonstede";

export type AlertTypeDto =
  | "likeThreshold"
  | "commentThreshold"
  | "postKeyword"
  | "commentKeyword";

export type AlertNotificationTypeDto = "dashboardAndEmail" | "dashboardOnly";

export type AiResponseRatingDto = "positive" | "negative";

export type AiResponseRating = "negative" | "positive";

/** Selectable AI performance profiles. Balanced and Advanced require elevated platform access. */
export type AiModelProfileDto =
  | "efficient"
  | "thorough"
  | "balanced"
  | "advanced";

export type AdoptionRateDetailsGraphTypeDto = "adoption" | "vacant" | "reach";

export type AdminTicketsVisibilityFilter = "private" | "collective";

export type AdminTicketsTabDto =
  | "inProgress"
  | "new"
  | "closed"
  | "reminder"
  | "newAndInProgress";

export type AdminNotificationTypeDto =
  | "unknown"
  | "message"
  | "messageComment"
  | "groupMessage"
  | "ticket"
  | "ticketAssignee"
  | "ticketComment";

export type AddressValidationStateDto = "valid" | "invalid";

export type AddressUploadState = "success" | "duplicate" | "error";

export interface ActiveWidgetsDto {
  activeWidgets: WidgetDataTypeDto[];
}

export interface AddressBuildingDto {
  name: string;
  id: string;
}

export interface AddressCompanyDto {
  locatedAt: string;
  id: string;
}

export interface AddressCreateRequest {
  buildingId: string;
  streetName: string;
  /** @format int32 */
  housenumber: number;
  housenumberSuffix?: string;
  postalCode: string;
  city: string;
  type?: string;
  floor?: string;
  remsAddressId?: string;
}

export interface AddressDto {
  streetName: string;
  houseNumber: string;
  houseNumberSuffix?: string;
  floor?: string;
  users: AddressUserDto[];
  typeConstraint?: ConstraintListItemDto;
  locationCode: string;
  validationState?: AddressValidationStateDto;
  location: string;
  city: string;
  postalCode: string;
  building: AddressBuildingDto;
  id: string;
}

export interface AddressEditRequest {
  buildingId: string;
  streetName: string;
  /** @format int32 */
  housenumber: number;
  housenumberSuffix?: string;
  postalCode: string;
  city: string;
  floor?: string;
  type?: string;
}

export interface AddressStatsDto {
  /** @format int32 */
  totalAddresses: number;
  /** @format int32 */
  registeredAddresses: number;
}

export interface AddressUnitLocoiaDto {
  id: string;
  /** Not required, only used for safety rail guard. */
  zipcode?: string;
  /** Not required, only used for safety rail guard. */
  houseNumber?: string;
}

export interface AddressUnitWoonbedrijfDto {
  id: string;
  /** Not required, only used for safety rail guard. */
  zipcode?: string;
  /** Not required, only used for safety rail guard. */
  houseNumber?: string;
}

export interface AddressUploadProgressUpdateDto {
  /** @format int32 */
  index: number;
  state: AddressUploadState;
  errorMessage?: string;
}

export interface AddressUserDto {
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface AdminNotificationDto {
  id: string;
  isRead: boolean;
  message: string;
  type: AdminNotificationTypeDto;
  buttonUrl: string;
  isOldDashboard: boolean;
  /** @format date-time */
  sentAt: string;
}

export interface AdminNotificationStatusDto {
  hasUnread: boolean;
  /** @format int32 */
  amount: number;
}

export interface AdminTicketActivityDto {
  /** @format date-time */
  postedAt: string;
  author: UserDto;
  comment?: AdminTicketCommentDto;
  statusChange?: AdminTicketStatusChangeActivityDto;
  assigneeChange?: AdminTicketAssigneeChangeActivityDto;
  rating?: AdminTicketRatingActivityDto;
  id: string;
}

export interface AdminTicketAddressDto {
  streetName: string;
  houseNumber: string;
  houseNumberSuffix?: string;
  postalCode: string;
  floor?: string;
  city: string;
  building: AddressBuildingDto;
  typeConstraint?: ConstraintListItemDto;
  id: string;
}

export interface AdminTicketAssigneeChangeActivityDto {
  newAssignee: UserDto;
  oldAssignee?: UserDto;
}

export interface AdminTicketCommentDto {
  content?: string;
  internal: boolean;
  images: ImageDto[];
  videos: VideoDto[];
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  /**
   * Deprecated: Ticket comments can not be edited anymore
   * @deprecated
   * @format date-time
   */
  updatedAt?: string;
  /**
   * Deprecated: Ticket comments can not be deleted anymore
   * @deprecated
   * @format date-time
   */
  deletedAt?: string;
  canEdit: boolean;
  canDelete: boolean;
  languageIsoCode?: string;
  isAutoReply: boolean;
  documents: DocumentUploadDto[];
  id: string;
}

export interface AdminTicketCompanyDto {
  name: string;
  id: string;
}

export interface AdminTicketDecisionTreePathDto {
  location: TicketCategoryLocationTypeDto;
  nodes: string[];
}

export interface AdminTicketDetailedListItemDto {
  appointments: TicketAppointmentFlagDto;
  /** @format int32 */
  activityCount: number;
  hasUnreadActivity: boolean;
  /** @format int32 */
  commentCount: number;
  hasUnreadComment: boolean;
  integrations: Record<string, TicketIntegrationStatusSummaryDto>;
  ratingFeedbacks: TicketFeedbackOptionDto[];
  title: string;
  /** @format date-time */
  createdAt: string;
  user: UserExtendedDto;
  assignee?: UserDto;
  address?: AdminTicketAddressDto;
  company?: AdminTicketCompanyDto;
  category: BaseTicketCategoryWithClosedDayInactivityDto;
  status: TicketStatusDto;
  /** @format int32 */
  rating?: number;
  visibility: TicketVisibilityDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  lastActivityAt: string;
  lastActivityBy?: UserDto;
  /** @format date-time */
  closedAt?: string;
  closedBy?: UserDto;
  canChangeStatus: boolean;
  canDelete: boolean;
  /** @format date-time */
  remindAt?: string;
  languageIsoCode?: string;
  id: string;
}

export interface AdminTicketDetailsDto {
  content: string;
  images: ImageDto[];
  user: UserTicketDetailsDto;
  videos: VideoDto[];
  createdBy: UserDto;
  possibleAssignees: UserDto[];
  possibleStatuses: TicketStatusDto[];
  canAddPublicComment: boolean;
  canAddInternalNote: boolean;
  canChangeAssignee: boolean;
  canSetReminder: boolean;
  ratingRemark?: string;
  requesterHasMultipleProjects: boolean;
  /**
   * If AI has determined that the responsibility for the maintenance should be assigned to the tenant or the landlord.
   * Null if AI has not (yet) made a suggestion.
   */
  responsibilityAssignee?: ResponsibilityAssigneeDto;
  phoneNumber?: string;
  suggestedResponse?: string;
  decisionTreePath?: AdminTicketDecisionTreePathDto;
  appointments: TicketAppointmentFlagDto;
  /** @format int32 */
  activityCount: number;
  hasUnreadActivity: boolean;
  /** @format int32 */
  commentCount: number;
  hasUnreadComment: boolean;
  integrations: Record<string, TicketIntegrationStatusSummaryDto>;
  ratingFeedbacks: TicketFeedbackOptionDto[];
  title: string;
  /** @format date-time */
  createdAt: string;
  assignee?: UserDto;
  address?: AdminTicketAddressDto;
  company?: AdminTicketCompanyDto;
  category: BaseTicketCategoryWithClosedDayInactivityDto;
  status: TicketStatusDto;
  /** @format int32 */
  rating?: number;
  visibility: TicketVisibilityDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  lastActivityAt: string;
  lastActivityBy?: UserDto;
  /** @format date-time */
  closedAt?: string;
  closedBy?: UserDto;
  canChangeStatus: boolean;
  canDelete: boolean;
  /** @format date-time */
  remindAt?: string;
  languageIsoCode?: string;
  id: string;
}

export interface AdminTicketFiltersDto {
  assignees: UserDto[];
  statuses: TicketStatusDto[];
  categories: BaseTicketCategoryDto[];
  addressTypes: string[];
}

export interface AdminTicketListItemDto {
  title: string;
  /** @format date-time */
  createdAt: string;
  user: UserExtendedDto;
  assignee?: UserDto;
  address?: AdminTicketAddressDto;
  company?: AdminTicketCompanyDto;
  category: BaseTicketCategoryWithClosedDayInactivityDto;
  status: TicketStatusDto;
  /** @format int32 */
  rating?: number;
  visibility: TicketVisibilityDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  lastActivityAt: string;
  lastActivityBy?: UserDto;
  /** @format date-time */
  closedAt?: string;
  closedBy?: UserDto;
  canChangeStatus: boolean;
  canDelete: boolean;
  /** @format date-time */
  remindAt?: string;
  languageIsoCode?: string;
  id: string;
}

export interface AdminTicketRatingActivityDto {
  /** @format int32 */
  rating?: number;
  ratingRemark?: string;
  ratingFeedback?: TicketFeedbackOptionDto[];
}

export interface AdminTicketStatsDto {
  /** @format int32 */
  tickets: number;
}

export interface AdminTicketStatusChangeActivityDto {
  oldStatus: TicketStatusDto;
  newStatus: TicketStatusDto;
}

export interface AdminTicketTabsStatsDto {
  /** @format int32 */
  newTickets: number;
  /** @format int32 */
  inProgressTickets: number;
  /** @format int32 */
  closedTickets: number;
  /** @format int32 */
  reminderTickets: number;
}

export interface AdoptionRateDetailsGraphItemDto {
  /** @format double */
  percentage: number;
  range: MonthlyReportDateRangeDto;
  isCurrentMonth: boolean;
}

export interface AdoptionRateDto {
  /** @format double */
  adoptionRatePercentage: number;
  /** @format double */
  reachRatePercentage: number;
  /** @format int32 */
  totalAddresses: number;
  /** @format int32 */
  totalAddressesInvited: number;
  /** @format int32 */
  invitedAddressesActivated: number;
  /** @format int32 */
  invitedAddressesNotActivated: number;
  /** @format int32 */
  unknownStatusAddresses: number;
  /** @format int32 */
  totalResidents: number;
}

export interface AiEmailUpdateDto {
  id: string;
  prompt: string;
  timePeriod: TimePeriodDto;
  /** @format date-time */
  createdAt: string;
}

export interface AiEmailUpdateRequest {
  prompt: string;
  timePeriod: TimePeriodDto;
}

export interface AlertConfigurationsDto {
  postKeywordAlerts: KeywordAlertConfigurationDto[];
  commentKeywordAlerts: KeywordAlertConfigurationDto[];
  numberOfLikesAlerts: ThresholdAlertConfigurationDto[];
  numberOfCommentsAlerts: ThresholdAlertConfigurationDto[];
}

export interface AnswerItem {
  questionId: string;
  /** @format int32 */
  rating?: number;
  yesNo?: boolean;
  text?: string;
  offeredAnswerId?: string;
  ranking?: RankingAnswerItem[];
}

export interface AnswerRequest {
  answers: AnswerItem[];
}

export interface AppBrandingDetailsDto {
  id: AppBrandingDto;
  appName: string;
  ownerName: string;
  aliases: string[];
  logoImageUrl: string;
  bannerImageUrl: string;
  websiteUrl: string;
  playStoreUrl: string;
  appStoreUrl: string;
  licenseAgreementLink: string;
  privacyPolicyLink: string;
  deepLink: string;
  address: string;
}

export interface AppNotificationGroupSettingDto {
  groupId: string;
  status: AppNotificationGroupSettingStatusDto;
}

export interface AppNotificationGroupSettingStatusRequest {
  status: AppNotificationGroupSettingStatusDto;
}

export interface AppNotificationSettingDto {
  appEnabled: boolean;
}

export interface AppNotificationSettingRequest {
  appEnabled?: boolean;
}

/** Appointment date and time information. */
export interface AppointmentDateTimeInformation {
  /** Delivery time frame details. */
  deliveryTimeFrame: DeliveryTimeFrame;
}

export interface AppointmentOptionDto {
  slotId: string;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
}

export interface AppointmentPlanningDto {
  planningId: string;
  state: TicketAppointmentStateDto;
  requiresManualFollowUp: boolean;
  options: AppointmentOptionDto[];
}

export interface AppTicketDto {
  title: string;
  content: string;
  images: ImageDto[];
  videos: VideoDto[];
  ratingFeedbacks: TicketFeedbackOptionDto[];
  user: UserDto;
  /**
   * Deprecated: Use User instead
   * @deprecated
   */
  author: UserDto;
  category: BaseTicketCategoryDto;
  categoryTreeNode?: BaseTicketCategoryTreeNodeDto;
  status: TicketStatusDto;
  /** @format date-time */
  postedAt: string;
  /** @format int32 */
  numberOfComments: number;
  visibility: TicketVisibilityDto;
  locatedAt?: string;
  /** @format date-time */
  lastActivityAt?: string;
  unread: boolean;
  /** @format date-time */
  modifiedAt: string;
  /** @format date-time */
  closedAt?: string;
  isClosed: boolean;
  /** @format int32 */
  rating?: number;
  remark?: string;
  isCollective: boolean;
  canComment: boolean;
  requestOrigin: TicketRequestOriginDto;
  newComment: boolean;
  languageIsoCode?: string;
  canReject: boolean;
  phoneNumber?: string;
  suggestedResponse?: string;
  /**
   * Per-ticket integration flags the resident apps read to decide which integration
   * endpoints to call for this ticket.
   */
  integrations: AppTicketIntegrationsDto;
  appointments: TicketAppointmentFlagDto;
  id: string;
}

/**
 * Per-ticket integration flags the resident apps read to decide which integration
 * endpoints to call for this ticket.
 */
export interface AppTicketIntegrationsDto {
  /**
   * Signals to the resident apps whether they should call the Jansen Huybregts ticket
   * endpoint for this ticket (i.e. the ticket is part of the Jansen Huybregts flow).
   */
  jansenHuybregts: JansenHuybregtsTicketFlagDto;
}

export interface AskForHelpItemMonthlyDto {
  /** @format int32 */
  askHelpCreatedCount: number;
  /** @format int32 */
  askHelpResolvedCount: number;
  isCurrentMonth: boolean;
  range: MonthlyReportDateRangeDto;
}

export interface AskForHelpMonthlyDto {
  data: AskForHelpItemMonthlyDto[];
}

export interface AssetBookingDetailDto {
  cancelledBy?: UserDto;
  cancellationReason?: CancellationReasonDto;
  cancellationReasonDescription?: string;
  regulationDocument?: DocumentUploadDto;
  id: string;
  /** @format date */
  date: string;
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
  asset: BookableAssetDto;
  /** @format date-time */
  cancelledAt?: string;
  author?: UserDto;
  bookingReason?: string;
  outlookEventId?: string;
  /** CanCancel is an alias for CanDelete. */
  canCancel: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface AssetBookingDto {
  id: string;
  /** @format date */
  date: string;
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
  asset: BookableAssetDto;
  /** @format date-time */
  cancelledAt?: string;
  author?: UserDto;
  bookingReason?: string;
  outlookEventId?: string;
  /** CanCancel is an alias for CanDelete. */
  canCancel: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface AssetBookingRequest {
  /** @format date */
  date: string;
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
  reason?: string;
}

export interface AssistantChatMessageInputRequest {
  role: AssistantChatMessageRoleDto;
  content: string;
}

export interface AssistantChatRequest {
  /** @format uuid */
  conversationId?: string;
  messages?: AssistantChatMessageInputRequest[];
  userMessage?: string;
  projectIds?: string[];
  maintainers?: string[];
  owners?: string[];
  cities?: string[];
  thinkingLevel?: AssistantThinkingLevel;
  pageContext?: AssistantPageContextRequest;
}

export interface AssistantConversationFiltersDto {
  projectIds?: string[];
  maintainers?: string[];
  owners?: string[];
  cities?: string[];
}

export interface AssistantConversationListItemDto {
  id: string;
  title: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  canDelete: boolean;
  filters?: AssistantConversationFiltersDto;
  myRating?: AiResponseRatingDto;
}

export interface AssistantConversationMessageDto {
  id: string;
  role: AssistantChatMessageRoleDto;
  content: string;
  followUpSuggestions?: string[];
  /** @format int32 */
  sequence: number;
  /** @format date-time */
  createdAt: string;
  myRating?: AiResponseRatingDto;
}

export interface AssistantPageContextRequest {
  scope: AssistantPageScopeRequest;
  /** @minLength 1 */
  entity: string;
  page: AssistantPageViewRequest;
  filters?: string;
  entityId?: string;
}

export interface AssistantRunEventDto {
  assistantRunEventId: string;
  assistantRunId: string;
  /** @format int32 */
  seq: number;
  type: string;
  /** @format int32 */
  iteration?: number;
  /** @format date-time */
  startedAtUtc: string;
  /** @format int32 */
  durationMs?: number;
  success: boolean;
  errorCode?: string;
  errorMessageShort?: string;
  portkeyTraceId?: string;
  promptId?: string;
  promptSlug?: string;
  promptVersionId?: string;
  providerRequestId?: string;
  toolName?: string;
  toolCallId?: string;
  toolCallArguments?: JsonElement;
}

export interface AssistantRunListItemDto {
  assistantRunId: string;
  requestId?: string;
  traceParent?: string;
  source: string;
  userId: string;
  user?: SimpleUserDto;
  projectIds: number[];
  projects: SimpleProjectDto[];
  /** @format date-time */
  startedAtUtc: string;
  /** @format date-time */
  finishedAtUtc?: string;
  status: string;
  /** @format int32 */
  totalDurationMs?: number;
  /** @format int32 */
  timeToFirstChunkMs?: number;
  /** @format int32 */
  iterationCount: number;
  /** @format int32 */
  toolCallCount: number;
  /** @format int32 */
  portkeyCallCount: number;
}

export interface AssistantRunTimelineDto {
  run: AssistantRunListItemDto;
  events: AssistantRunEventDto[];
}

export interface AutomatedSurveyDto {
  id: string;
  title: string;
  /** @format date-time */
  createdAt: string;
  questionGroups: QuestionGroupDto[];
  category: SurveyCategoryDto;
  isLocked: boolean;
  /** @format int32 */
  weeklyInterval: number;
  /** @format int32 */
  usersSampleSize: number;
  enabledProjects: SimpleProjectDto[];
  translations: AutomatedSurveyTranslationDto[];
}

export interface AutomatedSurveyEditRequest {
  id: string;
  questionGroups: QuestionGroupEditRequest[];
  category: SurveyCategoryDto;
  title?: string;
  description?: string;
  thankYouMessage?: string;
  titleTranslations: TranslationRequest[];
  descriptionTranslations: TranslationRequest[];
  thankYouMessageTranslations: TranslationRequest[];
  isLocked: boolean;
  /** @format int32 */
  weeklyInterval: number;
  /** @format int32 */
  usersSampleSize: number;
  enabledProjectsIds: string[];
}

export interface AutomatedSurveyIntervalResultDto {
  /** @format date-time */
  intervalDate: string;
  /** @format int32 */
  totalAsked: number;
  /** @format int32 */
  totalAnswered: number;
  /** @format double */
  averageScore: number;
}

export interface AutomatedSurveyQueueDetailsDto {
  questionDetails: AutomatedSurveyQueueQuestionDetailsListDto[];
  id: string;
  title: string;
  /** @format int32 */
  numberLeftInQueue: number;
  /** @format int32 */
  numberResponses: number;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  isActive: boolean;
}

export interface AutomatedSurveyQueueDetailsListDto {
  projectId: string;
  projectName: string;
  /** @format int32 */
  totalResponses: number;
  /** @format int32 */
  numberLeftInQueue: number;
  /** @format double */
  feelingAtHomeAverage: number;
  /** @format double */
  communityAverage: number;
  /** @format double */
  serviceAverage: number;
  /** @format double */
  buildingAverage: number;
}

export interface AutomatedSurveyQueueDto {
  id: string;
  title: string;
  /** @format int32 */
  numberLeftInQueue: number;
  /** @format int32 */
  numberResponses: number;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  isActive: boolean;
}

export interface AutomatedSurveyQueueQuestionDetailsDto {
  questionText?: string;
  questionGroupAnswers: QuestionGroupAnswerDtoPaginationResultDto;
}

export interface AutomatedSurveyQueueQuestionDetailsListDto {
  /** @format double */
  averageRating: number;
  ratingGroupedNumber: Record<string, number>;
  latestOpenQuestionResponse?: string;
  questionGroupType: QuestionGroupTypeDto;
  ratingQuestionText?: string;
  queueId: string;
  questionGroupId: string;
  openQuestionText?: string;
}

export interface AutomatedSurveyRequest {
  questionGroups: QuestionGroupRequest[];
  category: SurveyCategoryDto;
  title?: string;
  description?: string;
  thankYouMessage?: string;
  titleTranslations: TranslationRequest[];
  descriptionTranslations: TranslationRequest[];
  thankYouMessageTranslations: TranslationRequest[];
  isLocked: boolean;
  /** @format int32 */
  weeklyInterval: number;
  /** @format int32 */
  usersSampleSize: number;
  enabledProjectsIds: string[];
}

export interface AutomatedSurveyTranslationDto {
  languageId: LanguageIdDto;
  title: string;
  description: string;
  thankYouMessage: string;
}

export interface BaseTicketCategoryDto {
  name: string;
  requirePhoneNumber: boolean;
  allowVideos: boolean;
  id: string;
}

export interface BaseTicketCategoryTreeNodeDto {
  name: string;
  id: string;
}

export interface BaseTicketCategoryWithClosedDayInactivityDto {
  name: string;
  /** @format int32 */
  closeAfterInactiveDayAmount: number;
  id: string;
}

export interface BenchmarkFeelingAtHomeDto {
  /** @format double */
  rating: number;
}

export interface BookableAssetCreateRequest {
  projectConnectionId?: string;
  name: string;
  description: string;
  images: string[];
  sizeSpecification?: string;
  /** @format int32 */
  capacitySpecification?: number;
  locationSpecification?: string;
  /** @format double */
  pricePerHourSpecification?: number;
  regulationDocumentId?: string;
  bookableDays: BookableDayDto[];
  notificationEnabled: boolean;
  notificationEmail?: string;
  externalSyncEmail?: string;
  externalBookingProvider: ExternalBookingProviderDto;
  externalResourceId?: string;
  timeslot: BookableTimeslotDto;
  /** @format int32 */
  customTimeslot?: number;
  canBookSameDay: boolean;
  /** @format int32 */
  maxDaysInAdvance?: number;
  requireBookingReason: boolean;
  /**
   * Defines the number of hours a user can make changes (or cancel) to a booking before the booking starts.
   * @format int32
   */
  hoursForMutations?: number;
  canBookMultipleSlots: boolean;
  /**
   * The date when this bookable asset will be visible.
   * @format date-time
   */
  publishAt?: string;
  /**
   * The date when this bookable asset will be available for booking.
   * @format date-time
   */
  availableFrom?: string;
  /**
   * Defines the date and time when the bookable asset will be unpublished.
   * This also means that users will not be able to book the asset after this date.
   * @format date-time
   */
  unpublishAt?: string;
  enabled: boolean;
  audience?: ConstraintListItemDto[];
  /**
   * The number of seats available for this asset.
   * @format int32
   */
  seats: number;
}

export interface BookableAssetDeletedResult {
  /** @format int32 */
  bookingsCancelled: number;
}

export interface BookableAssetDetailDto {
  projectConnection?: ProjectConnectionDto;
  regulationDocument?: DocumentUploadDto;
  originalLanguageId: LanguageIdDto;
  bookableDays: BookableDayDto[];
  updatedBy?: UserDto;
  audience: ConstraintListItemDto[];
  id: string;
  translations: BookableAssetTranslationDto[];
  name: string;
  description: string;
  images: ImageDto[];
  sizeSpecification?: string;
  /** @format int32 */
  capacitySpecification?: number;
  locationSpecification?: string;
  /** @format double */
  pricePerHourSpecification?: number;
  regulationDocumentId?: string;
  projectConnectionId?: string;
  externalSyncEmail?: string;
  externalBookingProvider: ExternalBookingProviderDto;
  externalResourceId?: string;
  externalSyncStatus: ExternalSyncStatusDto;
  notificationEnabled: boolean;
  notificationEmail?: string;
  timeslot: BookableTimeslotDto;
  /** @format int32 */
  customTimeslot?: number;
  canBookSameDay: boolean;
  /** @format int32 */
  maxDaysInAdvance?: number;
  requireBookingReason: boolean;
  /** @format int32 */
  hoursForMutations?: number;
  canBookMultipleSlots: boolean;
  /** @format date-time */
  publishAt?: string;
  /** @format date-time */
  unpublishAt?: string;
  /**
   * From when other users can see the asset.
   * @format date-time
   */
  publishedAt?: string;
  /**
   * From when you can book the asset.
   * @format date-time
   */
  availableFrom?: string;
  enabled: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  authorId: string;
  author: UserDto;
  hasAudience: boolean;
  /**
   * The number of seats available for this asset.
   * @format int32
   */
  seats: number;
  canEdit: boolean;
  canDelete: boolean;
}

export interface BookableAssetDto {
  id: string;
  translations: BookableAssetTranslationDto[];
  name: string;
  description: string;
  images: ImageDto[];
  sizeSpecification?: string;
  /** @format int32 */
  capacitySpecification?: number;
  locationSpecification?: string;
  /** @format double */
  pricePerHourSpecification?: number;
  regulationDocumentId?: string;
  projectConnectionId?: string;
  externalSyncEmail?: string;
  externalBookingProvider: ExternalBookingProviderDto;
  externalResourceId?: string;
  externalSyncStatus: ExternalSyncStatusDto;
  notificationEnabled: boolean;
  notificationEmail?: string;
  timeslot: BookableTimeslotDto;
  /** @format int32 */
  customTimeslot?: number;
  canBookSameDay: boolean;
  /** @format int32 */
  maxDaysInAdvance?: number;
  requireBookingReason: boolean;
  /** @format int32 */
  hoursForMutations?: number;
  canBookMultipleSlots: boolean;
  /** @format date-time */
  publishAt?: string;
  /** @format date-time */
  unpublishAt?: string;
  /**
   * From when other users can see the asset.
   * @format date-time
   */
  publishedAt?: string;
  /**
   * From when you can book the asset.
   * @format date-time
   */
  availableFrom?: string;
  enabled: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  authorId: string;
  author: UserDto;
  hasAudience: boolean;
  /**
   * The number of seats available for this asset.
   * @format int32
   */
  seats: number;
  canEdit: boolean;
  canDelete: boolean;
}

export interface BookableAssetOutlookConfigurationTestDto {
  status: ExternalSyncStatusDto;
  message?: string;
}

export interface BookableAssetSlotsDto {
  slots: BookableSlotDto[];
}

export interface BookableAssetStatisticsDto {
  /** @format int32 */
  futureBookingsCount: number;
  mostRecentBooking?: AssetBookingDto;
}

export interface BookableAssetTranslationDto {
  languageId: string;
  name: string;
  description: string;
}

export interface BookableAssetUpdateBookingsToBeCancelledDto {
  /** @format int32 */
  bookingsToBeCancelled: number;
}

export interface BookableAssetUpdateBookingsToBeCancelledRequest {
  /** @format date-time */
  availableFrom?: string;
  /** @format date-time */
  unpublishAt?: string;
  bookableDays?: BookableDayDto[];
  /** @format int32 */
  seats?: number;
  audience?: ConstraintListItemDto[];
}

export interface BookableAssetUpdateRequest {
  name: string;
  description: string;
  images: string[];
  sizeSpecification?: string;
  /** @format int32 */
  capacitySpecification?: number;
  locationSpecification?: string;
  /** @format double */
  pricePerHourSpecification?: number;
  regulationDocumentId?: string;
  bookableDays: BookableDayDto[];
  notificationEnabled: boolean;
  notificationEmail?: string;
  externalSyncEmail?: string;
  externalBookingProvider: ExternalBookingProviderDto;
  externalResourceId?: string;
  timeslot: BookableTimeslotDto;
  /** @format int32 */
  customTimeslot?: number;
  canBookSameDay: boolean;
  /** @format int32 */
  maxDaysInAdvance?: number;
  requireBookingReason: boolean;
  /**
   * Defines the number of hours a user can make changes (or cancel) to a booking before the booking starts.
   * @format int32
   */
  hoursForMutations?: number;
  canBookMultipleSlots: boolean;
  /**
   * The date when this bookable asset will be visible.
   * @format date-time
   */
  publishAt?: string;
  /**
   * The date when this bookable asset will be available for booking.
   * @format date-time
   */
  availableFrom?: string;
  /**
   * Defines the date and time when the bookable asset will be unpublished.
   * This also means that users will not be able to book the asset after this date.
   * @format date-time
   */
  unpublishAt?: string;
  enabled: boolean;
  audience?: ConstraintListItemDto[];
  /**
   * The number of seats available for this asset.
   * @format int32
   */
  seats: number;
}

export interface BookableDayDto {
  day: DayDto;
  allDay: boolean;
  enabled: boolean;
  times: BookableDayTimeDto[];
}

export interface BookableDayTimeDto {
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
}

export interface BookableSlotDto {
  /** @format date */
  date: string;
  /** @format time */
  startTime: string;
  /** @format time */
  endTime: string;
  state: BookableAssetSlotStateDto;
  isAllDay: boolean;
}

export interface BookingAnalyticsAudienceScopeDto {
  type: BookingAnalyticsAudienceScopeTypeDto;
  dataPoints: BookingAnalyticsMonthlyPointDto[];
  projectConnection?: BookingAnalyticsProjectConnectionDto;
}

export interface BookingAnalyticsDistributionPointDto {
  x: string;
  /** @format int32 */
  y: number;
}

export interface BookingAnalyticsMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  cancelled: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format double */
  bookedHours: number;
  /** @format double */
  utilizationPercentage: number;
  isCurrentMonth: boolean;
}

export interface BookingAnalyticsOriginCountsDto {
  /** @format int32 */
  projectOnly: number;
  /** @format int32 */
  projectConnection: number;
}

export interface BookingAnalyticsPreviousPeriodDto {
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  cancelledBookings: number;
  /** @format double */
  cancellationPercentage: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format double */
  bookedHours: number;
  /** @format double */
  utilizationPercentage: number;
}

export interface BookingAnalyticsProjectConnectionDto {
  id: string;
  name: string;
}

export interface BookingAnalyticsSummaryDto {
  /** @format int32 */
  activeAssets: number;
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  upcomingBookings: number;
  /** @format int32 */
  completedBookings: number;
  /** @format int32 */
  cancelledBookings: number;
  /** @format double */
  cancellationPercentage: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format int32 */
  eligibleResidents: number;
  /** @format double */
  bookerReachPercentage: number;
  /** @format int32 */
  returningBookers: number;
  /** @format double */
  repeatBookerPercentage: number;
  /** @format double */
  bookedHours: number;
  /** @format double */
  utilizationPercentage: number;
  previousPeriod: BookingAnalyticsPreviousPeriodDto;
}

export interface BrandedAppAgreementOverviewDto {
  brand: AppBrandingDto;
  appName: string;
  ownerName: string;
  logoImageUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
  accountHolderEmail?: string;
  projects: BrandedAppProjectDto[];
  requests: BrandedAppAgreementRequestDto[];
}

export interface BrandedAppAgreementRequestDto {
  id: string;
  stores: BrandedAppStoreDto[];
  recipientEmail: string;
  /** @format date-time */
  requestedAt: string;
  /** @format date-time */
  sentAt?: string;
  /** @format date-time */
  confirmedAt?: string;
}

export interface BrandedAppProjectDto {
  id: string;
  name: string;
  state: string;
}

export interface BringmeParcelLocation {
  id?: string;
}

export interface BringmeParcelPerson {
  email?: string;
}

export interface BringmeParcelPickupCodes {
  manualPickupCode?: string;
}

export interface BringmeParcelWebhookRequest {
  eventType?: string;
  /** @format uuid */
  transactionId: string;
  location?: BringmeParcelLocation;
  receiver?: BringmeParcelPerson;
  pickupCodes?: BringmeParcelPickupCodes;
  /** @format date-time */
  timestamp?: string;
}

export interface BringmeProjectConfigurationDto {
  enabled: boolean;
  locationId?: string;
}

export interface BucketLeadTimeItemDto {
  /** @format int32 */
  bucket1Percentage: number;
  /** @format int32 */
  bucket1TierPercentage: number;
  /** @format int32 */
  bucket1MaxDays: number;
  /** @format int32 */
  bucket2Percentage: number;
  /** @format int32 */
  bucket2TierPercentage: number;
  /** @format int32 */
  bucket2MaxDays: number;
  /** @format int32 */
  bucket3Percentage: number;
  /** @format int32 */
  bucket3TierPercentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface BucketLeadTimeMonthlyDto {
  data: BucketLeadTimeItemDto[];
}

export interface BuildingCreateRequest {
  name: string;
  shouldCreateRealEstateGroup: boolean;
}

export interface BuildingDto {
  /** @format int32 */
  addressCount: number;
  name: string;
  id: string;
}

export interface BuildingEditRequest {
  name: string;
}

export interface CalendarItemDto {
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
  itemType: CalendarItemType;
  event?: EventDto;
  booking?: AssetBookingDto;
  id: string;
}

export interface ChatMessage {
  role: ChatMessageRole;
  message: string;
}

export interface ChatStateChangeRequest {
  chatPermission?: ChatPermission;
  /**
   * Deprecated: Use ChatPermission instead
   * @deprecated
   */
  hideChat?: boolean;
}

export interface ChatStatusDto {
  /** @format int32 */
  unreadCount: number;
  hasNewMessages: boolean;
}

export interface CloudMailinEnvelope {
  to: string;
  from: string;
}

export interface CloudMailinPayload {
  envelope: CloudMailinEnvelope;
  plain?: string;
  html?: string;
}

export interface CodeOfConductDocumentDto {
  isCustom: boolean;
  defaultCodeOfConductUrl: string;
  url: string;
  fileName?: string;
  id: string;
}

export interface CommentCreateRequest {
  /**
   * Deprecated: Use ContentTemplate instead
   * @deprecated
   */
  content?: string;
  contentTemplate?: string;
  mentions?: MentionInputDto[];
  /** @format uuid */
  imageId?: string;
  parentId?: string;
  videoIds?: string[];
}

export interface CommentDetailDto {
  parentId?: string;
  replies: NestedCommentDto[];
  latestReply?: CommentDto;
  content?: string;
  contentTemplate?: string;
  mentions: MentionDto[];
  autoTranslation?: CommentTranslationDto;
  image?: ImageDto;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: SimpleUserDto;
  /** @format date-time */
  updatedAt?: string;
  hasLiked: boolean;
  /** @format int32 */
  totalLikesCount: number;
  hasReplied: boolean;
  /** @format int32 */
  totalRepliesCount: number;
  canEdit: boolean;
  /**
   * Whether you can delete your own comment. (Deprecated: Use CanDeleteOwn instead.)
   * @deprecated
   */
  canDelete: boolean;
  /** Whether you can delete your own comment. */
  canDeleteOwn: boolean;
  /** Whether you can delete other users' comments. */
  canDeleteOther: boolean;
  canLike: boolean;
  canReply: boolean;
  /**
   * Deprecated: Use LanguageIsoCode instead
   * @deprecated
   */
  languageId: string;
  languageIsoCode?: string;
  videos: VideoDto[];
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  isSolution: boolean;
  id: string;
}

export interface CommentDto {
  latestReply?: CommentDto;
  content?: string;
  contentTemplate?: string;
  mentions: MentionDto[];
  autoTranslation?: CommentTranslationDto;
  image?: ImageDto;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: SimpleUserDto;
  /** @format date-time */
  updatedAt?: string;
  hasLiked: boolean;
  /** @format int32 */
  totalLikesCount: number;
  hasReplied: boolean;
  /** @format int32 */
  totalRepliesCount: number;
  canEdit: boolean;
  /**
   * Whether you can delete your own comment. (Deprecated: Use CanDeleteOwn instead.)
   * @deprecated
   */
  canDelete: boolean;
  /** Whether you can delete your own comment. */
  canDeleteOwn: boolean;
  /** Whether you can delete other users' comments. */
  canDeleteOther: boolean;
  canLike: boolean;
  canReply: boolean;
  /**
   * Deprecated: Use LanguageIsoCode instead
   * @deprecated
   */
  languageId: string;
  languageIsoCode?: string;
  videos: VideoDto[];
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  isSolution: boolean;
  id: string;
}

export interface CommentTranslationDto {
  content?: string;
  contentTemplate?: string;
  isAutoTranslated?: boolean;
}

export interface CommentUpdateRequest {
  /**
   * Deprecated: Use ContentTemplate instead
   * @deprecated
   */
  content?: string;
  contentTemplate?: string;
  mentions?: MentionInputDto[];
  /** @format uuid */
  imageId?: string;
  videoIds?: string[];
}

export interface CommunityFeedAnalyticsAudienceScopeDto {
  type: CommunityFeedAnalyticsAudienceScopeTypeDto;
  dataPoints: CommunityFeedAnalyticsMonthlyPointDto[];
  projectConnection?: CommunityFeedAnalyticsProjectConnectionDto;
}

export interface CommunityFeedAnalyticsDistributionPointDto {
  x: string;
  /** @format int32 */
  y: number;
}

export interface CommunityFeedAnalyticsDto {
  /** @format int32 */
  totalResidentPostCount?: number;
  mostReactedMessage?: MessageV2Dto;
  mostCommentedMessage?: MessageV2Dto;
  /** @format date-time */
  lastUpdatedAt: string;
}

export interface CommunityFeedAnalyticsEngagementPointDto {
  x: string;
  /** @format int32 */
  posts: number;
  /** @format int32 */
  interactions: number;
  /** @format double */
  interactionsPerPost: number;
}

export interface CommunityFeedAnalyticsFilterOptionsDto {
  groups: CommunityFeedAnalyticsGroupReferenceDto[];
}

export interface CommunityFeedAnalyticsGroupDto {
  id: string;
  name: string;
  type: CommunityFeedAnalyticsGroupTypeDto;
  /** @format int32 */
  posts: number;
  /** @format int32 */
  residentContributors: number;
  /** @format int32 */
  comments: number;
  /** @format int32 */
  reactions: number;
  /** @format double */
  interactionsPerPost: number;
}

export interface CommunityFeedAnalyticsGroupReferenceDto {
  id: string;
  name: string;
  type: CommunityFeedAnalyticsGroupTypeDto;
}

export interface CommunityFeedAnalyticsMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  residentPosts: number;
  /** @format int32 */
  projectTeamPosts: number;
  /** @format int32 */
  announcements: number;
  /** @format int32 */
  residentContributors: number;
  /** @format double */
  contributorReachPercentage: number;
  /** @format int32 */
  informationPosts: number;
  /** @format int32 */
  helpRequests: number;
  /** @format int32 */
  marketplacePosts: number;
  /** @format int32 */
  comments: number;
  /** @format int32 */
  reactions: number;
  /** @format double */
  interactionsPerPost: number;
  /** @format int32 */
  answeredHelpRequests: number;
  /** @format int32 */
  unansweredHelpRequests: number;
  isCurrentMonth: boolean;
}

export interface CommunityFeedAnalyticsOriginCountsDto {
  /** @format int32 */
  projectOnly: number;
  /** @format int32 */
  projectConnection: number;
}

export interface CommunityFeedAnalyticsPreviousPeriodDto {
  /** @format int32 */
  visiblePosts: number;
  /** @format int32 */
  residentPosts: number;
  /** @format int32 */
  uniqueResidentContributors: number;
  /** @format int32 */
  interactions: number;
  /** @format double */
  averageInteractionsPerPost: number;
  /** @format double */
  helpResponseRatePercentage: number;
  /** @format double */
  medianFirstResponseHours?: number;
}

export interface CommunityFeedAnalyticsProjectConnectionDto {
  id: string;
  name: string;
}

export interface CommunityFeedAnalyticsSummaryDto {
  /** @format int32 */
  visiblePosts: number;
  /** @format int32 */
  residentPosts: number;
  /** @format int32 */
  announcements: number;
  /** @format int32 */
  uniqueResidentContributors: number;
  /** @format int32 */
  eligibleResidents: number;
  /** @format double */
  contributorReachPercentage: number;
  /** @format int32 */
  interactions: number;
  /** @format double */
  averageInteractionsPerPost: number;
  /** @format int32 */
  helpRequests: number;
  /** @format int32 */
  unansweredHelpRequests: number;
  /** @format double */
  helpResponseRatePercentage: number;
  /** @format double */
  medianFirstResponseHours?: number;
  previousPeriod: CommunityFeedAnalyticsPreviousPeriodDto;
}

export interface CommunityFeedAudienceDto {
  interestGroups: CommunityFeedAudienceGroupDto[];
  helpCategories: CommunityFeedAudienceGroupDto[];
  realEstateGroups: CommunityFeedAudienceGroupDto[];
  projectConnections: CommunityFeedAudienceProjectConnectionDto[];
  project?: CommunityFeedAudienceProjectDto;
}

export interface CommunityFeedAudienceGroupDto {
  name: string;
  type: CommunityGroupTypeDto;
  /** @format date-time */
  lastActivityAt?: string;
  isResidentGroup: boolean;
  defaultPostingLevel: DefaultPostingAudienceDto;
  icon: CommunityGroupIconDto;
  image?: ImageDto;
  selectableAudience: CommunityFeedSelectableAudienceDto[];
  id: string;
}

export interface CommunityFeedAudienceProjectConnectionDto {
  name: string;
  /** @format int32 */
  audienceCount: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedAudienceProjectDto {
  name: string;
  /** @format int32 */
  audienceCount: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedItemV1Dto {
  type: CommunityFeedItemTypeDto;
  /** @format date-time */
  updatedAt?: string;
  message?: MessageV1Dto;
  survey?: CommunityFeedSurveyDto;
}

export interface CommunityFeedPollAnalyticsAudienceScopeDto {
  type: CommunityFeedAnalyticsAudienceScopeTypeDto;
  dataPoints: CommunityFeedPollAnalyticsMonthlyPointDto[];
  projectConnection?: CommunityFeedAnalyticsProjectConnectionDto;
}

export interface CommunityFeedPollAnalyticsDto {
  summary: CommunityFeedPollAnalyticsSummaryDto;
  monthly: CommunityFeedPollAnalyticsMonthlyPointDto[];
  audienceScopes: CommunityFeedPollAnalyticsAudienceScopeDto[];
  participationDistribution: CommunityFeedAnalyticsDistributionPointDto[];
}

export interface CommunityFeedPollAnalyticsMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  residentPolls: number;
  /** @format int32 */
  projectTeamPolls: number;
  /** @format int32 */
  responses: number;
  /** @format int32 */
  uniqueRespondents: number;
  /** @format double */
  participationRatePercentage?: number;
  isCurrentMonth: boolean;
}

export interface CommunityFeedPollAnalyticsSummaryDto {
  /** @format int32 */
  polls: number;
  /** @format int32 */
  openPolls: number;
  /** @format int32 */
  resultAvailablePolls: number;
  /** @format int32 */
  responses: number;
  /** @format int32 */
  uniqueRespondents: number;
  /** @format double */
  participationRatePercentage?: number;
  /** @format int32 */
  pollsWithoutResponses: number;
}

export interface CommunityFeedReportingDto {
  summary: CommunityFeedAnalyticsSummaryDto;
  monthly: CommunityFeedAnalyticsMonthlyPointDto[];
  audienceScopes: CommunityFeedAnalyticsAudienceScopeDto[];
  hasProjectConnections: boolean;
  responseTimeDistribution: CommunityFeedAnalyticsDistributionPointDto[];
  contributorFrequencyDistribution: CommunityFeedAnalyticsDistributionPointDto[];
  interactionDistribution: CommunityFeedAnalyticsDistributionPointDto[];
  audienceTypeDistribution: CommunityFeedAnalyticsDistributionPointDto[];
  engagementByContentPurpose: CommunityFeedAnalyticsEngagementPointDto[];
  groups: CommunityFeedAnalyticsGroupDto[];
  sentiment: CommunityFeedSentimentAnalyticsDto;
  polls: CommunityFeedPollAnalyticsDto;
  originCounts: CommunityFeedAnalyticsOriginCountsDto;
  filterOptions: CommunityFeedAnalyticsFilterOptionsDto;
}

export interface CommunityFeedSelectableAudienceDto {
  type: CommunityFeedSelectableAudienceTypeDto;
  project?: CommunityFeedSelectableAudienceItemDto;
  projectConnection?: CommunityFeedSelectableAudienceItemDto;
}

export interface CommunityFeedSelectableAudienceItemDto {
  name: string;
  /** @format int32 */
  audienceCount: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedSentimentAnalyticsDto {
  hasSufficientData: boolean;
  /** @format int32 */
  minimumSampleSize: number;
  /** @format int32 */
  analyzedResidentPosts: number;
  /** @format int32 */
  unscoredResidentPosts: number;
  /** @format double */
  averageScore?: number;
  /** @format double */
  netSentimentScore?: number;
  overall: CommunityFeedSentimentDistributionDto;
  monthly: CommunityFeedSentimentMonthlyPointDto[];
  topics: CommunityFeedSentimentTopicPointDto[];
  audienceScopes: CommunityFeedSentimentAudienceScopeDto[];
  responsiveness: CommunityFeedSentimentResponsivenessDto;
  responseTimeDistribution: CommunityFeedAnalyticsDistributionPointDto[];
}

export interface CommunityFeedSentimentAudienceScopeDto {
  type: CommunityFeedAnalyticsAudienceScopeTypeDto;
  dataPoints: CommunityFeedSentimentMonthlyPointDto[];
  projectConnection?: CommunityFeedAnalyticsProjectConnectionDto;
}

export interface CommunityFeedSentimentDistributionDto {
  /** @format int32 */
  negativePosts: number;
  /** @format int32 */
  neutralPosts: number;
  /** @format int32 */
  positivePosts: number;
  /** @format double */
  negativePercentage?: number;
  /** @format double */
  neutralPercentage?: number;
  /** @format double */
  positivePercentage?: number;
}

export interface CommunityFeedSentimentMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  analyzedPosts: number;
  /** @format double */
  averageScore?: number;
  /** @format double */
  netSentimentScore?: number;
  distribution: CommunityFeedSentimentDistributionDto;
  /** @format int32 */
  answeredNegativePosts: number;
  /** @format int32 */
  unansweredNegativePosts: number;
  hasSufficientData: boolean;
  isCurrentMonth: boolean;
}

export interface CommunityFeedSentimentResponsivenessDto {
  /** @format int32 */
  negativePosts: number;
  /** @format int32 */
  answeredNegativePosts: number;
  /** @format int32 */
  unansweredNegativePosts: number;
  /** @format double */
  responseRatePercentage?: number;
  /** @format double */
  medianFirstResponseHours?: number;
}

export interface CommunityFeedSentimentTopicPointDto {
  topic: string;
  /** @format int32 */
  analyzedPosts: number;
  /** @format double */
  averageScore: number;
  /** @format double */
  netSentimentScore: number;
  distribution: CommunityFeedSentimentDistributionDto;
}

export interface CommunityFeedStatsDto {
  /** @format int32 */
  allCount: number;
  /** @format int32 */
  announcementsCount: number;
  /** @format int32 */
  myPostsCount: number;
}

export interface CommunityFeedSurveyDto {
  /** @format int32 */
  questionCount: number;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startsAt?: string;
  /** @format date-time */
  endsAt?: string;
  group?: GroupDto;
  title: string;
  description: string;
  canRespond: CanRespondStatusDto;
  createdBy: UserDto;
  isUnread: boolean;
  scope: SurveyScope;
  originalLanguageId: LanguageIdDto;
  viewTracked: boolean;
  status: SurveyStatusDto;
  id: string;
}

export interface CommunityGroupCreateRequest {
  type: CommunityGroupTypeDto;
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  nameTranslations?: TranslationRequest[];
  /**
   * Deprecated: Use Description instead
   * @deprecated
   */
  descriptionTranslations?: TranslationRequest[];
  name?: string;
  description?: string;
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  audience: ConstraintListItemDto[];
  permissions: UserRoleCommunityGroupPermissionsDto[];
  /** @format uuid */
  imageId?: string;
  addAllResidents: boolean;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
}

export interface CommunityGroupDetailsDto {
  nameTranslations?: TranslationsDto[];
  descriptionTranslations?: TranslationsDto[];
  permissions?: UserRoleCommunityGroupPermissionsDto[];
  notificationSettings: AppNotificationGroupSettingDto;
  canPromote: boolean;
  /**
   * Indicates whether to show the promotion banner to the author.
   * Returns true as long as the group is not promoted or skipped by the author.
   */
  hasPromotionBanner: boolean;
  originalLanguageId: LanguageIdDto;
  type: CommunityGroupTypeDto;
  isResidentGroup: boolean;
  name: string;
  /**
   * Deprecated: Use Icon or Image instead
   * @deprecated
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  description: string;
  isMember: boolean;
  /** @format int32 */
  members: number;
  membersList: UserDtoPaginationResultDto;
  /** @format int32 */
  totalAudience?: number;
  /** @format int32 */
  joinedAudience?: number;
  image?: ImageDto;
  audience?: ConstraintListItemDto[];
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canEdit: boolean;
  canDelete: boolean;
  disabled: boolean;
  projectConnectionGroup?: ProjectConnectionGroupDto;
  systemGroup?: SystemGroupDto;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
  isOwner: boolean;
  id: string;
}

export interface CommunityGroupDto {
  type: CommunityGroupTypeDto;
  isResidentGroup: boolean;
  name: string;
  /**
   * Deprecated: Use Icon or Image instead
   * @deprecated
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  description: string;
  isMember: boolean;
  /** @format int32 */
  members: number;
  membersList: UserDtoPaginationResultDto;
  /** @format int32 */
  totalAudience?: number;
  /** @format int32 */
  joinedAudience?: number;
  image?: ImageDto;
  audience?: ConstraintListItemDto[];
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canEdit: boolean;
  canDelete: boolean;
  disabled: boolean;
  projectConnectionGroup?: ProjectConnectionGroupDto;
  systemGroup?: SystemGroupDto;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
  isOwner: boolean;
  id: string;
}

export interface CommunityGroupEditRequest {
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  nameTranslations?: TranslationRequest[];
  /**
   * Deprecated: Use Description instead
   * @deprecated
   */
  descriptionTranslations?: TranslationRequest[];
  name?: string;
  description?: string;
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  audience: ConstraintListItemDto[];
  permissions: UserRoleCommunityGroupPermissionsDto[];
  /** @format uuid */
  imageId?: string;
  addAllResidents: boolean;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
}

export interface CommunityPostEventCreateRequest {
  type: CommunityPostEventTypeDto;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  location?: string;
  /** @format int32 */
  maxParticipants?: number;
  /** @format int32 */
  maxGuestsPerParticipant?: number;
}

export interface CompanyAdoptionRateDto {
  /** @format double */
  adoptionRatePercentage: number;
  /** @format double */
  reachRatePercentage: number;
  /** @format int32 */
  totalCompanies: number;
  /** @format int32 */
  totalCompaniesWithOnboardedUsers: number;
  /** @format int32 */
  totalCompaniesWithUsers: number;
  /** @format int32 */
  totalResidents: number;
}

export interface CompanyDto {
  description: string;
  logoUrl: string;
  logo?: ImageDto;
  backgroundImageUrl?: string;
  backgroundImage?: ImageDto;
  /**
   * Deprecated: Use Building instead
   * @deprecated
   */
  buildingName: string;
  address: AddressCompanyDto;
  /** @format int32 */
  activeUserCount: number;
  /** @format int32 */
  inactiveUserCount?: number;
  locationCode?: string;
  canDelete: boolean;
  externalId?: string;
  name: string;
  building: AddressBuildingDto;
  id: string;
}

export interface CompanyRequest {
  name: string;
  description?: string;
  /** @format uuid */
  logoId?: string;
  /** @format uuid */
  backgroundImageId?: string;
  addressId: string;
  externalId?: string;
}

export interface ConnectedProjectDto {
  name: string;
  slug: string;
  logoUrl: string;
  styling: ProjectStylingDto;
  splashScreenLogoUrl: string;
  splashScreenBackgroundUrl: string;
  city: string;
  owner: string;
  maintenance: string;
  /** @format date-time */
  createdAt: string;
  userRole: UserRoleTypeDto;
  unread: boolean;
  projectBaseLanguageId: LanguageIdDto;
  customIconId?: CustomIconDto;
  projectType: ProjectTypeDto;
  appBranding: AppBrandingDto;
  /** @format int32 */
  appBrandingMaxSkips?: number;
  androidAppUrl: string;
  iosAppUrl: string;
  backgroundImage?: ImageDto;
  isZiezodan: boolean;
  activeState: ProjectActiveStateDto;
  id: string;
}

export interface ConnectedProjectsDto {
  projects: ConnectedProjectDto[];
}

export interface TicketOperationalInsightDto {
  /** @format int32 */
  createdTickets: number;
  /** @format int32 */
  closedTickets: number;
  /** @format int32 */
  openTickets: number;
  /** @format int32 */
  openTicketsChange: number;
  /** @format double */
  medianResolutionDays?: number;
  /** @format double */
  p90ResolutionDays?: number;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  ratedTickets: number;
  previousPeriod: TicketOperationalInsightPreviousPeriodDto;
}

export interface TicketOperationalInsightPreviousPeriodDto {
  /** @format double */
  medianResolutionDays?: number;
  /** @format double */
  averageRating?: number;
}

export interface CommunityFeedOperationalInsightDto {
  /** @format int32 */
  visiblePosts: number;
  /** @format int32 */
  residentPosts: number;
  /** @format int32 */
  uniqueResidentContributors: number;
  /** @format double */
  helpResponseRatePercentage: number;
  /** @format double */
  averageInteractionsPerPost: number;
  sentiment: CommunityFeedSentimentOperationalInsightDto;
  previousPeriod: CommunityFeedOperationalInsightPreviousPeriodDto;
}

export interface CommunityFeedOperationalInsightPreviousPeriodDto {
  /** @format int32 */
  visiblePosts: number;
  /** @format double */
  averageInteractionsPerPost: number;
}

export interface CommunityFeedSentimentOperationalInsightDto {
  hasSufficientData: boolean;
  /** @format int32 */
  minimumSampleSize: number;
  /** @format int32 */
  analyzedResidentPosts: number;
  /** @format double */
  averageScore?: number;
  /** @format double */
  netSentimentScore?: number;
  /** @format double */
  negativePercentage?: number;
  /** @format double */
  neutralPercentage?: number;
  /** @format double */
  positivePercentage?: number;
}

export interface EventOperationalInsightDto {
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  registrations: number;
  /** @format int32 */
  uniqueParticipants: number;
  /** @format int32 */
  zeroRegistrationOccurrences: number;
}

export interface BookingOperationalInsightDto {
  /** @format int32 */
  activeAssets: number;
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format int32 */
  eligibleResidents: number;
  /** @format double */
  bookerReachPercentage: number;
  /** @format double */
  utilizationPercentage: number;
  /** @format int32 */
  cancelledBookings: number;
  /** @format double */
  cancellationPercentage: number;
  previousPeriod: BookingOperationalInsightPreviousPeriodDto;
}

export interface BookingOperationalInsightPreviousPeriodDto {
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format double */
  utilizationPercentage: number;
  /** @format double */
  cancellationPercentage: number;
}

export interface ConstraintListItemDto {
  key: string;
  type: ConstraintTagTypeDto;
  id: string;
}

export interface ConsumptionResultDto {
  requestedMonth: ConsumptionUsageDto;
  previousMonth?: ConsumptionUsageDto;
  /** @format int32 */
  percentageChange?: number;
  /** @format int32 */
  usageChange?: number;
  unitType: UnitTypeDto;
}

export interface ConsumptionUsageDto {
  /** @format double */
  value: number;
}

export interface ConversationsMonthlyDto {
  data: ConversationsStartedItemDto[];
}

export interface ConversationsStartedItemDto {
  /** @format int32 */
  count: number;
  isCurrentMonth: boolean;
  range: MonthlyReportDateRangeDto;
}

export interface CopilotPromptConfigurationDto {
  type: CopilotPromptTypeDto;
  prompt: string;
  /** Selectable AI performance profiles. Balanced and Advanced require elevated platform access. */
  profile: AiModelProfileDto;
}

export interface CopilotPromptConfigurationsDto {
  configurations: CopilotPromptConfigurationDto[];
}

export interface CopilotRequest {
  templateId?: string;
  userInput: string;
  toneOfVoice?: CopilotToneOfVoiceDto;
  copilotOptions: CopilotOptionsDto[];
}

export interface CopilotResponseDto {
  generatedText: string;
  generatedTitle: string;
  id: string;
}

export interface CreatableTicketCategoryDto {
  notificationType: TicketCategoryNotificationTypeDto;
  projectHasMultipleBuildings: boolean;
  customIntroText?: string;
  regulations?: DocumentUploadDto;
  requireSignOffRegulations: boolean;
  requireImages: boolean;
  name: string;
  requirePhoneNumber: boolean;
  allowVideos: boolean;
  id: string;
}

export interface CreatedEntityDto {
  id: string;
}

export interface CreatedHousemateInviteDto {
  inviteCode: string;
}

export interface CreateEventRequest {
  type: EventTypeDto;
  projectConnectionId?: string;
  name?: string;
  description?: string;
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  nameTranslations?: TranslationRequest[];
  /**
   * Deprecated: Use Description instead
   * @deprecated
   */
  descriptionTranslations?: TranslationRequest[];
  /** @format int32 */
  maxParticipants?: number;
  /** @format int32 */
  maxGuestsPerParticipant?: number;
  categoryType: EventCategoryTypeDto;
  /** @format uuid */
  imageId?: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  publishAt?: string;
  location?: string;
  audience?: ConstraintListItemDto[];
}

export interface CreateFastMenuActionItemRequest {
  type: FastMenuActionItemTypeDto;
  selectedLabel?: string;
  translations?: FastMenuActionItemTranslationRequest[];
  url?: string;
  maintainer?: string;
  useType?: FastMenuActionItemUseTypeDto;
  dynamicExternalUrlType?: FastMenuActionItemDynamicUrlTypeDto;
  label?: string;
}

export interface CreateOfferedAnswerRequestDto {
  answer: string;
}

export interface CreateQuestionRequestDto {
  question: string;
  type: QuestionTypeDto;
  /** @format int32 */
  sorting: number;
  offeredAnswers?: CreateOfferedAnswerRequestDto[];
  /** @default false */
  useForAnalysis: boolean;
}

export interface CreateRelationLocoiaRequest {
  /**
   * The Id which is tracked by the external system. This Id is used to identify the relation. This Id is unique and should never change.
   * An Id is unique to the contract and not to the renter.
   */
  id: string;
  /** The unit for which this relation is related to. */
  addressUnitDto: AddressUnitLocoiaDto;
  /** The renters which are part of this relation. */
  renters: RenterLocoiaDto[];
  /**
   * The date when the relation starts.
   * The StartDate is only used for tracking purposes. The user will be added to the address unit as soon as the relation is processed.
   * @format date-time
   */
  startDate?: string;
}

/** During meeting of 17-04-2024 we discussed that this list should only have one renter, as there are no VHE's with multiple renters. */
export interface CreateRelationWoonbedrijfRequest {
  /**
   * The Id which is tracked by the external system. This Id is used to identify the relation. This Id is unique and should never change.
   * An Id is unique to the contract and not to the renter.
   */
  id: string;
  /** The unit for which this relation is related to. */
  addressUnitDto: AddressUnitWoonbedrijfDto;
  /** The renters which are part of this relation. */
  renters: RenterWoonbedrijfDto[];
  /**
   * The date when the relation starts.
   * The StartDate is only used for tracking purposes. The user will be added to the address unit as soon as the relation is processed.
   * @format date-time
   */
  startDate?: string;
}

export interface CreateSurveyBulkItemDto {
  projectId: string;
  surveyId?: string;
  status: CreateSurveyBulkItemStatusDto;
  errorMessage?: string;
}

export interface CreateSurveyBulkRequest {
  projectIds: string[];
  title: string;
  description: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  surveyCompleted: string;
  questions: CreateQuestionRequestDto[];
  systemGroupId?: string;
  category: SurveyCategoryDto;
  /** @default false */
  internal: boolean;
}

export interface CreateSurveyRequestDto {
  title: string;
  description: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  surveyCompleted: string;
  questions: CreateQuestionRequestDto[];
  groupId?: string;
  type: SurveyTypeDto;
  category: SurveyCategoryDto;
  /** @default false */
  internal: boolean;
}

export interface CreateUsersResultDto {
  users: UserDto[];
}

export interface DeleteAssetBookingRequest {
  reason?: string;
}

/** Delivery time frame details. */
export interface DeliveryTimeFrame {
  /**
   * Earliest delivery date.
   * @format date
   */
  deliveryDateEarliest: string;
  /**
   * Earliest delivery time.
   * @format time
   */
  deliveryTimeEarliest: string;
  /**
   * Latest delivery date.
   * @format date
   */
  deliveryDateLatest: string;
  /**
   * Latest delivery time.
   * @format time
   */
  deliveryTimeLatest: string;
}

export interface DeviceRegistrationRequest {
  /** APNS token or FCM token */
  deviceToken: string;
  platform: DevicePlatformDto;
  /** Our own custom support version. Used to version our push notification payloads. */
  supportVersion: RegistrationVersionDto;
  /** Some extra info about the device */
  deviceInfo?: string;
  appBrand: AppBrandingDto;
}

export interface DicoAppointmentDateTimeInformation {
  requiredDeliveryDate?: string;
  requiredDeliveryTime?: string;
  deliveryTimeFrame?: DicoDeliveryTimeFrame;
}

export interface DicoDeliveryTimeFrame {
  deliveryDateEarliest?: string;
  deliveryTimeEarliest?: string;
  deliveryDateLatest?: string;
  deliveryTimeLatest?: string;
}

export interface DicoInstructionData {
  instructionNumber?: string;
  status?: string;
  freeText?: string;
  appointmentDateTimeInformation?: DicoAppointmentDateTimeInformation;
}

export interface DicoParty {
  gln?: string;
}

export interface DicoProjectConfigurationDto {
  enabled: boolean;
  url: string;
  username: string;
  password: string;
  buyerGln: string;
  buyerName: string;
  contractorGln: string;
  contractorName: string;
  fallbackUserId: string;
  assigneeUserId?: string;
  ignoreCategories: boolean;
  appendTicketUrlToInstructions?: boolean;
}

export interface DicoStatusDto {
  state: DicoTicketStateDto;
  errorDetails?: string;
}

export interface DocumentDto {
  url: string;
  fileName?: string;
  id: string;
}

export interface DocumentsFileDetailsDto {
  nameTranslations: TranslationsDto[];
  originalLanguageId: LanguageIdDto;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  type: DocumentsItemTypeDto;
  document?: DocumentDto;
  isEmpty?: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canMove: boolean;
  section?: DocumentsItemDto;
  /** @format int32 */
  viewCount?: number;
  /** @format date-time */
  sortOrder: string;
  id: string;
}

export interface DocumentsFileRequest {
  name?: string;
  nameTranslations: TranslationRequest[];
  parentFolderId: string;
  uploadId: string;
}

export interface DocumentsFolderDetailsDto {
  nameTranslations: TranslationsDto[];
  originalLanguageId: LanguageIdDto;
  parentFolderId: string;
  name: string;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface DocumentsFolderDto {
  name: string;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface DocumentsFolderRequest {
  name?: string;
  nameTranslations: TranslationRequest[];
  parentFolderId: string;
}

export interface DocumentsItemDto {
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  type: DocumentsItemTypeDto;
  document?: DocumentDto;
  isEmpty?: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canMove: boolean;
  section?: DocumentsItemDto;
  /** @format int32 */
  viewCount?: number;
  /** @format date-time */
  sortOrder: string;
  id: string;
}

export interface DocumentsListDto {
  ancestors: DocumentsFolderDto[];
  items: DocumentsItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
  name: string;
  canAddNew: boolean;
  /**
   * Deprecated: Use CanDelete instead
   * @deprecated
   */
  canDeleteExisting: boolean;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface DocumentsRootDto {
  rootFolders: DocumentsRootFolderDto[];
}

export interface DocumentsRootFolderDetailsDto {
  nameTranslations: TranslationsDto[];
  descriptionTranslations: TranslationsDto[];
  originalLanguageId: LanguageIdDto;
  audience: ConstraintListItemDto[];
  permissions: UserRoleDocumentFolderPermissionsDto[];
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  name: string;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface DocumentsRootFolderDto {
  description?: string;
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar: string;
  /**
   * Deprecated: Use CanDelete instead
   * @deprecated
   */
  isEmpty: boolean;
  canAddItem: boolean;
  canDelete: boolean;
  name: string;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface DocumentsRootFolderRequest {
  name?: string;
  description?: string;
  nameTranslations: TranslationRequest[];
  descriptionTranslations?: TranslationRequest[];
  audience: ConstraintListItemDto[];
  permissions: UserRoleDocumentFolderPermissionsDto[];
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
}

export interface DocumentUploadDto {
  previewImage?: ImageDto;
  url: string;
  fileName?: string;
  /** @format int64 */
  fileSize?: number;
  id: string;
}

export interface EditTicketCommentRequest {
  /** @format uuid */
  imageId?: string;
  content?: string;
  documentIds?: string[];
  videoIds?: string[];
}

export interface EmailChangeDto {
  verificationCode: string;
  email: string;
}

export interface EmailChangeRequestDto {
  email: string;
}

export interface EmailExistsDto {
  exists: boolean;
  userId?: string;
}

export interface EmailExistsRequest {
  email: string;
}

export interface EndRelationLocoiaRequest {
  /** The Id which is tracked by the external system. This Id is used to identify the relation. */
  id: string;
  /**
   * DateTime in UTC when the relation should end. This is the date when the renter should be removed from the address unit.
   * Default is null, which means the relation will be ended immediately.
   * @format date-time
   */
  endDate?: string;
}

export interface EndRelationWoonbedrijfRequest {
  /** The Id which is tracked by the external system. This Id is used to identify the relation. */
  id: string;
  /**
   * DateTime in UTC when the relation should end. This is the date when the renter should be removed from the address unit.
   * Default is null, which means the relation will be ended immediately.
   * @format date-time
   */
  endDate?: string;
}

export interface EngagedResidentsMonthlyDto {
  benchmark: ProjectEngagementBenchmarkItemDto[];
  data: ProjectEngagementItemDto[];
}

export interface EventAnalyticsAudiencePointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  series: number;
  isCurrentMonth: boolean;
}

export interface EventAnalyticsAudienceScopeDto {
  type: EventAnalyticsAudienceScopeTypeDto;
  dataPoints: EventAnalyticsAudiencePointDto[];
  projectConnection?: EventAnalyticsProjectConnectionDto;
}

export interface EventAnalyticsCapacityDto {
  /** @format int32 */
  cappedOccurrences: number;
  distribution: EventAnalyticsChartPointDto[];
}

export interface EventAnalyticsChartPointDto {
  x: string;
  /** @format int32 */
  y: number;
  isCurrentMonth: boolean;
}

export interface EventAnalyticsMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  series: number;
  /** @format int32 */
  registrations: number;
  isCurrentMonth: boolean;
}

export interface EventAnalyticsOrganizerPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  residentLed: number;
  /** @format int32 */
  projectTeamLed: number;
  isCurrentMonth: boolean;
}

export interface EventAnalyticsOriginCountsDto {
  /** @format int32 */
  internal: number;
  /** @format int32 */
  external: number;
}

export interface EventAnalyticsProjectConnectionDto {
  id: string;
  name: string;
}

export interface EventAnalyticsSummaryDto {
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  oneOffOccurrences: number;
  /** @format int32 */
  recurringOccurrences: number;
  /** @format int32 */
  registrations: number;
  /** @format int32 */
  uniqueParticipants: number;
  /** @format int32 */
  zeroRegistrationOccurrences: number;
}

export interface EventAnalyticsTypeCountsDto {
  /** @format int32 */
  regular: number;
  /** @format int32 */
  announcement: number;
}

export interface EventCategoryDto {
  id: EventCategoryTypeDto;
  name: string;
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar: string;
}

export interface EventCreatedDto {
  id: string;
}

export interface EventDetailsDto {
  nameTranslations: TranslationsDto[];
  descriptionTranslations: TranslationsDto[];
  audience: ConstraintListItemDto[];
  originalLanguageId: LanguageIdDto;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  publishAt: string;
  /** @format date-time */
  publishedAt?: string;
  image?: ImageDto;
  location?: string;
  category: EventCategoryDto;
  type: EventTypeDto;
  name: string;
  description: string;
  isSignedUp: boolean;
  /**
   * Participants + their Guests summed
   * @format int32
   */
  participantCount?: number;
  /**
   * The total amount of guests that participants bring
   * @format int32
   */
  guestCount: number;
  /**
   * The maximum amount of participants allowed for this event.
   * This includes the guests that participants bring.
   * If null, there is no limit.
   * @format int32
   */
  maxParticipants?: number;
  /**
   * The maximum number of guests a single participant may bring.
   * null = unlimited, 0 = no guests allowed.
   * @format int32
   */
  maxGuestsPerParticipant?: number;
  organizer: UserDto;
  canEdit: boolean;
  /**
   * Whether the requester may manage participants. Registration availability,
   * capacity, and guest limits are validated separately for each action.
   */
  canManageParticipants: boolean;
  canDelete: boolean;
  canParticipate: boolean;
  projectConnection?: ProjectConnectionDto;
  participants: EventParticipantDto[];
  hasAudience: boolean;
  canEditAudience: boolean;
  externalParty?: EventExternalPartyDto;
  externalPartyUrl?: string;
  id: string;
}

export interface EventDto {
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  publishAt: string;
  /** @format date-time */
  publishedAt?: string;
  image?: ImageDto;
  location?: string;
  category: EventCategoryDto;
  type: EventTypeDto;
  name: string;
  description: string;
  isSignedUp: boolean;
  /**
   * Participants + their Guests summed
   * @format int32
   */
  participantCount?: number;
  /**
   * The total amount of guests that participants bring
   * @format int32
   */
  guestCount: number;
  /**
   * The maximum amount of participants allowed for this event.
   * This includes the guests that participants bring.
   * If null, there is no limit.
   * @format int32
   */
  maxParticipants?: number;
  /**
   * The maximum number of guests a single participant may bring.
   * null = unlimited, 0 = no guests allowed.
   * @format int32
   */
  maxGuestsPerParticipant?: number;
  organizer: UserDto;
  canEdit: boolean;
  /**
   * Whether the requester may manage participants. Registration availability,
   * capacity, and guest limits are validated separately for each action.
   */
  canManageParticipants: boolean;
  canDelete: boolean;
  canParticipate: boolean;
  projectConnection?: ProjectConnectionDto;
  participants: EventParticipantDto[];
  hasAudience: boolean;
  externalParty?: EventExternalPartyDto;
  externalPartyUrl?: string;
  id: string;
}

export interface EventParticipantCandidateAddressDto {
  street: string;
  houseNumber?: string;
  houseNumberSuffix?: string;
}

export interface EventParticipantCandidateDto {
  id: string;
  fullName: string;
  firstName: string;
  prefix?: string;
  lastName: string;
  avatar?: ImageDto;
  address: EventParticipantCandidateAddressDto;
  project: EventParticipantCandidateProjectDto;
}

export interface EventParticipantCandidateProjectDto {
  id: string;
  name: string;
}

export interface EventParticipantDto {
  /** @format int32 */
  guestCount: number;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface EventSignUpRequest {
  /**
   * @format int32
   * @default 0
   */
  guestCount: number;
}

export interface FastMenuActionItemDto {
  /** @format int32 */
  order: number;
  type: FastMenuActionItemTypeDto;
  translationLabel?: string;
  text?: string;
  translations?: FastMenuActionItemTranslationDto[];
  url?: string;
  maintainer?: string;
  useType?: FastMenuActionItemUseTypeDto;
  dynamicExternalUrlType?: FastMenuActionItemDynamicUrlTypeDto;
  id: string;
}

export interface FastMenuActionItemDynamicUrlDto {
  url: string;
}

export interface FastMenuActionItemTranslationDto {
  text: string;
  language: LanguageIdDto;
}

export interface FastMenuActionItemTranslationRequest {
  languageId: LanguageIdDto;
  label: string;
}

export interface FeelingAtHomeDataMonthlyDto {
  /** Month's FAH score. */
  totalFeelingAtHomeScore?: TotalFeelingAtHomeScoreDto;
  /** Benchmark FAH score value. */
  benchmarkFeelingAtHomeScore?: BenchmarkFeelingAtHomeDto;
  /**
   * Date which scores correspond to.
   * @format date-time
   */
  month: string;
  /**
   * Community pillar score for the month.
   * @format double
   */
  communityScore?: number;
  /**
   * Building pillar score for the month.
   * @format double
   */
  buildingScore?: number;
  /**
   * Services pillar score for the month.
   * @format double
   */
  servicesScore?: number;
  /**
   * Response rate is a number between 0 and 1.
   * @format double
   * @default 0
   */
  responseRate: number;
}

export interface FeelingAtHomeDetailsDto {
  /** @format date-time */
  startedAt: string;
  /** @format int32 */
  totalResponseCount?: number;
  /** @format int32 */
  totalAskedCount?: number;
  questions: FeelingAtHomeSurveyQuestionDto[];
}

export interface FeelingAtHomeDistributionDto {
  type: FeelingAtHomeDistributionTypeDto;
  /** @format double */
  score: number;
  /** @format double */
  importance: number;
}

export interface FeelingAtHomeQuestionResponseDto {
  user: UserDto;
  /** @format date-time */
  answeredAt: string;
  /** @format int32 */
  rating: number;
  answer?: string;
}

export interface FeelingAtHomeScoreAndDistributionDto {
  /** @format double */
  rating: number;
  /** @format date-time */
  month: string;
  /** @format int32 */
  answerCount: number;
  distributions?: FeelingAtHomeDistributionDto[];
}

export interface FeelingAtHomeSurveyQuestionDto {
  id: string;
  ratingQuestionText: string;
  explanation?: string;
  openQuestionText?: string;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  responseCount: number;
  category: QuestionGroupType;
  responses: FeelingAtHomeQuestionResponseDto[];
}

export interface FeelingAtHomeWidgetSuggestionDto {
  id: string;
  title: string;
  description: string;
  /** @format date-time */
  viewedAt?: string;
  tips: FeelingAtHomeWidgetSuggestionTipDto[];
}

export interface FeelingAtHomeWidgetSuggestionsDto {
  /** Empty here means that we don't have results yet. Null means FAH hasn't started yet. */
  suggestions?: FeelingAtHomeWidgetSuggestionDto[];
  /**
   * When we last generated suggestions.
   * @format date-time
   */
  lastUpdatedAt?: string;
}

export interface FeelingAtHomeWidgetSuggestionTipDto {
  id: string;
  title: string;
  items: FeelingAtHomeWidgetSuggestionTipItemDto[];
  rating?: AiResponseRatingDto;
  /** @format date-time */
  ratedAt?: string;
}

export interface FeelingAtHomeWidgetSuggestionTipItemDto {
  item: string;
}

export interface FeelingAtHomeWidgetV2Dto {
  totalFeelingAtHomeScore?: TotalFeelingAtHomeScoreDto;
  latestMonthlyFeelingAtHomeScore?: LastFeelingAtHomeScoreDto;
  lastFeelingAtHomeScore?: LastFeelingAtHomeScoreDto;
  benchmarkFeelingAtHomeScore?: BenchmarkFeelingAtHomeDto;
  status: FeelingAtHomeDataStatusDto;
  hasFeelAtHomeDetailsLink: boolean;
  distributions?: FeelingAtHomeDistributionDto[];
  lastMonthFeelingAtHomeScore?: FeelingAtHomeScoreAndDistributionDto;
  manualSurveyId?: string;
}

export interface GenericAlertTriggeredDto {
  alertId: string;
  alertType: AlertTypeDto;
  /** @format date-time */
  sentAt: string;
  alertName: string;
  messageId: string;
  projectName: string;
  projectId: string;
  matchedKeywords?: string;
  content: string;
  emailSent: boolean;
}

export interface GenericDashboardNotificationSettingsRequest {
  generalMessageNew?: GlobalNotificationSettingRequest;
  generalMessageCommentNew?: GlobalNotificationSettingRequest;
  ticketAssignToMe?: GlobalNotificationSettingRequest;
  ticketAssignedCommentNew?: GlobalNotificationSettingRequest;
  chatNew?: GlobalNotificationSettingRequest;
  sendCommunitySummaryEmailInterval?: NotificationTimedValueDto;
  sendMonthlyReportingEmail?: boolean;
}

export interface GenericNotificationSettingsDto {
  myTicketStatusChange: AppNotificationSettingDto;
  myTicketNewComment: AppNotificationSettingDto;
  ticketAssignToMe: GlobalNotificationSettingDto;
  ticketAssignedCommentNew: GlobalNotificationSettingDto;
  generalMessageNew: GlobalNotificationSettingDto;
  newGeneralMessageInProjectConnection?: AppNotificationSettingDto;
  generalMessageCommentNew: GlobalNotificationSettingDto;
  newGeneralAnnouncement: AppNotificationSettingDto;
  newGeneralAnnouncementComments: AppNotificationSettingDto;
  eventNew: AppNotificationSettingDto;
  eventChange: AppNotificationSettingDto;
  eventReminder: AppNotificationSettingDto;
  chatNew: GlobalNotificationSettingDto;
  surveyNew: AppNotificationSettingDto;
  sendCommunitySummaryEmailInterval: NotificationTimedValueDto;
  sendMonthlyReportingEmail: boolean;
  cancelledReservations: AppNotificationSettingDto;
  reservationReminders: AppNotificationSettingDto;
  myPupUpdates: AppNotificationSettingDto;
  bringmeUpdates: AppNotificationSettingDto;
}

export interface GlobalNotificationSettingDto {
  appEnabled: boolean;
  dashboardEnabled: boolean;
  emailEnabled: boolean;
}

export interface GlobalNotificationSettingRequest {
  appEnabled?: boolean;
  dashboardEnabled?: boolean;
  emailEnabled?: boolean;
}

export interface GroupDto {
  name: string;
  type: CommunityGroupTypeDto;
  isMember: boolean;
  id: string;
}

export interface GroupNotificationSettingDto {
  groupId: string;
  groupName: string;
  type: CommunityGroupTypeDto;
  status: AppNotificationGroupSettingStatusDto;
}

export interface GroupNotificationSettingRequest {
  groupId: string;
  status: AppNotificationGroupSettingStatusDto;
}

export interface GroupRecentActivityDto {
  group: GroupWithImageDto;
  /** @format int32 */
  newPosts: number;
}

export interface GroupWithIconDto {
  /**
   * @format char
   * @minLength 1
   * @maxLength 1
   */
  iconChar?: string;
  icon: CommunityGroupIconDto;
  groupType: CommunityGroupType;
  name: string;
  type: CommunityGroupTypeDto;
  isMember: boolean;
  id: string;
}

export interface GroupWithImageDto {
  image?: ImageDto;
  name: string;
  type: CommunityGroupTypeDto;
  isMember: boolean;
  id: string;
}

export interface HeaderImageDto {
  imageUrl: string;
}

export interface HealthDistrictProjectConfigurationDto {
  enabled: boolean;
  baseUrl?: string;
  tokenUrl?: string;
  clientId?: string;
  clientSecret?: string;
  username?: string;
  password?: string;
  apiUserId?: string;
}

export interface HomeDnaProjectConfigurationDto {
  enabled: boolean;
  clientTenant?: string;
  clientSecret?: string;
  buyerGln?: string;
  buyerName?: string;
  contractorGln?: string;
  contractorName?: string;
}

export interface HomeDnaStatusDto {
  state: HomeDnaTicketStateDto;
  errorDetails?: string;
  /** @format date-time */
  plannedFrom?: string;
  /** @format date-time */
  plannedTo?: string;
}

export interface HubSpotProjectConfigurationDto {
  enabled: boolean;
  privateAppAccessToken?: string;
  syncCompaniesFromHubSpot: boolean;
  syncContactsFromHubSpot: boolean;
  syncContactsToHubSpot: boolean;
  registerContactMomentsToHubSpot: boolean;
  requesterUserId?: string;
  fallbackAddressId?: string;
  webhookUrl?: string;
}

export interface IBaseStreamChunk {
  chunkType: StreamedChunkType;
}

/** @format binary */
export type IFormFile = File;

export interface ILoqCredentialsDto {
  serviceAddress: string;
  customerCode: string;
  username: string;
  password?: string;
}

export interface ILoqKeyDto {
  status: ILoqKeyStatusDto;
  registrationData?: string;
  otp?: string;
  supportEmail?: string;
  supportPhone?: string;
  supportImage?: ImageDto;
}

export interface ILoqOptionDto {
  id: string;
  name: string;
}

export interface ILoqOptionsDto {
  realEstates: ILoqOptionDto[];
  zones: ILoqOptionDto[];
  securityAccesses: ILoqOptionDto[];
}

export interface ILoqProjectConfigurationDto {
  enabled: boolean;
  serviceAddress?: string;
  customerCode?: string;
  username?: string;
  password?: string;
  lockGroupId?: string;
  realEstateId?: string;
  zoneId?: string;
  securityAccessMappings: ILoqSecurityAccessMappingDto[];
  supportUserId?: string;
}

export interface ILoqSecurityAccessMappingDto {
  addressId: string;
  securityAccessIds: string[];
}

export interface ImageDto {
  /** @format uuid */
  publicId: string;
  description?: string;
  url: string;
  blurHash?: string;
  metadata: ImageMetadataDto;
  id: string;
}

export interface ImageMetadataDto {
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface InfoProjectDto {
  isSameProject: boolean;
  name: string;
  maintenance: string;
  owner: string;
  slug: string;
  city: string;
  id: string;
}

/** Instruction data that can include ACC, AFH, or GER status. */
export interface InstructionData {
  /** Instruction number. */
  instructionNumber: string;
  /** Status of the instruction. */
  status: Status;
  /** Appointment date and time information, applicable for AFH status. */
  appointmentDateTimeInformation?: AppointmentDateTimeInformation;
  /**
   * Date when the task is ready, applicable for GER status.
   * @format date
   */
  dateReady?: string;
  /** Free text description, applicable for GER status. */
  freeText?: string;
}

export interface IntegrationMappingDto {
  owner?: IntegrationPartnerDto;
  primaryExternalId?: string;
  secondaryExternalId?: string;
}

export interface IntegrationMappingRowRequest {
  /** @format int32 */
  rowNumber: number;
  entityId: string;
  primaryExternalId?: string;
  secondaryExternalId?: string;
  unlinkPrimary: boolean;
  unlinkSecondary: boolean;
}

export interface IntegrationReconciliationDatasetDto {
  dataType: IntegrationReconciliationDataTypeDto;
  rows: IntegrationReconciliationDatasetRowDto[];
}

export interface IntegrationReconciliationDatasetRowDto {
  entityId: string;
  displayName: string;
  location?: string;
  email?: string;
  primaryExternalId?: string;
  secondaryExternalId?: string;
  owner?: IntegrationPartnerDto;
}

export interface IntegrationReconciliationRequest {
  rows: IntegrationMappingRowRequest[];
}

export interface IntegrationReconciliationResultDto {
  runId?: string;
  applied: boolean;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  changedCount: number;
  /** @format int32 */
  unchangedCount: number;
  /** @format int32 */
  warningCount: number;
  /** @format int32 */
  failedCount: number;
  rows: IntegrationReconciliationResultRowDto[];
}

export interface IntegrationReconciliationResultRowDto {
  /** @format int32 */
  rowNumber: number;
  entityId: string;
  entityLabel: string;
  status: IntegrationReconciliationRowStatusDto;
  message?: string;
  primaryExternalId?: string;
  secondaryExternalId?: string;
}

export interface IntegrationReconciliationRunDto {
  id: string;
  dataType: IntegrationReconciliationDataTypeDto;
  origin: IntegrationReconciliationOriginDto;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  completedAt: string;
  initiatedBy?: string;
  /** @format int32 */
  totalCount: number;
  /** @format int32 */
  updatedCount: number;
  /** @format int32 */
  unchangedCount: number;
  /** @format int32 */
  warningCount: number;
  /** @format int32 */
  failedCount: number;
  rows: IntegrationReconciliationRunRowDto[];
}

export interface IntegrationReconciliationRunRowDto {
  /** @format int32 */
  rowNumber: number;
  entityId?: string;
  entityLabel: string;
  status: IntegrationReconciliationRowStatusDto;
  message?: string;
  primaryExternalId?: string;
  secondaryExternalId?: string;
}

export interface IntercomIdentityDto {
  hmac: string;
}

export interface IqbiProjectConfigurationDto {
  enabled: boolean;
  credentials?: string;
  locationUuid?: string;
}

/**
 * string JansenHuybregtsAppointmentOptionDto.SlotId identifies the stored Area of People option and is intentionally
 * independent from the Jansen Huybregts resource code.
 */
export interface JansenHuybregtsAppointmentOptionDto {
  slotId: string;
  /** @format date-time */
  start: string;
  /** @format date-time */
  end: string;
}

export interface JansenHuybregtsPlanningDto {
  planningId: string;
  state: JansenHuybregtsTicketStateDto;
  requiresManualFollowUp: boolean;
  errorDetails?: string;
  options: JansenHuybregtsAppointmentOptionDto[];
}

export interface JansenHuybregtsProjectConfigurationDto {
  enabled: boolean;
  baseUrl: string;
  apiKey: string;
  fallbackUserId: string;
  assigneeUserId?: string;
  requesterUserId?: string;
  ignoreCategories: boolean;
  statusMappings?: JansenHuybregtsTicketStatusMappingDto[];
}

export interface JansenHuybregtsAopTicketStatusOptionDto {
  id: string;
  label: string;
  color: string;
  defaultStatus: TicketStatusTypeDto;
}

export interface JansenHuybregtsExternalTicketStatusOptionDto {
  label: string;
  value: string;
}

export interface JansenHuybregtsTicketStatusMappingDto {
  externalStatus: string;
  ticketStatusId: string;
}

export interface JansenHuybregtsTicketStatusOptionsDto {
  externalStatuses: JansenHuybregtsExternalTicketStatusOptionDto[];
  aopStatuses: JansenHuybregtsAopTicketStatusOptionDto[];
}

/**
 * Signals to the resident apps whether they should call the Jansen Huybregts ticket
 * endpoint for this ticket (i.e. the ticket is part of the Jansen Huybregts flow).
 */
export interface JansenHuybregtsTicketFlagDto {
  enabled: boolean;
}

export interface JansenHuybregtsTicketStatusDto {
  ticketId: string;
  state: JansenHuybregtsTicketStateDto;
  externalCode?: string;
  requiresManualFollowUp: boolean;
  errorDetails?: string;
  /** @format date-time */
  selectedAppointmentStart?: string;
  /** @format date-time */
  selectedAppointmentEnd?: string;
  options: JansenHuybregtsAppointmentOptionDto[];
}

export type JsonElement = any;

export interface KeywordAlertConfigurationCreateRequest {
  keywords: string[];
  enabled: boolean;
  name: string;
  email?: string;
  projectIds: string[];
  alertNotificationType: AlertNotificationTypeDto;
}

export interface KeywordAlertConfigurationDto {
  keywords?: string;
  enabled: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: string;
  name: string;
  email: string;
  projects: SimpleProjectDto[];
  alertNotificationType: AlertNotificationTypeDto;
  id: string;
}

export interface LanguageDto {
  id: string;
  description: string;
  poEditorCode: string;
  previewText: string;
  introText: string;
  autoTranslationLanguageOnly: boolean;
}

export interface LastFeelingAtHomeScoreDto {
  /** @format double */
  rating: number;
  /** @format date-time */
  month: string;
}

export interface MaintenanceStatus {
  messageNumber?: string;
  messageDate?: string;
  messageTime?: string;
  buyer?: DicoParty;
  contractor?: DicoParty;
  instructionData?: DicoInstructionData;
}

export interface ManageReactionRequest {
  reactionType?: ReactionTypeDto;
}

export interface MassAddressAddressCreateRequest {
  projectId: string;
  buildingId: string;
  streetName: string;
  /** @format int32 */
  housenumber: number;
  housenumberSuffix?: string;
  postalCode: string;
  city: string;
  type?: string;
  floor?: string;
}

export interface MassAddressCreateRequest {
  addresses: MassAddressAddressCreateRequest[];
}

export interface MassMessageCreatedEntityDto {
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  projectCount: number;
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  addressCount?: number;
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  audienceResidentsCount: number;
  /** @format date-time */
  expectedFinishDateTime?: string;
  /** @format int32 */
  minutesExpectedToFinish: number;
  reach?: MassPostReachDto;
}

export interface MassPostReachDto {
  /** @format int32 */
  projectCount: number;
  /** @format int32 */
  addressCount: number;
  /** @format int32 */
  residentCount: number;
}

export interface McpOAuthAuthorizationServerMetadata {
  issuer: string;
  authorization_endpoint: string;
  token_endpoint: string;
  registration_endpoint: string;
  scopes_supported: string[];
  response_types_supported: string[];
  grant_types_supported: string[];
  code_challenge_methods_supported: string[];
  token_endpoint_auth_methods_supported: string[];
}

export interface McpOAuthClientRegistrationRequest {
  client_name?: string;
  redirect_uris?: string[];
  grant_types?: string[];
  response_types?: string[];
  scope?: string;
}

export interface McpOAuthClientRegistrationResponse {
  client_id: string;
  client_name: string;
  redirect_uris: string[];
  grant_types: string[];
  response_types: string[];
  scope: string;
  token_endpoint_auth_method: string;
}

export interface McpOAuthProtectedResourceMetadata {
  resource: string;
  authorization_servers: string[];
  scopes_supported: string[];
  bearer_methods_supported: string[];
}

export interface McpTokenCreateRequest {
  name?: string;
}

export interface McpTokenCreateResponse {
  /** @format int32 */
  tokenId: number;
  token: string;
  tokenPrefix: string;
  name: string;
  scope: string;
  /** @format date-time */
  createdAtUtc: string;
}

export interface McpTokenListItem {
  /** @format int32 */
  tokenId: number;
  tokenPrefix: string;
  name: string;
  scope: string;
  /** @format date-time */
  createdAtUtc: string;
  /** @format date-time */
  lastUsedAtUtc?: string;
  /** @format date-time */
  revokedAtUtc?: string;
}

export interface MentionDto {
  id: string;
  targetType: MentionTargetTypeDto;
  targetId?: string;
  text: string;
}

export interface MentionInputDto {
  id: string;
  targetType: MentionTargetTypeDto;
  targetId: string;
  text: string;
}

export interface MentionSuggestionDto {
  targetType: MentionTargetTypeDto;
  targetId: string;
  name: string;
  image?: ImageDto;
  subtitle?: string;
  /** @format int32 */
  eligibleMemberCount?: number;
}

export interface MessageCommentReactionDto {
  commentId: string;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  reactionType: ReactionTypeDto;
}

export interface MessageCreatedEntityDto {
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  addressCount?: number;
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  unknownAddressCount?: number;
  /**
   * Deprecated: Use Reach instead
   * @deprecated
   * @format int32
   */
  audienceResidentsCount?: number;
  reach?: PostReachDto;
  pollId?: string;
  eventId?: string;
  id: string;
}

export interface MessageCreateRequest {
  title: string;
  /**
   * Deprecated: Use ContentTemplate instead
   * @deprecated
   */
  content: string;
  contentTemplate?: string;
  mentions?: MentionInputDto[];
  /**
   * Deprecated: Use ImageIds instead
   * @deprecated
   * @format uuid
   */
  imageId?: string;
  documentIds?: string[];
  groupId?: string;
  projectConnectionId?: string;
  type: MessageTypeDto;
  isHiddenFromAdmins: boolean;
  /** @format date-time */
  scheduledFor?: string;
  messageLabel?: MessageLabelDto;
  relatedGroupId?: string;
  imageIds?: string[];
  videoIds?: string[];
  issueStatus?: IssueStatusDto;
  aiTemplateId?: string;
  isEmailPreviewOnly?: boolean;
  poll?: PollAttachmentCreateRequest;
  event?: CommunityPostEventCreateRequest;
}

export interface MessageDetailV1Dto {
  likes: MessageReactionDto[];
  title: string;
  content: string;
  images: ImageDto[];
  type: MessageTypeDto;
  /** @format int32 */
  totalLikeCount: number;
  author: UserDto;
  group?: GroupDto;
  projectConnection?: ProjectConnectionDto;
  hasCommented: boolean;
  canEdit: boolean;
  canLike: boolean;
  canComment: boolean;
  canReport: boolean;
  canShare: boolean;
  canArchive: boolean;
  canDelete: boolean;
  isHiddenFromAdmins: boolean;
  isUnread: boolean;
  isLiked: boolean;
  isMuted: boolean;
  hasAdminBeenInformed: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  reportedAt?: string;
  /** @format date-time */
  lastActivityAt?: string;
  /** @format date-time */
  scheduledAt?: string;
  /** @format date-time */
  postedAt?: string;
  /** @format date-time */
  modifiedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  archivedAt?: string;
  messageLabel?: MessageLabelDto;
  languageIsoCode: string;
  /** @format int32 */
  totalCommentCount: number;
  /** @format date-time */
  updatedAt?: string;
  id: string;
}

export interface MessageInformDto {
  informedBy: UserDto;
  informed: UserDto;
  /** @format date-time */
  createdAt: string;
}

export interface MessageInformRequest {
  /** Extra information on why the user is being informed */
  content: string;
  /** List of user IDs to inform; maximum of 25 users */
  adminsToInform: string[];
}

export interface MessageLabelsItemDto {
  /** @format int32 */
  askHelpCount: number;
  /** @format int32 */
  informCount: number;
  /** @format int32 */
  sellItemCount: number;
  isCurrentMonth: boolean;
  range: MonthlyReportDateRangeDto;
}

export interface MessageLabelsStatMonthlyDto {
  data: MessageLabelsItemDto[];
}

export interface MessageMultipleProjectsCreateRequest {
  title: string;
  content: string;
  imageIds?: string[];
  videoIds?: string[];
  documentIds?: string[];
  type: MessageTypeDto;
  systemGroupId?: string;
  /** @format date-time */
  scheduledFor?: string;
  messageLabel?: MessageLabelDto;
  projectSelected: string[];
  aiTemplateId?: string;
  isEmailPreviewOnly?: boolean;
  poll?: PollAttachmentCreateRequest;
}

export interface MessageReactionDto {
  messageId: string;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  reactionType: ReactionTypeDto;
}

export interface MessageReportRequest {
  reason: MessageReportReasonDto;
  description?: string;
}

export interface MessageSentimentDto {
  /** @format int32 */
  score?: number;
  /** @format int32 */
  outOf: number;
}

export interface MessageStatusChangeRequest {
  newStatus: MessageStatusDto;
  reason: ClosePostReasonDto;
  details?: string;
}

export interface MessageTopicsDto {
  topics: string[];
}

export interface MessageTranslationDto {
  title: string;
  content?: string;
  contentTemplate?: string;
  isAutoTranslated?: boolean;
}

export interface MessageUpdateRequest {
  title: string;
  documentIds?: string[];
  /**
   * Deprecated: Use ContentTemplate instead
   * @deprecated
   */
  content: string;
  contentTemplate?: string;
  mentions?: MentionInputDto[];
  /**
   * Deprecated: Use ImageIds instead
   * @deprecated
   * @format uuid
   */
  imageId?: string;
  /** @format date-time */
  scheduledAt?: string;
  imageIds?: string[];
  videoIds?: string[];
}

export interface MessageV1Dto {
  title: string;
  content: string;
  images: ImageDto[];
  type: MessageTypeDto;
  /** @format int32 */
  totalLikeCount: number;
  author: UserDto;
  group?: GroupDto;
  projectConnection?: ProjectConnectionDto;
  hasCommented: boolean;
  canEdit: boolean;
  canLike: boolean;
  canComment: boolean;
  canReport: boolean;
  canShare: boolean;
  canArchive: boolean;
  canDelete: boolean;
  isHiddenFromAdmins: boolean;
  isUnread: boolean;
  isLiked: boolean;
  isMuted: boolean;
  hasAdminBeenInformed: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  reportedAt?: string;
  /** @format date-time */
  lastActivityAt?: string;
  /** @format date-time */
  scheduledAt?: string;
  /** @format date-time */
  postedAt?: string;
  /** @format date-time */
  modifiedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  archivedAt?: string;
  messageLabel?: MessageLabelDto;
  languageIsoCode: string;
  /** @format int32 */
  totalCommentCount: number;
  /** @format date-time */
  updatedAt?: string;
  id: string;
}

export interface MessageEventDto {
  id: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  location?: string;
  allowsRegistration: boolean;
  canParticipate: boolean;
  isSignedUp: boolean;
}

export interface MessageV2Dto {
  event?: MessageEventDto;
  title: string;
  poll?: PollDto;
  content: string;
  contentTemplate?: string;
  mentions: MentionDto[];
  autoTranslation?: MessageTranslationDto;
  images: ImageDto[];
  type: MessageTypeDto;
  /** @format int32 */
  totalLikeCount: number;
  author: UserDto;
  group?: GroupDto;
  projectConnection?: ProjectConnectionDto;
  hasCommented: boolean;
  canEdit: boolean;
  canLike: boolean;
  canComment: boolean;
  canReport: boolean;
  canShare: boolean;
  canArchive: boolean;
  /**
   * Whether you can delete your own message. (Deprecated: Use CanDeleteOwn instead.)
   * @deprecated
   */
  canDelete: boolean;
  /** Whether you can delete your own message. */
  canDeleteOwn: boolean;
  /** Whether you can delete other users' messages. */
  canDeleteOther: boolean;
  isHiddenFromAdmins: boolean;
  isUnread: boolean;
  isLiked: boolean;
  isMuted: boolean;
  hasAdminBeenInformed: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  reportedAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  scheduledAt?: string;
  /** @format date-time */
  postedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: SimpleUserDto;
  /** @format date-time */
  archivedAt?: string;
  messageLabel?: MessageLabelDto;
  languageIsoCode: string;
  /** @format int32 */
  totalCommentCount: number;
  /** @format date-time */
  lastActivityAt?: string;
  documents: DocumentUploadDto[];
  videos: VideoDto[];
  issueStatus?: IssueStatusDto;
  /** The reference to the related group, in case the message is trying to promote a group. */
  relatedGroup?: RelatedGroupDto;
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  isInactivePost: boolean;
  /** @format int32 */
  uniqueViewCount?: number;
  viewTracked: boolean;
  bulkMessageId?: string;
  id: string;
}

export interface MonthlyReportDateRangeDto {
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  /** @format int32 */
  year: number;
  /** @format int32 */
  month: number;
}

export interface MyPupPayload {
  messageType?: string;
  message?: MyPupPayloadMessage;
}

export interface MyPupPayloadMessage {
  stateCode?: string;
  /** @format date-time */
  eventDate?: string;
  providerKey?: string;
  deeplink?: string;
}

export interface MyPupProjectConfigurationDto {
  enabled: boolean;
}

export interface NestedCommentDto {
  content?: string;
  contentTemplate?: string;
  mentions: MentionDto[];
  autoTranslation?: CommentTranslationDto;
  image?: ImageDto;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: SimpleUserDto;
  /** @format date-time */
  updatedAt?: string;
  hasLiked: boolean;
  /** @format int32 */
  totalLikesCount: number;
  hasReplied: boolean;
  /** @format int32 */
  totalRepliesCount: number;
  canEdit: boolean;
  /**
   * Whether you can delete your own comment. (Deprecated: Use CanDeleteOwn instead.)
   * @deprecated
   */
  canDelete: boolean;
  /** Whether you can delete your own comment. */
  canDeleteOwn: boolean;
  /** Whether you can delete other users' comments. */
  canDeleteOther: boolean;
  canLike: boolean;
  canReply: boolean;
  /**
   * Deprecated: Use LanguageIsoCode instead
   * @deprecated
   */
  languageId: string;
  languageIsoCode?: string;
  videos: VideoDto[];
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  isSolution: boolean;
  id: string;
}

export interface NotificationSettingsDto {
  ticketUnassignedUpdates: TicketCategoryNotificationSettingDto[];
  groups: GroupNotificationSettingDto[];
  myTicketStatusChange: AppNotificationSettingDto;
  myTicketNewComment: AppNotificationSettingDto;
  ticketAssignToMe: GlobalNotificationSettingDto;
  ticketAssignedCommentNew: GlobalNotificationSettingDto;
  generalMessageNew: GlobalNotificationSettingDto;
  newGeneralMessageInProjectConnection?: AppNotificationSettingDto;
  generalMessageCommentNew: GlobalNotificationSettingDto;
  newGeneralAnnouncement: AppNotificationSettingDto;
  newGeneralAnnouncementComments: AppNotificationSettingDto;
  eventNew: AppNotificationSettingDto;
  eventChange: AppNotificationSettingDto;
  eventReminder: AppNotificationSettingDto;
  chatNew: GlobalNotificationSettingDto;
  surveyNew: AppNotificationSettingDto;
  sendCommunitySummaryEmailInterval: NotificationTimedValueDto;
  sendMonthlyReportingEmail: boolean;
  cancelledReservations: AppNotificationSettingDto;
  reservationReminders: AppNotificationSettingDto;
  myPupUpdates: AppNotificationSettingDto;
  bringmeUpdates: AppNotificationSettingDto;
}

export interface NotificationSettingsRequest {
  myTicketStatusChange?: AppNotificationSettingRequest;
  myTicketNewComment?: AppNotificationSettingRequest;
  ticketUnassignedUpdates?: TicketCategoryNotificationSettingRequest[];
  newGeneralMessageInProjectConnection?: AppNotificationSettingRequest;
  newGeneralAnnouncement?: AppNotificationSettingRequest;
  newGeneralAnnouncementComments?: AppNotificationSettingRequest;
  groups?: GroupNotificationSettingRequest[];
  eventNew?: AppNotificationSettingRequest;
  eventChange?: AppNotificationSettingRequest;
  eventReminder?: AppNotificationSettingRequest;
  newChatMessageDashboardSound?: GlobalNotificationSettingRequest;
  surveyNew?: AppNotificationSettingRequest;
  cancelledReservations?: AppNotificationSettingRequest;
  reservationReminders?: AppNotificationSettingRequest;
  myPupUpdates?: AppNotificationSettingRequest;
  bringmeUpdates?: AppNotificationSettingRequest;
  applyToAllProjects: boolean;
  generalMessageNew?: GlobalNotificationSettingRequest;
  generalMessageCommentNew?: GlobalNotificationSettingRequest;
  ticketAssignToMe?: GlobalNotificationSettingRequest;
  ticketAssignedCommentNew?: GlobalNotificationSettingRequest;
  chatNew?: GlobalNotificationSettingRequest;
  sendCommunitySummaryEmailInterval?: NotificationTimedValueDto;
  sendMonthlyReportingEmail?: boolean;
}

export interface OfferedAnswerDto {
  text: string;
  subtitle?: string;
  id: string;
}

export interface OfficeRndAddressMappingDto {
  prefix: string;
  addressId: string;
}

export interface OfficeRndProjectConfigurationDto {
  enabled: boolean;
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;
  requesterUserId?: string;
  /** @format date-time */
  initialImportStartDate?: string;
  fallbackAddressId?: string;
  addressMappings: OfficeRndAddressMappingDto[];
  /** @default false */
  dryRunEnabled: boolean;
}

export interface OnboardingScreenCreateRequest {
  title: string;
  subtitle: string;
  /** @format uuid */
  imageId: string;
}

export interface OnboardingScreenDto {
  id: string;
  title: string;
  subtitle?: string;
  image: ImageDto;
}

export interface OnboardingScreenEditRequest {
  title: string;
  subtitle: string;
  /** @format uuid */
  imageId: string;
}

export interface OutlookProjectConfigurationDto {
  enabled: boolean;
  tenantId?: string;
  clientId?: string;
  clientSecret?: string;
  baseUrl?: string;
}

export interface JimProjectConfigurationDto {
  enabled: boolean;
  username?: string;
  password?: string;
  baseUrl?: string;
  hasPassword: boolean;
}

export interface JimRoomDto {
  id: string;
  name: string;
  /** @format int32 */
  capacity?: number;
}

export interface JimConnectionTestDto {
  success: boolean;
  message?: string;
}

export interface AddressDtoPaginationResultDto {
  items: AddressDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AdminNotificationDtoPaginationResultDto {
  items: AdminNotificationDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AdminTicketActivityDtoPaginationResultDto {
  items: AdminTicketActivityDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AdminTicketDetailedListItemDtoPaginationResultDto {
  items: AdminTicketDetailedListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AdminTicketListItemDtoPaginationResultDto {
  items: AdminTicketListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AppTicketDtoPaginationResultDto {
  items: AppTicketDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AssetBookingDtoPaginationResultDto {
  items: AssetBookingDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AssistantConversationListItemDtoPaginationResultDto {
  items: AssistantConversationListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AssistantConversationMessageDtoPaginationResultDto {
  items: AssistantConversationMessageDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AssistantRunListItemDtoPaginationResultDto {
  items: AssistantRunListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AutomatedSurveyDtoPaginationResultDto {
  items: AutomatedSurveyDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AutomatedSurveyQueueDetailsListDtoPaginationResultDto {
  items: AutomatedSurveyQueueDetailsListDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface AutomatedSurveyQueueDtoPaginationResultDto {
  items: AutomatedSurveyQueueDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface BookableAssetDtoPaginationResultDto {
  items: BookableAssetDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface BuildingDtoPaginationResultDto {
  items: BuildingDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CommentDtoPaginationResultDto {
  items: CommentDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CommunityFeedItemV1DtoPaginationResultDto {
  items: CommunityFeedItemV1Dto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CommunityGroupDtoPaginationResultDto {
  items: CommunityGroupDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CompanyDtoPaginationResultDto {
  items: CompanyDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ConstraintListItemDtoPaginationResultDto {
  items: ConstraintListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface DocumentsItemDTOPaginationResultDto {
  items: DocumentsItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface EventDtoPaginationResultDto {
  items: EventDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface EventParticipantCandidateDtoPaginationResultDto {
  items: EventParticipantCandidateDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface EventParticipantDtoPaginationResultDto {
  items: EventParticipantDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface GenericAlertTriggeredDtoPaginationResultDto {
  items: GenericAlertTriggeredDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface MessageCommentReactionDtoPaginationResultDto {
  items: MessageCommentReactionDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface MessageInformDtoPaginationResultDto {
  items: MessageInformDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface MessageReactionDtoPaginationResultDto {
  items: MessageReactionDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface MessageV1DtoPaginationResultDto {
  items: MessageV1Dto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface OnboardingScreenDtoPaginationResultDto {
  items: OnboardingScreenDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PollDtoPaginationResultDto {
  items: PollDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PortfolioAdminTicketDtoPaginationResultDto {
  items: PortfolioAdminTicketDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ProjectConnectionDetailsDtoPaginationResultDto {
  items: ProjectConnectionDetailsDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ProjectConnectionGroupDtoPaginationResultDto {
  items: ProjectConnectionGroupDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ProjectOverviewItemDtoPaginationResultDto {
  items: ProjectOverviewItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface QuestionGroupAnswerDtoPaginationResultDto {
  items: QuestionGroupAnswerDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ResidentNotificationDtoPaginationResultDto {
  items: ResidentNotificationDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface SimpleProjectDtoPaginationResultDto {
  items: SimpleProjectDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface SurveyDtoPaginationResultDto {
  items: SurveyDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface SystemGroupDtoPaginationResultDto {
  items: SystemGroupDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface TicketCategoryDtoPaginationResultDto {
  items: TicketCategoryDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface TicketCommentDtoPaginationResultDto {
  items: TicketCommentDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface TicketStatusDetailsDtoPaginationResultDto {
  items: TicketStatusDetailsDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface UserDtoPaginationResultDto {
  items: UserDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface UserExtendedDtoPaginationResultDto {
  items: UserExtendedDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface UserListItemDtoPaginationResultDto {
  items: UserListItemDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface UserLookupDtoPaginationResultDto {
  items: UserLookupDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface UserWithAudienceDtoPaginationResultDto {
  items: UserWithAudienceDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PartnerCategoriesDto {
  id: PartnerCategoryDto;
  name: string;
}

/** Message creation request for partner integrations. */
export interface PartnerMessageCreateRequest {
  /** The project the message should be posted in */
  projectId: string;
  /** The title of the message */
  title: string;
  /** The content/body of the message */
  content: string;
  /** The group ID to post the message to (optional) */
  groupId?: string;
  /** Whether the post allows users to comment on it (optional) */
  disableComments?: boolean;
  /**
   * Whether the post is an announcement; if this is set to false, DisableComments is ignored
   * @default true
   */
  announcement?: boolean;
  /** A list of images to attach to the message (optional) */
  imageIds?: string[];
  /**
   * Date/time to schedule the message for future publishing (optional)
   * @format date-time
   */
  scheduledFor?: string;
}

/** Represents a party involved in the transaction. */
export interface Party {
  /** Global Location Number of the party. */
  gln: string;
}

export interface PollAnswersResultsDto {
  /** @format int32 */
  totalVoters: number;
  pollResults: PollResultDto[];
}

export interface PollAnswerUpdateRequest {
  id: string;
  text: string;
}

export interface PollAttachmentCreateRequest {
  allowMultipleAnswers: boolean;
  /** @format date-time */
  endsAt: string;
  question: string;
  answers: string[];
}

export interface PollCreatedEntityDto {
  reach?: PostReachDto;
  messageId?: string;
  id: string;
}

export interface PollCreateRequest {
  title: string;
  description: string;
  /** @format uuid */
  imageId?: string;
  documentIds?: string[];
  videoIds?: string[];
  hideFromPropertyManager: boolean;
  allowMultipleAnswers: boolean;
  /** @format date-time */
  endsAt: string;
  question: string;
  answers: string[];
  groupId?: string;
  projectConnectionId?: string;
  imageIds?: string[];
  messageLabel?: MessageLabelDto;
  type: MessageTypeDto;
  isEmailPreviewOnly?: boolean;
  aiTemplateId?: string;
  /** @format date-time */
  scheduledFor?: string;
}

export interface PollDto {
  title: string;
  description: string;
  languageIsoCode?: string;
  autoTranslation?: PollTranslationDto;
  type: MessageTypeDto;
  images: ImageDto[];
  videos: VideoDto[];
  /** @format date-time */
  createdAt: string;
  createdBy: UserDto;
  /** @format date-time */
  communityFeedDate: string;
  /** @format date-time */
  postedAt: string;
  /** @format date-time */
  scheduledAt?: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  group?: GroupDto;
  projectConnection?: ProjectConnectionDto;
  isUnread: boolean;
  canSeeResults: boolean;
  question: string;
  answers: OfferedAnswerDto[];
  allowMultipleAnswers: boolean;
  /**
   * CanRespond states the status of the poll for the current user.
   * e.g. this property returns Ended if the poll has ended, even if the user has already answered.
   */
  canRespond: CanRespondStatusDto;
  canEdit: boolean;
  /**
   * Deprecated: Use CanDeleteOwn instead.
   * @deprecated
   */
  canDelete: boolean;
  canDeleteOwn: boolean;
  canDeleteOther: boolean;
  isHiddenFromAdmins: boolean;
  userResponse?: UserPollResponseDto;
  results?: PollResultDto[];
  documents?: DocumentUploadDto[];
  viewTracked: boolean;
  messageId?: string;
  /** @format int32 */
  totalCommentCount: number;
  canComment: boolean;
  canLike: boolean;
  canShare: boolean;
  /** @format date-time */
  lastActivityAt: string;
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  id: string;
}

export interface PollResultDto {
  answer: OfferedAnswerDto;
  /** @format int32 */
  count: number;
  hasWon: boolean;
  voters: UserDto[];
}

export interface PollTranslationDto {
  title: string;
  description: string;
  question: string;
  answers: OfferedAnswerDto[];
  results?: PollResultDto[];
  isAutoTranslated: boolean;
}

export interface PollUpdateRequest {
  title: string;
  description: string;
  documentIds?: string[];
  videoIds?: string[];
  /** @format uuid */
  imageId?: string;
  question: string;
  answers: PollAnswerUpdateRequest[];
  imageIds?: string[];
  /** @format date-time */
  scheduledAt?: string;
}

export interface PortfolioAdminTicketDto {
  project: SimpleProjectDto;
  /** @format date-time */
  createdAt: string;
  title: string;
  locatedAt?: string;
  user: UserDto;
  category: BaseTicketCategoryDto;
  status: TicketStatusDto;
  assignee?: UserDto;
  /** @format date-time */
  remindAt?: string;
  /** @format int32 */
  activityCount: number;
  hasUnreadActivity: boolean;
  visibility: TicketVisibilityDto;
  /** @format date-time */
  lastActivityAt: string;
  lastActivityBy?: UserDto;
  /** @format date-time */
  closedAt?: string;
  closedBy?: UserDto;
  /** @format int32 */
  rating?: number;
  canChangeStatus: boolean;
  canDelete: boolean;
  integrations: Record<string, TicketIntegrationStatusSummaryDto>;
  id: string;
}

export interface PortfolioAiProjectConfigurationDto {
  projectId: string;
  configuration: CopilotPromptConfigurationsDto;
}

export interface PortfolioBookingAnalyticsDto {
  summary: BookingAnalyticsSummaryDto;
  monthly: BookingAnalyticsMonthlyPointDto[];
  audienceScopes: BookingAnalyticsAudienceScopeDto[];
  durationDistribution: BookingAnalyticsDistributionPointDto[];
  weekdayDistribution: BookingAnalyticsDistributionPointDto[];
  timeOfDayDistribution: BookingAnalyticsDistributionPointDto[];
  bookerDistribution: BookingAnalyticsDistributionPointDto[];
  originCounts: BookingAnalyticsOriginCountsDto;
}

export interface PortfolioBookingAnalyticsRequestDto {
  projectIds: string[];
  dateRange: DateRangeDto;
  status?: BookingAnalyticsStatusDto;
  origin?: BookingAnalyticsOriginDto;
}

export interface PortfolioCommunityFeedReportingRequestDto {
  projectIds: string[];
  dateRange: DateRangeDto;
  authorType?: CommunityFeedAnalyticsAuthorTypeDto;
  contentType?: CommunityFeedAnalyticsContentTypeDto;
  groupId?: string;
  origin?: CommunityFeedAnalyticsOriginDto;
  status?: CommunityFeedAnalyticsStatusDto;
}

export interface PortfolioEventAnalyticsDto {
  eventTypeCounts: EventAnalyticsTypeCountsDto;
  originCounts: EventAnalyticsOriginCountsDto;
  summary: EventAnalyticsSummaryDto;
  monthly: EventAnalyticsMonthlyPointDto[];
  audienceScopes: EventAnalyticsAudienceScopeDto[];
  organizerActivity: EventAnalyticsOrganizerPointDto[];
  registrationSizes: EventAnalyticsChartPointDto[];
  registrationLeadTimes: EventAnalyticsChartPointDto[];
  capacity: EventAnalyticsCapacityDto;
  recurring: PortfolioEventAnalyticsRecurringDto;
}

export interface PortfolioEventAnalyticsRecurringDto {
  /** @format int32 */
  seriesCount: number;
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  registrations: number;
}

export interface PortfolioEventAnalyticsRequestDto {
  projectIds: string[];
  dateRange: DateRangeDto;
  eventType: EventAnalyticsEventTypeDto;
  origin?: EventAnalyticsOriginDto;
  category?: EventCategoryTypeDto;
  status?: EventAnalyticsStatusDto;
}

export interface PortfolioExportFilter {
  projectIds: string[];
}

export interface PortfolioILoqProjectConfigurationDto {
  projectId: string;
  canManage: boolean;
  configuration: ILoqProjectConfigurationDto;
}

export interface PortfolioMinimalTicketDto {
  ticketId: string;
  projectId: string;
}

export interface PortfolioPermissionsDto {
  canMassMessageAnnouncementPost: boolean;
  canMassMessageGeneralPost: boolean;
  canMassSurvey: boolean;
  canMassCreateAddresses: boolean;
  canInviteAdmins: boolean;
  canCreateChat: boolean;
}

export interface PortfolioRemsProjectConfigurationDto {
  projectId: string;
  canManage: boolean;
  configuration: RemsProjectConfigurationDto;
}

export interface PortfolioTicketAnalyticsDto {
  summary: TicketAnalyticsSummaryDto;
  monthly: TicketAnalyticsMonthlyPointDto[];
  benchmark: TicketAnalyticsBenchmarkPointDto[];
  categories: TicketAnalyticsCategoryDto[];
  backlogAgeBuckets: TicketAnalyticsDistributionPointDto[];
  resolutionBuckets: TicketAnalyticsDistributionPointDto[];
  visibilityDistribution: TicketAnalyticsDistributionPointDto[];
  filterOptions: TicketAnalyticsFilterOptionsDto;
}

export interface PortfolioTicketAnalyticsRequestDto {
  projectIds: string[];
  dateRange: DateRangeDto;
  categoryId?: string;
  status?: TicketAnalyticsStatusDto;
  visibility?: TicketAnalyticsVisibilityDto;
}

export interface PortfolioTicketAssigneeFilterOptionDto {
  accountId: string;
  fullName: string;
  email: string;
  isCurrentAccount: boolean;
}

export interface PortfolioTicketFilterOptionsDto {
  statuses: PortfolioTicketStatusFilterOptionDto[];
  categories: string[];
  assignees: PortfolioTicketAssigneeFilterOptionDto[];
}

export interface PortfolioTicketStatusFilterOptionDto {
  key: string;
  name: string;
  color?: string;
}

export interface PostReachDto {
  /** @format int32 */
  addressCount: number;
  /** @format int32 */
  residentCount: number;
}

export interface PostTemplateDto {
  id: string;
  name: string;
  description?: string;
  prompt: string;
  category: string;
  postType: MessageTypeDto;
}

/** Request model for processing ACC, AFH, or GER status. */
export interface ProcessRequest {
  /** Buyer information. */
  buyer: Party;
  /** Contractor information. */
  contractor: Party;
  /** Instruction data. */
  instructionData: InstructionData;
}

export interface ProjectApiAccessConfigurationDto {
  enabled: boolean;
  apiUserId?: string;
  apiKey?: string;
}

export interface ProjectBuildingDto {
  projectId: string;
  projectName: string;
  name: string;
  id: string;
}

export interface ProjectConnectionCreateRequest {
  projectIds: string[];
  name: string;
  content?: string;
  contentTranslations: TranslationRequest[];
  description?: string;
  /** @format uuid */
  backgroundImageId: string;
}

export interface ProjectConnectionDetailsDto {
  backgroundImage?: ImageDto;
  content: string;
  contentTranslations: TranslationsDto[];
  originalLanguageId: LanguageIdDto;
  internalDescription: string;
  projects: ProjectConnectionProjectDto[];
  canJoin: boolean;
  isJoined: boolean;
  groups?: ProjectConnectionGroupDtoPaginationResultDto;
  name: string;
  id: string;
}

export interface ProjectConnectionDto {
  name: string;
  id: string;
}

export interface ProjectConnectionEditRequest {
  name: string;
  content?: string;
  contentTranslations: TranslationRequest[];
  description?: string;
  /** @format uuid */
  backgroundImageId: string;
}

export interface ProjectConnectionGroupCreateRequest {
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  name?: string;
  description?: string;
  translations?: SystemGroupTranslationDto[];
  /** @format uuid */
  imageId: string;
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface ProjectConnectionGroupDetailDto {
  id: string;
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  name: string;
  description: string;
  originalLanguageId: LanguageIdDto;
  translations?: SystemGroupTranslationDto[];
  image: ImageDto;
  projectConnectionId: string;
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface ProjectConnectionGroupDto {
  name: string;
  description: string;
  projectConnectionId: string;
  id: string;
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  translations?: SystemGroupTranslationDto[];
  image: ImageDto;
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface ProjectConnectionGroupUpdateRequest {
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  name?: string;
  description?: string;
  translations?: SystemGroupTranslationDto[];
  /** @format uuid */
  imageId: string;
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface ProjectConnectionProjectDto {
  name: string;
  baseLanguageId: LanguageIdDto;
  id: string;
}

export interface ProjectConnectionUserPrivacySettingsRequest {
  showAvatar?: boolean;
}

export interface ProjectConnectionUserSettingsRequest {
  showConnectionsInCommunityFeed?: boolean;
  showConnectionsInEvents?: boolean;
  showConnectionsInServices?: boolean;
}

export interface ProjectCreateRequest {
  name: string;
  city: string;
  owner: string;
  maintenance: string;
  languageId: LanguageIdDto;
  projectType: ProjectTypeDto;
  appBranding: AppBrandingDto;
  cloneProjectId?: string;
  developmentType: DevelopmentTypeDto;
  brandedAppPrompt?: BrandedAppPromptDto;
  allowHidePostForAdmin?: boolean;
  hideYoutubeLinksInInvitationEmails?: boolean;
}

export interface ProjectDetailedDto {
  city: string;
  languageId: LanguageIdDto;
  type: ProjectTypeDto;
  appBranding: AppBrandingDto;
  brandedAppPrompt?: BrandedAppPromptDto;
  logo: ImageDto;
  logoLight?: ImageDto;
  backgroundImage?: ImageDto;
  splashScreenBackground?: ImageDto;
  styling: ProjectStylingDto;
  useBackgroundImageForSplashScreen: boolean;
  selectedSplashScreenLogo: SelectedSplashScreenLogoDto;
  isZiezodan: boolean;
  activeState: ProjectActiveStateDto;
  developmentType: DevelopmentTypeDto;
  codeOfConduct: CodeOfConductDocumentDto;
  allowHidePostForAdmin: boolean;
  hideYoutubeLinksInInvitationEmails: boolean;
  housemateInvitesEnabled: boolean;
  name: string;
  maintenance: string;
  owner: string;
  slug: string;
  id: string;
}

export interface ProjectEditRequest {
  name: string;
  /** @maxLength 64 */
  slug?: string;
  city: string;
  owner: string;
  maintenance: string;
  projectType: ProjectTypeDto;
  appBranding: AppBrandingDto;
  activeState?: ProjectActiveStateDto;
  developmentType: DevelopmentTypeDto;
  customCodeOfConductId?: string;
  brandedAppPrompt?: BrandedAppPromptDto;
  allowHidePostForAdmin?: boolean;
  hideYoutubeLinksInInvitationEmails?: boolean;
  housemateInvitesEnabled?: boolean;
}

export interface ProjectEngagementBenchmarkItemDto {
  /** @format double */
  engagedResidentPercentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface ProjectEngagementItemDto {
  /** @format double */
  engagedResidentPercentage: number;
  /** @format int32 */
  postCount: number;
  /** @format int32 */
  commentCount: number;
  /** @format int32 */
  likeCount: number;
  /** @format int32 */
  commentLikeCount: number;
  /** @format int32 */
  collectiveTicketCount: number;
  /** @format int32 */
  eventCount: number;
  /** @format int32 */
  surveyCount: number;
  /** @format int32 */
  pollCount: number;
  /** @format int32 */
  reservationCount: number;
  range: MonthlyReportDateRangeDto;
}

export interface ProjectOverviewItemDto {
  name: string;
  city: string;
  owner: string;
  maintenance: string;
  logoUrl: string;
  slug: string;
  logo?: ImageDto;
  backgroundImageUrl?: string;
  backgroundImage?: ImageDto;
  type: ProjectTypeDto;
  /** @format date-time */
  createdAt: string;
  stats?: ProjectStatsDto;
  previousStats?: ProjectStatsDto;
  /** These statistics are generated once per 24 hours. */
  liveStats?: ProjectStatsDto;
  userRoleType: UserRoleTypeDto;
  activeState: ProjectActiveStateDto;
  id: string;
}

export interface ProjectStatsDto {
  /** @format date-time */
  from: string;
  /** @format double */
  engagedResidentPercentage?: number;
  /** @format double */
  adoptionPercentage?: number;
  /** @format double */
  averageTicketRating?: number;
  /** @format double */
  feelingAtHomeAverageRatingAllTime?: number;
}

export interface ProjectStylingDto {
  /** Page header background color */
  tintColor: string;
  /** The color of the text on the page header (when the page header goes transparent after scroll?) */
  textLightColor: string;
  /** Button color */
  navigationColor: string;
  /** Main background color */
  backgroundColor: string;
  /** Unread dots color */
  dangerColor: string;
  /** Body text color */
  textDarkColor: string;
  /** Title text color */
  textHeadersColor: string;
  /** The color of the text on the page header (when not scrolled?) */
  pageTitleUnscrolledColor: string;
}

export interface ProjectStylingRequest {
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  color1: string;
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  color2: string;
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  color3: string;
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  pageTitleUnscrolledColor: string;
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  backgroundColor: string;
  /** @format uuid */
  imageLogoDarkId?: string;
  /** @format uuid */
  imageLogoLightId?: string;
  /** @format uuid */
  backgroundImageId?: string;
  /** @format uuid */
  splashScreenBackgroundId?: string;
  useBackgroundImageForSplashScreen: boolean;
  selectedSplashScreenLogo: SelectedSplashScreenLogoDto;
}

export interface ProjectSummaryDto {
  communitySummary: string;
  /** @format int32 */
  sentiment: number;
  hashtags: string[];
}

export interface ProjectsWhereUserCanInviteResultDto {
  projects: SimpleProjectDto[];
}

export interface PublicBrandedAppAgreementRequestDto {
  brand: AppBrandingDto;
  appName: string;
  ownerName: string;
  logoImageUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
  stores: BrandedAppStoreDto[];
  /** @format date-time */
  requestedAt: string;
  /** @format date-time */
  confirmedAt?: string;
}

export interface QuestionDto {
  type: QuestionTypeDto;
  question: string;
  description?: string;
  /** @format int32 */
  sorting: number;
  answers?: OfferedAnswerDto[];
  responses?: ResponseDto[];
  useForAnalysis: boolean;
  id: string;
}

export interface QuestionGroupAnswerDto {
  userName?: string;
  /** @format int32 */
  rating: number;
  openAnswerText?: string;
  /** @format date-time */
  date?: string;
}

export interface QuestionGroupDto {
  translations: QuestionGroupTranslationDto[];
  type: QuestionGroupTypeDto;
  /** @format int32 */
  order: number;
  id: string;
}

export interface QuestionGroupEditRequest {
  id?: string;
  ratingQuestionTemplate?: string;
  openQuestionTemplate?: string;
  explanation?: string;
  ratingQuestionTemplateTranslations: TranslationRequest[];
  openQuestionTemplateTranslations?: TranslationRequest[];
  explanationTranslations?: TranslationRequest[];
  type: QuestionGroupTypeDto;
  /** @format int32 */
  order: number;
}

export interface QuestionGroupRequest {
  ratingQuestionTemplate?: string;
  openQuestionTemplate?: string;
  explanation?: string;
  ratingQuestionTemplateTranslations: TranslationRequest[];
  openQuestionTemplateTranslations?: TranslationRequest[];
  explanationTranslations?: TranslationRequest[];
  type: QuestionGroupTypeDto;
  /** @format int32 */
  order: number;
}

export interface QuestionGroupTranslationDto {
  languageId: LanguageIdDto;
  ratingQuestionTemplate: string;
  openQuestionTemplate: string;
  explanation: string;
}

export interface QuestionRequest {
  question: string;
}

export interface RankingAnswerItem {
  answerId: string;
  /** @format int32 */
  sort: number;
}

export interface RateMessageDto {
  rating: AiResponseRatingDto;
  comment?: string;
}

export interface RecentActivityAnnouncementDto {
  type: CommunityFeedItemTypeDto;
  /** @format date-time */
  postedAt: string;
  message?: RecentActivityMessageAnnouncementDto;
  poll?: RecentActivityPollAnnouncementDto;
}

export interface RecentActivityDto {
  /** @format int32 */
  newAnnouncements: number;
  /** @format int32 */
  newPostsInGroups: number;
  announcements: RecentActivityAnnouncementDto[];
  recentPostsInGroups: GroupRecentActivityDto[];
  surveys: SimpleSurveyDto[];
}

export interface RecentActivityMessageAnnouncementDto {
  id: string;
  title: string;
  content: string;
}

export interface RecentActivityPollAnnouncementDto {
  id: string;
  title: string;
  description: string;
}

export interface RegisterEventParticipantRequest {
  userId: string;
  /**
   * @format int32
   * @default 0
   */
  guestCount: number;
}

export interface RelatedGroupDto {
  description: string;
  isOwner: boolean;
  isResidentGroup: boolean;
  image?: ImageDto;
  name: string;
  type: CommunityGroupTypeDto;
  isMember: boolean;
  id: string;
}

export interface ReminderStatusDto {
  canBeReminded: boolean;
  recentlyInvited: boolean;
  reminders: SignupReminderDto[];
}

export interface RemsBuildingComplexCodeDto {
  buildingId: string;
  complexCode?: string;
}

export interface RemsContractDto {
  id: string;
  description: string;
}

export interface RemsContractsProjectConfigurationDto {
  enabled: boolean;
  syncContacts: boolean;
}

export interface RemsContractsProjectConfigurationRequest {
  enabled: boolean;
  syncContacts: boolean;
}

export interface RemsProjectConfigurationDto {
  tickets: RemsTicketsProjectConfigurationDto;
  contracts: RemsContractsProjectConfigurationDto;
  tenantId: string;
  communityUserContactId: string;
  communityUserRelationId: string;
  complexCode?: string;
  buildingComplexCodes: RemsBuildingComplexCodeDto[];
}

export interface RemsProjectConfigurationRequest {
  tickets: RemsTicketsProjectConfigurationRequest;
  contracts: RemsContractsProjectConfigurationRequest;
  tenantId?: string;
  communityUserContactId?: string;
  communityUserRelationId?: string;
  complexCode?: string;
  buildingComplexCodes?: RemsBuildingComplexCodeDto[];
}

export interface RemsStatusDto {
  state: RemsTicketStateDto;
  errorDetails?: string;
  externalId?: string;
  version: RemsVersionDto;
  contracts: RemsContractDto[];
}

export interface RemsSyncRequest {
  contractId?: string;
  sendAsCollective: boolean;
}

export interface RemsTicketsProjectConfigurationDto {
  enabled: boolean;
  syncClosedStatus: boolean;
  sendTicketUpdates: boolean;
  autoSendTickets: boolean;
  defectCode: string;
}

export interface RemsTicketsProjectConfigurationRequest {
  enabled: boolean;
  syncClosedStatus: boolean;
  sendTicketUpdates: boolean;
  autoSendTickets: boolean;
  defectCode?: string;
}

export interface RenterLocoiaDto {
  /** The Id which is tracked by the external system. This Id is used to identify the renter. This Id is unique and should never change. */
  id: string;
  /** Required if initial is empty */
  firstName?: string;
  /** Required if FirstName is empty */
  initial?: string;
  lastName: string;
  email: string;
}

export interface RenterWoonbedrijfDto {
  /** The Id which is tracked by the external system. This Id is used to identify the renter. This Id is unique and should never change. */
  id: string;
  /** Required if initial is empty */
  firstName?: string;
  /** Required if FirstName is empty */
  initial?: string;
  lastName: string;
  email: string;
}

export interface ResidentEngagementDto {
  period: BenchmarkPeriodDto;
  engagements: ResidentTimeEngagementDto[];
}

export interface ResidentEngagementMonthlyDto {
  /** @format double */
  percentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface ResidentGroupCreateRequest {
  name: string;
  description: string;
  /** @format uuid */
  imageId: string;
}

export interface ResidentGroupEditRequest {
  name: string;
  description: string;
  /** @format uuid */
  imageId: string;
}

export interface ResidentNotificationDto {
  entityId: string;
  /** For special cases where two ids are needed to identify the entity. For example; the booking of an asset. */
  subEntityId?: string;
  content: string;
  notificationType: DashboardNotificationEntityTypeDto;
  poster: UserDto;
  /** @format date-time */
  posted: string;
  /** Backwards-compatible read state derived from DateTime? ResidentNotificationDto.ReadAt. */
  read: boolean;
  /**
   * UTC date the notification was first marked as read; omitted when unread.
   * @format date-time
   */
  readAt?: string;
  /** Only used for MyPup integration for now, it's a web link to a details screen in MyPup (e.g. a specific package) */
  deepLink?: string;
  /**
   * Content of the message or comment (limited to 24 chars, 25 chars with ...)
   * Only populated when Action = PostDeleted | CommentDeleted
   */
  entityTitle?: string;
  id: string;
}

export interface ResidentTimeEngagementDto {
  /** @format double */
  engagementPercentage: number;
  /** @format int32 */
  engagementCount: number;
  /** @format double */
  benchmarkEngagementPercentage: number;
  type: ResidentTimeEngagementTypeDto;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
}

export interface ResponseDto {
  id: string;
  respondent: UserDto;
  /** @format int32 */
  rating?: number;
  text?: string;
  offeredAnswerId?: string;
  pollAnswer?: boolean;
}

export interface ResponsibilitySuggestionRatingRequest {
  rating: ResponsibilitySuggestionRatingDto;
}

export interface SelectAppointmentRequest {
  slotId: string;
}

export interface SelectJansenHuybregtsAppointmentRequest {
  slotId: string;
}

export interface SelfAddressDto {
  /**
   * Deprecated: Use PostalCode instead
   * @deprecated
   */
  zipCode: string;
  location: string;
  city: string;
  postalCode: string;
  building: AddressBuildingDto;
  id: string;
}

export interface SelfCompanyDto {
  name: string;
  building: AddressBuildingDto;
  id: string;
}

export interface SelfConnectedProjectSettingsDto {
  showLastName: boolean;
  showAvatar: boolean;
  hasCommunityBanner: boolean;
  showConnectionInCommunityFeed: boolean;
  showConnectionInEvents: boolean;
  showConnectionInServices: boolean;
}

export interface SelfDeleteRequest {
  reason: SelfDeleteReasonDto;
  details?: string;
}

export interface SelfDto {
  isOnlyAllowedToViewAssignedOrOwnTickets: boolean;
  email: string;
  /**
   * Deprecated: Use UiLanguage or AutoTranslationLanguage instead
   * @deprecated
   */
  language: LanguageDto;
  /** Language for static UI text translated through POEditor. */
  uiLanguage: LanguageDto;
  /** Language used for dynamic auto translations. Null disables automatic translation. */
  autoTranslationLanguage?: LanguageDto;
  role: SelfUserRoleDto;
  project: SelfProjectDto;
  address?: SelfAddressDto;
  company?: SelfCompanyDto;
  /** @format date-time */
  onboardedAt?: string;
  /** @format date-time */
  codeOfConductAgreedAt?: string;
  codeOfConduct: DocumentDto;
  splashScreenLogo?: ImageDto;
  splashScreenBackground?: ImageDto;
  phoneNumber?: string;
  connectionSettings: SelfConnectedProjectSettingsDto;
  connections: ProjectConnectionDto[];
  newConnectionStatus: NewConnectionStatus;
  marketPlaceGroupId?: string;
  marketPlaceGroupName?: string;
  hasNativeRateActive: boolean;
  newChatMessageDashboardSound: boolean;
  allowHidePostForAdmin: boolean;
  calendarVisibility: CalendarVisibilityDto;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface SelfLanguageRequest {
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId?: LanguageIdDto;
  /** Language used for dynamic auto translations. Null disables automatic translation. */
  autoTranslationLanguageId?: string;
  /** Language for static UI text translated through POEditor. */
  uiLanguageId?: LanguageIdDto;
}

export interface SelfPrivacySettingsRequest {
  hideEmail?: boolean;
  hidePhoneNumber?: boolean;
  enableChat?: boolean;
  hideHouseNumber?: boolean;
}

export interface SelfProjectDto {
  name: string;
  slug: string;
  city: string;
  owner?: string;
  maintenance?: string;
  type: ProjectTypeDto;
  appBranding: AppBrandingDto;
  /** @format int32 */
  appBrandingMaxSkips?: number;
  /**
   * Deprecated: Use the one from branding endpoint instead
   * @deprecated
   */
  androidAppUrl: string;
  /**
   * Deprecated: Use the one from branding endpoint instead
   * @deprecated
   */
  iosAppUrl: string;
  logoUrl: string;
  styling: ProjectStylingDto;
  backgroundImage?: ImageDto;
  activeState: ProjectActiveStateDto;
  id: string;
}

export interface SelfRegistrationDetailsDto {
  project?: SimpleProjectDto;
  code: string;
  /** @format uuid */
  guid: string;
}

export interface SelfRequest {
  languageId: LanguageIdDto;
  hideEmail?: boolean;
  hidePhonenumber?: boolean;
  isAssignableToTickets?: boolean;
  enableChat?: boolean;
}

export interface SelfUserRoleDto {
  name: string;
  type: UserRoleTypeDto;
  isResidentType: boolean;
  permissions: SelfUserRolePermissionsDto;
  id: string;
}

export interface SelfUserRolePermissionsDto {
  community: UserRoleCommunityPermissionsDto;
  repairManagement: UserRoleRepairManagementPermissionsDto;
  userManagement: UserRoleUserManagementPermissionsDto;
  projectManagement: UserRoleProjectManagementPermissionsDto;
  integrations: UserRoleIntegrationsPermissionsDto;
  addressManagement: UserRoleAddressManagementPermissionsDto;
  servicePartners: UserRoleServicePartnersPermissionsDto;
  surveys: UserRoleSurveysPermissionsDto;
  events: UserRoleEventsPermissionsDto;
  assets: UserRoleAssetsPermissionsDto;
  documents: UserRoleDocumentsPermissionsDto;
  repairCategories: UserRoleRepairCategoryPermissionsEntityDto[];
  canListDocuments: boolean;
  canListPosts: boolean;
  canCreatePosts: boolean;
  canCreateAnnouncements: boolean;
  canCreateStandardPosts: boolean;
  canCreatePostsInGroup: boolean;
  canCreateTicket: boolean;
  canViewTickets: boolean;
  canPostInMarketplace: boolean;
}

export interface SendBrandedAppAgreementRequestDto {
  brand: AppBrandingDto;
  stores: BrandedAppStoreDto[];
}

export interface ServicePartnerAccessLinkDto {
  url: string;
}

export interface ServicePartnerCreateRequest {
  type: ServicePartnerPageTypeDto;
  /** @maxLength 128 */
  title: string;
  /** @maxLength 128 */
  subtitle?: string;
  description?: string;
  audience: ConstraintListItemDto[];
  permissions: UserRoleServicePartnerPagePermissionsDto[];
  category: PartnerCategoryDto;
  email?: string;
  phoneNumber?: string;
  /** @format uuid */
  headerImageId?: string;
  /** @format uuid */
  profileImageId: string;
  projectConnectionId?: string;
}

export interface ServicePartnerPageDetailsDto {
  permissions: UserRoleServicePartnerPagePermissionsDto[];
  partnerProperties: ServicePartnerPagePropertiesDto;
  audience: ConstraintListItemDto[];
  originalLanguageId: LanguageIdDto;
  category: PartnerCategoriesDto;
  title: string;
  subtitle?: string;
  description?: string;
  email?: string;
  phoneNumber?: string;
  profileImage?: ImageDto;
  headerImage?: ImageDto;
  connection?: ProjectConnectionDto;
  canEdit: boolean;
  canDelete: boolean;
  type: ServicePartnerPageTypeDto;
  isUnread: boolean;
  hasAudience: boolean;
  /** @format int32 */
  viewCount?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  id: string;
}

export interface ServicePartnerPageDto {
  category: PartnerCategoriesDto;
  title: string;
  subtitle?: string;
  description?: string;
  email?: string;
  phoneNumber?: string;
  profileImage?: ImageDto;
  headerImage?: ImageDto;
  connection?: ProjectConnectionDto;
  canEdit: boolean;
  canDelete: boolean;
  type: ServicePartnerPageTypeDto;
  isUnread: boolean;
  hasAudience: boolean;
  /** @format int32 */
  viewCount?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  id: string;
}

export interface ServicePartnerPageIqbiPropertiesDto {
  status: ServicePartnerPageIqbiStatusDto;
}

export interface ServicePartnerPageMyPupPropertiesDto {
  isRegistered: boolean;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   * @format uuid
   */
  uuid: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  authKey: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  pup?: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  email: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  firstName: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  lastName: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  language: string;
  /**
   * Deprecated: Use the service partner access-link endpoint.
   * @deprecated
   */
  phoneNumber?: string;
}

export interface ServicePartnerPagePaginationResultDto {
  /** List of all types that can be created. */
  allowedTypes: ServicePartnerPageTypeDto[];
  items: ServicePartnerPageDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ServicePartnerPagePropertiesDto {
  iqbi?: ServicePartnerPageIqbiPropertiesDto;
  myPup?: ServicePartnerPageMyPupPropertiesDto;
}

export interface ServicePartnerRequest {
  /** @maxLength 128 */
  title: string;
  /** @maxLength 128 */
  subtitle?: string;
  description?: string;
  audience: ConstraintListItemDto[];
  permissions: UserRoleServicePartnerPagePermissionsDto[];
  category: PartnerCategoryDto;
  email?: string;
  phoneNumber?: string;
  /** @format uuid */
  headerImageId?: string;
  /** @format uuid */
  profileImageId: string;
  projectConnectionId?: string;
}

export interface SetReminderDto {
  /** @format date-time */
  reminderDate: string;
}

export interface SignalRBroadcastRequest {
  hub: string;
  groups: string[];
  method: string;
  payload: JsonElement;
}

export interface SignupReminderDto {
  /** @format date-time */
  lastReminded: string;
  state: ReminderStateDto;
}

export interface SimpleProjectDto {
  name: string;
  maintenance: string;
  owner: string;
  slug: string;
  city: string;
  id: string;
}

export interface SimpleSurveyDto {
  title: string;
  id: string;
}

export interface SimpleUserDto {
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface StartAppointmentPlanningRequest {
  categoryId: string;
  categoryNodeId?: string;
  title: string;
  content: string;
  imageIds?: string[];
}

export interface StartJansenHuybregtsPlanningRequest {
  /**
   * Category the repair is reported under. Always required, the same way it is when
   * creating a ticket.
   */
  categoryId: string;
  /**
   * Selected room decision-tree node (leaf), when the category is a room decision tree.
   * Its `ExternalCode` becomes the Jansen Huybregts roomCode. Leave empty when the
   * selection ends on the category itself, which then has to carry a
   * `TreeOverrideExternalCode`.
   */
  categoryNodeId?: string;
  title: string;
  content: string;
  imageIds?: string[];
}

export interface SurveyDetailsDto {
  questions: QuestionDto[];
  completedMessage: string;
  endedMessage: string;
  scope: SurveyScope;
  internal: boolean;
  originalLanguageId: LanguageIdDto;
  type: SurveyTypeDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  group?: GroupDto;
  title: string;
  description: string;
  canRespond: CanRespondStatusDto;
  canView: boolean;
  canViewResults: boolean;
  canEdit: boolean;
  canDelete: boolean;
  createdBy?: UserDto;
  /** @format int32 */
  questionCount: number;
  /** @format int32 */
  answerCount?: number;
  isUnread: boolean;
  isPublished: boolean;
  category: SurveyCategoryDto;
  /** @format date-time */
  followedUpAt?: string;
  viewTracked: boolean;
  status: SurveyStatusDto;
  bulkSurveyId?: string;
  id: string;
}

export interface SurveyDto {
  type: SurveyTypeDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  group?: GroupDto;
  title: string;
  description: string;
  canRespond: CanRespondStatusDto;
  canView: boolean;
  canViewResults: boolean;
  canEdit: boolean;
  canDelete: boolean;
  createdBy?: UserDto;
  /** @format int32 */
  questionCount: number;
  /** @format int32 */
  answerCount?: number;
  isUnread: boolean;
  isPublished: boolean;
  category: SurveyCategoryDto;
  /** @format date-time */
  followedUpAt?: string;
  viewTracked: boolean;
  status: SurveyStatusDto;
  bulkSurveyId?: string;
  id: string;
}

export interface SurveyExportLine {
  id: string;
  question: string;
  answer: string;
  respondent: string;
  address: string;
  building: string;
  addressType: string;
  floor: string;
}

export interface SurveyFollowUpSuggestionDto {
  id: string;
  /** @format date-time */
  createdAt: string;
  suggestion: string;
  /** @format double */
  confidenceScore: number;
  action?: SurveyFollowUpSuggestionAction;
  rationale: string;
  rating?: AiResponseRating;
  /** @format date-time */
  ratedAt?: string;
}

export interface SurveyQuestionSummaryDto {
  /** The summary of all the answers to the question. */
  summary: string;
  /** Suggestion is not always applicable, so it can be null. */
  suggestion?: string;
  /**
   * The average sentiment of all the answers to the question.
   * @format int32
   */
  sentiment: number;
  /** The hashtags generated from the answers to the question. Most of the time this will contain 5 hashtags. */
  hashtags: string[];
}

export interface SurveyWidgetInfoDto {
  surveyId: string;
  questionId: string;
  question: string;
}

export interface SwoogoProjectConfigurationDto {
  enabled: boolean;
  clientId?: string;
  clientSecret?: string;
  creatorUser?: UserDto;
  webhookUrl?: string;
}

export interface SwoogoProjectConfigurationRequest {
  enabled: boolean;
  clientId?: string;
  clientSecret?: string;
  creatorUserId?: string;
}

export interface SystemGroupCreateRequest {
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  translations?: SystemGroupTranslationDto[];
  /** @format uuid */
  imageId: string;
  excludedProjectIds: string[];
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
  name?: string;
  description?: string;
}

export interface SystemGroupDetailDto {
  originalLanguageId: LanguageIdDto;
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  excludedProjects?: SimpleProjectDto[];
  id: string;
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  translations?: SystemGroupTranslationDto[];
  image: ImageDto;
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface SystemGroupDto {
  excludedProjects?: SimpleProjectDto[];
  id: string;
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  translations?: SystemGroupTranslationDto[];
  image: ImageDto;
  postingLevel: PostingLevelDto;
  defaultPostingAudience: DefaultPostingAudienceDto;
}

export interface SystemGroupTranslationDto {
  languageId: string;
  name: string;
  description: string;
}

export interface SystemGroupUpdateRequest {
  type: CommunityGroupTypeDto;
  icon: CommunityGroupIconDto;
  translations?: SystemGroupTranslationDto[];
  /** @format uuid */
  imageId: string;
  permissions: UserRoleTypeCommunityGroupPermissionsEntityRequest[];
  defaultPostingAudience: DefaultPostingAudienceDto;
  name?: string;
  description?: string;
}

export interface TextStream {
  chunk: string;
}

export interface ThresholdAlertConfigurationCreateRequest {
  /** @format int32 */
  percentageThreshold: number;
  enabled: boolean;
  name: string;
  email?: string;
  projectIds: string[];
  alertNotificationType: AlertNotificationTypeDto;
}

export interface ThresholdAlertConfigurationDto {
  /** @format int32 */
  percentageThreshold?: number;
  enabled: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  modifiedAt?: string;
  name: string;
  email: string;
  projects: SimpleProjectDto[];
  alertNotificationType: AlertNotificationTypeDto;
  id: string;
}

export interface TicketAnalyticsBenchmarkPointDto {
  /** @format date-time */
  x: string;
  /** @format double */
  averageResolutionDays?: number;
  /** @format double */
  averageRating?: number;
}

export interface TicketAnalyticsCategoryDto {
  id: string;
  name: string;
  /** @format int32 */
  tickets: number;
  /** @format int32 */
  closedTickets: number;
  /** @format int32 */
  openTickets: number;
  /** @format double */
  medianResolutionDays?: number;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  ratedTickets: number;
}

export interface TicketAnalyticsCategoryReferenceDto {
  id: string;
  name: string;
}

export interface TicketAnalyticsDistributionPointDto {
  x: string;
  /** @format int32 */
  y: number;
}

export interface TicketAnalyticsFilterOptionsDto {
  categories: TicketAnalyticsCategoryReferenceDto[];
}

export interface TicketAnalyticsMonthlyPointDto {
  /** @format date-time */
  x: string;
  /** @format int32 */
  created: number;
  /** @format int32 */
  closed: number;
  /** @format int32 */
  openAtEnd: number;
  /** @format double */
  averageResolutionDays?: number;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  ratedTickets: number;
  isCurrentMonth: boolean;
}

export interface TicketAnalyticsPreviousPeriodDto {
  /** @format int32 */
  createdTickets: number;
  /** @format int32 */
  closedTickets: number;
  /** @format int32 */
  uniqueReporters: number;
  /** @format double */
  medianResolutionDays?: number;
  /** @format double */
  averageRating?: number;
}

export interface TicketAnalyticsSummaryDto {
  /** @format int32 */
  createdTickets: number;
  /** @format int32 */
  closedTickets: number;
  /** @format int32 */
  openTickets: number;
  /** @format int32 */
  openTicketsChange: number;
  /** @format int32 */
  uniqueReporters: number;
  /** @format int32 */
  eligibleResidents: number;
  /** @format double */
  reporterReachPercentage: number;
  /** @format double */
  medianResolutionDays?: number;
  /** @format double */
  p90ResolutionDays?: number;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  ratedTickets: number;
  previousPeriod: TicketAnalyticsPreviousPeriodDto;
}

export interface TicketAppointmentDto {
  ticketId: string;
  state: TicketAppointmentStateDto;
  requiresManualFollowUp: boolean;
  /** @format date-time */
  selectedAppointmentStart?: string;
  /** @format date-time */
  selectedAppointmentEnd?: string;
  options: AppointmentOptionDto[];
  canSelect: boolean;
  canChange: boolean;
}

export interface TicketAppointmentFlagDto {
  hasDetails: boolean;
}

export interface TicketAssigneeChangeRequest {
  note?: string;
  assigneeId: string;
}

export interface TicketAverageLeadTimeMonthlyDto {
  benchmark: TicketsBenchmarkItemDto[];
  data: TicketsAverageLeadTimeItemDto[];
}

export interface TicketAverageRatingMonthlyDto {
  /** @format double */
  minRating: number;
  /** @format double */
  maxRating: number;
  benchmark: TicketsBenchmarkItemDto[];
  data: TicketsAverageRatingItemDto[];
}

export interface TicketCategoryDetailsDto {
  /** @format int32 */
  closeAfterInactiveDayAmount: number;
  translations: TranslationsDto[];
  permissions: UserRoleRepairCategoryPermissionsDto[];
  treeVveEnabled: boolean;
  treeOverrideExternalCode?: string;
  type: TicketCategoryTypeDto;
  defaultAssignee?: UserDto;
  disabled: boolean;
  notificationType: TicketCategoryNotificationTypeDto;
  audience: ConstraintListItemDto[];
  canDelete: boolean;
  projectHasMultipleBuildings: boolean;
  reopenPolicy: ReopenPolicyDto;
  dicoEnabled: boolean;
  requireImages: boolean;
  name: string;
  requirePhoneNumber: boolean;
  allowVideos: boolean;
  id: string;
}

export interface TicketCategoryDto {
  type: TicketCategoryTypeDto;
  defaultAssignee?: UserDto;
  disabled: boolean;
  notificationType: TicketCategoryNotificationTypeDto;
  audience: ConstraintListItemDto[];
  canDelete: boolean;
  projectHasMultipleBuildings: boolean;
  reopenPolicy: ReopenPolicyDto;
  dicoEnabled: boolean;
  requireImages: boolean;
  name: string;
  requirePhoneNumber: boolean;
  allowVideos: boolean;
  id: string;
}

export interface TicketCategoryNotificationSettingDto {
  ticketCategoryId: string;
  ticketCategoryName: string;
  dashboardEnabled: boolean;
  emailEnabled: boolean;
  appEnabled: boolean;
}

export interface TicketCategoryNotificationSettingRequest {
  ticketCategoryId: string;
  dashboardEnabled?: boolean;
  emailEnabled?: boolean;
  appEnabled?: boolean;
}

export interface TicketCategoryRequest {
  type: TicketCategoryTypeDto;
  name?: string;
  translations: TranslationRequest[];
  audience?: ConstraintListItemDto[];
  defaultAssigneeId?: string;
  disabled: boolean;
  /** @format int32 */
  closeAfterInactiveDayAmount?: number;
  notificationType: TicketCategoryNotificationTypeDto;
  permissions: UserRoleRepairCategoryPermissionsDto[];
  reopenPolicy: ReopenPolicyDto;
  treeVveEnabled: boolean;
  dicoEnabled: boolean;
  treeOverrideExternalCode?: string;
  requirePhoneNumber: boolean;
  requireImages: boolean;
}

export interface TicketCategoryTreeDto {
  nodes: TicketCategoryTreeNodeDto[];
}

export interface TicketCategoryTreeNodeCreateRequest {
  treeNodeParentId?: string;
  name: string;
  description?: string;
  icon?: TicketCategoryNodeIconDto;
  externalCode?: string;
  externalSecondaryCode?: string;
  useTreeOverrideExternalCode: boolean;
  locationType: TicketCategoryTreeNodeLocationTypeDto;
}

export interface TicketCategoryTreeNodeDto {
  description?: string;
  icon?: TicketCategoryNodeIconDto;
  externalCode?: string;
  externalSecondaryCode?: string;
  useTreeOverrideExternalCode: boolean;
  enabled: boolean;
  isFinal: boolean;
  locationType: TicketCategoryTreeNodeLocationTypeDto;
  children?: TicketCategoryTreeNodeDto[];
  name: string;
  id: string;
}

export interface TicketCategoryTreeNodeUpdateRequest {
  name: string;
  description?: string;
  icon?: TicketCategoryNodeIconDto;
  externalCode?: string;
  externalSecondaryCode?: string;
  useTreeOverrideExternalCode: boolean;
  locationType: TicketCategoryTreeNodeLocationTypeDto;
}

export interface TicketCommentDto {
  /** @format int32 */
  ticketId: number;
  content?: string;
  image?: ImageDto;
  author: UserDto;
  /** @format date-time */
  postedAt: string;
  /**
   * Deprecated: Ticket comments can not be edited anymore
   * @deprecated
   * @format date-time
   */
  modifiedAt?: string;
  /**
   * Deprecated: Ticket comments can not be deleted anymore
   * @deprecated
   * @format date-time
   */
  deletedAt?: string;
  languageIsoCode?: string;
  isAutoReply: boolean;
  documents: DocumentUploadDto[];
  videos: VideoDto[];
  id: string;
}

export interface TicketCommentRequest {
  accessType?: TicketCommentVisibility;
  /** @format uuid */
  imageId?: string;
  content?: string;
  documentIds?: string[];
  videoIds?: string[];
}

export interface TicketCommentTranslationDto {
  content?: string;
}

export interface TicketFeedbackLabelByRatingDto {
  options: TicketFeedbackOptionDto[];
  /** @format int32 */
  rating: number;
}

export interface TicketFeedbackOptionDto {
  label: FeedbackLabelDto;
  value: string;
}

export interface TicketFiltersDto {
  assignees: UserDto[];
  statuses: TicketStatusDto[];
  categories: BaseTicketCategoryDto[];
}

export interface TicketIntegrationStatusSummaryDto {
  present: boolean;
  enabled: boolean;
  state: string;
  externalId?: string;
  /** @format date-time */
  updatedAt?: string;
  errorDetails?: string;
  data?: any;
}

export interface TicketOverviewDto {
  benchmark: TicketsBenchmarkOverviewItemDto[];
  data: TicketsOverviewItemDto[];
}

export interface TicketRateRequest {
  remark: string;
  /** @format int32 */
  rating?: number;
  /** @format date-time */
  closedAt?: string;
  feedbackOptions?: FeedbackLabelDto[];
}

export interface TicketRequest {
  /** Needs to be supplied if not working with the decision tree format. */
  categoryId?: string;
  /** Either this or CategoryId should be supplied. This should only be used when working with decision tree format. */
  categoryNodeId?: string;
  title: string;
  content: string;
  reporterId?: string;
  visibility?: TicketVisibilityDto;
  assigneeId?: string;
  imageIds?: string[];
  videoIds?: string[];
  requestOrigin?: TicketRequestOriginDto;
  locationType?: TicketCategoryLocationTypeDto;
  phoneNumber?: string;
  /**
   * Stage-1 Jansen Huybregts: the pre-ticket planning the resident ran, and the
   * appointment slot they selected. Supplied together so the work order is submitted
   * when the ticket is created.
   */
  appointmentPlanningId?: string;
  appointmentSlotId?: string;
  jansenHuybregtsPlanningId?: string;
  jansenHuybregtsSlotId?: string;
}

export interface TicketResponseSuggestionDto {
  ticketId: string;
  response: string;
}

export interface TicketResponseSuggestionRequest {
  additionalInfo?: string;
}

export interface TicketResponsibilitySuggestionDto {
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format int32 */
  confidence: number;
  assignee: ResponsibilityAssigneeDto;
  rating: ResponsibilitySuggestionRatingDto;
}

export interface TicketsAverageLeadTimeItemDto {
  /** @format int32 */
  closedTicketCount: number;
  /** @format double */
  averageDaysBeforeTicketClosed?: number;
  categoryName: string;
  categoryId: string;
  isCurrentMonth: boolean;
  range: MonthlyReportDateRangeDto;
}

export interface TicketsAverageRatingItemDto {
  /** @format int32 */
  ratedTicketCount: number;
  /** @format double */
  averageRating?: number;
  categoryName: string;
  categoryId: string;
  isCurrentMonth: boolean;
  range: MonthlyReportDateRangeDto;
}

export interface TicketsBenchmarkItemDto {
  /** @format double */
  averageRating?: number;
  /** @format double */
  benchmarkDaysBeforeTicketClosed?: number;
  range: MonthlyReportDateRangeDto;
}

export interface TicketsBenchmarkOverviewItemDto {
  /** @format double */
  averageTicketRating?: number;
  /** @format int32 */
  ticketClosedByResidentPercentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface TicketsOverviewItemDto {
  /** @format int32 */
  ticketCount: number;
  /** @format int32 */
  ticketClosedCount: number;
  /** @format double */
  averageTicketRating?: number;
  /** @format int32 */
  ticketClosedByResidentPercentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface TicketStatsDto {
  /** @format int32 */
  tickets: number;
}

export interface TicketStatusChangeRequest {
  silent?: boolean;
  statusId: string;
}

export interface TicketStatusDetailsDto {
  nameTranslations: TranslationsDto[];
  originalLanguageId: LanguageIdDto;
  isDefault: boolean;
  /**
   * Deprecated: No longer used
   * @deprecated
   * @format int32
   */
  notificationIntervalInHours?: number;
  /** @format int32 */
  timesUsed: number;
  id: string;
  type: TicketStatusTypeDto;
  name: string;
  color: string;
}

export interface TicketStatusDto {
  id: string;
  type: TicketStatusTypeDto;
  name: string;
  color: string;
}

export interface TicketStatusRequest {
  /** @pattern ^#(?:[0-9a-fA-F]{3}){1,2}$ */
  color: string;
  name?: string;
  nameTranslations: TranslationRequest[];
  type: TicketStatusTypeDto;
  isDefault: boolean;
  /**
   * Deprecated: No longer used
   * @deprecated
   * @format int32
   */
  notificationIntervalInHours?: number;
}

export interface TicketTabsStatsDto {
  /** @format int32 */
  openTickets: number;
  /** @format int32 */
  closedTickets: number;
}

export interface TicketTranslationDto {
  title?: string;
  content?: string;
}

export interface TotalFeelingAtHomeScoreDto {
  /** @format double */
  rating: number;
}

export interface TranslateRequest {
  text: string;
  languages: LanguageIdDto[];
}

export interface TranslateResult {
  text: string;
  languages: LanguageIdDto;
}

export interface TranslationRequest {
  languageId: LanguageIdDto;
  value: string;
}

export interface TranslationsDto {
  languageId: string;
  value: string;
}

export interface UnreadStatusDto {
  /** @format int32 */
  unreadChats: number;
  /** @format int32 */
  unreadMessages: number;
  /** @format int32 */
  unreadNotifications: number;
  /** @format int32 */
  unreadServices: number;
  /**
   * @format int32
   * @default 0
   */
  unseenNotifications: number;
}

export interface UpdateEventParticipantRequest {
  /**
   * @format int32
   * @default 0
   */
  guestCount: number;
}

export interface UpdateEventRequest {
  name?: string;
  description?: string;
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  nameTranslations?: TranslationRequest[];
  /**
   * Deprecated: Use Description instead
   * @deprecated
   */
  descriptionTranslations?: TranslationRequest[];
  /** @format int32 */
  maxParticipants?: number;
  /** @format int32 */
  maxGuestsPerParticipant?: number;
  categoryType: EventCategoryTypeDto;
  /** @format uuid */
  imageId?: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  publishAt?: string;
  location?: string;
  audience?: ConstraintListItemDto[];
}

export interface UpdateFastMenuActionItemRequest {
  type: FastMenuActionItemTypeDto;
  selectedLabel?: string;
  translations?: FastMenuActionItemTranslationRequest[];
  url?: string;
  maintainer?: string;
  useType?: FastMenuActionItemUseTypeDto;
  dynamicExternalUrlType?: FastMenuActionItemDynamicUrlTypeDto;
  label?: string;
}

export interface UpdateIssueStatusDto {
  issueStatus: IssueStatusDto;
}

export interface UpdateIssueStatusRequest {
  updateReason: UpdateIssueReasonDto;
}

export interface UpdateOfferedAnswerRequestDto {
  answer: string;
  id?: string;
}

export interface UpdateQuestionRequestDto {
  question: string;
  type: QuestionTypeDto;
  /** @format int32 */
  sorting: number;
  offeredAnswers?: UpdateOfferedAnswerRequestDto[];
  /** @default false */
  useForAnalysis: boolean;
  id?: string;
}

export interface UpdateSurveyRequestDto {
  title: string;
  description: string;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  surveyCompleted: string;
  questions: UpdateQuestionRequestDto[];
  groupId?: string;
  internal: boolean;
}

export interface UptimeComponentDto {
  name: string;
  status: UptimeStatusDto;
}

export interface UptimeResultDto {
  status: UptimeStatusDto;
  affectedComponents: UptimeComponentDto[];
  /** @format date-time */
  updatedAt?: string;
}

export interface UserAccountNotificationSettingsDto {
  /** Whether the user wants to receive a monthly living experience report email */
  monthlyLivingExperienceReport: boolean;
}

export interface UserAccountNotificationSettingsRequest {
  monthlyLivingExperienceReportEmail?: boolean;
}

export interface UserAccountTicketsConfigurationDto {
  /** This is shown at the top of the page when creating a new ticket */
  customIntroText?: string;
  /** Regulations document shown in create ticket page */
  regulations?: DocumentUploadDto;
  /** Whether the user must sign off the regulations document before creating a ticket */
  requireSignOffRegulations: boolean;
  /** When a ticket is created, the user will receive an automatic reply with this text */
  autoReplyText?: string;
}

export interface UserAccountTicketsConfigurationRequest {
  customIntroText?: string;
  regulationsId?: string;
  requireSignOffRegulations: boolean;
  autoReplyText?: string;
}

export interface UserCreateRequest {
  email: string;
  firstName: string;
  prefix?: string;
  lastName: string;
  uiLanguage: LanguageIdDto;
  autoTranslationLanguage?: string;
  occupation?: string;
  addressId?: string;
  companyId?: string;
  roleId?: string;
  isSuperAdmin?: boolean;
  mobileNumber?: string;
  avatarId?: string;
  /** @format date-time */
  deactivateAfter?: string;
  /** Only usable for super admins */
  chatPermission?: ChatPermission;
  /**
   * Only usable for super admins (Deprecated: Use ChatPermission instead)
   * @deprecated
   */
  hideChat?: boolean;
  /** Only usable for super admins */
  emailSignOffUserId?: string;
  isOnlyAllowedOwnRepairRequests?: boolean;
  isAssignableToAllTickets?: boolean;
  onboardingCompleted?: boolean;
  relationInformation?: UserRelationCreateRequest;
  remsContactId?: string;
  remsContractId?: string;
}

export interface UserDeletionDateRequest {
  /** @format date-time */
  deleteAt?: string;
  projectIds?: string[];
}

export interface UserDetailsDto {
  addressId: string;
  companyId?: string;
  interestGroups: GroupWithIconDto[];
  helpCategories: GroupWithIconDto[];
  canEmailBeEdited: boolean;
  canRoleBeEdited: boolean;
  /** @format date-time */
  lastActivityDate?: string;
  infoProject: InfoProjectDto;
  /**
   * Deprecated: Use InfoProject instead
   * @deprecated
   */
  project?: SimpleProjectDto;
  addressTags: ConstraintListItemDto[];
  userRelationInformation?: UserRelationInformationDto;
  bulkDeleted?: boolean;
  integrationMapping?: IntegrationMappingDto;
  /** @format date-time */
  invitedAt?: string;
  canBeReinvited: boolean;
  phoneNumber?: string;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserDto {
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserExtendedDto {
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserILoqStatusDto {
  status: ILoqKeyStatusDto;
}

export interface UserListItemDto {
  /** @format date-time */
  invitedAt?: string;
  canBeReinvited: boolean;
  phoneNumber?: string;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserLookupDto {
  project: SimpleProjectDto;
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  projectName: string;
  /**
   * Deprecated: Do not use me I'm pointless
   * @deprecated
   */
  city?: string;
  /**
   * Deprecated: Do not use me I'm pointless
   * @deprecated
   */
  zipCode?: string;
  /** @format date-time */
  invitedAt?: string;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserPollResponseDto {
  answers: OfferedAnswerDto[];
  /** @format date-time */
  answeredAt: string;
}

export interface UserProjectAccessDto {
  userId: string;
  canEditUser: boolean;
  canEditNotificationSettings: boolean;
  canDelete: boolean;
}

export interface UserProjectDto {
  id: string;
  name: string;
  access: UserProjectAccessDto;
}

export interface UserRelationCreateRequest {
  /** Provide the ID if the relation already exists. */
  id?: string;
  /**
   * Only used if the relation is new.
   * @format date-time
   */
  startDate?: string;
  /** Only used if the relation is new. This is the ID of the external partner. Not needed if the relation is internal. */
  partnerId?: string;
}

export interface UserRelationInformationDetailDto {
  users: UserDto[];
  id: string;
  /** @format date-time */
  startDate: string;
  partnerId?: string;
}

export interface UserRelationInformationDto {
  id: string;
  /** @format date-time */
  startDate: string;
  partnerId?: string;
}

export interface UserRoleAddressManagementPermissionsDto {
  roleId: string;
  canManageCompanies: boolean;
  canManageAddresses: boolean;
  canListAddresses: boolean;
  canEditAddress: boolean;
  canManageBuildings: boolean;
}

export interface UserRoleAddressManagementPermissionsRequest {
  canManageCompanies: boolean;
  canManageAddresses: boolean;
  canListAddresses: boolean;
  canEditAddress: boolean;
  canManageBuildings: boolean;
}

export interface UserRoleAssetsPermissionsDto {
  roleId: string;
  canViewSchedule: boolean;
  canManageOwn: boolean;
  canManageAll: boolean;
}

export interface UserRoleAssetsPermissionsRequest {
  canViewSchedule: boolean;
  canManageOwn: boolean;
  canManageAll: boolean;
}

export interface UserRoleCommunityGroupPermissionsDto {
  roleId: string;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canListPosts: boolean;
  canCommentPost: boolean;
}

export interface UserRoleCommunityGroupPermissionsEntityDto {
  groupId: string;
  roleId: string;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canListPosts: boolean;
  canCommentPost: boolean;
}

export interface UserRoleCommunityGroupPermissionsEntityRequest {
  groupId: string;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canListPosts: boolean;
  canCommentPost: boolean;
}

export interface UserRoleCommunityPermissionsDto {
  roleId: string;
  canListGroups: boolean;
  canCreateGroup: boolean;
  canEditGroup: boolean;
  canDeleteGroup: boolean;
  canCreateGeneralPost: boolean;
  canCreateGeneralPostInProjectConnection: boolean;
  canCreateGeneralAnnouncement: boolean;
  canListGeneralPosts: boolean;
  canCommentGeneralPosts: boolean;
  canDeleteContent: boolean;
  canArchiveContent: boolean;
}

export interface UserRoleCommunityPermissionsRequest {
  canListGroups: boolean;
  canCreateGroup: boolean;
  canEditGroup: boolean;
  canDeleteGroup: boolean;
  canCreateGeneralPost: boolean;
  canCreateGeneralPostInProjectConnection: boolean;
  canCreateGeneralAnnouncement: boolean;
  canListGeneralPosts: boolean;
  canCommentGeneralPosts: boolean;
  canDeleteContent: boolean;
  canArchiveContent: boolean;
}

export interface UserRoleDetailsDto {
  users: UserDto[];
  name: string;
  locked: boolean;
  default: boolean;
  hasUsers: boolean;
  type: UserRoleTypeDto;
  isResidentType: boolean;
  residentRoleVariant?: ResidentRoleVariantDto;
  permissions: UserRolePermissionsDto;
  id: string;
}

export interface UserRoleDocumentFolderPermissionsDto {
  roleId: string;
  canCreateDocument: boolean;
  canDeleteDocument: boolean;
  canListDocuments: boolean;
}

export interface UserRoleDocumentFolderPermissionsEntityDto {
  folderId: string;
  roleId: string;
  canCreateDocument: boolean;
  canDeleteDocument: boolean;
  canListDocuments: boolean;
}

export interface UserRoleDocumentFolderPermissionsEntityRequest {
  folderId: string;
  canCreateDocument: boolean;
  canDeleteDocument: boolean;
  canListDocuments: boolean;
}

export interface UserRoleDocumentsPermissionsDto {
  roleId: string;
  canManageAll: boolean;
}

export interface UserRoleDocumentsPermissionsRequest {
  canManageAll: boolean;
}

export interface UserRoleDto {
  name: string;
  locked: boolean;
  default: boolean;
  hasUsers: boolean;
  type: UserRoleTypeDto;
  isResidentType: boolean;
  residentRoleVariant?: ResidentRoleVariantDto;
  permissions: UserRolePermissionsDto;
  id: string;
}

export interface UserRoleEventsPermissionsDto {
  roleId: string;
  canManage: boolean;
  canManageAll: boolean;
  canListAll: boolean;
}

export interface UserRoleEventsPermissionsRequest {
  canManage: boolean;
  canManageAll: boolean;
  canListAll: boolean;
}

export interface UserRoleIntegrationsPermissionsDto {
  roleId: string;
  /**
   * Deprecated: Use the integration specific permissions instead.
   * @deprecated
   */
  canManageAll: boolean;
  canManageZiezodan: boolean;
  canManageMyPup: boolean;
  canManageBringme: boolean;
  canManageDico: boolean;
  canManageSwoogo: boolean;
  canManageCopilot: boolean;
  canManageIqbi: boolean;
  canManageHomeDna: boolean;
  canManageRems: boolean;
  canManageHealthDistrict: boolean;
  canManageOfficeRnd: boolean;
  canManageWunderbricks: boolean;
  canManageHubSpot: boolean;
  canManageOutlook: boolean;
  canManageJim: boolean;
  canManageProjectApiAccess: boolean;
  canManageILoq: boolean;
  canManageJansenHuybregts: boolean;
}

export interface UserRoleIntegrationsPermissionsRequest {
  /**
   * Deprecated: Use the integration specific permissions instead.
   * @deprecated
   */
  canManageAll?: boolean;
  canManageZiezodan: boolean;
  canManageMyPup: boolean;
  canManageBringme: boolean;
  canManageDico: boolean;
  canManageSwoogo: boolean;
  canManageCopilot: boolean;
  canManageIqbi: boolean;
  canManageHomeDna: boolean;
  canManageRems: boolean;
  canManageHealthDistrict: boolean;
  canManageOfficeRnd: boolean;
  canManageWunderbricks: boolean;
  canManageHubSpot: boolean;
  canManageOutlook: boolean;
  canManageJim: boolean;
  canManageProjectApiAccess: boolean;
  canManageILoq: boolean;
  canManageJansenHuybregts: boolean;
}

export interface UserRolePermissionsDto {
  community: UserRoleCommunityPermissionsDto;
  communityGroups: UserRoleCommunityGroupPermissionsEntityDto[];
  repairManagement: UserRoleRepairManagementPermissionsDto;
  repairCategories: UserRoleRepairCategoryPermissionsEntityDto[];
  documents: UserRoleDocumentsPermissionsDto;
  folders: UserRoleDocumentFolderPermissionsEntityDto[];
  userManagement: UserRoleUserManagementPermissionsDto;
  addressManagement: UserRoleAddressManagementPermissionsDto;
  servicePartners: UserRoleServicePartnersPermissionsDto;
  servicePages: UserRoleServicePartnerPagePermissionsEntityDto[];
  surveys: UserRoleSurveysPermissionsDto;
  events: UserRoleEventsPermissionsDto;
  assets: UserRoleAssetsPermissionsDto;
  projectManagement: UserRoleProjectManagementPermissionsDto;
  integrations: UserRoleIntegrationsPermissionsDto;
}

export interface UserRolePermissionsRequest {
  community: UserRoleCommunityPermissionsRequest;
  communityGroups: UserRoleCommunityGroupPermissionsEntityRequest[];
  repairManagement: UserRoleRepairManagementPermissionsRequest;
  repairCategories: UserRoleRepairCategoryPermissionsEntityRequest[];
  documents: UserRoleDocumentsPermissionsRequest;
  folders: UserRoleDocumentFolderPermissionsEntityRequest[];
  userManagement: UserRoleUserManagementPermissionsRequest;
  addressManagement: UserRoleAddressManagementPermissionsRequest;
  servicePartners: UserRoleServicePagesPermissionsRequest;
  servicePages: UserRoleServicePartnerPagePermissionsEntityRequest[];
  surveys: UserRoleSurveysPermissionsRequest;
  events: UserRoleEventsPermissionsRequest;
  assets: UserRoleAssetsPermissionsRequest;
  projectManagement: UserRoleProjectManagementPermissionsRequest;
  integrations: UserRoleIntegrationsPermissionsRequest;
}

export interface UserRoleProjectManagementPermissionsDto {
  roleId: string;
  canViewAll: boolean;
  canManageAll: boolean;
}

export interface UserRoleProjectManagementPermissionsRequest {
  canViewAll: boolean;
  canManageAll: boolean;
}

export interface UserRoleRepairCategoryPermissionsDto {
  roleId: string;
  canAddRequest: boolean;
  canUpdateRequestStatus: boolean;
  canListAllRequests: boolean;
  canListAssignedToMeRequests: boolean;
  canListCollectiveRequests: boolean;
  canCommentPublic: boolean;
  canCommentInternal: boolean;
}

export interface UserRoleRepairCategoryPermissionsEntityDto {
  categoryId: string;
  roleId: string;
  canAddRequest: boolean;
  canUpdateRequestStatus: boolean;
  canListAllRequests: boolean;
  canListAssignedToMeRequests: boolean;
  canListCollectiveRequests: boolean;
  canCommentPublic: boolean;
  canCommentInternal: boolean;
}

export interface UserRoleRepairCategoryPermissionsEntityRequest {
  categoryId: string;
  canAddRequest: boolean;
  canUpdateRequestStatus: boolean;
  canListAllRequests: boolean;
  canListAssignedToMeRequests: boolean;
  canListCollectiveRequests: boolean;
  canCommentPublic: boolean;
  canCommentInternal: boolean;
}

export interface UserRoleRepairManagementPermissionsDto {
  roleId: string;
  canManageCategories: boolean;
  canListCategories: boolean;
  canManageStatuses: boolean;
  canListStatuses: boolean;
}

export interface UserRoleRepairManagementPermissionsRequest {
  canManageCategories: boolean;
  canListCategories: boolean;
  canManageStatuses: boolean;
  canListStatuses: boolean;
}

export interface UserRoleRequest {
  name: string;
  type: UserRoleTypeDto;
  residentRoleVariant?: ResidentRoleVariantDto;
  permissions: UserRolePermissionsRequest;
}

export interface UserRoleServicePagesPermissionsRequest {
  canManagePages: boolean;
  canCreatePages: boolean;
  canListPages: boolean;
}

export interface UserRoleServicePartnerPagePermissionsDto {
  roleId: string;
  canManageContent: boolean;
}

export interface UserRoleServicePartnerPagePermissionsEntityDto {
  pageId: string;
  roleId: string;
  canManageContent: boolean;
}

export interface UserRoleServicePartnerPagePermissionsEntityRequest {
  pageId: string;
  canManageContent: boolean;
}

export interface UserRoleServicePartnersPermissionsDto {
  roleId: string;
  canManagePages: boolean;
  canCreatePages: boolean;
  canListPages: boolean;
}

export interface UserRoleSurveysPermissionsDto {
  roleId: string;
  canListAll: boolean;
  canManage: boolean;
}

export interface UserRoleSurveysPermissionsRequest {
  canListAll: boolean;
  canManage: boolean;
}

export interface UserRoleTypeCommunityGroupPermissionsEntityRequest {
  roleType: UserRoleTypeDto;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canListPosts: boolean;
  canCommentPost: boolean;
}

export interface UserRoleTypePermissionsDto {
  roleType: UserRoleTypeDto;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canListPosts: boolean;
  canCommentPost: boolean;
}

export interface UserRoleUserManagementPermissionsDto {
  roleId: string;
  canManageRoles: boolean;
  canAssignRoles: boolean;
  canInviteUser: boolean;
  canDeleteUser: boolean;
  canEditResidentInfo: boolean;
  canEditAdminInfo: boolean;
  canListUsers: boolean;
  canEditNotificationSettings: boolean;
  canBulkUploadUsers: boolean;
}

export interface UserRoleUserManagementPermissionsRequest {
  canManageRoles: boolean;
  canAssignRoles: boolean;
  canInviteUser: boolean;
  canDeleteUser: boolean;
  canEditResidentInfo: boolean;
  canEditAdminInfo: boolean;
  canListUsers: boolean;
  canEditNotificationSettings: boolean;
  canBulkUploadUsers: boolean;
}

export interface UsersMultipleCreateRequest {
  email: string;
  firstName: string;
  lastName: string;
  roleType?: UserRoleTypeDto;
  isSuperAdmin?: boolean;
  mobileNumber?: string;
  avatarId?: string;
  /** @format date-time */
  deactivateAfter?: string;
  projectIds: string[];
  /** Only usable for super admins */
  chatPermission?: ChatPermission;
  /**
   * Only usable for super admins (Deprecated: Use ChatPermission instead)
   * @deprecated
   */
  hideChat?: boolean;
  isOnlyAllowedOwnTickets?: boolean;
  isAssignableToAllTickets?: boolean;
  onboardingCompleted?: boolean;
  notificationSettings?: GenericDashboardNotificationSettingsRequest;
}

export interface UserStatsDto {
  /** @format int32 */
  totalResidents: number;
}

export interface UserTicketDetailsDto {
  phoneNumber?: string;
  roleId: string;
  locatedAt?: string;
  backgroundImage?: ImageDto;
  biography?: string;
  occupation?: string;
  isAssignableToTickets: boolean;
  isOnlyAllowedOwnTickets: boolean;
  canBeDeleted: boolean;
  canBeEdited: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  registeredAt?: string;
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId: LanguageIdDto;
  uiLanguageId: LanguageIdDto;
  autoTranslationLanguageId?: string;
  isSuperAdmin: boolean;
  deletionSource?: UserMutationSourceDto;
  /** @format date-time */
  deleteAfter?: string;
  deletedByUserId?: string;
  invitedByUserId?: string;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface UserTicketHistoryDto {
  /** @format int32 */
  userTotal: number;
  /** @format int32 */
  addressTotal: number;
  history: AdminTicketListItemDtoPaginationResultDto;
}

export interface UserUpdateRequest {
  firstName: string;
  lastName: string;
  mobileNumber?: string;
  email: string;
  occupation?: string;
  addressId?: string;
  companyId?: string;
  uiLanguage?: LanguageIdDto;
  autoTranslationLanguageId?: string;
  avatarId?: string;
  chatPermission?: ChatPermission;
  /**
   * Deprecated: Use ChatPermission instead
   * @deprecated
   */
  hideChat: boolean;
  roleId?: string;
  isSuperAdmin?: boolean;
  /** @format date-time */
  deactivateAfter?: string;
  isOnlyAllowedOwnTickets?: boolean;
  isAssignableToAllTickets?: boolean;
  onboardingCompleted?: boolean;
  applyToAllProjects: boolean;
}

export interface UserWithAudienceDto {
  postId: string;
  canAccess: boolean;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface ValidatedRegistrationCodeDto {
  /** @format uuid */
  accessToken: string;
  accessType: RegistrationCodeType;
  codeOwner: string;
  projectId: string;
  projectName: string;
}

export interface ValidateRegistrationCodeRequest {
  /**
   * Unique device or session identifier.
   * Will be used to detect multiple failed attempts to avoid abuse.
   * Could be a random string in worst case.
   */
  deviceId: string;
  /** Registration code */
  code: string;
}

export interface VerifyEmailRequest {
  email: string;
}

export interface VerifyEmailResultDto {
  exists: boolean;
}

export interface VideoDto {
  /** @format uuid */
  publicId: string;
  description?: string;
  url: string;
  fileName?: string;
  /** @format int64 */
  fileSize?: number;
  processingStatus: ProcessingStatusDto;
  /** @format double */
  duration?: number;
  formattedDuration?: string;
  thumbnail?: ImageDto;
  /** @format int32 */
  viewCount?: number;
  id: string;
}

export interface VideoStartUploadRequest {
  fileName?: string;
  mimeType?: string;
  /** @format int32 */
  totalChunks: number;
  skipProcessing?: boolean;
}

export interface VideoUploadDto {
  uploadId: string;
}

export interface WallboardFeedItemView {
  /** @format int32 */
  id: number;
  type: string;
  stage: string;
  /** @format int32 */
  count: number;
  /** @format date-time */
  occurredAt: string;
  /** @format date-time */
  windowStart: string;
  /** @format date-time */
  windowEnd: string;
  contextLabel?: string;
  isTakeover: boolean;
}

export interface WallboardIntegrationActivityView {
  id: string;
  integration: string;
  action: string;
  /** @format date-time */
  occurredAt: string;
  tone: string;
}

export interface WallboardIntegrationMeasureView {
  /** @format int32 */
  value: number;
  label: string;
  period: string;
}

export interface WallboardIntegrationNodeView {
  id: string;
  label: string;
  tone: string;
  /** @format int32 */
  metricValue: number;
  metricLabel: string;
  /** @format int32 */
  comparedToValue?: number;
  comparedToLabel?: string;
}

export interface WallboardIntegrationStoryView {
  id: string;
  mode: string;
  integration: string;
  primary: WallboardIntegrationMeasureView;
  secondary?: WallboardIntegrationMeasureView;
  detail?: string;
  nodes: WallboardIntegrationNodeView[];
  activity: WallboardIntegrationActivityView[];
}

export interface WallboardSnapshotView {
  /** @format date-time */
  generatedAt: string;
  /** @format int32 */
  cursor: number;
  activity: WallboardFeedItemView[];
  trends: WallboardTrendPointView[];
  totals: WallboardTotalsView;
  integrationStories: WallboardIntegrationStoryView[];
}

export interface WallboardTotalsView {
  /** @format int32 */
  onboardedResidents: number;
  /** @format int32 */
  contributionsToday: number;
  /** @format int32 */
  communitiesActiveToday: number;
  /** @format int32 */
  activeResidentsToday: number;
  /** @format int32 */
  communityMomentsLast10Minutes: number;
}

export interface WallboardTrendPointView {
  /** @format date-time */
  month: string;
  /** @format int32 */
  adoption: number;
  /** @format int32 */
  engagement: number;
  /** @format int32 */
  contribution: number;
  /** @format int32 */
  onboardedResidents: number;
}

export interface WeeklyCountDto {
  /** @format int32 */
  weekNumber?: number;
  /** @format int32 */
  count: number;
}

export interface WeeklyCountOverviewDto {
  weeklyCount: WeeklyCountDto[];
  /** @format int32 */
  totalOverall: number;
}

export interface WidgetDataDto {
  /** @format double */
  percentage: number;
  isIncreasePositive: boolean;
}

export interface WidgetsDataTypesRequest {
  widgetDataType: WidgetDataTypeDto[];
}

export interface WunderbricksAopTicketStatusOptionDto {
  id: string;
  label: string;
  color: string;
  defaultStatus: TicketDefaultStatus;
}

export interface WunderbricksExternalTicketStatusOptionDto {
  label: string;
  value: string;
  defaultValue: boolean;
}

export interface WunderbricksProjectConfigurationDto {
  contractsEnabled: boolean;
  ticketsEnabled: boolean;
  autoSendTickets: boolean;
  instanceUrl?: string;
  clientId?: string;
  clientSecret?: string;
  requesterUserId?: string;
  /** @format date-time */
  syncContractsFromDate?: string;
  statusMappings?: WunderbricksTicketStatusMappingDto[];
}

export interface WunderbricksStatusDto {
  state: WunderbricksTicketStateDto;
  caseId?: string;
  caseNumber?: string;
  status?: string;
  isClosed: boolean;
  errorDetails?: string;
  canSubmit: boolean;
}

export interface WunderbricksTicketStatusMappingDto {
  externalStatus: string;
  ticketStatusId: string;
}

export interface WunderbricksTicketStatusOptionsDto {
  externalStatuses: WunderbricksExternalTicketStatusOptionDto[];
  aopStatuses: WunderbricksAopTicketStatusOptionDto[];
}

export interface ZiezodanProjectConfigurationDto {
  enabled: boolean;
}

export interface AddMemberRequest {
  userIds: string[];
}

export interface AdoptionRateDetailsDto {
  period: BenchmarkPeriodDto;
  data: AdoptionRateDetailsGraphItemDto[];
  benchmark: AdoptionRateDetailsGraphItemDto[];
}

export interface AppointmentSelectionDto {
  canSelect: boolean;
  preparation: AppointmentPreparationDto;
}

export interface BookingAnalyticsAssetReferenceDto {
  id: string;
  name: string;
}

export interface BookingAnalyticsAssetRowDto {
  id: string;
  name: string;
  origin: BookingAnalyticsOriginDto;
  projectConnectionName?: string;
  /** @format int32 */
  bookings: number;
  /** @format int32 */
  uniqueBookers: number;
  /** @format double */
  bookedHours: number;
  /** @format double */
  cancellationPercentage: number;
  /** @format double */
  utilizationPercentage: number;
  enabled: boolean;
}

export interface BookingAnalyticsBookingRowDto {
  id: string;
  assetId: string;
  assetName: string;
  origin: BookingAnalyticsOriginDto;
  projectConnectionName?: string;
  authorName: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startsAt: string;
  weekday: BookingAnalyticsWeekdayDto;
  timeOfDay: BookingAnalyticsTimeOfDayDto;
  /** @format date-time */
  endsAt: string;
  /** @format double */
  durationHours: number;
  status: BookingAnalyticsStatusDto;
  bookingReason?: string;
}

export interface BookingAnalyticsDto {
  summary: BookingAnalyticsSummaryDto;
  monthly: BookingAnalyticsMonthlyPointDto[];
  audienceScopes: BookingAnalyticsAudienceScopeDto[];
  durationDistribution: BookingAnalyticsDistributionPointDto[];
  weekdayDistribution: BookingAnalyticsDistributionPointDto[];
  timeOfDayDistribution: BookingAnalyticsDistributionPointDto[];
  bookerDistribution: BookingAnalyticsDistributionPointDto[];
  assets: BookingAnalyticsAssetRowDto[];
  bookings: BookingAnalyticsBookingRowDto[];
  originCounts: BookingAnalyticsOriginCountsDto;
  filterOptions: BookingAnalyticsFilterOptionsDto;
}

export interface BookingAnalyticsFilterOptionsDto {
  assets: BookingAnalyticsAssetReferenceDto[];
}

export interface ChatBlockStatusDto {
  blockedByRequester: boolean;
  blockedByOtherUser: boolean;
}

export interface ChatDto {
  groupChatInfo?: GroupChatInfoDto;
  privateChatInfo?: PrivateChatInfoDto;
  chatType: ChatTypeDto;
  hasUnreadReply: boolean;
  /** @format int32 */
  unreadReplies: number;
  latestReply?: ChatReplyDto;
  /** @format date-time */
  pinnedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  notificationGlobalSetting: boolean;
  notificationChatSetting: boolean;
  blockStatus?: ChatBlockStatusDto;
  canReply: boolean;
  /**
   * Deprecated: Use /replies endpoint
   * @deprecated
   */
  replies: ChatReplyDtoPaginationResultDto;
  id: string;
}

export interface ChatReplyDto {
  image?: ImageDto;
  text?: string;
  /** @format date-time */
  sentAt: string;
  author?: UserDto;
  isUnread: boolean;
  hasBeenSeenByAll: boolean;
  replyType?: ReplyTypeDto;
  users?: SimpleUserDto[];
  videos: VideoDto[];
  id: string;
}

export interface ChatReplyRequest {
  /** @format uuid */
  imageId?: string;
  text?: string;
  videoIds?: string[];
}

export interface CommunityFeedAudienceGroupV2Dto {
  name: string;
  type: CommunityGroupTypeDto;
  /** @format date-time */
  lastActivityAt?: string;
  isResidentGroup: boolean;
  defaultPostingLevel: DefaultPostingAudienceDto;
  icon: CommunityGroupIconDto;
  image?: ImageDto;
  selectableAudience: CommunityFeedSelectableAudienceV2Dto[];
  id: string;
}

export interface CommunityFeedAudienceProjectConnectionV2Dto {
  name: string;
  /** @format int32 */
  audienceCount: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedAudienceProjectV2Dto {
  name: string;
  /** @format int32 */
  audienceCount?: number;
  /** @format int32 */
  addressWithUsersCount?: number;
  /** @format int32 */
  totalAddressCount?: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedAudienceV2Dto {
  interestGroups: CommunityFeedAudienceGroupV2Dto[];
  helpCategories: CommunityFeedAudienceGroupV2Dto[];
  realEstateGroups: CommunityFeedAudienceGroupV2Dto[];
  projectConnections: CommunityFeedAudienceProjectConnectionV2Dto[];
  project?: CommunityFeedAudienceProjectV2Dto;
}

export interface CommunityFeedBulkViewRequest {
  viewedPosts?: string[];
  viewedSurveys?: string[];
  viewedPolls?: string[];
}

export interface CommunityFeedItemV2Dto {
  type: CommunityFeedItemTypeDto;
  /** @format date-time */
  updatedAt?: string;
  message?: MessageV2Dto;
  survey?: CommunityFeedSurveyDto;
  poll?: PollDto;
}

export interface CommunityFeedSelectableAudienceItemV2Dto {
  name: string;
  /** @format int32 */
  audienceCount?: number;
  /** @format int32 */
  addressCount?: number;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  id: string;
}

export interface CommunityFeedSelectableAudienceV2Dto {
  type: CommunityFeedSelectableAudienceTypeV2Dto;
  project?: CommunityFeedSelectableAudienceItemV2Dto;
  projectConnection?: CommunityFeedSelectableAudienceItemV2Dto;
}

export interface CommunityGroupDetailsV2Dto {
  nameTranslations?: TranslationsDto[];
  descriptionTranslations?: TranslationsDto[];
  permissions?: UserRoleCommunityGroupPermissionsDto[];
  notificationSettings: AppNotificationGroupSettingDto;
  audience?: ConstraintListItemDto[];
  canPromote: boolean;
  /**
   * Indicates whether to show the promotion banner to the author.
   * Returns true as long as the group is not promoted or skipped by the author.
   */
  hasPromotionBanner: boolean;
  /** @format int32 */
  totalResidentsAudience?: number;
  /** @format int32 */
  joinedResidents?: number;
  originalLanguageId: LanguageIdDto;
  type: CommunityGroupTypeDto;
  isResidentGroup: boolean;
  name: string;
  description: string;
  isMember: boolean;
  image?: ImageDto;
  members: UserDtoPaginationResultDto;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canEdit: boolean;
  canDelete: boolean;
  disabled: boolean;
  projectConnectionGroupId?: string;
  systemGroupId?: string;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
  isOwner: boolean;
  hasAudience: boolean;
  /** @format date-time */
  lastActivityAt?: string;
  id: string;
}

export interface CommunityGroupV2Dto {
  type: CommunityGroupTypeDto;
  isResidentGroup: boolean;
  name: string;
  description: string;
  isMember: boolean;
  image?: ImageDto;
  members: UserDtoPaginationResultDto;
  canCreatePost: boolean;
  canCreateAnnouncement: boolean;
  canEdit: boolean;
  canDelete: boolean;
  disabled: boolean;
  projectConnectionGroupId?: string;
  systemGroupId?: string;
  postingLevel?: PostingLevelDto;
  icon: CommunityGroupIconDto;
  isOwner: boolean;
  hasAudience: boolean;
  /** @format date-time */
  lastActivityAt?: string;
  id: string;
}

export interface CreatableTicketCategoryInfoDto {
  canBePublic: boolean;
  projectHasMultipleBuildings: boolean;
  customIntroText?: string;
  regulations?: DocumentUploadDto;
  requireSignOffRegulations: boolean;
  requirePhoneNumber: boolean;
  requireImages: boolean;
  allowVideos: boolean;
  defaultAssignee?: UserDto;
  /**
   * Per-category integration flags the resident apps read to decide which integration flow
   * a repair in this category goes through. Mirrors the ticket DTO's `integrations` shape.
   */
  integrations: CreatableTicketCategoryIntegrationsDto;
  appointments: AppointmentSelectionDto;
}

/**
 * Per-category integration flags the resident apps read to decide which integration flow
 * a repair in this category goes through. Mirrors the ticket DTO's `integrations` shape.
 */
export interface CreatableTicketCategoryIntegrationsDto {
  jansenHuybregts: JansenHuybregtsCategoryFlagDto;
}

export interface CreatableTicketCategoryLocationDto {
  location: TicketCategoryLocationTypeDto;
  nodes: CreatableTicketCategoryNodeDto[];
}

export interface CreatableTicketCategoryNodeDto {
  id: string;
  name: string;
  description?: string;
  type: TicketCategoryNodeTypeDto;
  icon?: TicketCategoryNodeIconDto;
  nodeInfo?: CreatableTicketCategoryNodeInfoDto;
  children: CreatableTicketCategoryNodeDto[];
}

export interface CreatableTicketCategoryNodeInfoDto {
  canBePublic: boolean;
  projectHasMultipleBuildings: boolean;
  customIntroText?: string;
  regulations?: DocumentUploadDto;
  requireSignOffRegulations: boolean;
  requirePhoneNumber: boolean;
  requireImages: boolean;
  allowVideos: boolean;
  /**
   * Per-category integration flags the resident apps read to decide which integration flow
   * a repair in this category goes through. Mirrors the ticket DTO's `integrations` shape.
   */
  integrations: CreatableTicketCategoryIntegrationsDto;
  appointments: AppointmentSelectionDto;
}

export interface CreatableTicketCategoryNodeParentDto {
  name: string;
  id: string;
}

export interface CreatableTicketCategorySearchNodeDto {
  parents: CreatableTicketCategoryNodeParentDto[];
  id: string;
  name: string;
  description?: string;
  type: TicketCategoryNodeTypeDto;
  icon?: TicketCategoryNodeIconDto;
  nodeInfo?: CreatableTicketCategoryNodeInfoDto;
  children: CreatableTicketCategoryNodeDto[];
}

export interface CreatableTicketCategoryTreeDto {
  locations: CreatableTicketCategoryLocationDto[];
}

export interface CreatableTicketCategoryV2Dto {
  id: string;
  name: string;
  type: TicketCategoryTypeDto;
  categoryInfo?: CreatableTicketCategoryInfoDto;
  tree?: CreatableTicketCategoryTreeDto;
}

export interface CreatableTicketTreeDto {
  categories: CreatableTicketCategoryV2Dto[];
}

export interface CreateEventsRequest {
  /** @format int32 */
  recurrenceCount: number;
  recurrence?: RecurrenceDto;
  type: EventTypeDto;
  projectConnectionId?: string;
  name?: string;
  description?: string;
  /**
   * Deprecated: Use Name instead
   * @deprecated
   */
  nameTranslations?: TranslationRequest[];
  /**
   * Deprecated: Use Description instead
   * @deprecated
   */
  descriptionTranslations?: TranslationRequest[];
  /** @format int32 */
  maxParticipants?: number;
  /** @format int32 */
  maxGuestsPerParticipant?: number;
  categoryType: EventCategoryTypeDto;
  /** @format uuid */
  imageId?: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  /** @format date-time */
  publishAt?: string;
  location?: string;
  audience?: ConstraintListItemDto[];
}

export interface CreateGroupChatRequest {
  name: string;
  userIds: string[];
  /** @format uuid */
  imageId?: string;
}

export interface CreatePrivateChatRequest {
  userId: string;
}

export interface EngagedResidentsMonthlyPercentageDto {
  period: BenchmarkPeriodDto;
  benchmark: ProjectEngagementBenchmarkItemDto[];
  data: ProjectEngagementPercentageItemDto[];
}

export interface EventAnalyticsDto {
  eventTypeCounts: EventAnalyticsTypeCountsDto;
  originCounts: EventAnalyticsOriginCountsDto;
  summary: EventAnalyticsSummaryDto;
  monthly: EventAnalyticsMonthlyPointDto[];
  audienceScopes: EventAnalyticsAudienceScopeDto[];
  organizerActivity: EventAnalyticsOrganizerPointDto[];
  registrationSizes: EventAnalyticsChartPointDto[];
  registrationLeadTimes: EventAnalyticsChartPointDto[];
  capacity: EventAnalyticsCapacityDto;
  recurring: EventAnalyticsRecurringDto;
  events: EventAnalyticsEventRowDto[];
}

export interface EventAnalyticsEventRowDto {
  id: string;
  name: string;
  origin: EventAnalyticsOriginDto;
  /** @format date-time */
  startsAt: string;
  recurrence: EventAnalyticsRecurrenceDto;
  /** @format int32 */
  registrations: number;
  /** @format int32 */
  guests: number;
  /** @format int32 */
  capacity?: number;
  status: EventAnalyticsStatusDto;
  category: EventCategoryTypeDto;
}

export interface EventAnalyticsRecurringDto {
  /** @format int32 */
  seriesCount: number;
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  registrations: number;
  series: EventAnalyticsSeriesDto[];
}

export interface EventAnalyticsSeriesDto {
  id: string;
  name: string;
  frequency: EventAnalyticsRecurrenceFrequencyDto;
  /** @format int32 */
  occurrences: number;
  /** @format int32 */
  registrations: number;
  /** @format double */
  averageRegistrations: number;
  /** @format int32 */
  zeroRegistrationOccurrences: number;
  dataPoints: EventAnalyticsChartPointDto[];
}

export interface EventsCreatedDto {
  events: EventCreatedDto[];
}

export interface FeelingAtHomeDetailsV2Dto {
  /** @format date-time */
  startedAt: string;
  /** @format int32 */
  totalResponseCount?: number;
  /** @format int32 */
  totalAskedCount?: number;
  questions: FeelingAtHomeSurveyQuestionV2Dto[];
}

export interface FeelingAtHomeDto {
  id?: string;
  /** @format date-time */
  endDate?: string;
  /** @format double */
  averageRating: number;
  isAutomated: boolean;
}

export interface FeelingAtHomeSurveyQuestionV2Dto {
  id: string;
  ratingQuestionText: string;
  explanation?: string;
  openQuestionText?: string;
  /** @format double */
  averageRating?: number;
  /** @format int32 */
  responseCount: number;
  category: QuestionGroupType;
  ratingGroupedNumber: Record<string, number>;
  responses: FeelingAtHomeQuestionResponseDto[];
}

export interface FeelingAtHomeWidgetDto {
  feelingAtHomeScore?: FeelingAtHomeDto;
  previousFeelingAtHomeScore?: FeelingAtHomeDto;
  benchmarkFeelingAtHomeScore: FeelingAtHomeDto;
}

export interface GroupChatInfoDto {
  name: string;
  image?: ImageDto;
  isMember: boolean;
  canLeave: boolean;
}

export interface JansenHuybregtsCategoryFlagDto {
  enabled: boolean;
}

export interface MessageDetailV2Dto {
  likes: MessageReactionDto[];
  event?: MessageEventDto;
  title: string;
  poll?: PollDto;
  content: string;
  contentTemplate?: string;
  mentions: MentionDto[];
  autoTranslation?: MessageTranslationDto;
  images: ImageDto[];
  type: MessageTypeDto;
  /** @format int32 */
  totalLikeCount: number;
  author: UserDto;
  group?: GroupDto;
  projectConnection?: ProjectConnectionDto;
  hasCommented: boolean;
  canEdit: boolean;
  canLike: boolean;
  canComment: boolean;
  canReport: boolean;
  canShare: boolean;
  canArchive: boolean;
  /**
   * Whether you can delete your own message. (Deprecated: Use CanDeleteOwn instead.)
   * @deprecated
   */
  canDelete: boolean;
  /** Whether you can delete your own message. */
  canDeleteOwn: boolean;
  /** Whether you can delete other users' messages. */
  canDeleteOther: boolean;
  isHiddenFromAdmins: boolean;
  isUnread: boolean;
  isLiked: boolean;
  isMuted: boolean;
  hasAdminBeenInformed: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  reportedAt?: string;
  /** @format date-time */
  updatedAt?: string;
  /** @format date-time */
  scheduledAt?: string;
  /** @format date-time */
  postedAt?: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: SimpleUserDto;
  /** @format date-time */
  archivedAt?: string;
  messageLabel?: MessageLabelDto;
  languageIsoCode: string;
  /** @format int32 */
  totalCommentCount: number;
  /** @format date-time */
  lastActivityAt?: string;
  documents: DocumentUploadDto[];
  videos: VideoDto[];
  issueStatus?: IssueStatusDto;
  /** The reference to the related group, in case the message is trying to promote a group. */
  relatedGroup?: RelatedGroupDto;
  totalReactionCountByType: Record<string, number>;
  requesterReactionType?: ReactionTypeDto;
  isInactivePost: boolean;
  /** @format int32 */
  uniqueViewCount?: number;
  viewTracked: boolean;
  bulkMessageId?: string;
  id: string;
}

export interface MessageStatusChangeRequestV2 {
  newStatus: MessageStatusDto;
  reason: ClosePostReasonV2Dto;
  details?: string;
}

export interface ChatDtoPaginationResultDto {
  items: ChatDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface ChatReplyDtoPaginationResultDto {
  items: ChatReplyDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CommunityFeedItemV2DtoPaginationResultDto {
  items: CommunityFeedItemV2Dto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface CommunityGroupV2DtoPaginationResultDto {
  items: CommunityGroupV2Dto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface MessageV2DtoPaginationResultDto {
  items: MessageV2Dto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PortfolioChatDtoPaginationResultDto {
  items: PortfolioChatDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PortfolioUserDtoPaginationResultDto {
  items: PortfolioUserDto[];
  /** @format int32 */
  total: number;
  hasMore: boolean;
}

export interface PortfolioChatDto {
  project: SimpleProjectDto;
  groupChatInfo?: GroupChatInfoDto;
  privateChatInfo?: PrivateChatInfoDto;
  chatType: ChatTypeDto;
  hasUnreadReply: boolean;
  /** @format int32 */
  unreadReplies: number;
  latestReply?: ChatReplyDto;
  /** @format date-time */
  pinnedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  notificationGlobalSetting: boolean;
  notificationChatSetting: boolean;
  blockStatus?: ChatBlockStatusDto;
  canReply: boolean;
  /**
   * Deprecated: Use /replies endpoint
   * @deprecated
   */
  replies: ChatReplyDtoPaginationResultDto;
  id: string;
}

export interface PortfolioChatPermissionRequest {
  chatPermission: ChatPermission;
}

export interface PortfolioUserDto {
  project?: SimpleProjectDto;
  /**
   * Deprecated: Use Avatar instead (notice: provide own fallback image)
   * @deprecated
   */
  avatarUrl?: string;
  avatar?: ImageDto;
  /** @format date-time */
  deletedAt?: string;
  email?: string;
  isAdmin: boolean;
  canViewProfile: boolean;
  chatEnabled: boolean;
  chatPermission: ChatPermission;
  phoneNumberHidden: boolean;
  emailHidden: boolean;
  hideHouseNumber: boolean;
  fullName: string;
  firstName: string;
  lastName: string;
  projectId: string;
  id: string;
}

export interface PrivateChatInfoDto {
  receiver: UserDto;
}

export interface ProjectEngagementPercentageItemDto {
  /** @format int32 */
  engagedResident: number;
  /** @format double */
  eventCountPercentage: number;
  /** @format double */
  likeCountPercentage: number;
  /** @format double */
  postCountPercentage: number;
  /** @format double */
  surveyCountPercentage: number;
  /** @format double */
  pollCountPercentage: number;
  /** @format double */
  collectiveTicketCountPercentage: number;
  /** @format double */
  commentCountPercentage: number;
  /** @format double */
  commentLikeCountPercentage: number;
  /** @format int32 */
  privateTicketCount: number;
  /** @format int32 */
  chatCount: number;
  /** @format double */
  chatCountPercentage: number;
  /** @format int32 */
  ratedTicketCount?: number;
  /** @format int32 */
  surveysAnsweredCount: number;
  /** @format int32 */
  eventsAtendeesCount: number;
  /** @format int32 */
  pollsAnsweredCount: number;
  /** @format int32 */
  residentGroupsCreatedCount: number;
  /** @format int32 */
  totalContributionCount: number;
  isCurrentMonth: boolean;
  /** @format double */
  engagedResidentPercentage: number;
  /** @format int32 */
  postCount: number;
  /** @format int32 */
  commentCount: number;
  /** @format int32 */
  likeCount: number;
  /** @format int32 */
  commentLikeCount: number;
  /** @format int32 */
  collectiveTicketCount: number;
  /** @format int32 */
  eventCount: number;
  /** @format int32 */
  surveyCount: number;
  /** @format int32 */
  pollCount: number;
  /** @format int32 */
  reservationCount: number;
  range: MonthlyReportDateRangeDto;
}

export interface QuickReplyMessageCreateTokenRequest {
  messageId: string;
}

export interface QuickReplyTicketCreateTokenRequest {
  ticketId: string;
}

export interface RegistrationConnectDto {
  result: RegistrationConnectStateDto;
}

export interface RegistrationRequestV2 {
  /** Code scanned or entered by the user. Send either a location code or a housemate invite code here; the backend validates location codes first and tries housemate invites when no location exists. */
  code?: string;
  /**
   * Deprecated: Use Code instead
   * @deprecated
   */
  locationCode?: string;
  languageId?: string;
  locationCodeInput?: LocationCodeInputDto;
}

export interface RemoveMemberRequest {
  userId: string;
}

export interface ResidentEngagementMonthlyBenchmarkDto {
  /** @format double */
  percentage: number;
  range: MonthlyReportDateRangeDto;
}

export interface ResidentEngagementMonthlyDataDto {
  /** @format double */
  percentage: number;
  range: MonthlyReportDateRangeDto;
  isCurrentMonth: boolean;
}

export interface ResidentEngagementMonthlyV2Dto {
  benchmark: ResidentEngagementMonthlyBenchmarkDto[];
  data: ResidentEngagementMonthlyDataDto[];
}

export interface SelfUpdateRequest {
  /**
   * Deprecated: Use UiLanguageId and AutoTranslationLanguageId instead
   * @deprecated
   */
  languageId?: LanguageIdDto;
  /** Language for static UI text translated through POEditor. */
  uiLanguageId?: LanguageIdDto;
  /** Language used for dynamic auto translations. Null disables automatic translation. */
  autoTranslationLanguageId?: string;
  hideEmail: boolean;
  hidePhoneNumber: boolean;
  hideHouseNumber: boolean;
  enableChat: boolean;
  firstName: string;
  lastName: string;
  biography?: string;
  phoneNumber?: string;
  occupation?: string;
  avatarId?: string;
}

export interface SurveyDetailsV2Dto {
  questionGroups: SurveyQuestionGroupDto[];
  completedMessage: string;
  endedMessage: string;
  scope: SurveyScope;
  isInternal: boolean;
  originalLanguageId: LanguageIdDto;
  type: SurveyTypeDto;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  startsAt: string;
  /** @format date-time */
  endsAt: string;
  group?: GroupDto;
  title: string;
  description: string;
  canRespond: CanRespondStatusDto;
  canView: boolean;
  canViewResults: boolean;
  canEdit: boolean;
  canDelete: boolean;
  createdBy?: UserDto;
  /** @format int32 */
  questionCount: number;
  /** @format int32 */
  answerCount?: number;
  isUnread: boolean;
  isPublished: boolean;
  category: SurveyCategoryDto;
  /** @format date-time */
  followedUpAt?: string;
  viewTracked: boolean;
  status: SurveyStatusDto;
  bulkSurveyId?: string;
  id: string;
}

export interface SurveyQuestionGroupDto {
  explanation: string;
  /** @format int32 */
  order: number;
  questions: QuestionDto[];
}

export interface TicketAnalyticsDto {
  summary: TicketAnalyticsSummaryDto;
  monthly: TicketAnalyticsMonthlyPointDto[];
  benchmark: TicketAnalyticsBenchmarkPointDto[];
  categories: TicketAnalyticsCategoryDto[];
  backlogAgeBuckets: TicketAnalyticsDistributionPointDto[];
  resolutionBuckets: TicketAnalyticsDistributionPointDto[];
  visibilityDistribution: TicketAnalyticsDistributionPointDto[];
  tickets: TicketAnalyticsRowDto[];
  filterOptions: TicketAnalyticsFilterOptionsDto;
}

export interface TicketAnalyticsRowDto {
  id: string;
  title: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  closedAt?: string;
  category: TicketAnalyticsCategoryReferenceDto;
  status: TicketAnalyticsStatusReferenceDto;
  visibility: TicketAnalyticsVisibilityDto;
  reporterName: string;
  assigneeName?: string;
  /** @format double */
  resolutionDays?: number;
  /** @format double */
  rating?: number;
}

export interface TicketAnalyticsStatusReferenceDto {
  type: TicketAnalyticsStatusDto;
  name: string;
  color: string;
}

export interface UpdateGroupChatRequest {
  name: string;
  /** @format uuid */
  imageId?: string;
}

export interface UserBulkDeleteRequest {
  projectIds?: string[];
}

export interface CommunityPillarDto {
  type: CommunityPillarTypeDto;
  /** @format double */
  score: number;
  /** @format int32 */
  responseCount: number;
  /** @format int32 */
  priority: number;
}

export interface CommunityPillarProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  pillars: CommunityPillarDto[];
}

export interface CommunityPillarsDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: CommunityPillarProjectDto[];
}

export interface CommunitySupportDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: CommunitySupportProjectDto[];
}

export interface CommunitySupportProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /** @format int32 */
  helpRequestCount: number;
  /** @format int32 */
  solvedHelpRequestCount: number;
}

export interface PlatformReachDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: PlatformReachProjectDto[];
}

export interface PlatformReachProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /** @format int32 */
  totalAddressCount: number;
  /** @format int32 */
  reachableAddressCount: number;
  /** @format int32 */
  adminPostCount: number;
  /** @format date-time */
  adminsLastPostedAt?: string;
}

export interface PlatformResidentsDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: ProjectResidentsDto[];
}

export interface PortfolioFeelingAtHomeDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: PortfolioFeelingAtHomeProjectDto[];
}

export interface PortfolioFeelingAtHomeProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /** @format int32 */
  responseCount: number;
  /** @format double */
  feelAtHomeScore: number;
}

export interface ProjectResidentsDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /**
   * Total amount of residents invited
   * @format int32
   */
  invitedResidentCount: number;
  /**
   * Total amount of residents onboarded
   * @format int32
   */
  onboardedResidentCount: number;
  /**
   * Total amount of residents that are considered "engaged" - actively using the platform
   * @format int32
   */
  engagedResidentCount: number;
  /**
   * Total amount of residents that are considered "socially involved" - participating in community interactions
   * @format int32
   */
  contributingResidentCount: number;
  /**
   * Total amount of residents that are considered "supportive" - resolving others' help requests in the community feed
   * @format int32
   */
  supportiveResidentCount: number;
  /** Benchmark percentages for engaged and socially-active residents based on project type and maturity period */
  benchmark: ResidentsBenchmarkDto;
}

export interface ResidentNotificationResultDto {
  notifications: ResidentNotificationDtoPaginationResultDto;
  /** @format date-time */
  lastRequested?: string;
}

export interface ResidentsBenchmarkDto {
  /**
   * Benchmark percentage for onboarded (adopted) residents
   * @format int32
   */
  adoptionPercentage: number;
  /**
   * Benchmark percentage for engaged residents
   * @format int32
   */
  engagedResidentPercentage: number;
  /**
   * Benchmark percentage for socially-active (contributing) residents
   * @format int32
   */
  contributingResidentPercentage: number;
}

export interface TicketsResolutionTimeDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: TicketsResolutionTimeProjectDto[];
}

export interface TicketsResolutionTimeProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /** @format int32 */
  closedTicketCount: number;
  /** @format double */
  avgResolutionTimeInDays: number;
}

export interface TicketsSatisfactionDto {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  projects: TicketsSatisfactionProjectDto[];
}

export interface TicketsSatisfactionProjectDto {
  projectId: string;
  projectName: string;
  projectSlug: string;
  projectLogo: ImageDto;
  /** @format int32 */
  ticketCount: number;
  /** @format double */
  avgSatisfactionScore: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    ["application/json"]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["application/vnd.api+json"]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["text/plain"]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    ["multipart/form-data"]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    ["application/x-www-form-urlencoded"]: (input: any) =>
      this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || "application/json"];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== "multipart/form-data"
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Area of People Core API V3
 * @version v3
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Home
   * @name Get
   * @request GET:/
   */
  get = (
    query?: {
      "api-version"?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  wellKnown = {
    /**
     * No description
     *
     * @tags McpOAuth
     * @name GetWellKnownOauthProtectedResourceMcp
     * @request GET:/.well-known/oauth-protected-resource/mcp
     */
    "get.wellKnownOauthProtectedResourceMcp": (
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<McpOAuthProtectedResourceMetadata, any>({
        path: `/.well-known/oauth-protected-resource/mcp`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpOAuth
     * @name GetWellKnownOauthAuthorizationServerMcp
     * @request GET:/.well-known/oauth-authorization-server/mcp
     */
    "get.wellKnownOauthAuthorizationServerMcp": (
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<McpOAuthAuthorizationServerMetadata, any>({
        path: `/.well-known/oauth-authorization-server/mcp`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  mcp = {
    /**
     * No description
     *
     * @tags McpOAuth
     * @name PostMcpOauthRegister
     * @request POST:/mcp/oauth/register
     */
    postMcpOauthRegister: (
      data: McpOAuthClientRegistrationRequest,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<McpOAuthClientRegistrationResponse, any>({
        path: `/mcp/oauth/register`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpOAuth
     * @name GetMcpOauthAuthorize
     * @request GET:/mcp/oauth/authorize
     */
    getMcpOauthAuthorize: (
      query?: {
        response_type?: string;
        client_id?: string;
        redirect_uri?: string;
        state?: string;
        scope?: string;
        code_challenge?: string;
        code_challenge_method?: string;
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/mcp/oauth/authorize`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpOAuth
     * @name PostMcpOauthAuthorize
     * @request POST:/mcp/oauth/authorize
     */
    postMcpOauthAuthorize: (
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/mcp/oauth/authorize`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpOAuth
     * @name PostMcpOauthToken
     * @request POST:/mcp/oauth/token
     */
    postMcpOauthToken: (
      data: any,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/mcp/oauth/token`,
        method: "POST",
        query: query,
        body: data,
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags Addresses
     * @name GetAddressesV1
     * @request GET:/api/v1/addresses
     * @secure
     */
    getAddressesV1: (
      query?: {
        Search?: string;
        AddressType?: string[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AddressDtoPaginationResultDto, any>({
        path: `/api/v1/addresses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name PostAddressesV1
     * @request POST:/api/v1/addresses
     * @secure
     */
    postAddressesV1: (data: AddressCreateRequest, params: RequestParams = {}) =>
      this.request<AddressDto, any>({
        path: `/api/v1/addresses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name GetAddressesStatsV1
     * @request GET:/api/v1/addresses/stats
     * @secure
     */
    getAddressesStatsV1: (params: RequestParams = {}) =>
      this.request<AddressStatsDto, any>({
        path: `/api/v1/addresses/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name GetAddressesDetailsV1
     * @request GET:/api/v1/addresses/{id}
     * @secure
     */
    getAddressesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<AddressDto, any>({
        path: `/api/v1/addresses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name PutAddressesV1
     * @request PUT:/api/v1/addresses/{id}
     * @secure
     */
    putAddressesV1: (
      id: string,
      data: AddressEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/addresses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name DeleteAddressesByIdV1
     * @request DELETE:/api/v1/addresses/{id}
     * @secure
     */
    deleteAddressesByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/addresses/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name PutAddressesRegenerateLocationCodeV1
     * @request PUT:/api/v1/addresses/{id}/regenerate-location-code
     * @secure
     */
    putAddressesRegenerateLocationCodeV1: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/addresses/${id}/regenerate-location-code`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name GetAddressesTypesV1
     * @request GET:/api/v1/addresses/types
     * @secure
     */
    getAddressesTypesV1: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/addresses/types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminNotifications
     * @name GetAdminNotificationsV1
     * @request GET:/api/v1/admin-notifications
     * @secure
     */
    getAdminNotificationsV1: (
      query?: {
        ExcludeRead?: boolean;
        Types?: AdminNotificationTypeDto[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminNotificationDtoPaginationResultDto, any>({
        path: `/api/v1/admin-notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminNotifications
     * @name GetAdminNotificationsStatusV1
     * @request GET:/api/v1/admin-notifications/status
     * @secure
     */
    getAdminNotificationsStatusV1: (params: RequestParams = {}) =>
      this.request<AdminNotificationStatusDto, any>({
        path: `/api/v1/admin-notifications/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminNotifications
     * @name DeleteAdminNotificationsReadByIdV1
     * @request DELETE:/api/v1/admin-notifications/read/{id}
     * @secure
     */
    deleteAdminNotificationsReadByIdV1: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin-notifications/read/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminNotifications
     * @name DeleteAdminNotificationsReadV1
     * @request DELETE:/api/v1/admin-notifications/read
     * @secure
     */
    deleteAdminNotificationsReadV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin-notifications/read`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsTicketRatingMonthlyV1
     * @request GET:/api/v1/analytics/ticket-rating/monthly
     * @secure
     */
    getAnalyticsTicketRatingMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketAverageRatingMonthlyDto, any>({
        path: `/api/v1/analytics/ticket-rating/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsTicketLeadTimeMonthlyV1
     * @request GET:/api/v1/analytics/ticket-lead-time/monthly
     * @secure
     */
    getAnalyticsTicketLeadTimeMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketAverageLeadTimeMonthlyDto, any>({
        path: `/api/v1/analytics/ticket-lead-time/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Analytics
     * @name GetAnalyticsEngagedResidentsMonthlyV1
     * @request GET:/api/v1/analytics/engaged-residents/monthly
     * @deprecated
     * @secure
     */
    getAnalyticsEngagedResidentsMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<EngagedResidentsMonthlyDto, any>({
        path: `/api/v1/analytics/engaged-residents/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsTicketOverviewMonthlyV1
     * @request GET:/api/v1/analytics/ticket-overview/monthly
     * @secure
     */
    getAnalyticsTicketOverviewMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketOverviewDto, any>({
        path: `/api/v1/analytics/ticket-overview/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsConversationsMonthlyV1
     * @request GET:/api/v1/analytics/conversations/monthly
     * @secure
     */
    getAnalyticsConversationsMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationsMonthlyDto, any>({
        path: `/api/v1/analytics/conversations/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsAskForHelpMonthlyV1
     * @request GET:/api/v1/analytics/ask-for-help/monthly
     * @secure
     */
    getAnalyticsAskForHelpMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<AskForHelpMonthlyDto, any>({
        path: `/api/v1/analytics/ask-for-help/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsBucketTicketLeadTimeMonthlyV1
     * @request GET:/api/v1/analytics/bucket-ticket-lead-time/monthly
     * @secure
     */
    getAnalyticsBucketTicketLeadTimeMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<BucketLeadTimeMonthlyDto, any>({
        path: `/api/v1/analytics/bucket-ticket-lead-time/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsAdoptionRateV1
     * @request GET:/api/v1/analytics/adoption-rate
     * @secure
     */
    getAnalyticsAdoptionRateV1: (params: RequestParams = {}) =>
      this.request<AdoptionRateDto, any>({
        path: `/api/v1/analytics/adoption-rate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsCompanyAdoptionRateV1
     * @request GET:/api/v1/analytics/company-adoption-rate
     * @secure
     */
    getAnalyticsCompanyAdoptionRateV1: (params: RequestParams = {}) =>
      this.request<CompanyAdoptionRateDto, any>({
        path: `/api/v1/analytics/company-adoption-rate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Analytics
     * @name GetAnalyticsAdoptionRateDetailsDetailsV1
     * @request GET:/api/v1/analytics/adoption-rate/details/{adoptionRateDetailsGraphType}
     * @deprecated
     * @secure
     */
    getAnalyticsAdoptionRateDetailsDetailsV1: (
      adoptionRateDetailsGraphType: AdoptionRateDetailsGraphTypeDto,
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdoptionRateDetailsGraphItemDto[], any>({
        path: `/api/v1/analytics/adoption-rate/details/${adoptionRateDetailsGraphType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsResidentEngagementV1
     * @summary The engagement of residents on a current basis (last 24 hours, last 7 days, last 30 days) These numbers are calculated on the fly
     * @request GET:/api/v1/analytics/resident-engagement
     * @secure
     */
    getAnalyticsResidentEngagementV1: (params: RequestParams = {}) =>
      this.request<ResidentEngagementDto, any>({
        path: `/api/v1/analytics/resident-engagement`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Analytics
     * @name GetAnalyticsResidentEngagementDetailsV1
     * @summary The engagement of residents on a monthly basis These numbers are stored on a monthly basis
     * @request GET:/api/v1/analytics/resident-engagement/details
     * @deprecated
     * @secure
     */
    getAnalyticsResidentEngagementDetailsV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResidentEngagementMonthlyDto[], any>({
        path: `/api/v1/analytics/resident-engagement/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsWeeklyChatConversationsV1
     * @request GET:/api/v1/analytics/weekly-chat-conversations
     * @secure
     */
    getAnalyticsWeeklyChatConversationsV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<WeeklyCountOverviewDto, any>({
        path: `/api/v1/analytics/weekly-chat-conversations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsWeeklyMessagesV1
     * @request GET:/api/v1/analytics/weekly-messages
     * @secure
     */
    getAnalyticsWeeklyMessagesV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<WeeklyCountOverviewDto, any>({
        path: `/api/v1/analytics/weekly-messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsMessageLabelStatsV1
     * @request GET:/api/v1/analytics/message-label-stats
     * @secure
     */
    getAnalyticsMessageLabelStatsV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageLabelsStatMonthlyDto, any>({
        path: `/api/v1/analytics/message-label-stats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeV1
     * @request GET:/api/v1/analytics/feeling-at-home
     * @secure
     */
    getAnalyticsFeelingAtHomeV1: (params: RequestParams = {}) =>
      this.request<FeelingAtHomeWidgetV2Dto, any>({
        path: `/api/v1/analytics/feeling-at-home`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeSuggestionsV1
     * @request GET:/api/v1/analytics/feeling-at-home/suggestions
     * @secure
     */
    getAnalyticsFeelingAtHomeSuggestionsV1: (params: RequestParams = {}) =>
      this.request<FeelingAtHomeWidgetSuggestionsDto, any>({
        path: `/api/v1/analytics/feeling-at-home/suggestions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name PostAnalyticsFeelingAtHomeSuggestionsReadV1
     * @request POST:/api/v1/analytics/feeling-at-home/suggestions/{suggestionId}/read
     * @secure
     */
    postAnalyticsFeelingAtHomeSuggestionsReadV1: (
      suggestionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/analytics/feeling-at-home/suggestions/${suggestionId}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name PostAnalyticsFeelingAtHomeSuggestionsTipsRateV1
     * @request POST:/api/v1/analytics/feeling-at-home/suggestions/tips/{tipId}/rate
     * @secure
     */
    postAnalyticsFeelingAtHomeSuggestionsTipsRateV1: (
      tipId: string,
      data: AiResponseRatingDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/analytics/feeling-at-home/suggestions/tips/${tipId}/rate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeMonthlyV1
     * @request GET:/api/v1/analytics/feeling-at-home/monthly
     * @secure
     */
    getAnalyticsFeelingAtHomeMonthlyV1: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<FeelingAtHomeDataMonthlyDto[], any>({
        path: `/api/v1/analytics/feeling-at-home/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeDetailsV1
     * @request GET:/api/v1/analytics/feeling-at-home/details
     * @secure
     */
    getAnalyticsFeelingAtHomeDetailsV1: (
      query?: {
        /** @format date-time */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FeelingAtHomeDetailsDto, any>({
        path: `/api/v1/analytics/feeling-at-home/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeExportV1
     * @request GET:/api/v1/analytics/feeling-at-home/export
     * @secure
     */
    getAnalyticsFeelingAtHomeExportV1: (
      query?: {
        /** @format date-time */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/analytics/feeling-at-home/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsCommunityFeedV1
     * @request GET:/api/v1/analytics/community-feed
     * @secure
     */
    getAnalyticsCommunityFeedV1: (params: RequestParams = {}) =>
      this.request<CommunityFeedAnalyticsDto, any>({
        path: `/api/v1/analytics/community-feed`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name PostAssistantChatV1
     * @request POST:/api/v1/assistant/chat
     * @secure
     */
    postAssistantChatV1: (
      data: AssistantChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<IBaseStreamChunk[], any>({
        path: `/api/v1/assistant/chat`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name GetAssistantConversationsV1
     * @request GET:/api/v1/assistant/conversations
     * @secure
     */
    getAssistantConversationsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssistantConversationListItemDtoPaginationResultDto, any>({
        path: `/api/v1/assistant/conversations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name GetAssistantConversationsDetailsV1
     * @request GET:/api/v1/assistant/conversations/{conversationId}
     * @secure
     */
    getAssistantConversationsDetailsV1: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<AssistantConversationListItemDto, any>({
        path: `/api/v1/assistant/conversations/${conversationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name DeleteAssistantConversationsByIdV1
     * @request DELETE:/api/v1/assistant/conversations/{conversationId}
     * @secure
     */
    deleteAssistantConversationsByIdV1: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/assistant/conversations/${conversationId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name GetAssistantConversationsMessagesV1
     * @request GET:/api/v1/assistant/conversations/{conversationId}/messages
     * @secure
     */
    getAssistantConversationsMessagesV1: (
      conversationId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssistantConversationMessageDtoPaginationResultDto, any>({
        path: `/api/v1/assistant/conversations/${conversationId}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name PostAssistantConversationsRateV1
     * @request POST:/api/v1/assistant/conversations/{conversationId}/rate
     * @secure
     */
    postAssistantConversationsRateV1: (
      conversationId: string,
      data: RateMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/assistant/conversations/${conversationId}/rate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant
     * @name PostAssistantConversationsMessagesRateV1
     * @request POST:/api/v1/assistant/conversations/{conversationId}/messages/{messageId}/rate
     * @secure
     */
    postAssistantConversationsMessagesRateV1: (
      conversationId: string,
      messageId: string,
      data: RateMessageDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/assistant/conversations/${conversationId}/messages/${messageId}/rate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name GetAuthenticationStatusV1
     * @request GET:/api/v1/authentication/status
     * @secure
     */
    getAuthenticationStatusV1: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/authentication/status`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrandedAppAgreements
     * @name GetBrandedAppAgreementsV1
     * @request GET:/api/v1/branded-app-agreements
     * @secure
     */
    getBrandedAppAgreementsV1: (params: RequestParams = {}) =>
      this.request<BrandedAppAgreementOverviewDto[], any>({
        path: `/api/v1/branded-app-agreements`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrandedAppAgreements
     * @name PostBrandedAppAgreementsV1
     * @request POST:/api/v1/branded-app-agreements
     * @secure
     */
    postBrandedAppAgreementsV1: (
      data: SendBrandedAppAgreementRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<BrandedAppAgreementRequestDto, any>({
        path: `/api/v1/branded-app-agreements`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrandedAppAgreements
     * @name GetBrandedAppAgreementsDetailsV1
     * @request GET:/api/v1/branded-app-agreements/{token}
     */
    getBrandedAppAgreementsDetailsV1: (
      token: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicBrandedAppAgreementRequestDto, any>({
        path: `/api/v1/branded-app-agreements/${token}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrandedAppAgreements
     * @name PostBrandedAppAgreementsConfirmV1
     * @request POST:/api/v1/branded-app-agreements/{token}/confirm
     */
    postBrandedAppAgreementsConfirmV1: (
      token: string,
      params: RequestParams = {},
    ) =>
      this.request<PublicBrandedAppAgreementRequestDto, any>({
        path: `/api/v1/branded-app-agreements/${token}/confirm`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buildings
     * @name GetBuildingsV1
     * @request GET:/api/v1/buildings
     * @secure
     */
    getBuildingsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BuildingDtoPaginationResultDto, any>({
        path: `/api/v1/buildings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buildings
     * @name PostBuildingsV1
     * @request POST:/api/v1/buildings
     * @secure
     */
    postBuildingsV1: (
      data: BuildingCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<BuildingDto, any>({
        path: `/api/v1/buildings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buildings
     * @name GetBuildingsDetailsV1
     * @request GET:/api/v1/buildings/{id}
     * @secure
     */
    getBuildingsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<BuildingDto, any>({
        path: `/api/v1/buildings/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buildings
     * @name PutBuildingsV1
     * @request PUT:/api/v1/buildings/{id}
     * @secure
     */
    putBuildingsV1: (
      id: string,
      data: BuildingEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/buildings/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buildings
     * @name DeleteBuildingsByIdV1
     * @request DELETE:/api/v1/buildings/{id}
     * @secure
     */
    deleteBuildingsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/buildings/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calendar
     * @name GetCalendarV1
     * @request GET:/api/v1/calendar
     * @secure
     */
    getCalendarV1: (params: RequestParams = {}) =>
      this.request<CalendarItemDto[], any>({
        path: `/api/v1/calendar`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatNotificationSettings
     * @name GetChatsNotificationSettingsV1
     * @request GET:/api/v1/chats/{chat}/notification-settings
     * @secure
     */
    getChatsNotificationSettingsV1: (
      chat: string,
      params: RequestParams = {},
    ) =>
      this.request<AppNotificationSettingDto, any>({
        path: `/api/v1/chats/${chat}/notification-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatNotificationSettings
     * @name PutChatsNotificationSettingsV1
     * @request PUT:/api/v1/chats/{chat}/notification-settings
     * @secure
     */
    putChatsNotificationSettingsV1: (
      chat: string,
      data: AppNotificationSettingRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppNotificationSettingDto, any>({
        path: `/api/v1/chats/${chat}/notification-settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsStatusV1
     * @request GET:/api/v1/chats/status
     * @secure
     */
    getChatsStatusV1: (params: RequestParams = {}) =>
      this.request<ChatStatusDto, any>({
        path: `/api/v1/chats/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsAvailableUsersV1
     * @request GET:/api/v1/chats/available-users
     * @secure
     */
    getChatsAvailableUsersV1: (
      query?: {
        search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserExtendedDtoPaginationResultDto, any>({
        path: `/api/v1/chats/available-users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsAvailableUsersDetailsV1
     * @request GET:/api/v1/chats/available-users/{id}
     * @secure
     */
    getChatsAvailableUsersDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<UserDto, any>({
        path: `/api/v1/chats/available-users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsStateV1
     * @request POST:/api/v1/chats/state
     * @secure
     */
    postChatsStateV1: (
      data: ChatStateChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/chats/state`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * @description Do note that this paginationQuery applies it to each of the entities. Meaning that if you set the limit to 3, this would set the limit to 3 for both Messages and Surveys; resulting into 6 items (if both Messages and Surveys have enough available). (Deprecated: Use V2 instead)
     *
     * @tags CommunityFeed
     * @name GetCommunityFeedV1
     * @request GET:/api/v1/community-feed
     * @deprecated
     * @secure
     */
    getCommunityFeedV1: (
      query?: {
        Query?: string;
        PosterId?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        GroupIds?: string[];
        Tab?: CommunityFeedTabsDto;
        Connection?: CommunityFeedConnectionFilterDto;
        ExcludeArchivedPosts?: boolean;
        FeedTypes?: CommunityFeedType[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedItemV1DtoPaginationResultDto, any>({
        path: `/api/v1/community-feed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags CommunityFeed
     * @name GetCommunityFeedAudienceV1
     * @request GET:/api/v1/community-feed/audience
     * @deprecated
     * @secure
     */
    getCommunityFeedAudienceV1: (
      query?: {
        /** Whether the endpoint returns only the audience you can create normal posts in, or also the audience you can create announcements in. */
        IncludeAnnouncements?: boolean;
        /** Whether the endpoint returns only the groups you can create project posts in. */
        ExcludeProjectConnections?: boolean;
        GroupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedAudienceDto, any>({
        path: `/api/v1/community-feed/audience`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompaniesV1
     * @summary Retrieves Companies for the logged in user
     * @request GET:/api/v1/companies
     * @secure
     */
    getCompaniesV1: (
      query?: {
        search?: string;
        SortBy?: CompanySortablePropertiesDto;
        SortDescending?: boolean;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyDtoPaginationResultDto, any>({
        path: `/api/v1/companies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name PostCompaniesV1
     * @request POST:/api/v1/companies
     * @secure
     */
    postCompaniesV1: (data: CompanyRequest, params: RequestParams = {}) =>
      this.request<CompanyDto, any>({
        path: `/api/v1/companies`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint will filter out company the logged in user can't see
     *
     * @tags Companies
     * @name GetCompaniesDetailsV1
     * @summary Retrieves companies by given id
     * @request GET:/api/v1/companies/{id}
     * @secure
     */
    getCompaniesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<CompanyDto, any>({
        path: `/api/v1/companies/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name PutCompaniesV1
     * @request PUT:/api/v1/companies/{id}
     * @secure
     */
    putCompaniesV1: (
      id: string,
      data: CompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/companies/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name DeleteCompaniesByIdV1
     * @request DELETE:/api/v1/companies/{id}
     * @secure
     */
    deleteCompaniesByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/companies/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name PutCompaniesRegenerateLocationCodeV1
     * @request PUT:/api/v1/companies/{id}/regenerate-location-code
     * @secure
     */
    putCompaniesRegenerateLocationCodeV1: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/companies/${id}/regenerate-location-code`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompaniesMembersV1
     * @request GET:/api/v1/companies/{id}/members
     * @secure
     */
    getCompaniesMembersV1: (
      id: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserExtendedDtoPaginationResultDto, any>({
        path: `/api/v1/companies/${id}/members`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name GetConfigurationV1
     * @request GET:/api/v1/configuration
     */
    getConfigurationV1: (
      query?: {
        /** @default 0 */
        appBrand?: AppBrandingDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/api/v1/configuration`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name GetConfigurationBrandsV1
     * @request GET:/api/v1/configuration/brands
     */
    getConfigurationBrandsV1: (params: RequestParams = {}) =>
      this.request<AppBrandingDetailsDto[], any>({
        path: `/api/v1/configuration/brands`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Configuration
     * @name GetConfigurationBrandsDetailsV1
     * @request GET:/api/v1/configuration/brands/{brand}
     */
    getConfigurationBrandsDetailsV1: (
      brand: string,
      params: RequestParams = {},
    ) =>
      this.request<AppBrandingDetailsDto, any>({
        path: `/api/v1/configuration/brands/${brand}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Constraints
     * @name GetConstraintsV1
     * @request GET:/api/v1/constraints
     * @secure
     */
    getConstraintsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConstraintListItemDtoPaginationResultDto, any>({
        path: `/api/v1/constraints`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsV1
     * @request GET:/api/v1/documents
     * @secure
     */
    getDocumentsV1: (params: RequestParams = {}) =>
      this.request<DocumentsRootDto, any>({
        path: `/api/v1/documents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsRecentlyUploadedV1
     * @summary Retrieves a list of recently uploaded documents based on the specified criteria.
     * @request GET:/api/v1/documents/recently-uploaded
     * @secure
     */
    getDocumentsRecentlyUploadedV1: (
      query?: {
        /**
         * The date and time since which the documents should be retrieved. If not specified, no date filter is applied. (optional)
         * @format date-time
         */
        since?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentsItemDTOPaginationResultDto, any>({
        path: `/api/v1/documents/recently-uploaded`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsDetailsV1
     * @request GET:/api/v1/documents/{folderId}
     * @secure
     */
    getDocumentsDetailsV1: (
      folderId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentsListDto, any>({
        path: `/api/v1/documents/${folderId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PostDocumentsRootFolderV1
     * @request POST:/api/v1/documents/root-folder
     * @secure
     */
    postDocumentsRootFolderV1: (
      data: DocumentsRootFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/documents/root-folder`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsRootFolderDetailsV1
     * @request GET:/api/v1/documents/root-folder/{id}
     * @secure
     */
    getDocumentsRootFolderDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<DocumentsRootFolderDetailsDto, any>({
        path: `/api/v1/documents/root-folder/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PutDocumentsRootFolderV1
     * @request PUT:/api/v1/documents/root-folder/{id}
     * @secure
     */
    putDocumentsRootFolderV1: (
      id: string,
      data: DocumentsRootFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/root-folder/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DeleteDocumentsRootFolderByIdV1
     * @request DELETE:/api/v1/documents/root-folder/{id}
     * @secure
     */
    deleteDocumentsRootFolderByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/root-folder/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PostDocumentsFolderV1
     * @request POST:/api/v1/documents/folder
     * @secure
     */
    postDocumentsFolderV1: (
      data: DocumentsFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/documents/folder`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsFolderDetailsV1
     * @request GET:/api/v1/documents/folder/{id}
     * @secure
     */
    getDocumentsFolderDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<DocumentsFolderDetailsDto, any>({
        path: `/api/v1/documents/folder/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PutDocumentsFolderV1
     * @request PUT:/api/v1/documents/folder/{id}
     * @secure
     */
    putDocumentsFolderV1: (
      id: string,
      data: DocumentsFolderRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/folder/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DeleteDocumentsFolderByIdV1
     * @request DELETE:/api/v1/documents/folder/{id}
     * @secure
     */
    deleteDocumentsFolderByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/folder/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PostDocumentsFileV1
     * @request POST:/api/v1/documents/file
     * @secure
     */
    postDocumentsFileV1: (
      data: DocumentsFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/documents/file`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name GetDocumentsFileDetailsV1
     * @request GET:/api/v1/documents/file/{id}
     * @secure
     */
    getDocumentsFileDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<DocumentsFileDetailsDto, any>({
        path: `/api/v1/documents/file/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PutDocumentsFileV1
     * @request PUT:/api/v1/documents/file/{id}
     * @secure
     */
    putDocumentsFileV1: (
      id: string,
      data: DocumentsFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/file/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DeleteDocumentsFileByIdV1
     * @request DELETE:/api/v1/documents/file/{id}
     * @secure
     */
    deleteDocumentsFileByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/file/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name PutDocumentsUpdateViewCountV1
     * @request PUT:/api/v1/documents/{id}/update-view-count
     * @secure
     */
    putDocumentsUpdateViewCountV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/${id}/update-view-count`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventsV1
     * @request GET:/api/v1/events
     * @secure
     */
    getEventsV1: (
      query?: {
        TimeFrame?: EventTimeFrameDto;
        Category?: EventCategoryTypeDto;
        Search?: string;
        CreatedByMe?: boolean;
        IsSignedUp?: boolean;
        Connection?: CommunityFeedConnectionFilterDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventDtoPaginationResultDto, any>({
        path: `/api/v1/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 endpoint
     *
     * @tags Events
     * @name PostEventsV1
     * @request POST:/api/v1/events
     * @deprecated
     * @secure
     */
    postEventsV1: (data: CreateEventRequest, params: RequestParams = {}) =>
      this.request<EventCreatedDto, any>({
        path: `/api/v1/events`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventsCategoriesV1
     * @request GET:/api/v1/events/categories
     * @secure
     */
    getEventsCategoriesV1: (params: RequestParams = {}) =>
      this.request<EventCategoryDto[], any>({
        path: `/api/v1/events/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventsDetailsV1
     * @request GET:/api/v1/events/{id}
     * @secure
     */
    getEventsDetailsV1: (
      id: string,
      query?: {
        /** @default false */
        includeAllParticipants?: boolean;
        /** @default true */
        replaceParameters?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventDetailsDto, any>({
        path: `/api/v1/events/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PutEventsV1
     * @request PUT:/api/v1/events/{id}
     * @secure
     */
    putEventsV1: (
      id: string,
      data: UpdateEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<EventCreatedDto, any>({
        path: `/api/v1/events/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name DeleteEventsByIdV1
     * @request DELETE:/api/v1/events/{id}
     * @secure
     */
    deleteEventsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventsParticipantsV1
     * @request GET:/api/v1/events/{id}/participants
     * @secure
     */
    getEventsParticipantsV1: (
      id: string,
      query?: {
        search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventParticipantDtoPaginationResultDto, any>({
        path: `/api/v1/events/${id}/participants`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PostEventsParticipantsV1
     * @request POST:/api/v1/events/{id}/participants
     * @secure
     */
    postEventsParticipantsV1: (
      id: string,
      data: RegisterEventParticipantRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}/participants`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name GetEventsParticipantCandidatesV1
     * @request GET:/api/v1/events/{id}/participant-candidates
     * @secure
     */
    getEventsParticipantCandidatesV1: (
      id: string,
      query?: {
        search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventParticipantCandidateDtoPaginationResultDto, any>({
        path: `/api/v1/events/${id}/participant-candidates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PutEventsParticipantsV1
     * @request PUT:/api/v1/events/{id}/participants/{userId}
     * @secure
     */
    putEventsParticipantsV1: (
      id: string,
      userId: string,
      data: UpdateEventParticipantRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}/participants/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name DeleteEventsParticipantsByIdV1
     * @request DELETE:/api/v1/events/{id}/participants/{userId}
     * @secure
     */
    deleteEventsParticipantsByIdV1: (
      id: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}/participants/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PostEventsSignupV1
     * @request POST:/api/v1/events/{id}/signup
     * @secure
     */
    postEventsSignupV1: (
      id: string,
      data: EventSignUpRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}/signup`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PostEventsSignoffV1
     * @request POST:/api/v1/events/{id}/signoff
     * @secure
     */
    postEventsSignoffV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/events/${id}/signoff`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PostEventsReadV1
     * @request POST:/api/v1/events/{event}/read
     * @secure
     */
    postEventsReadV1: (event: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/events/${event}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name GetFastActionItemsV1
     * @request GET:/api/v1/fast-action-items
     * @secure
     */
    getFastActionItemsV1: (params: RequestParams = {}) =>
      this.request<FastMenuActionItemDto[], any>({
        path: `/api/v1/fast-action-items`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name PostFastActionItemsV1
     * @request POST:/api/v1/fast-action-items
     * @secure
     */
    postFastActionItemsV1: (
      data: CreateFastMenuActionItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<FastMenuActionItemDto, any>({
        path: `/api/v1/fast-action-items`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name GetFastActionItemsDetailsV1
     * @request GET:/api/v1/fast-action-items/{id}
     * @secure
     */
    getFastActionItemsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<FastMenuActionItemDto, any>({
        path: `/api/v1/fast-action-items/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name PutFastActionItemsV1
     * @request PUT:/api/v1/fast-action-items/{id}
     * @secure
     */
    putFastActionItemsV1: (
      id: string,
      data: UpdateFastMenuActionItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<FastMenuActionItemDto, any>({
        path: `/api/v1/fast-action-items/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name DeleteFastActionItemsByIdV1
     * @request DELETE:/api/v1/fast-action-items/{id}
     * @secure
     */
    deleteFastActionItemsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/fast-action-items/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FastMenuActionItems
     * @name GetFastActionItemsDynamicUrlV1
     * @request GET:/api/v1/fast-action-items/{id}/dynamic-url
     * @secure
     */
    getFastActionItemsDynamicUrlV1: (id: string, params: RequestParams = {}) =>
      this.request<FastMenuActionItemDynamicUrlDto, any>({
        path: `/api/v1/fast-action-items/${id}/dynamic-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesDocumentsV1
     * @request POST:/api/v1/files/documents
     * @secure
     */
    postFilesDocumentsV1: (
      data: {
        /** @format binary */
        file?: File;
        link?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentDto, any>({
        path: `/api/v1/files/documents`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesImagesV1
     * @request POST:/api/v1/files/images
     * @secure
     */
    postFilesImagesV1: (
      data: {
        description?: string;
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/api/v1/files/images`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use UploadImage instead
     *
     * @tags Files
     * @name PostImagesV1
     * @request POST:/api/v1/images
     * @deprecated
     * @secure
     */
    postImagesV1: (
      data: {
        description?: string;
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, any>({
        path: `/api/v1/images`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesVideosV1
     * @request POST:/api/v1/files/videos
     * @secure
     */
    postFilesVideosV1: (
      data: IFormFile,
      query?: {
        FileName?: string;
        MimeType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VideoDto, any>({
        path: `/api/v1/files/videos`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesVideosChunkInitiateV1
     * @request POST:/api/v1/files/videos/chunk/initiate
     * @secure
     */
    postFilesVideosChunkInitiateV1: (
      data: VideoStartUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<VideoUploadDto, any>({
        path: `/api/v1/files/videos/chunk/initiate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesVideosChunkV1
     * @request POST:/api/v1/files/videos/chunk/{uploadId}/{chunkIndex}
     * @secure
     */
    postFilesVideosChunkV1: (
      uploadId: string,
      chunkIndex: number,
      data: IFormFile,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/files/videos/chunk/${uploadId}/${chunkIndex}`,
        method: "POST",
        body: data,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PostFilesVideosChunkCompleteV1
     * @request POST:/api/v1/files/videos/chunk/{uploadId}/complete
     * @secure
     */
    postFilesVideosChunkCompleteV1: (
      uploadId: string,
      params: RequestParams = {},
    ) =>
      this.request<VideoDto, any>({
        path: `/api/v1/files/videos/chunk/${uploadId}/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name PutFilesVideosUpdateViewCountV1
     * @request PUT:/api/v1/files/videos/{id}/update-view-count
     * @secure
     */
    putFilesVideosUpdateViewCountV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/files/videos/${id}/update-view-count`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupNotificationSettings
     * @name GetGroupsNotificationSettingsV1
     * @request GET:/api/v1/groups/{group}/notification-settings
     * @secure
     */
    getGroupsNotificationSettingsV1: (
      group: string,
      params: RequestParams = {},
    ) =>
      this.request<AppNotificationGroupSettingDto, any>({
        path: `/api/v1/groups/${group}/notification-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GroupNotificationSettings
     * @name PutGroupsNotificationSettingsV1
     * @request PUT:/api/v1/groups/{group}/notification-settings
     * @secure
     */
    putGroupsNotificationSettingsV1: (
      group: string,
      data: AppNotificationGroupSettingStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppNotificationGroupSettingDto, any>({
        path: `/api/v1/groups/${group}/notification-settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 instead
     *
     * @tags Groups
     * @name GetGroupsV1
     * @request GET:/api/v1/groups
     * @deprecated
     * @secure
     */
    getGroupsV1: (
      query?: {
        groupType?: CommunityGroupTypeDto;
        search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDtoPaginationResultDto, any>({
        path: `/api/v1/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 instead
     *
     * @tags Groups
     * @name PostGroupsV1
     * @request POST:/api/v1/groups
     * @deprecated
     * @secure
     */
    postGroupsV1: (
      data: CommunityGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsDto, any>({
        path: `/api/v1/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 instead
     *
     * @tags Groups
     * @name GetGroupsDetailsV1
     * @request GET:/api/v1/groups/{id}
     * @deprecated
     * @secure
     */
    getGroupsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<CommunityGroupDetailsDto, any>({
        path: `/api/v1/groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 instead
     *
     * @tags Groups
     * @name PutGroupsV1
     * @request PUT:/api/v1/groups/{id}
     * @deprecated
     * @secure
     */
    putGroupsV1: (
      id: string,
      data: CommunityGroupEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsDto, any>({
        path: `/api/v1/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name DeleteGroupsByIdV1
     * @request DELETE:/api/v1/groups/{id}
     * @secure
     */
    deleteGroupsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PostGroupsFollowV1
     * @request POST:/api/v1/groups/{id}/follow
     * @secure
     */
    postGroupsFollowV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/groups/${id}/follow`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PostGroupsUnfollowV1
     * @request POST:/api/v1/groups/{id}/unfollow
     * @secure
     */
    postGroupsUnfollowV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/groups/${id}/unfollow`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PostGroupsSkipPromotionV1
     * @summary Skip the promotion of a group as the owner of the group. Only the owner of the group can call this endpoint.
     * @request POST:/api/v1/groups/{id}/skip-promotion
     * @secure
     */
    postGroupsSkipPromotionV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/groups/${id}/skip-promotion`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupsMembersV1
     * @request GET:/api/v1/groups/{id}/members
     * @secure
     */
    getGroupsMembersV1: (
      id: string,
      query?: {
        search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserExtendedDtoPaginationResultDto, any>({
        path: `/api/v1/groups/${id}/members`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PostGroupsEnableV1
     * @request POST:/api/v1/groups/{id}/enable
     * @secure
     */
    postGroupsEnableV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/groups/${id}/enable`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name GetIloqKeyV1
     * @request GET:/api/v1/iloq-key
     * @secure
     */
    getIloqKeyV1: (params: RequestParams = {}) =>
      this.request<ILoqKeyDto, any>({
        path: `/api/v1/iloq-key`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name PostIloqKeyCompleteV1
     * @request POST:/api/v1/iloq-key/complete
     * @secure
     */
    postIloqKeyCompleteV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/iloq-key/complete`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name PostIloqKeyRefreshV1
     * @request POST:/api/v1/iloq-key/refresh
     * @secure
     */
    postIloqKeyRefreshV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/iloq-key/refresh`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name GetIloqKeyUsersDetailsV1
     * @request GET:/api/v1/iloq-key/users/{userId}
     * @secure
     */
    getIloqKeyUsersDetailsV1: (userId: string, params: RequestParams = {}) =>
      this.request<UserILoqStatusDto, any>({
        path: `/api/v1/iloq-key/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name PostIloqKeyResetV1
     * @request POST:/api/v1/iloq-key/reset
     * @secure
     */
    postIloqKeyResetV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/iloq-key/reset`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ILoqKey
     * @name PostIloqKeyUsersResetV1
     * @request POST:/api/v1/iloq-key/users/{userId}/reset
     * @secure
     */
    postIloqKeyUsersResetV1: (userId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/iloq-key/users/${userId}/reset`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImages90X90V1
     * @request GET:/api/v1/images/{id}/90x90
     */
    getImages90x90V1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/images/${id}/90x90`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImages180X180V1
     * @request GET:/api/v1/images/{id}/180x180
     */
    getImages180x180V1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/images/${id}/180x180`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImages360X360V1
     * @request GET:/api/v1/images/{id}/360x360
     */
    getImages360x360V1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/images/${id}/360x360`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImagesLargeV1
     * @request GET:/api/v1/images/{id}/large
     */
    getImagesLargeV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/images/${id}/large`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsRemsV1
     * @request GET:/api/v1/integrations/rems
     * @secure
     */
    getIntegrationsRemsV1: (params: RequestParams = {}) =>
      this.request<RemsProjectConfigurationDto, any>({
        path: `/api/v1/integrations/rems`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsRemsV1
     * @request PUT:/api/v1/integrations/rems
     * @secure
     */
    putIntegrationsRemsV1: (
      data: RemsProjectConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/rems`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsRemsReconciliationDetailsV1
     * @request GET:/api/v1/integrations/rems/reconciliation/{dataType}
     * @secure
     */
    getIntegrationsRemsReconciliationDetailsV1: (
      dataType: IntegrationReconciliationDataTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationReconciliationDatasetDto, any>({
        path: `/api/v1/integrations/rems/reconciliation/${dataType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsRemsReconciliationPreviewV1
     * @request POST:/api/v1/integrations/rems/reconciliation/{dataType}/preview
     * @secure
     */
    postIntegrationsRemsReconciliationPreviewV1: (
      dataType: IntegrationReconciliationDataTypeDto,
      data: IntegrationReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationReconciliationResultDto, any>({
        path: `/api/v1/integrations/rems/reconciliation/${dataType}/preview`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsRemsReconciliationApplyV1
     * @request POST:/api/v1/integrations/rems/reconciliation/{dataType}/apply
     * @secure
     */
    postIntegrationsRemsReconciliationApplyV1: (
      dataType: IntegrationReconciliationDataTypeDto,
      data: IntegrationReconciliationRequest,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationReconciliationResultDto, any>({
        path: `/api/v1/integrations/rems/reconciliation/${dataType}/apply`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsRemsReconciliationRunsV1
     * @request GET:/api/v1/integrations/rems/reconciliation-runs
     * @secure
     */
    getIntegrationsRemsReconciliationRunsV1: (params: RequestParams = {}) =>
      this.request<IntegrationReconciliationRunDto[], any>({
        path: `/api/v1/integrations/rems/reconciliation-runs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsZiezodanV1
     * @request GET:/api/v1/integrations/ziezodan
     * @secure
     */
    getIntegrationsZiezodanV1: (params: RequestParams = {}) =>
      this.request<ZiezodanProjectConfigurationDto, any>({
        path: `/api/v1/integrations/ziezodan`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsZiezodanV1
     * @request PUT:/api/v1/integrations/ziezodan
     * @secure
     */
    putIntegrationsZiezodanV1: (
      data: ZiezodanProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/ziezodan`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsIqbiV1
     * @request GET:/api/v1/integrations/iqbi
     * @secure
     */
    getIntegrationsIqbiV1: (params: RequestParams = {}) =>
      this.request<IqbiProjectConfigurationDto, any>({
        path: `/api/v1/integrations/iqbi`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsIqbiV1
     * @request PUT:/api/v1/integrations/iqbi
     * @secure
     */
    putIntegrationsIqbiV1: (
      data: IqbiProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/iqbi`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsMypupV1
     * @request GET:/api/v1/integrations/mypup
     * @secure
     */
    getIntegrationsMypupV1: (params: RequestParams = {}) =>
      this.request<MyPupProjectConfigurationDto, any>({
        path: `/api/v1/integrations/mypup`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsMypupV1
     * @request PUT:/api/v1/integrations/mypup
     * @secure
     */
    putIntegrationsMypupV1: (
      data: MyPupProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/mypup`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsBringmeV1
     * @request GET:/api/v1/integrations/bringme
     * @secure
     */
    getIntegrationsBringmeV1: (params: RequestParams = {}) =>
      this.request<BringmeProjectConfigurationDto, any>({
        path: `/api/v1/integrations/bringme`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsBringmeV1
     * @request PUT:/api/v1/integrations/bringme
     * @secure
     */
    putIntegrationsBringmeV1: (
      data: BringmeProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/bringme`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsOutlookV1
     * @request GET:/api/v1/integrations/outlook
     * @secure
     */
    getIntegrationsOutlookV1: (params: RequestParams = {}) =>
      this.request<OutlookProjectConfigurationDto, any>({
        path: `/api/v1/integrations/outlook`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsOutlookV1
     * @request PUT:/api/v1/integrations/outlook
     * @secure
     */
    putIntegrationsOutlookV1: (
      data: OutlookProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/outlook`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsJimV1
     * @request GET:/api/v1/integrations/jim
     * @secure
     */
    getIntegrationsJimV1: (params: RequestParams = {}) =>
      this.request<JimProjectConfigurationDto, any>({
        path: `/api/v1/integrations/jim`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsJimV1
     * @request PUT:/api/v1/integrations/jim
     * @secure
     */
    putIntegrationsJimV1: (
      data: JimProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/jim`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsJimTestV1
     * @request POST:/api/v1/integrations/jim/test
     * @secure
     */
    postIntegrationsJimTestV1: (params: RequestParams = {}) =>
      this.request<JimConnectionTestDto, any>({
        path: `/api/v1/integrations/jim/test`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsJimRoomsV1
     * @request GET:/api/v1/integrations/jim/rooms
     * @secure
     */
    getIntegrationsJimRoomsV1: (params: RequestParams = {}) =>
      this.request<JimRoomDto[], any>({
        path: `/api/v1/integrations/jim/rooms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsDicoV1
     * @request GET:/api/v1/integrations/dico
     * @secure
     */
    getIntegrationsDicoV1: (params: RequestParams = {}) =>
      this.request<DicoProjectConfigurationDto, any>({
        path: `/api/v1/integrations/dico`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsDicoV1
     * @request PUT:/api/v1/integrations/dico
     * @secure
     */
    putIntegrationsDicoV1: (
      data: DicoProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/dico`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsJansenHuybregtsV1
     * @request GET:/api/v1/integrations/jansen-huybregts
     * @secure
     */
    getIntegrationsJansenHuybregtsV1: (params: RequestParams = {}) =>
      this.request<JansenHuybregtsProjectConfigurationDto, any>({
        path: `/api/v1/integrations/jansen-huybregts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsJansenHuybregtsTicketStatusOptionsV1
     * @request GET:/api/v1/integrations/jansen-huybregts/ticket-status-options
     * @secure
     */
    getIntegrationsJansenHuybregtsTicketStatusOptionsV1: (params: RequestParams = {}) =>
      this.request<JansenHuybregtsTicketStatusOptionsDto, any>({
        path: `/api/v1/integrations/jansen-huybregts/ticket-status-options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsJansenHuybregtsV1
     * @request PUT:/api/v1/integrations/jansen-huybregts
     * @secure
     */
    putIntegrationsJansenHuybregtsV1: (
      data: JansenHuybregtsProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/jansen-huybregts`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsOfficerndV1
     * @request GET:/api/v1/integrations/officernd
     * @secure
     */
    getIntegrationsOfficerndV1: (params: RequestParams = {}) =>
      this.request<OfficeRndProjectConfigurationDto, any>({
        path: `/api/v1/integrations/officernd`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsOfficerndV1
     * @request PUT:/api/v1/integrations/officernd
     * @secure
     */
    putIntegrationsOfficerndV1: (
      data: OfficeRndProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/officernd`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsWunderbricksV1
     * @request GET:/api/v1/integrations/wunderbricks
     * @secure
     */
    getIntegrationsWunderbricksV1: (params: RequestParams = {}) =>
      this.request<WunderbricksProjectConfigurationDto, any>({
        path: `/api/v1/integrations/wunderbricks`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsWunderbricksV1
     * @request PUT:/api/v1/integrations/wunderbricks
     * @secure
     */
    putIntegrationsWunderbricksV1: (
      data: WunderbricksProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/wunderbricks`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsWunderbricksTicketStatusOptionsV1
     * @request GET:/api/v1/integrations/wunderbricks/ticket-status-options
     * @secure
     */
    getIntegrationsWunderbricksTicketStatusOptionsV1: (
      params: RequestParams = {},
    ) =>
      this.request<WunderbricksTicketStatusOptionsDto, any>({
        path: `/api/v1/integrations/wunderbricks/ticket-status-options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsHubspotV1
     * @request GET:/api/v1/integrations/hubspot
     * @secure
     */
    getIntegrationsHubspotV1: (params: RequestParams = {}) =>
      this.request<HubSpotProjectConfigurationDto, any>({
        path: `/api/v1/integrations/hubspot`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsHubspotV1
     * @request PUT:/api/v1/integrations/hubspot
     * @secure
     */
    putIntegrationsHubspotV1: (
      data: HubSpotProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/hubspot`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsSwoogoV1
     * @request GET:/api/v1/integrations/swoogo
     * @secure
     */
    getIntegrationsSwoogoV1: (params: RequestParams = {}) =>
      this.request<SwoogoProjectConfigurationDto, any>({
        path: `/api/v1/integrations/swoogo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsSwoogoV1
     * @request PUT:/api/v1/integrations/swoogo
     * @secure
     */
    putIntegrationsSwoogoV1: (
      data: SwoogoProjectConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/swoogo`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsCopilotPromptConfigurationsV1
     * @request GET:/api/v1/integrations/copilot-prompt-configurations
     * @secure
     */
    getIntegrationsCopilotPromptConfigurationsV1: (
      params: RequestParams = {},
    ) =>
      this.request<CopilotPromptConfigurationsDto, any>({
        path: `/api/v1/integrations/copilot-prompt-configurations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsCopilotPromptConfigurationsV1
     * @request PUT:/api/v1/integrations/copilot-prompt-configurations
     * @secure
     */
    putIntegrationsCopilotPromptConfigurationsV1: (
      data: CopilotPromptConfigurationsDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/copilot-prompt-configurations`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsHomednaV1
     * @request GET:/api/v1/integrations/homedna
     * @secure
     */
    getIntegrationsHomednaV1: (params: RequestParams = {}) =>
      this.request<HomeDnaProjectConfigurationDto, any>({
        path: `/api/v1/integrations/homedna`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsHomednaV1
     * @request PUT:/api/v1/integrations/homedna
     * @secure
     */
    putIntegrationsHomednaV1: (
      data: HomeDnaProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/homedna`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsHealthdistrictV1
     * @request GET:/api/v1/integrations/healthdistrict
     * @secure
     */
    getIntegrationsHealthdistrictV1: (params: RequestParams = {}) =>
      this.request<HealthDistrictProjectConfigurationDto, any>({
        path: `/api/v1/integrations/healthdistrict`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsHealthdistrictV1
     * @request PUT:/api/v1/integrations/healthdistrict
     * @secure
     */
    putIntegrationsHealthdistrictV1: (
      data: HealthDistrictProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/healthdistrict`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsProjectApiAccessV1
     * @request GET:/api/v1/integrations/project-api-access
     * @secure
     */
    getIntegrationsProjectApiAccessV1: (params: RequestParams = {}) =>
      this.request<ProjectApiAccessConfigurationDto, any>({
        path: `/api/v1/integrations/project-api-access`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsProjectApiAccessV1
     * @request PUT:/api/v1/integrations/project-api-access
     * @secure
     */
    putIntegrationsProjectApiAccessV1: (
      data: ProjectApiAccessConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/project-api-access`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsProjectApiAccessRotateKeyV1
     * @request POST:/api/v1/integrations/project-api-access/rotate-key
     * @secure
     */
    postIntegrationsProjectApiAccessRotateKeyV1: (
      query?: {
        apiUserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectApiAccessConfigurationDto, any>({
        path: `/api/v1/integrations/project-api-access/rotate-key`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationsIloqV1
     * @request GET:/api/v1/integrations/iloq
     * @secure
     */
    getIntegrationsIloqV1: (params: RequestParams = {}) =>
      this.request<ILoqProjectConfigurationDto, any>({
        path: `/api/v1/integrations/iloq`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PutIntegrationsIloqV1
     * @request PUT:/api/v1/integrations/iloq
     * @secure
     */
    putIntegrationsIloqV1: (
      data: ILoqProjectConfigurationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/integrations/iloq`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsIloqLockGroupsV1
     * @request POST:/api/v1/integrations/iloq/lock-groups
     * @secure
     */
    postIntegrationsIloqLockGroupsV1: (
      data: ILoqCredentialsDto,
      params: RequestParams = {},
    ) =>
      this.request<ILoqOptionDto[], any>({
        path: `/api/v1/integrations/iloq/lock-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name PostIntegrationsIloqOptionsV1
     * @request POST:/api/v1/integrations/iloq/{lockGroupId}/options
     * @secure
     */
    postIntegrationsIloqOptionsV1: (
      lockGroupId: string,
      data: ILoqCredentialsDto,
      params: RequestParams = {},
    ) =>
      this.request<ILoqOptionsDto, any>({
        path: `/api/v1/integrations/iloq/${lockGroupId}/options`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Intercom
     * @name GetIntercomIdentityV1
     * @request GET:/api/v1/intercom/identity
     * @secure
     */
    getIntercomIdentityV1: (params: RequestParams = {}) =>
      this.request<IntercomIdentityDto, any>({
        path: `/api/v1/intercom/identity`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Languages
     * @name GetLanguagesV1
     * @request GET:/api/v1/languages
     * @deprecated
     * @secure
     */
    getLanguagesV1: (params: RequestParams = {}) =>
      this.request<LanguageDto[], any>({
        path: `/api/v1/languages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name GetLanguagesBaseV1
     * @request GET:/api/v1/languages/base
     * @secure
     */
    getLanguagesBaseV1: (params: RequestParams = {}) =>
      this.request<LanguageDto[], any>({
        path: `/api/v1/languages/base`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: No longer relevant, use v2/languages instead
     *
     * @tags Languages
     * @name GetLanguagesAllV1
     * @request GET:/api/v1/languages/all
     * @deprecated
     * @secure
     */
    getLanguagesAllV1: (params: RequestParams = {}) =>
      this.request<LanguageDto[], any>({
        path: `/api/v1/languages/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassAddresses
     * @name PostMassAddressesV1
     * @request POST:/api/v1/mass-addresses
     * @secure
     */
    postMassAddressesV1: (
      data: MassAddressCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddressUploadProgressUpdateDto[], any>({
        path: `/api/v1/mass-addresses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassAddresses
     * @name GetMassAddressesProjectsV1
     * @request GET:/api/v1/mass-addresses/projects
     * @secure
     */
    getMassAddressesProjectsV1: (params: RequestParams = {}) =>
      this.request<SimpleProjectDto[], any>({
        path: `/api/v1/mass-addresses/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassAddresses
     * @name GetMassAddressesBuildingsV1
     * @request GET:/api/v1/mass-addresses/buildings
     * @secure
     */
    getMassAddressesBuildingsV1: (params: RequestParams = {}) =>
      this.request<ProjectBuildingDto[], any>({
        path: `/api/v1/mass-addresses/buildings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name PostNotificationsAppRegistrationV1
     * @request POST:/api/v1/notifications/app/registration
     * @secure
     */
    postNotificationsAppRegistrationV1: (
      data: DeviceRegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/app/registration`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name DeleteNotificationsAppRegistrationByIdV1
     * @request DELETE:/api/v1/notifications/app/registration/{token}
     */
    deleteNotificationsAppRegistrationByIdV1: (
      token: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/app/registration/${token}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationSettings
     * @name GetNotificationSettingsSelfV1
     * @request GET:/api/v1/notification-settings/self
     * @secure
     */
    getNotificationSettingsSelfV1: (params: RequestParams = {}) =>
      this.request<NotificationSettingsDto, any>({
        path: `/api/v1/notification-settings/self`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationSettings
     * @name PatchNotificationSettingsSelfV1
     * @request PATCH:/api/v1/notification-settings/self
     * @secure
     */
    patchNotificationSettingsSelfV1: (
      data: NotificationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notification-settings/self`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationSettings
     * @name GetNotificationSettingsDefaultsV1
     * @request GET:/api/v1/notification-settings/defaults
     * @secure
     */
    getNotificationSettingsDefaultsV1: (params: RequestParams = {}) =>
      this.request<GenericNotificationSettingsDto, any>({
        path: `/api/v1/notification-settings/defaults`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationSettings
     * @name GetNotificationSettingsDetailsV1
     * @request GET:/api/v1/notification-settings/{userId}
     * @secure
     */
    getNotificationSettingsDetailsV1: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<NotificationSettingsDto, any>({
        path: `/api/v1/notification-settings/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationSettings
     * @name PatchNotificationSettingsV1
     * @request PATCH:/api/v1/notification-settings/{userId}
     * @secure
     */
    patchNotificationSettingsV1: (
      userId: string,
      data: NotificationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notification-settings/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnboardingScreens
     * @name GetOnboardingScreensV1
     * @request GET:/api/v1/onboarding-screens
     * @secure
     */
    getOnboardingScreensV1: (params: RequestParams = {}) =>
      this.request<OnboardingScreenDtoPaginationResultDto, any>({
        path: `/api/v1/onboarding-screens`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnboardingScreens
     * @name PostOnboardingScreensV1
     * @request POST:/api/v1/onboarding-screens
     * @secure
     */
    postOnboardingScreensV1: (
      data: OnboardingScreenCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OnboardingScreenDto, any>({
        path: `/api/v1/onboarding-screens`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnboardingScreens
     * @name GetOnboardingScreensDetailsV1
     * @request GET:/api/v1/onboarding-screens/{id}
     * @secure
     */
    getOnboardingScreensDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<OnboardingScreenDto, any>({
        path: `/api/v1/onboarding-screens/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnboardingScreens
     * @name PutOnboardingScreensV1
     * @request PUT:/api/v1/onboarding-screens/{id}
     * @secure
     */
    putOnboardingScreensV1: (
      id: string,
      data: OnboardingScreenEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/onboarding-screens/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnboardingScreens
     * @name DeleteOnboardingScreensByIdV1
     * @request DELETE:/api/v1/onboarding-screens/{id}
     * @secure
     */
    deleteOnboardingScreensByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/onboarding-screens/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsRolesV1
     * @request GET:/api/v1/permissions/roles
     * @secure
     */
    getPermissionsRolesV1: (params: RequestParams = {}) =>
      this.request<UserRoleDto[], any>({
        path: `/api/v1/permissions/roles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PostPermissionsRolesV1
     * @request POST:/api/v1/permissions/roles
     * @secure
     */
    postPermissionsRolesV1: (
      data: UserRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/permissions/roles`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsDefaultTypeV1
     * @request GET:/api/v1/permissions/default/type
     * @secure
     */
    getPermissionsDefaultTypeV1: (params: RequestParams = {}) =>
      this.request<UserRoleTypePermissionsDto[], any>({
        path: `/api/v1/permissions/default/type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsDefaultGroupV1
     * @request GET:/api/v1/permissions/default/group
     * @secure
     */
    getPermissionsDefaultGroupV1: (params: RequestParams = {}) =>
      this.request<UserRoleCommunityGroupPermissionsDto[], any>({
        path: `/api/v1/permissions/default/group`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsDefaultRepairCategoryV1
     * @request GET:/api/v1/permissions/default/repair-category
     * @secure
     */
    getPermissionsDefaultRepairCategoryV1: (params: RequestParams = {}) =>
      this.request<UserRoleRepairCategoryPermissionsDto[], any>({
        path: `/api/v1/permissions/default/repair-category`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsDefaultServicePageV1
     * @request GET:/api/v1/permissions/default/service-page
     * @secure
     */
    getPermissionsDefaultServicePageV1: (params: RequestParams = {}) =>
      this.request<UserRoleServicePartnerPagePermissionsDto[], any>({
        path: `/api/v1/permissions/default/service-page`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsDefaultFolderV1
     * @request GET:/api/v1/permissions/default/folder
     * @secure
     */
    getPermissionsDefaultFolderV1: (params: RequestParams = {}) =>
      this.request<UserRoleDocumentFolderPermissionsDto[], any>({
        path: `/api/v1/permissions/default/folder`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name GetPermissionsRolesDetailsV1
     * @request GET:/api/v1/permissions/roles/{id}
     * @secure
     */
    getPermissionsRolesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<UserRoleDetailsDto, any>({
        path: `/api/v1/permissions/roles/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PutPermissionsRolesV1
     * @request PUT:/api/v1/permissions/roles/{id}
     * @secure
     */
    putPermissionsRolesV1: (
      id: string,
      data: UserRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/permissions/roles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name DeletePermissionsRolesByIdV1
     * @request DELETE:/api/v1/permissions/roles/{id}
     * @secure
     */
    deletePermissionsRolesByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/permissions/roles/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsV1
     * @request GET:/api/v1/polls
     * @secure
     */
    getPollsV1: (
      query?: {
        Query?: string;
        PosterId?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        GroupIds?: string[];
        Tab?: CommunityFeedTabsDto;
        Connection?: CommunityFeedConnectionFilterDto;
        ExcludeArchivedPosts?: boolean;
        FeedTypes?: CommunityFeedType[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PollDtoPaginationResultDto, any>({
        path: `/api/v1/polls`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name PostPollsV1
     * @request POST:/api/v1/polls
     * @secure
     */
    postPollsV1: (data: PollCreateRequest, params: RequestParams = {}) =>
      this.request<PollCreatedEntityDto, any>({
        path: `/api/v1/polls`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsDetailsV1
     * @request GET:/api/v1/polls/{id}
     * @secure
     */
    getPollsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<PollDto, any>({
        path: `/api/v1/polls/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name PutPollsV1
     * @request PUT:/api/v1/polls/{id}
     * @secure
     */
    putPollsV1: (
      id: string,
      data: PollUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/polls/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name DeletePollsByIdV1
     * @request DELETE:/api/v1/polls/{id}
     * @secure
     */
    deletePollsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/polls/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsReachV1
     * @request GET:/api/v1/polls/{id}/reach
     * @secure
     */
    getPollsReachV1: (id: string, params: RequestParams = {}) =>
      this.request<PostReachDto, any>({
        path: `/api/v1/polls/${id}/reach`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name PostPollsVoteV1
     * @request POST:/api/v1/polls/{id}/vote
     * @secure
     */
    postPollsVoteV1: (id: string, data: string[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/polls/${id}/vote`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name DeletePollsVoteV1
     * @request DELETE:/api/v1/polls/{id}/vote
     * @secure
     */
    deletePollsVoteV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/polls/${id}/vote`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsAnswersV1
     * @request GET:/api/v1/polls/{id}/answers
     * @secure
     */
    getPollsAnswersV1: (id: string, params: RequestParams = {}) =>
      this.request<PollAnswersResultsDto, any>({
        path: `/api/v1/polls/${id}/answers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsAnswersDetailsV1
     * @request GET:/api/v1/polls/{id}/answers/{answerId}
     * @secure
     */
    getPollsAnswersDetailsV1: (
      id: string,
      answerId: string,
      params: RequestParams = {},
    ) =>
      this.request<PollAnswersResultsDto, any>({
        path: `/api/v1/polls/${id}/answers/${answerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name PostPollsReadV1
     * @request POST:/api/v1/polls/{id}/read
     * @secure
     */
    postPollsReadV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/polls/${id}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsResidentEngagementV1
     * @request GET:/api/v1/portfolio-analytics/resident-engagement
     * @secure
     */
    getPortfolioAnalyticsResidentEngagementV1: (params: RequestParams = {}) =>
      this.request<ResidentTimeEngagementDto, any>({
        path: `/api/v1/portfolio-analytics/resident-engagement`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name PostPortfolioAnalyticsEventsReportingV1
     * @request POST:/api/v1/portfolio-analytics/events-reporting
     * @secure
     */
    postPortfolioAnalyticsEventsReportingV1: (
      data: PortfolioEventAnalyticsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioEventAnalyticsDto, any>({
        path: `/api/v1/portfolio-analytics/events-reporting`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name PostPortfolioAnalyticsTicketsReportingV1
     * @request POST:/api/v1/portfolio-analytics/tickets-reporting
     * @secure
     */
    postPortfolioAnalyticsTicketsReportingV1: (
      data: PortfolioTicketAnalyticsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioTicketAnalyticsDto, any>({
        path: `/api/v1/portfolio-analytics/tickets-reporting`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name PostPortfolioAnalyticsTicketsReportingSummaryV1
     * @request POST:/api/v1/portfolio-analytics/tickets-reporting/summary
     * @secure
     */
    postPortfolioAnalyticsTicketsReportingSummaryV1: (
      data: PortfolioTicketAnalyticsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<TicketOperationalInsightDto, any>({
        path: `/api/v1/portfolio-analytics/tickets-reporting/summary`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name PostPortfolioAnalyticsBookingsReportingV1
     * @request POST:/api/v1/portfolio-analytics/bookings-reporting
     * @secure
     */
    postPortfolioAnalyticsBookingsReportingV1: (
      data: PortfolioBookingAnalyticsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioBookingAnalyticsDto, any>({
        path: `/api/v1/portfolio-analytics/bookings-reporting`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name PostPortfolioAnalyticsCommunityFeedReportingV1
     * @request POST:/api/v1/portfolio-analytics/community-feed-reporting
     * @secure
     */
    postPortfolioAnalyticsCommunityFeedReportingV1: (
      data: PortfolioCommunityFeedReportingRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedReportingDto, any>({
        path: `/api/v1/portfolio-analytics/community-feed-reporting`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioIntegrations
     * @name GetPortfolioIntegrationsRemsV1
     * @request GET:/api/v1/portfolio-integrations/rems
     * @secure
     */
    getPortfolioIntegrationsRemsV1: (params: RequestParams = {}) =>
      this.request<PortfolioRemsProjectConfigurationDto[], any>({
        path: `/api/v1/portfolio-integrations/rems`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioIntegrations
     * @name GetPortfolioIntegrationsIloqV1
     * @request GET:/api/v1/portfolio-integrations/iloq
     * @secure
     */
    getPortfolioIntegrationsIloqV1: (params: RequestParams = {}) =>
      this.request<PortfolioILoqProjectConfigurationDto[], any>({
        path: `/api/v1/portfolio-integrations/iloq`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioIntegrations
     * @name GetPortfolioIntegrationsAiV1
     * @request GET:/api/v1/portfolio-integrations/ai
     * @secure
     */
    getPortfolioIntegrationsAiV1: (params: RequestParams = {}) =>
      this.request<PortfolioAiProjectConfigurationDto[], any>({
        path: `/api/v1/portfolio-integrations/ai`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioPermissions
     * @name GetPortfolioPermissionsV1
     * @request GET:/api/v1/portfolio-permissions
     * @secure
     */
    getPortfolioPermissionsV1: (params: RequestParams = {}) =>
      this.request<PortfolioPermissionsDto, any>({
        path: `/api/v1/portfolio-permissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name GetProjectOverviewV1
     * @request GET:/api/v1/project/overview
     * @secure
     */
    getProjectOverviewV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /** @format date-time */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectOverviewItemDtoPaginationResultDto, any>({
        path: `/api/v1/project/overview`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name PostProjectExportV1
     * @request POST:/api/v1/project/export
     * @secure
     */
    postProjectExportV1: (
      data: PortfolioExportFilter,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project/export`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name GetProjectOverviewBenchmarkV1
     * @request GET:/api/v1/project/overview/benchmark
     * @secure
     */
    getProjectOverviewBenchmarkV1: (
      query?: {
        /** @format date-time */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectStatsDto, any>({
        path: `/api/v1/project/overview/benchmark`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name GetProjectDetailsV1
     * @request GET:/api/v1/project/details
     * @secure
     */
    getProjectDetailsV1: (params: RequestParams = {}) =>
      this.request<ProjectDetailedDto, any>({
        path: `/api/v1/project/details`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name PostProjectV1
     * @request POST:/api/v1/project
     * @secure
     */
    postProjectV1: (data: ProjectCreateRequest, params: RequestParams = {}) =>
      this.request<ProjectDetailedDto, any>({
        path: `/api/v1/project`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name PutProjectV1
     * @request PUT:/api/v1/project/{id}
     * @secure
     */
    putProjectV1: (
      id: string,
      data: ProjectEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectDetailedDto, any>({
        path: `/api/v1/project/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name DeleteProjectByIdV1
     * @request DELETE:/api/v1/project/{id}
     * @secure
     */
    deleteProjectByIdV1: (
      id: string,
      query?: {
        deleteUsers?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name PutProjectStylingV1
     * @request PUT:/api/v1/project/{id}/styling
     * @secure
     */
    putProjectStylingV1: (
      id: string,
      data: ProjectStylingRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectDetailedDto, any>({
        path: `/api/v1/project/${id}/styling`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Registration
     * @name PostRegistrationValidateCodeV1
     * @request POST:/api/v1/registration/validate-code
     */
    postRegistrationValidateCodeV1: (
      data: ValidateRegistrationCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ValidatedRegistrationCodeDto, any>({
        path: `/api/v1/registration/validate-code`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentGroups
     * @name PostResidentGroupsV1
     * @request POST:/api/v1/resident-groups
     * @secure
     */
    postResidentGroupsV1: (
      data: ResidentGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsDto, any>({
        path: `/api/v1/resident-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentGroups
     * @name PutResidentGroupsV1
     * @request PUT:/api/v1/resident-groups/{id}
     * @secure
     */
    putResidentGroupsV1: (
      id: string,
      data: ResidentGroupEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsDto, any>({
        path: `/api/v1/resident-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name GetResidentNotificationsV1
     * @request GET:/api/v1/resident-notifications
     * @secure
     */
    getResidentNotificationsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResidentNotificationDtoPaginationResultDto, any>({
        path: `/api/v1/resident-notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags ResidentNotifications
     * @name GetResidentNotificationsStatusV1
     * @request GET:/api/v1/resident-notifications/status
     * @deprecated
     * @secure
     */
    getResidentNotificationsStatusV1: (params: RequestParams = {}) =>
      this.request<UnreadStatusDto, any>({
        path: `/api/v1/resident-notifications/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name DeleteResidentNotificationsBadgeV1
     * @request DELETE:/api/v1/resident-notifications/badge
     * @secure
     */
    deleteResidentNotificationsBadgeV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/resident-notifications/badge`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name PutResidentNotificationsReadV1
     * @request PUT:/api/v1/resident-notifications/{id}/read
     * @secure
     */
    putResidentNotificationsReadV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/resident-notifications/${id}/read`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name DeleteResidentNotificationsByIdV1
     * @request DELETE:/api/v1/resident-notifications/{id}
     * @secure
     */
    deleteResidentNotificationsByIdV1: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/resident-notifications/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Self
     * @name GetSelfV1
     * @request GET:/api/v1/self
     * @deprecated
     * @secure
     */
    getSelfV1: (params: RequestParams = {}) =>
      this.request<SelfDto, any>({
        path: `/api/v1/self`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Self
     * @name PutSelfV1
     * @request PUT:/api/v1/self
     * @deprecated
     * @secure
     */
    putSelfV1: (data: SelfRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PutSelfLanguageV1
     * @request PUT:/api/v1/self/language
     * @secure
     */
    putSelfLanguageV1: (
      data: SelfLanguageRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/self/language`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PatchSelfPrivacySettingsV1
     * @request PATCH:/api/v1/self/privacy-settings
     * @secure
     */
    patchSelfPrivacySettingsV1: (
      data: SelfPrivacySettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/self/privacy-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name GetSelfProjectsV1
     * @request GET:/api/v1/self/projects
     * @secure
     */
    getSelfProjectsV1: (params: RequestParams = {}) =>
      this.request<ConnectedProjectsDto, any>({
        path: `/api/v1/self/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PutSelfProjectsV1
     * @summary No need to use this endpoint when Backend API usage is replaced with Core API for all use cases. The reason to update DB on project switch is that Backend API is not working with project context (headers).
     * @request PUT:/api/v1/self/projects
     * @secure
     */
    putSelfProjectsV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self/projects`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PostSelfDeleteV1
     * @request POST:/api/v1/self/delete
     * @secure
     */
    postSelfDeleteV1: (data: SelfDeleteRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PostSelfOnboardingV1
     * @summary Mark user as onboarded.
     * @request POST:/api/v1/self/onboarding
     * @secure
     */
    postSelfOnboardingV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self/onboarding`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PostSelfCodeOfConductAgreeV1
     * @summary Mark user has read code of conduct.
     * @request POST:/api/v1/self/code-of-conduct/agree
     * @secure
     */
    postSelfCodeOfConductAgreeV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self/code-of-conduct/agree`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PutSelfAssignableV1
     * @request PUT:/api/v1/self/assignable
     * @secure
     */
    putSelfAssignableV1: (data: boolean, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/self/assignable`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name GetSelfAddressV1
     * @request GET:/api/v1/self/address
     * @secure
     */
    getSelfAddressV1: (params: RequestParams = {}) =>
      this.request<SelfRegistrationDetailsDto, any>({
        path: `/api/v1/self/address`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name GetSystemGroupsV1
     * @request GET:/api/v1/system-groups
     * @secure
     */
    getSystemGroupsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /** @default 0 */
        sorting?: SortByDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<SystemGroupDtoPaginationResultDto, any>({
        path: `/api/v1/system-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name PostSystemGroupsV1
     * @request POST:/api/v1/system-groups
     * @secure
     */
    postSystemGroupsV1: (
      data: SystemGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<SystemGroupDetailDto, any>({
        path: `/api/v1/system-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name GetSystemGroupsDetailsV1
     * @request GET:/api/v1/system-groups/{id}
     * @secure
     */
    getSystemGroupsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<SystemGroupDetailDto, any>({
        path: `/api/v1/system-groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name PutSystemGroupsV1
     * @request PUT:/api/v1/system-groups/{id}
     * @secure
     */
    putSystemGroupsV1: (
      id: string,
      data: SystemGroupUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/system-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name DeleteSystemGroupsByIdV1
     * @request DELETE:/api/v1/system-groups/{id}
     * @secure
     */
    deleteSystemGroupsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/system-groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name PostSystemGroupsEnableV1
     * @request POST:/api/v1/system-groups/{id}/enable/{projectId}
     * @secure
     */
    postSystemGroupsEnableV1: (
      id: string,
      projectId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/system-groups/${id}/enable/${projectId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemGroups
     * @name GetSystemGroupsProjectsV1
     * @request GET:/api/v1/system-groups/{id}/projects
     * @secure
     */
    getSystemGroupsProjectsV1: (id: string, params: RequestParams = {}) =>
      this.request<SimpleProjectDtoPaginationResultDto, any>({
        path: `/api/v1/system-groups/${id}/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Translations
     * @name GetTranslationsDetailsV1
     * @request GET:/api/v1/translations/{clientType}/{languageId}
     */
    getTranslationsDetailsV1: (
      clientType: TranslationClientTypeDto,
      languageId: LanguageIdDto,
      query?: {
        /** @format uuid */
        releaseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, string>, any>({
        path: `/api/v1/translations/${clientType}/${languageId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Translations
     * @name PostTranslationsTranslateV1
     * @request POST:/api/v1/translations/translate
     * @secure
     */
    postTranslationsTranslateV1: (
      data: TranslateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TranslateResult[], any>({
        path: `/api/v1/translations/translate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Uptime
     * @name GetUptimeV1
     * @request GET:/api/v1/uptime
     */
    getUptimeV1: (params: RequestParams = {}) =>
      this.request<UptimeResultDto, any>({
        path: `/api/v1/uptime`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallboard
     * @name GetWallboardSnapshotV1
     * @request GET:/api/v1/wallboard/snapshot
     */
    getWallboardSnapshotV1: (params: RequestParams = {}) =>
      this.request<WallboardSnapshotView, any>({
        path: `/api/v1/wallboard/snapshot`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wallboard
     * @name GetWallboardFeedV1
     * @request GET:/api/v1/wallboard/feed
     */
    getWallboardFeedV1: (
      query?: {
        /** @format int32 */
        after?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WallboardFeedItemView[], any>({
        path: `/api/v1/wallboard/feed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WidgetData
     * @name GetWidgetsDataDetailsV1
     * @request GET:/api/v1/widgets/data/{widgetDataType}
     * @secure
     */
    getWidgetsDataDetailsV1: (
      widgetDataType: WidgetDataTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<WidgetDataDto, any>({
        path: `/api/v1/widgets/data/${widgetDataType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WidgetManagement
     * @name GetWidgetsActiveV1
     * @request GET:/api/v1/widgets/active
     * @secure
     */
    getWidgetsActiveV1: (params: RequestParams = {}) =>
      this.request<ActiveWidgetsDto, any>({
        path: `/api/v1/widgets/active`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WidgetManagement
     * @name PostWidgetsActiveV1
     * @request POST:/api/v1/widgets/active
     * @secure
     */
    postWidgetsActiveV1: (
      data: WidgetsDataTypesRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/widgets/active`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRelations
     * @name GetAddressesRelationV1
     * @request GET:/api/v1/addresses/{addressId}/relation
     * @secure
     */
    getAddressesRelationV1: (addressId: string, params: RequestParams = {}) =>
      this.request<UserRelationInformationDetailDto[], void>({
        path: `/api/v1/addresses/${addressId}/relation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRelations
     * @name DeleteAddressesRelationByIdV1
     * @summary Ends the relation. For now this only sets the EndDate to a date. But in the future it will also remove the users related to the relation.
     * @request DELETE:/api/v1/addresses/{addressId}/relation/{relationId}
     * @secure
     */
    deleteAddressesRelationByIdV1: (
      relationId: string,
      addressId: string,
      query?: {
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/addresses/${addressId}/relation/${relationId}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserRelations
     * @name GetAddressesRelationHistoryV1
     * @request GET:/api/v1/addresses/{addressId}/relation/history
     * @secure
     */
    getAddressesRelationHistoryV1: (
      addressId: string,
      params: RequestParams = {},
    ) =>
      this.request<UserRelationInformationDto[], any>({
        path: `/api/v1/addresses/${addressId}/relation/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersLookupV1
     * @request GET:/api/v1/users/lookup
     * @secure
     */
    getUsersLookupV1: (
      query?: {
        City?: string;
        Street?: string;
        House?: string;
        FirstName?: string;
        LastName?: string;
        Email?: string;
        ProjectId?: string;
        Statuses?: UserStatusDto[];
        RoleTypes?: UserRoleTypeDto[];
        SortBy?: UserSortablePropertiesDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserLookupDtoPaginationResultDto, any>({
        path: `/api/v1/users/lookup`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersV1
     * @request GET:/api/v1/users
     * @secure
     */
    getUsersV1: (
      query?: {
        Search?: string;
        CompanyId?: string;
        Statuses?: UserStatusDto[];
        RoleIds?: string[];
        SortBy?: UserSortablePropertiesDto;
        SortDescending?: boolean;
        Tab?: UserListTabDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserListItemDtoPaginationResultDto, any>({
        path: `/api/v1/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersV1
     * @request POST:/api/v1/users
     * @secure
     */
    postUsersV1: (data: UserCreateRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/users`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersDetailsV1
     * @request GET:/api/v1/users/{userId}
     * @secure
     */
    getUsersDetailsV1: (userId: string, params: RequestParams = {}) =>
      this.request<UserDetailsDto, any>({
        path: `/api/v1/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use v2 instead
     *
     * @tags Users
     * @name GetUsersGroupsV1
     * @request GET:/api/v1/users/{userId}/groups
     * @deprecated
     * @secure
     */
    getUsersGroupsV1: (
      userId: string,
      query?: {
        groupType?: CommunityGroupTypeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDtoPaginationResultDto, any>({
        path: `/api/v1/users/${userId}/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersRepairAssigneesV1
     * @request GET:/api/v1/users/repair-assignees
     * @secure
     */
    getUsersRepairAssigneesV1: (params: RequestParams = {}) =>
      this.request<UserDto[], any>({
        path: `/api/v1/users/repair-assignees`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use GetTicketAssignees instead
     *
     * @tags Users
     * @name GetUsersRepairAssigneesByRolesV1
     * @request GET:/api/v1/users/repair-assignees-by-roles
     * @deprecated
     * @secure
     */
    getUsersRepairAssigneesByRolesV1: (
      query?: {
        roles?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDto[], any>({
        path: `/api/v1/users/repair-assignees-by-roles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersStatsV1
     * @request GET:/api/v1/users/stats
     * @secure
     */
    getUsersStatsV1: (params: RequestParams = {}) =>
      this.request<UserStatsDto, any>({
        path: `/api/v1/users/stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersChangeEmailV1
     * @request POST:/api/v1/users/change-email
     * @secure
     */
    postUsersChangeEmailV1: (
      data: EmailChangeRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/change-email`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersVerifyEmailChangeCodeV1
     * @request POST:/api/v1/users/verify-email-change-code
     * @secure
     */
    postUsersVerifyEmailChangeCodeV1: (
      data: EmailChangeDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/verify-email-change-code`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersAdminsV1
     * @request GET:/api/v1/users/admins
     * @secure
     */
    getUsersAdminsV1: (params: RequestParams = {}) =>
      this.request<UserDto[], any>({
        path: `/api/v1/users/admins`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersResidentInvitesHousemateV1
     * @request POST:/api/v1/users/resident-invites/housemate
     * @secure
     */
    postUsersResidentInvitesHousemateV1: (params: RequestParams = {}) =>
      this.request<CreatedHousemateInviteDto, any>({
        path: `/api/v1/users/resident-invites/housemate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PutUsersV1
     * @request PUT:/api/v1/users/{id}
     * @secure
     */
    putUsersV1: (
      id: string,
      data: UserUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name DeleteUsersByIdV1
     * @request DELETE:/api/v1/users/{id}
     * @secure
     */
    deleteUsersByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/users/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PutUsersAssignableV1
     * @request PUT:/api/v1/users/{id}/assignable
     * @secure
     */
    putUsersAssignableV1: (
      id: string,
      data: boolean,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/${id}/assignable`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersEmailExistsV1
     * @request POST:/api/v1/users/email-exists
     * @secure
     */
    postUsersEmailExistsV1: (
      data: EmailExistsRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailExistsDto, any>({
        path: `/api/v1/users/email-exists`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PutUsersDeletionDateV1
     * @request PUT:/api/v1/users/{id}/deletion-date
     * @secure
     */
    putUsersDeletionDateV1: (
      id: string,
      data: UserDeletionDateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/users/${id}/deletion-date`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersProjectsV1
     * @request GET:/api/v1/users/{userId}/projects
     * @secure
     */
    getUsersProjectsV1: (userId: string, params: RequestParams = {}) =>
      this.request<UserProjectDto[], any>({
        path: `/api/v1/users/${userId}/projects`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersRecentJoinedResidentV1
     * @request GET:/api/v1/users/recent-joined-resident
     * @secure
     */
    getUsersRecentJoinedResidentV1: (params: RequestParams = {}) =>
      this.request<UserDto[], any>({
        path: `/api/v1/users/recent-joined-resident`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use GetProjects instead
     *
     * @tags Users
     * @name GetUsersProjectsDeletableV1
     * @request GET:/api/v1/users/{userId}/projects-deletable
     * @deprecated
     * @secure
     */
    getUsersProjectsDeletableV1: (userId: string, params: RequestParams = {}) =>
      this.request<SimpleProjectDto[], any>({
        path: `/api/v1/users/${userId}/projects-deletable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use Auth API endpoint instead
     *
     * @tags UserSignInSignUp
     * @name PostUserSignInSignUpVerifyEmailV1
     * @request POST:/api/v1/user-sign-in-sign-up/verify-email
     * @deprecated
     */
    postUserSignInSignUpVerifyEmailV1: (
      data: VerifyEmailRequest,
      params: RequestParams = {},
    ) =>
      this.request<VerifyEmailResultDto, any>({
        path: `/api/v1/user-sign-in-sign-up/verify-email`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSignupReminders
     * @name GetUsersUserSignupRemindersV1
     * @request GET:/api/v1/users/{userId}/user-signup-reminders
     * @secure
     */
    getUsersUserSignupRemindersV1: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<ReminderStatusDto, void>({
        path: `/api/v1/users/${userId}/user-signup-reminders`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSignupReminders
     * @name PostUsersUserSignupRemindersV1
     * @request POST:/api/v1/users/{userId}/user-signup-reminders
     * @secure
     */
    postUsersUserSignupRemindersV1: (
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/users/${userId}/user-signup-reminders`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UsersMultiple
     * @name PostUsersMultipleV1
     * @request POST:/api/v1/users-multiple
     * @secure
     */
    postUsersMultipleV1: (
      data: UsersMultipleCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateUsersResultDto, any>({
        path: `/api/v1/users-multiple`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UsersMultiple
     * @name GetUsersMultipleProjectsCanInviteV1
     * @request GET:/api/v1/users-multiple/projects-can-invite
     * @secure
     */
    getUsersMultipleProjectsCanInviteV1: (params: RequestParams = {}) =>
      this.request<ProjectsWhereUserCanInviteResultDto, any>({
        path: `/api/v1/users-multiple/projects-can-invite`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountNotificationSettings
     * @name GetAccountNotificationSettingsV1
     * @request GET:/api/v1/account/notification-settings
     * @secure
     */
    getAccountNotificationSettingsV1: (params: RequestParams = {}) =>
      this.request<UserAccountNotificationSettingsDto, any>({
        path: `/api/v1/account/notification-settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountNotificationSettings
     * @name PatchAccountNotificationSettingsV1
     * @request PATCH:/api/v1/account/notification-settings
     * @secure
     */
    patchAccountNotificationSettingsV1: (
      data: UserAccountNotificationSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/account/notification-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountTicketsConfiguration
     * @name GetUserProfileTicketsConfigurationV1
     * @request GET:/api/v1/user-profile-tickets-configuration
     * @secure
     */
    getUserProfileTicketsConfigurationV1: (params: RequestParams = {}) =>
      this.request<UserAccountTicketsConfigurationDto, any>({
        path: `/api/v1/user-profile-tickets-configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountTicketsConfiguration
     * @name PutUserProfileTicketsConfigurationV1
     * @request PUT:/api/v1/user-profile-tickets-configuration
     * @secure
     */
    putUserProfileTicketsConfigurationV1: (
      data: UserAccountTicketsConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/user-profile-tickets-configuration`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountTicketsConfiguration
     * @name GetAccountTicketsConfigurationV1
     * @request GET:/api/v1/account/tickets-configuration
     * @secure
     */
    getAccountTicketsConfigurationV1: (params: RequestParams = {}) =>
      this.request<UserAccountTicketsConfigurationDto, any>({
        path: `/api/v1/account/tickets-configuration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccountTicketsConfiguration
     * @name PutAccountTicketsConfigurationV1
     * @request PUT:/api/v1/account/tickets-configuration
     * @secure
     */
    putAccountTicketsConfigurationV1: (
      data: UserAccountTicketsConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/account/tickets-configuration`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentPlanning
     * @name PostTicketsAppointmentPlanningsV1
     * @request POST:/api/v1/tickets/appointment-plannings
     * @secure
     */
    postTicketsAppointmentPlanningsV1: (
      data: StartAppointmentPlanningRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentPlanningDto, any>({
        path: `/api/v1/tickets/appointment-plannings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppointmentPlanning
     * @name GetTicketsAppointmentPlanningsDetailsV1
     * @request GET:/api/v1/tickets/appointment-plannings/{planningId}
     * @secure
     */
    getTicketsAppointmentPlanningsDetailsV1: (
      planningId: string,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentPlanningDto, any>({
        path: `/api/v1/tickets/appointment-plannings/${planningId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JansenHuybregtsPlanning
     * @name PostTicketsJansenHuybregtsPlanningsV1
     * @request POST:/api/v1/tickets/jansen-huybregts/plannings
     * @secure
     */
    postTicketsJansenHuybregtsPlanningsV1: (
      data: StartJansenHuybregtsPlanningRequest,
      params: RequestParams = {},
    ) =>
      this.request<JansenHuybregtsPlanningDto, any>({
        path: `/api/v1/tickets/jansen-huybregts/plannings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JansenHuybregtsPlanning
     * @name GetTicketsJansenHuybregtsPlanningsDetailsV1
     * @request GET:/api/v1/tickets/jansen-huybregts/plannings/{planningId}
     * @secure
     */
    getTicketsJansenHuybregtsPlanningsDetailsV1: (
      planningId: string,
      params: RequestParams = {},
    ) =>
      this.request<JansenHuybregtsPlanningDto, any>({
        path: `/api/v1/tickets/jansen-huybregts/plannings/${planningId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketAppointment
     * @name GetTicketsAppointmentV1
     * @request GET:/api/v1/tickets/{ticketId}/appointment
     * @secure
     */
    getTicketsAppointmentV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<TicketAppointmentDto, any>({
        path: `/api/v1/tickets/${ticketId}/appointment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketAppointment
     * @name PostTicketsAppointmentSelectV1
     * @request POST:/api/v1/tickets/{ticketId}/appointment/select
     * @secure
     */
    postTicketsAppointmentSelectV1: (
      ticketId: string,
      data: SelectAppointmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketAppointmentDto, any>({
        path: `/api/v1/tickets/${ticketId}/appointment/select`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketAppointment
     * @name PostTicketsAppointmentChangeV1
     * @request POST:/api/v1/tickets/{ticketId}/appointment/change
     * @secure
     */
    postTicketsAppointmentChangeV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<TicketAppointmentDto, any>({
        path: `/api/v1/tickets/${ticketId}/appointment/change`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetTicketCategoriesV1
     * @summary Permission check is not included by design Endpoint is used for management pages
     * @request GET:/api/v1/ticket-categories
     * @secure
     */
    getTicketCategoriesV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /**
         * Obsolete, used to be used to filter on categories you can create tickets in. Now use /creatable endpoint instead
         * @default false
         */
        onlyCreatable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDtoPaginationResultDto, any>({
        path: `/api/v1/ticket-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name PostTicketCategoriesV1
     * @request POST:/api/v1/ticket-categories
     * @secure
     */
    postTicketCategoriesV1: (
      data: TicketCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/ticket-categories`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetRepairCategoriesV1
     * @summary Permission check is not included by design Endpoint is used for management pages
     * @request GET:/api/v1/repair-categories
     * @secure
     */
    getRepairCategoriesV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /**
         * Obsolete, used to be used to filter on categories you can create tickets in. Now use /creatable endpoint instead
         * @default false
         */
        onlyCreatable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDtoPaginationResultDto, any>({
        path: `/api/v1/repair-categories`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name PostRepairCategoriesV1
     * @request POST:/api/v1/repair-categories
     * @secure
     */
    postRepairCategoriesV1: (
      data: TicketCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/repair-categories`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetTicketCategoriesCreatableV1
     * @summary All categories you can create tickets in
     * @request GET:/api/v1/ticket-categories/creatable
     * @secure
     */
    getTicketCategoriesCreatableV1: (params: RequestParams = {}) =>
      this.request<CreatableTicketCategoryDto[], any>({
        path: `/api/v1/ticket-categories/creatable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetRepairCategoriesCreatableV1
     * @summary All categories you can create tickets in
     * @request GET:/api/v1/repair-categories/creatable
     * @secure
     */
    getRepairCategoriesCreatableV1: (params: RequestParams = {}) =>
      this.request<CreatableTicketCategoryDto[], any>({
        path: `/api/v1/repair-categories/creatable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetTicketCategoriesDetailsV1
     * @request GET:/api/v1/ticket-categories/{id}
     * @secure
     */
    getTicketCategoriesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/ticket-categories/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name PutTicketCategoriesV1
     * @request PUT:/api/v1/ticket-categories/{id}
     * @secure
     */
    putTicketCategoriesV1: (
      id: string,
      data: TicketCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/ticket-categories/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name DeleteTicketCategoriesByIdV1
     * @request DELETE:/api/v1/ticket-categories/{id}
     * @secure
     */
    deleteTicketCategoriesByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/ticket-categories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetRepairCategoriesDetailsV1
     * @request GET:/api/v1/repair-categories/{id}
     * @secure
     */
    getRepairCategoriesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/repair-categories/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name PutRepairCategoriesV1
     * @request PUT:/api/v1/repair-categories/{id}
     * @secure
     */
    putRepairCategoriesV1: (
      id: string,
      data: TicketCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryDetailsDto, any>({
        path: `/api/v1/repair-categories/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name DeleteRepairCategoriesByIdV1
     * @request DELETE:/api/v1/repair-categories/{id}
     * @secure
     */
    deleteRepairCategoriesByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/repair-categories/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name GetTicketCategoryTreeDetailsV1
     * @request GET:/api/v1/ticket-category-tree/{categoryId}
     * @secure
     */
    getTicketCategoryTreeDetailsV1: (
      categoryId: string,
      params: RequestParams = {},
    ) =>
      this.request<TicketCategoryTreeDto, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name PostTicketCategoryTreeV1
     * @request POST:/api/v1/ticket-category-tree/{categoryId}
     * @secure
     */
    postTicketCategoryTreeV1: (
      categoryId: string,
      data: TicketCategoryTreeNodeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name PutTicketCategoryTreeEnableV1
     * @request PUT:/api/v1/ticket-category-tree/{categoryId}/{nodeId}/enable
     * @secure
     */
    putTicketCategoryTreeEnableV1: (
      categoryId: string,
      nodeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}/${nodeId}/enable`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name PutTicketCategoryTreeDisableV1
     * @request PUT:/api/v1/ticket-category-tree/{categoryId}/{nodeId}/disable
     * @secure
     */
    putTicketCategoryTreeDisableV1: (
      categoryId: string,
      nodeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}/${nodeId}/disable`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name PutTicketCategoryTreeV1
     * @request PUT:/api/v1/ticket-category-tree/{categoryId}/{nodeId}
     * @secure
     */
    putTicketCategoryTreeV1: (
      categoryId: string,
      nodeId: string,
      data: TicketCategoryTreeNodeUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}/${nodeId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategoryTree
     * @name DeleteTicketCategoryTreeByIdV1
     * @request DELETE:/api/v1/ticket-category-tree/{categoryId}/{nodeId}
     * @secure
     */
    deleteTicketCategoryTreeByIdV1: (
      categoryId: string,
      nodeId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/ticket-category-tree/${categoryId}/${nodeId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name GetTicketsDetailsV1
     * @request GET:/api/v1/tickets/{ticketId}
     * @secure
     */
    getTicketsDetailsV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<AppTicketDto, any>({
        path: `/api/v1/tickets/${ticketId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name GetTicketsCommentsV1
     * @request GET:/api/v1/tickets/{ticketId}/comments
     * @secure
     */
    getTicketsCommentsV1: (
      ticketId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketCommentDtoPaginationResultDto, any>({
        path: `/api/v1/tickets/${ticketId}/comments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name PostTicketsCommentsV1
     * @request POST:/api/v1/tickets/{ticketId}/comments
     * @secure
     */
    postTicketsCommentsV1: (
      ticketId: string,
      data: TicketCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCommentDto, any>({
        path: `/api/v1/tickets/${ticketId}/comments`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name GetTicketsHistoryDetailsV1
     * @request GET:/api/v1/tickets/{ticketId}/history/{ticketHistoryType}
     * @secure
     */
    getTicketsHistoryDetailsV1: (
      ticketId: string,
      ticketHistoryType: TicketHistoryTypeDto,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserTicketHistoryDto, any>({
        path: `/api/v1/tickets/${ticketId}/history/${ticketHistoryType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name PutTicketsCommentsV1
     * @request PUT:/api/v1/tickets/{ticketId}/comments/{commentId}
     * @secure
     */
    putTicketsCommentsV1: (
      ticketId: string,
      commentId: string,
      data: EditTicketCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketCommentDto, any>({
        path: `/api/v1/tickets/${ticketId}/comments/${commentId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name PutTicketsRateV1
     * @request PUT:/api/v1/tickets/{ticketId}/rate
     * @secure
     */
    putTicketsRateV1: (
      ticketId: string,
      data: TicketRateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppTicketDto, any>({
        path: `/api/v1/tickets/${ticketId}/rate`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name PostTicketsReadV1
     * @request POST:/api/v1/tickets/{ticketId}/read
     * @secure
     */
    postTicketsReadV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/tickets/${ticketId}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name GetTicketsTranslationsDetailsV1
     * @request GET:/api/v1/tickets/{ticketId}/translations/{isoCode}
     * @secure
     */
    getTicketsTranslationsDetailsV1: (
      ticketId: string,
      isoCode: string,
      params: RequestParams = {},
    ) =>
      this.request<TicketTranslationDto, any>({
        path: `/api/v1/tickets/${ticketId}/translations/${isoCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketDetails
     * @name GetTicketsCommentsTranslationsDetailsV1
     * @request GET:/api/v1/tickets/{ticketId}/comments/{commentId}/translations/{isoCode}
     * @secure
     */
    getTicketsCommentsTranslationsDetailsV1: (
      ticketId: string,
      commentId: string,
      isoCode: string,
      params: RequestParams = {},
    ) =>
      this.request<TicketCommentTranslationDto, any>({
        path: `/api/v1/tickets/${ticketId}/comments/${commentId}/translations/${isoCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketJansenHuybregts
     * @name GetTicketsJansenHuybregtsV1
     * @request GET:/api/v1/tickets/{ticketId}/jansen-huybregts
     * @secure
     */
    getTicketsJansenHuybregtsV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<JansenHuybregtsTicketStatusDto, any>({
        path: `/api/v1/tickets/${ticketId}/jansen-huybregts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketJansenHuybregts
     * @name PostTicketsJansenHuybregtsSelectV1
     * @request POST:/api/v1/tickets/{ticketId}/jansen-huybregts/select
     * @secure
     */
    postTicketsJansenHuybregtsSelectV1: (
      ticketId: string,
      data: SelectJansenHuybregtsAppointmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<JansenHuybregtsTicketStatusDto, any>({
        path: `/api/v1/tickets/${ticketId}/jansen-huybregts/select`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketJansenHuybregts
     * @name PostTicketsJansenHuybregtsChangeV1
     * @request POST:/api/v1/tickets/{ticketId}/jansen-huybregts/change
     * @secure
     */
    postTicketsJansenHuybregtsChangeV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<JansenHuybregtsTicketStatusDto, any>({
        path: `/api/v1/tickets/${ticketId}/jansen-huybregts/change`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name PostTicketsV1
     * @request POST:/api/v1/tickets
     * @secure
     */
    postTicketsV1: (data: TicketRequest, params: RequestParams = {}) =>
      this.request<AppTicketDto, any>({
        path: `/api/v1/tickets`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsV1
     * @request GET:/api/v1/tickets
     * @secure
     */
    getTicketsV1: (
      query?: {
        RepairRequestFilterType?: TicketFilterTypeDto;
        StatusType?: TicketStatusFilterTypeDto;
        SortBy?: TicketSortingDto;
        Search?: string;
        StatusIds?: string[];
        ReporterIds?: string[];
        CategoryIds?: string[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppTicketDtoPaginationResultDto, any>({
        path: `/api/v1/tickets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsFiltersV1
     * @request GET:/api/v1/tickets/filters
     * @secure
     */
    getTicketsFiltersV1: (params: RequestParams = {}) =>
      this.request<TicketFiltersDto, any>({
        path: `/api/v1/tickets/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsStatsDetailsV1
     * @request GET:/api/v1/tickets/stats/{statusType}
     * @secure
     */
    getTicketsStatsDetailsV1: (
      statusType: TicketStatusFilterTypeDto,
      params: RequestParams = {},
    ) =>
      this.request<TicketStatsDto, any>({
        path: `/api/v1/tickets/stats/${statusType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsStatsAllStatusesV1
     * @request GET:/api/v1/tickets/stats/all-statuses
     * @secure
     */
    getTicketsStatsAllStatusesV1: (
      query?: {
        RepairRequestFilterType?: TicketFilterTypeDto;
        StatusType?: TicketStatusFilterTypeDto;
        SortBy?: TicketSortingDto;
        Search?: string;
        StatusIds?: string[];
        ReporterIds?: string[];
        CategoryIds?: string[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketTabsStatsDto, any>({
        path: `/api/v1/tickets/stats/all-statuses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsFeedbackOptionsV1
     * @request GET:/api/v1/tickets/feedback-options
     * @secure
     */
    getTicketsFeedbackOptionsV1: (params: RequestParams = {}) =>
      this.request<TicketFeedbackLabelByRatingDto[], any>({
        path: `/api/v1/tickets/feedback-options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketStatuses
     * @name GetTicketStatusesV1
     * @request GET:/api/v1/ticket-statuses
     * @secure
     */
    getTicketStatusesV1: (params: RequestParams = {}) =>
      this.request<TicketStatusDetailsDtoPaginationResultDto, any>({
        path: `/api/v1/ticket-statuses`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketStatuses
     * @name PostTicketStatusesV1
     * @request POST:/api/v1/ticket-statuses
     * @secure
     */
    postTicketStatusesV1: (
      data: TicketStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketStatusDetailsDto, any>({
        path: `/api/v1/ticket-statuses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketStatuses
     * @name GetTicketStatusesDetailsV1
     * @request GET:/api/v1/ticket-statuses/{id}
     * @secure
     */
    getTicketStatusesDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<TicketStatusDetailsDto, any>({
        path: `/api/v1/ticket-statuses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketStatuses
     * @name PutTicketStatusesV1
     * @request PUT:/api/v1/ticket-statuses/{id}
     * @secure
     */
    putTicketStatusesV1: (
      id: string,
      data: TicketStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketStatusDetailsDto, any>({
        path: `/api/v1/ticket-statuses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketStatuses
     * @name DeleteTicketStatusesByIdV1
     * @request DELETE:/api/v1/ticket-statuses/{id}
     * @secure
     */
    deleteTicketStatusesByIdV1: (
      id: string,
      query?: {
        replacementStatusId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/ticket-statuses/${id}`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name PostAutomatedSurveysV1
     * @request POST:/api/v1/automated-surveys
     * @secure
     */
    postAutomatedSurveysV1: (
      data: AutomatedSurveyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyDto, any>({
        path: `/api/v1/automated-surveys`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysV1
     * @request GET:/api/v1/automated-surveys
     * @secure
     */
    getAutomatedSurveysV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyDtoPaginationResultDto, any>({
        path: `/api/v1/automated-surveys`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name PutAutomatedSurveysV1
     * @request PUT:/api/v1/automated-surveys/{id}
     * @secure
     */
    putAutomatedSurveysV1: (
      id: string,
      data: AutomatedSurveyEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/automated-surveys/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysDetailsV1
     * @request GET:/api/v1/automated-surveys/{id}
     * @secure
     */
    getAutomatedSurveysDetailsV1: (
      id: string,
      query?: {
        /** @default false */
        includeRankingQuestion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyDto, any>({
        path: `/api/v1/automated-surveys/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysQueuesV1
     * @request GET:/api/v1/automated-surveys/queues
     * @secure
     */
    getAutomatedSurveysQueuesV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyQueueDtoPaginationResultDto, any>({
        path: `/api/v1/automated-surveys/queues`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysActiveDetailsV1
     * @request GET:/api/v1/automated-surveys/{id}/active-details
     * @secure
     */
    getAutomatedSurveysActiveDetailsV1: (
      id: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyQueueDetailsListDtoPaginationResultDto, any>({
        path: `/api/v1/automated-surveys/${id}/active-details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysQueuesDetailsV1
     * @request GET:/api/v1/automated-surveys/queues/{queueId}/details
     * @secure
     */
    getAutomatedSurveysQueuesDetailsV1: (
      queueId: string,
      query?: {
        /** @default false */
        includeRankingQuestion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyQueueDetailsDto, any>({
        path: `/api/v1/automated-surveys/queues/${queueId}/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysQueuesQuestionsDetailsV1
     * @request GET:/api/v1/automated-surveys/queues/{queueId}/questions/{questionGroupId}/details
     * @secure
     */
    getAutomatedSurveysQueuesQuestionsDetailsV1: (
      queueId: string,
      questionGroupId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyQueueQuestionDetailsDto, any>({
        path: `/api/v1/automated-surveys/queues/${queueId}/questions/${questionGroupId}/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysQueuesQuestionsDetailsSummaryV1
     * @request GET:/api/v1/automated-surveys/queues/{queueId}/questions/{questionGroupId}/details/summary
     * @secure
     */
    getAutomatedSurveysQueuesQuestionsDetailsSummaryV1: (
      queueId: string,
      questionGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionSummaryDto, any>({
        path: `/api/v1/automated-surveys/queues/${queueId}/questions/${questionGroupId}/details/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AutomatedSurveys
     * @name GetAutomatedSurveysAnalyticsDetailsV1
     * @summary Gets the results of the survey per interval for the given project
     * @request GET:/api/v1/automated-surveys/{id}/analytics/{questionGroupId}
     * @secure
     */
    getAutomatedSurveysAnalyticsDetailsV1: (
      id: string,
      questionGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<AutomatedSurveyIntervalResultDto[], any>({
        path: `/api/v1/automated-surveys/${id}/analytics/${questionGroupId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassSurveys
     * @name GetMassSurveysGroupsV1
     * @request GET:/api/v1/mass-surveys/groups
     * @secure
     */
    getMassSurveysGroupsV1: (
      query?: {
        Sorting?: SortByDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<SystemGroupDto[], any>({
        path: `/api/v1/mass-surveys/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassSurveys
     * @name GetMassSurveysProjectsV1
     * @request GET:/api/v1/mass-surveys/projects
     * @secure
     */
    getMassSurveysProjectsV1: (
      query?: {
        GroupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SimpleProjectDto[], any>({
        path: `/api/v1/mass-surveys/projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassSurveys
     * @name PostMassSurveysV1
     * @request POST:/api/v1/mass-surveys
     * @secure
     */
    postMassSurveysV1: (
      data: CreateSurveyBulkRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateSurveyBulkItemDto[], any>({
        path: `/api/v1/mass-surveys`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysV1
     * @request GET:/api/v1/surveys
     * @secure
     */
    getSurveysV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyDtoPaginationResultDto, any>({
        path: `/api/v1/surveys`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PostSurveysV1
     * @request POST:/api/v1/surveys
     * @secure
     */
    postSurveysV1: (data: CreateSurveyRequestDto, params: RequestParams = {}) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/surveys`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysDetailsV1
     * @request GET:/api/v1/surveys/{id}
     * @secure
     */
    getSurveysDetailsV1: (
      id: string,
      query?: {
        /** @default false */
        includeRankingQuestion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyDetailsDto, any>({
        path: `/api/v1/surveys/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PutSurveysV1
     * @request PUT:/api/v1/surveys/{id}
     * @secure
     */
    putSurveysV1: (
      id: string,
      data: UpdateSurveyRequestDto,
      query?: {
        /** @default false */
        includeRankingQuestion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyDetailsDto, any>({
        path: `/api/v1/surveys/${id}`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name DeleteSurveysByIdV1
     * @request DELETE:/api/v1/surveys/{id}
     * @secure
     */
    deleteSurveysByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/surveys/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PostSurveysReadV1
     * @request POST:/api/v1/surveys/{id}/read
     * @secure
     */
    postSurveysReadV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/surveys/${id}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PostSurveysAnswerV1
     * @request POST:/api/v1/surveys/{id}/answer
     * @secure
     */
    postSurveysAnswerV1: (
      id: string,
      data: AnswerRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/surveys/${id}/answer`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysExportV1
     * @request GET:/api/v1/surveys/{id}/export
     * @secure
     */
    getSurveysExportV1: (id: string, params: RequestParams = {}) =>
      this.request<SurveyExportLine[], any>({
        path: `/api/v1/surveys/${id}/export`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysSuggestedFollowUpsV1
     * @request GET:/api/v1/surveys/{id}/suggested-follow-ups
     * @secure
     */
    getSurveysSuggestedFollowUpsV1: (id: string, params: RequestParams = {}) =>
      this.request<SurveyFollowUpSuggestionDto[], any>({
        path: `/api/v1/surveys/${id}/suggested-follow-ups`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PostSurveysSuggestedFollowUpsRateV1
     * @request POST:/api/v1/surveys/{id}/suggested-follow-ups/{followUpId}/rate
     * @secure
     */
    postSurveysSuggestedFollowUpsRateV1: (
      id: string,
      followUpId: string,
      data: AiResponseRatingDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/surveys/${id}/suggested-follow-ups/${followUpId}/rate`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysSummaryV1
     * @request GET:/api/v1/surveys/{surveyId}/{questionId}/summary
     * @secure
     */
    getSurveysSummaryV1: (
      surveyId: string,
      questionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionSummaryDto, any>({
        path: `/api/v1/surveys/${surveyId}/${questionId}/summary`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysFeelAtHomeWidgetV1
     * @request GET:/api/v1/surveys/feel-at-home-widget
     * @secure
     */
    getSurveysFeelAtHomeWidgetV1: (params: RequestParams = {}) =>
      this.request<SurveyWidgetInfoDto, any>({
        path: `/api/v1/surveys/feel-at-home-widget`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name PostSurveysFollowUpV1
     * @request POST:/api/v1/surveys/{id}/follow-up
     * @secure
     */
    postSurveysFollowUpV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/surveys/${id}/follow-up`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iqbi
     * @name GetServicepartnersIqbiConsumptionV1
     * @request GET:/api/v1/servicepartners/iqbi/consumption
     * @secure
     */
    getServicepartnersIqbiConsumptionV1: (
      query?: {
        /**
         * The month for which to get the consumption data. Since this is a date parameter, the day is ignored.
         * @format date
         */
        month?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConsumptionResultDto[], void>({
        path: `/api/v1/servicepartners/iqbi/consumption`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iqbi
     * @name PostServicepartnersIqbiConfirmAddressV1
     * @summary Confirm current address of the user. Necessary to ensure the user can use the IQBI service and only see the data since the address confirmation.
     * @request POST:/api/v1/servicepartners/iqbi/confirm-address
     * @secure
     */
    postServicepartnersIqbiConfirmAddressV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/iqbi/confirm-address`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iqbi
     * @name PostServicepartnersIqbiConsentV1
     * @summary Provide consent for the user's address to be used with the IQBI service.
     * @request POST:/api/v1/servicepartners/iqbi/consent
     * @secure
     */
    postServicepartnersIqbiConsentV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/iqbi/consent`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyPup
     * @name PostServicepartnersMypupRegisterV1
     * @request POST:/api/v1/servicepartners/mypup/register
     * @secure
     */
    postServicepartnersMypupRegisterV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/mypup/register`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MyPupExternal
     * @name PostServicepartnersMypupExternalNotificationV1
     * @request POST:/api/v1/servicepartners/mypup/external/notification
     */
    postServicepartnersMypupExternalNotificationV1: (
      query: {
        /** API Key */
        apikey: string;
      },
      data: MyPupPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/mypup/external/notification`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name GetServicepartnersV1
     * @request GET:/api/v1/servicepartners
     * @secure
     */
    getServicepartnersV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /** @default false */
        includeFromConnection?: boolean;
        /** @default false */
        returnAllowedTypes?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServicePartnerPagePaginationResultDto, any>({
        path: `/api/v1/servicepartners`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name PostServicepartnersV1
     * @request POST:/api/v1/servicepartners
     * @secure
     */
    postServicepartnersV1: (
      data: ServicePartnerCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/servicepartners`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name GetServicepartnersCategoriesV1
     * @request GET:/api/v1/servicepartners/categories
     * @secure
     */
    getServicepartnersCategoriesV1: (params: RequestParams = {}) =>
      this.request<PartnerCategoriesDto[], any>({
        path: `/api/v1/servicepartners/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name GetServicepartnersDetailsV1
     * @request GET:/api/v1/servicepartners/{id}
     * @secure
     */
    getServicepartnersDetailsV1: (
      id: string,
      query?: {
        /** @default false */
        replaceParameters?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServicePartnerPageDetailsDto, any>({
        path: `/api/v1/servicepartners/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name PutServicepartnersV1
     * @request PUT:/api/v1/servicepartners/{id}
     * @secure
     */
    putServicepartnersV1: (
      id: string,
      data: ServicePartnerRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/servicepartners/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name DeleteServicepartnersByIdV1
     * @request DELETE:/api/v1/servicepartners/{id}
     * @secure
     */
    deleteServicepartnersByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name PostServicepartnersReadV1
     * @request POST:/api/v1/servicepartners/{id}/read
     * @secure
     */
    postServicepartnersReadV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/${id}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name GetServicepartnersAccessLinkV1
     * @request GET:/api/v1/servicepartners/{id}/access-link
     * @secure
     */
    getServicepartnersAccessLinkV1: (
      id: string,
      query?: {
        returnUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServicePartnerAccessLinkDto, any>({
        path: `/api/v1/servicepartners/${id}/access-link`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ServicePartners
     * @name PutServicepartnersUpdateViewCountV1
     * @request PUT:/api/v1/servicepartners/{id}/update-view-count
     * @secure
     */
    putServicepartnersUpdateViewCountV1: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/servicepartners/${id}/update-view-count`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name GetProjectConnectionsGroupsV1
     * @request GET:/api/v1/project-connections/{connectionId}/groups
     * @secure
     */
    getProjectConnectionsGroupsV1: (
      connectionId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectConnectionGroupDtoPaginationResultDto, any>({
        path: `/api/v1/project-connections/${connectionId}/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name PostProjectConnectionsGroupsV1
     * @request POST:/api/v1/project-connections/{connectionId}/groups
     * @secure
     */
    postProjectConnectionsGroupsV1: (
      connectionId: string,
      data: ProjectConnectionGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectConnectionGroupDetailDto, any>({
        path: `/api/v1/project-connections/${connectionId}/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name GetProjectConnectionsGroupsDetailsV1
     * @request GET:/api/v1/project-connections/{connectionId}/groups/{id}
     * @secure
     */
    getProjectConnectionsGroupsDetailsV1: (
      id: string,
      connectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProjectConnectionGroupDetailDto, any>({
        path: `/api/v1/project-connections/${connectionId}/groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name PutProjectConnectionsGroupsV1
     * @request PUT:/api/v1/project-connections/{connectionId}/groups/{id}
     * @secure
     */
    putProjectConnectionsGroupsV1: (
      connectionId: string,
      id: string,
      data: ProjectConnectionGroupUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${connectionId}/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name DeleteProjectConnectionsGroupsByIdV1
     * @request DELETE:/api/v1/project-connections/{connectionId}/groups/{id}
     * @secure
     */
    deleteProjectConnectionsGroupsByIdV1: (
      connectionId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${connectionId}/groups/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnectionGroups
     * @name PostProjectConnectionsGroupsEnableV1
     * @request POST:/api/v1/project-connections/{connectionId}/groups/{id}/enable/{projectId}
     * @secure
     */
    postProjectConnectionsGroupsEnableV1: (
      id: string,
      projectId: string,
      connectionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${connectionId}/groups/${id}/enable/${projectId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Groups are only returned if IncludeAllFromAccount is true
     *
     * @tags ProjectConnections
     * @name GetProjectConnectionsV1
     * @request GET:/api/v1/project-connections
     * @secure
     */
    getProjectConnectionsV1: (
      query?: {
        IncludeAllFromProfile?: boolean;
        /** Only get project connections that this project is in */
        IncludeAllFromAccount?: boolean;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectConnectionDetailsDtoPaginationResultDto, any>({
        path: `/api/v1/project-connections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PostProjectConnectionsV1
     * @request POST:/api/v1/project-connections
     * @secure
     */
    postProjectConnectionsV1: (
      data: ProjectConnectionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectConnectionDetailsDto, any>({
        path: `/api/v1/project-connections`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name GetProjectConnectionsDetailsV1
     * @request GET:/api/v1/project-connections/{id}
     * @secure
     */
    getProjectConnectionsDetailsV1: (id: string, params: RequestParams = {}) =>
      this.request<ProjectConnectionDetailsDto, any>({
        path: `/api/v1/project-connections/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PutProjectConnectionsV1
     * @request PUT:/api/v1/project-connections/{id}
     * @secure
     */
    putProjectConnectionsV1: (
      id: string,
      data: ProjectConnectionEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name DeleteProjectConnectionsByIdV1
     * @request DELETE:/api/v1/project-connections/{id}
     * @secure
     */
    deleteProjectConnectionsByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name GetProjectConnectionsInvitesV1
     * @request GET:/api/v1/project-connections/invites
     * @secure
     */
    getProjectConnectionsInvitesV1: (params: RequestParams = {}) =>
      this.request<ProjectConnectionDetailsDto[], any>({
        path: `/api/v1/project-connections/invites`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PostProjectConnectionsJoinV1
     * @request POST:/api/v1/project-connections/{id}/join
     * @secure
     */
    postProjectConnectionsJoinV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/${id}/join`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PatchProjectConnectionsSettingsV1
     * @request PATCH:/api/v1/project-connections/settings
     * @secure
     */
    patchProjectConnectionsSettingsV1: (
      data: ProjectConnectionUserSettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PatchProjectConnectionsPrivacySettingsV1
     * @request PATCH:/api/v1/project-connections/privacy-settings
     * @secure
     */
    patchProjectConnectionsPrivacySettingsV1: (
      data: ProjectConnectionUserPrivacySettingsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/privacy-settings`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectConnections
     * @name PostProjectConnectionsPrivacySettingsSeenV1
     * @request POST:/api/v1/project-connections/privacy-settings/seen
     * @secure
     */
    postProjectConnectionsPrivacySettingsSeenV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/project-connections/privacy-settings/seen`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Deprecated: Use /api/v1/portfolio-permissions instead
     *
     * @tags MassMessages
     * @name GetMassMessagesV1
     * @request GET:/api/v1/mass-messages
     * @deprecated
     * @secure
     */
    getMassMessagesV1: (params: RequestParams = {}) =>
      this.request<PortfolioPermissionsDto, any>({
        path: `/api/v1/mass-messages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassMessages
     * @name PostMassMessagesV1
     * @request POST:/api/v1/mass-messages
     * @secure
     */
    postMassMessagesV1: (
      data: MessageMultipleProjectsCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MassMessageCreatedEntityDto, any>({
        path: `/api/v1/mass-messages`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassMessages
     * @name GetMassMessagesGroupsV1
     * @request GET:/api/v1/mass-messages/groups
     * @secure
     */
    getMassMessagesGroupsV1: (
      query?: {
        MessageType?: MessageTypeDto;
        Sorting?: SortByDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<SystemGroupDto[], any>({
        path: `/api/v1/mass-messages/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MassMessages
     * @name GetMassMessagesProjectsV1
     * @request GET:/api/v1/mass-messages/projects
     * @secure
     */
    getMassMessagesProjectsV1: (
      query?: {
        MessageType?: MessageTypeDto;
        GroupId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SimpleProjectDto[], any>({
        path: `/api/v1/mass-messages/projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageCommentLikes
     * @name GetMessagesCommentsReactV1
     * @request GET:/api/v1/messages/{messageId}/comments/{commentId}/react
     * @secure
     */
    getMessagesCommentsReactV1: (
      messageId: string,
      commentId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageCommentReactionDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}/react`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageCommentLikes
     * @name PutMessagesCommentsReactV1
     * @request PUT:/api/v1/messages/{messageId}/comments/{commentId}/react
     * @secure
     */
    putMessagesCommentsReactV1: (
      messageId: string,
      commentId: string,
      data: ManageReactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}/react`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageCommentLikes
     * @name GetMessagesCommentsLikesV1
     * @request GET:/api/v1/messages/{messageId}/comments/{commentId}/likes
     * @secure
     */
    getMessagesCommentsLikesV1: (
      messageId: string,
      commentId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageCommentReactionDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}/likes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageCommentLikes
     * @name PostMessagesCommentsLikesV1
     * @request POST:/api/v1/messages/{messageId}/comments/{commentId}/likes
     * @secure
     */
    postMessagesCommentsLikesV1: (
      messageId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}/likes`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageCommentLikes
     * @name DeleteMessagesCommentsLikesV1
     * @request DELETE:/api/v1/messages/{messageId}/comments/{commentId}/likes
     * @secure
     */
    deleteMessagesCommentsLikesV1: (
      messageId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}/likes`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name GetMessagesCommentsV1
     * @request GET:/api/v1/messages/{messageId}/comments
     * @secure
     */
    getMessagesCommentsV1: (
      messageId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        SortDescending?: boolean;
        SortBy?: MessageCommentSortablePropertiesDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommentDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/comments`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name PostMessagesCommentsV1
     * @request POST:/api/v1/messages/{messageId}/comments
     * @secure
     */
    postMessagesCommentsV1: (
      messageId: string,
      data: CommentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommentDto, any>({
        path: `/api/v1/messages/${messageId}/comments`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name GetMessagesCommentsDetailsV1
     * @request GET:/api/v1/messages/{messageId}/comments/{commentId}
     * @secure
     */
    getMessagesCommentsDetailsV1: (
      messageId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<CommentDetailDto, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name DeleteMessagesCommentsByIdV1
     * @request DELETE:/api/v1/messages/{messageId}/comments/{commentId}
     * @secure
     */
    deleteMessagesCommentsByIdV1: (
      messageId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name PutMessagesCommentsV1
     * @request PUT:/api/v1/messages/{messageId}/comments/{commentId}
     * @secure
     */
    putMessagesCommentsV1: (
      messageId: string,
      commentId: string,
      data: CommentUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/comments/${commentId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags MessageDetails
     * @name GetMessagesDetailsV1
     * @request GET:/api/v1/messages/{messageId}
     * @deprecated
     * @secure
     */
    getMessagesDetailsV1: (messageId: string, params: RequestParams = {}) =>
      this.request<MessageDetailV1Dto, any>({
        path: `/api/v1/messages/${messageId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Deprecated: Use change-status instead
     *
     * @tags MessageDetails
     * @name DeleteMessagesByIdV1
     * @request DELETE:/api/v1/messages/{messageId}
     * @deprecated
     * @secure
     */
    deleteMessagesByIdV1: (messageId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PutMessagesV1
     * @request PUT:/api/v1/messages/{messageId}
     * @secure
     */
    putMessagesV1: (
      messageId: string,
      data: MessageUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * @description Deprecated: Use read instead
     *
     * @tags MessageDetails
     * @name PostMessagesMarkReadV1
     * @request POST:/api/v1/messages/{messageId}/markRead
     * @deprecated
     * @secure
     */
    postMessagesMarkReadV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/markRead`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PostMessagesReadV1
     * @request POST:/api/v1/messages/{messageId}/read
     * @secure
     */
    postMessagesReadV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PostMessagesReportV1
     * @request POST:/api/v1/messages/{messageId}/report
     * @secure
     */
    postMessagesReportV1: (
      messageId: string,
      data: MessageReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/report`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PostMessagesChangeStatusV1
     * @request POST:/api/v1/messages/{messageId}/change-status
     * @secure
     */
    postMessagesChangeStatusV1: (
      messageId: string,
      data: MessageStatusChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/change-status`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PutMessagesMuteV1
     * @request PUT:/api/v1/messages/{messageId}/mute
     * @secure
     */
    putMessagesMuteV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/mute`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name DeleteMessagesMuteV1
     * @request DELETE:/api/v1/messages/{messageId}/mute
     * @secure
     */
    deleteMessagesMuteV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/mute`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PutMessagesIssueStatusUpdateV1
     * @request PUT:/api/v1/messages/{messageId}/issue-status-update
     * @secure
     */
    putMessagesIssueStatusUpdateV1: (
      messageId: string,
      data: UpdateIssueStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateIssueStatusDto, any>({
        path: `/api/v1/messages/${messageId}/issue-status-update`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name GetMessagesReachV1
     * @request GET:/api/v1/messages/{messageId}/reach
     * @secure
     */
    getMessagesReachV1: (messageId: string, params: RequestParams = {}) =>
      this.request<PostReachDto, any>({
        path: `/api/v1/messages/${messageId}/reach`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageInforms
     * @name PostMessagesInformsV1
     * @request POST:/api/v1/messages/{messageId}/informs
     * @secure
     */
    postMessagesInformsV1: (
      messageId: string,
      data: MessageInformRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/informs`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageInforms
     * @name GetMessagesInformsV1
     * @request GET:/api/v1/messages/{messageId}/informs
     * @secure
     */
    getMessagesInformsV1: (
      messageId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageInformDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/informs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageInforms
     * @name GetMessagesInformsUsersV1
     * @request GET:/api/v1/messages/{messageId}/informs/users
     * @secure
     */
    getMessagesInformsUsersV1: (
      messageId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserWithAudienceDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/informs/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageLikes
     * @name GetMessagesReactV1
     * @request GET:/api/v1/messages/{messageId}/react
     * @secure
     */
    getMessagesReactV1: (
      messageId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageReactionDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/react`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageLikes
     * @name PutMessagesReactV1
     * @request PUT:/api/v1/messages/{messageId}/react
     * @secure
     */
    putMessagesReactV1: (
      messageId: string,
      data: ManageReactionRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/react`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageLikes
     * @name GetMessagesLikesV1
     * @request GET:/api/v1/messages/{messageId}/likes
     * @secure
     */
    getMessagesLikesV1: (
      messageId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageReactionDtoPaginationResultDto, any>({
        path: `/api/v1/messages/${messageId}/likes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageLikes
     * @name PostMessagesLikeV1
     * @request POST:/api/v1/messages/{messageId}/like
     * @secure
     */
    postMessagesLikeV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/like`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageLikes
     * @name DeleteMessagesLikeV1
     * @request DELETE:/api/v1/messages/{messageId}/like
     * @secure
     */
    deleteMessagesLikeV1: (messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/${messageId}/like`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Deprecated: Use V2 instead
     *
     * @tags Messages
     * @name GetMessagesV1
     * @request GET:/api/v1/messages
     * @deprecated
     * @secure
     */
    getMessagesV1: (
      query?: {
        Query?: string;
        PosterId?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        GroupIds?: string[];
        Tab?: CommunityFeedTabsDto;
        Connection?: CommunityFeedConnectionFilterDto;
        ExcludeArchivedPosts?: boolean;
        FeedTypes?: CommunityFeedType[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageV1DtoPaginationResultDto, any>({
        path: `/api/v1/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name PostMessagesV1
     * @request POST:/api/v1/messages
     * @secure
     */
    postMessagesV1: (data: MessageCreateRequest, params: RequestParams = {}) =>
      this.request<MessageCreatedEntityDto, any>({
        path: `/api/v1/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name GetMessagesUnreadStatsV1
     * @request GET:/api/v1/messages/unread-stats
     * @secure
     */
    getMessagesUnreadStatsV1: (params: RequestParams = {}) =>
      this.request<CommunityFeedStatsDto, any>({
        path: `/api/v1/messages/unread-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name GetMessagesMentionsV1
     * @request GET:/api/v1/messages/mentions
     * @secure
     */
    getMessagesMentionsV1: (
      query?: {
        search?: string;
        messageId?: string;
        groupId?: string;
        projectConnectionId?: string;
        /** @default false */
        hideFromAdmins?: boolean;
        /** @default 0 */
        type?: MessageTypeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<MentionSuggestionDto[], any>({
        path: `/api/v1/messages/mentions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name PostMessagesMarkAllAsReadV1
     * @request POST:/api/v1/messages/markAllAsRead
     * @secure
     */
    postMessagesMarkAllAsReadV1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/messages/markAllAsRead`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name GetMessagesRecentActivityV1
     * @request GET:/api/v1/messages/recent-activity
     * @secure
     */
    getMessagesRecentActivityV1: (params: RequestParams = {}) =>
      this.request<RecentActivityDto, any>({
        path: `/api/v1/messages/recent-activity`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageTemplates
     * @name GetMessageTemplatesV1
     * @request GET:/api/v1/message-templates
     * @secure
     */
    getMessageTemplatesV1: (
      query?: {
        /** @default false */
        isPortfolio?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PostTemplateDto[], any>({
        path: `/api/v1/message-templates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name GetBookableAssetsV1
     * @request GET:/api/v1/bookable-assets
     * @secure
     */
    getBookableAssetsV1: (
      query?: {
        HideUnpublished?: boolean;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookableAssetDtoPaginationResultDto, any>({
        path: `/api/v1/bookable-assets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name PostBookableAssetsV1
     * @request POST:/api/v1/bookable-assets
     * @secure
     */
    postBookableAssetsV1: (
      data: BookableAssetCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/bookable-assets`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name GetBookableAssetsDetailsV1
     * @request GET:/api/v1/bookable-assets/{assetId}
     * @secure
     */
    getBookableAssetsDetailsV1: (assetId: string, params: RequestParams = {}) =>
      this.request<BookableAssetDetailDto, any>({
        path: `/api/v1/bookable-assets/${assetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name PutBookableAssetsV1
     * @request PUT:/api/v1/bookable-assets/{assetId}
     * @secure
     */
    putBookableAssetsV1: (
      assetId: string,
      data: BookableAssetUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/bookable-assets/${assetId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name DeleteBookableAssetsByIdV1
     * @request DELETE:/api/v1/bookable-assets/{assetId}
     * @secure
     */
    deleteBookableAssetsByIdV1: (assetId: string, params: RequestParams = {}) =>
      this.request<BookableAssetDeletedResult, any>({
        path: `/api/v1/bookable-assets/${assetId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name PostBookableAssetsOutlookTestV1
     * @request POST:/api/v1/bookable-assets/{assetId}/outlook/test
     * @secure
     */
    postBookableAssetsOutlookTestV1: (
      assetId: string,
      params: RequestParams = {},
    ) =>
      this.request<BookableAssetOutlookConfigurationTestDto, any>({
        path: `/api/v1/bookable-assets/${assetId}/outlook/test`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name GetBookableAssetsSlotsV1
     * @request GET:/api/v1/bookable-assets/{assetId}/slots
     * @secure
     */
    getBookableAssetsSlotsV1: (
      assetId: string,
      query?: {
        /** @format date */
        Date?: string;
        ExcludedBookingIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BookableAssetSlotsDto, any>({
        path: `/api/v1/bookable-assets/${assetId}/slots`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name PostBookableAssetsBookingsToBeCancelledV1
     * @request POST:/api/v1/bookable-assets/{assetId}/bookings-to-be-cancelled
     * @secure
     */
    postBookableAssetsBookingsToBeCancelledV1: (
      assetId: string,
      data: BookableAssetUpdateBookingsToBeCancelledRequest,
      params: RequestParams = {},
    ) =>
      this.request<BookableAssetUpdateBookingsToBeCancelledDto, any>({
        path: `/api/v1/bookable-assets/${assetId}/bookings-to-be-cancelled`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BookableAssets
     * @name GetBookableAssetsStatisticsV1
     * @summary Retrieves the statistics for a bookable asset.
     * @request GET:/api/v1/bookable-assets/{assetId}/statistics
     * @secure
     */
    getBookableAssetsStatisticsV1: (
      assetId: string,
      query?: {
        /**
         * Optional. Determines whether to include today's bookings in the statistics.
         * Only applies to AssetBookingDto? BookableAssetStatisticsDto.MostRecentBooking
         * @default true
         */
        includeToday?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookableAssetStatisticsDto, any>({
        path: `/api/v1/bookable-assets/${assetId}/statistics`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name GetBookableAssetsBookingsV1
     * @summary Retrieves the bookings for a specific asset based on the provided filter.
     * @request GET:/api/v1/bookable-assets/{assetId}/bookings
     * @secure
     */
    getBookableAssetsBookingsV1: (
      assetId: string,
      query?: {
        /** @format date */
        Date?: string;
        /**
         * Optional. If not provided, the filter will be applied only for the specified date.
         * Cannot be greater than 32 days from the specified date.
         * @format date
         */
        Until?: string;
        IncludeCancelled?: boolean;
        /**
         * Collection of booking IDs that are excluded from the results of a request, to prevent them from being considered in the current operation.
         * This is particularly useful in scenarios such as editing a booking, where the booking being edited (e.g., ID 7) should not appear in the query results to (incorrect) avoid conflicts.
         */
        ExcludedBookingIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetBookingDto[], any>({
        path: `/api/v1/bookable-assets/${assetId}/bookings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name PostBookableAssetsBookingsV1
     * @request POST:/api/v1/bookable-assets/{assetId}/bookings
     * @secure
     */
    postBookableAssetsBookingsV1: (
      assetId: string,
      data: AssetBookingRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, void>({
        path: `/api/v1/bookable-assets/${assetId}/bookings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name GetBookableAssetsMyBookingsV1
     * @summary Retrieves all the bookings for the logged-in user based on the specified pagination settings.
     * @request GET:/api/v1/bookable-assets/bookings
     * @secure
     */
    getBookableAssetsMyBookingsV1: (
      query?: {
        TimeFrame?: BookingsTimeFrameDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetBookingDtoPaginationResultDto, any>({
        path: `/api/v1/bookable-assets/bookings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name GetBookableAssetsBookingsDetailsV1
     * @request GET:/api/v1/bookable-assets/{assetId}/bookings/{bookingId}
     * @secure
     */
    getBookableAssetsBookingsDetailsV1: (
      bookingId: string,
      assetId: string,
      params: RequestParams = {},
    ) =>
      this.request<AssetBookingDetailDto, any>({
        path: `/api/v1/bookable-assets/${assetId}/bookings/${bookingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name DeleteBookableAssetsBookingsByIdV1
     * @request DELETE:/api/v1/bookable-assets/{assetId}/bookings/{bookingId}
     * @secure
     */
    deleteBookableAssetsBookingsByIdV1: (
      bookingId: string,
      assetId: string,
      data: DeleteAssetBookingRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/bookable-assets/${assetId}/bookings/${bookingId}`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name PutBookableAssetsBookingsV1
     * @request PUT:/api/v1/bookable-assets/{assetId}/bookings/{bookingId}
     * @secure
     */
    putBookableAssetsBookingsV1: (
      bookingId: string,
      assetId: string,
      data: AssetBookingRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssetBookingDetailDto, void>({
        path: `/api/v1/bookable-assets/${assetId}/bookings/${bookingId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name GetBookableAssetsBookingsExportV1
     * @request GET:/api/v1/bookable-assets/{assetId}/bookings/export
     * @secure
     */
    getBookableAssetsBookingsExportV1: (
      assetId: string,
      query?: {
        /** @default false */
        includeHistory?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/bookable-assets/${assetId}/bookings/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bookings
     * @name GetBookableAssetsBookingsProjectExportV1
     * @request GET:/api/v1/bookable-assets/bookings/export
     * @secure
     */
    getBookableAssetsBookingsProjectExportV1: (
      query?: {
        /** @default false */
        includeHistory?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/bookable-assets/bookings/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name GetAlertsConfigurationsV1
     * @request GET:/api/v1/alerts-configurations
     * @secure
     */
    getAlertsConfigurationsV1: (params: RequestParams = {}) =>
      this.request<AlertConfigurationsDto, any>({
        path: `/api/v1/alerts-configurations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PostAlertsConfigurationsPostKeywordsV1
     * @request POST:/api/v1/alerts-configurations/post-keywords
     * @secure
     */
    postAlertsConfigurationsPostKeywordsV1: (
      data: KeywordAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/post-keywords`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PutAlertsConfigurationsPostKeywordsV1
     * @request PUT:/api/v1/alerts-configurations/post-keywords/{id}
     * @secure
     */
    putAlertsConfigurationsPostKeywordsV1: (
      id: string,
      data: KeywordAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/post-keywords/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PostAlertsConfigurationsCommentKeywordsV1
     * @request POST:/api/v1/alerts-configurations/comment-keywords
     * @secure
     */
    postAlertsConfigurationsCommentKeywordsV1: (
      data: KeywordAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/comment-keywords`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PutAlertsConfigurationsCommentKeywordsV1
     * @request PUT:/api/v1/alerts-configurations/comment-keywords/{id}
     * @secure
     */
    putAlertsConfigurationsCommentKeywordsV1: (
      id: string,
      data: KeywordAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/comment-keywords/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PostAlertsConfigurationsNumberOfLikesV1
     * @request POST:/api/v1/alerts-configurations/number-of-likes
     * @secure
     */
    postAlertsConfigurationsNumberOfLikesV1: (
      data: ThresholdAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/number-of-likes`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PutAlertsConfigurationsNumberOfLikesV1
     * @request PUT:/api/v1/alerts-configurations/number-of-likes/{id}
     * @secure
     */
    putAlertsConfigurationsNumberOfLikesV1: (
      id: string,
      data: ThresholdAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/number-of-likes/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PostAlertsConfigurationsNumberOfCommentsV1
     * @request POST:/api/v1/alerts-configurations/number-of-comments
     * @secure
     */
    postAlertsConfigurationsNumberOfCommentsV1: (
      data: ThresholdAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/number-of-comments`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AlertsConfigurations
     * @name PutAlertsConfigurationsNumberOfCommentsV1
     * @request PUT:/api/v1/alerts-configurations/number-of-comments/{id}
     * @secure
     */
    putAlertsConfigurationsNumberOfCommentsV1: (
      id: string,
      data: ThresholdAlertConfigurationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/alerts-configurations/number-of-comments/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TriggeredAlerts
     * @name GetTriggeredAlertsV1
     * @request GET:/api/v1/triggered-alerts
     * @secure
     */
    getTriggeredAlertsV1: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /** @default false */
        onlyDashboard?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenericAlertTriggeredDtoPaginationResultDto, any>({
        path: `/api/v1/triggered-alerts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiEmailUpdate
     * @name GetAiEmailUpdateV1
     * @request GET:/api/v1/ai-email-update
     * @secure
     */
    getAiEmailUpdateV1: (params: RequestParams = {}) =>
      this.request<AiEmailUpdateDto[], any>({
        path: `/api/v1/ai-email-update`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiEmailUpdate
     * @name PostAiEmailUpdateV1
     * @request POST:/api/v1/ai-email-update
     * @secure
     */
    postAiEmailUpdateV1: (
      data: AiEmailUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, any>({
        path: `/api/v1/ai-email-update`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AiEmailUpdate
     * @name DeleteAiEmailUpdateByIdV1
     * @request DELETE:/api/v1/ai-email-update/{id}
     * @secure
     */
    deleteAiEmailUpdateByIdV1: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/ai-email-update/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatBot
     * @name PostChatsBotV1
     * @request POST:/api/v1/chats/bot
     * @secure
     */
    postChatsBotV1: (data: ChatMessage[], params: RequestParams = {}) =>
      this.request<ChatMessage[], any>({
        path: `/api/v1/chats/bot`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunityGroupAi
     * @name PostGroupsAiGenerateHeaderImageV1
     * @request POST:/api/v1/groups/{id}/ai/generate-header-image
     * @secure
     */
    postGroupsAiGenerateHeaderImageV1: (
      id: string,
      query?: {
        extraInformation?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<HeaderImageDto[], any>({
        path: `/api/v1/groups/${id}/ai/generate-header-image`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Copilot
     * @name PostCopilotV1
     * @request POST:/api/v1/copilot
     * @secure
     */
    postCopilotV1: (data: CopilotRequest, params: RequestParams = {}) =>
      this.request<CopilotResponseDto, any>({
        path: `/api/v1/copilot`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Copilot
     * @name PostCopilotStreamV1
     * @request POST:/api/v1/copilot/stream
     * @secure
     */
    postCopilotStreamV1: (data: CopilotRequest, params: RequestParams = {}) =>
      this.request<TextStream[], any>({
        path: `/api/v1/copilot/stream`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessagesAi
     * @name PostMessagesAiSentimentV1
     * @request POST:/api/v1/messages-ai/{messageId}/sentiment
     * @secure
     */
    postMessagesAiSentimentV1: (
      messageId: string,
      params: RequestParams = {},
    ) =>
      this.request<MessageSentimentDto, any>({
        path: `/api/v1/messages-ai/${messageId}/sentiment`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessagesAi
     * @name PostMessagesAiTopicsV1
     * @request POST:/api/v1/messages-ai/{messageId}/topics
     * @secure
     */
    postMessagesAiTopicsV1: (messageId: string, params: RequestParams = {}) =>
      this.request<MessageTopicsDto, any>({
        path: `/api/v1/messages-ai/${messageId}/topics`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSummary
     * @name GetProjectSummaryV1
     * @request GET:/api/v1/project/summary
     * @secure
     */
    getProjectSummaryV1: (
      query?: {
        /**
         * Date from when posts should be used to load a summary
         * @format date-time
         */
        from?: string;
        /**
         * Date to when posts should be used to load a summary
         * @format date-time
         */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectSummaryDto, any>({
        path: `/api/v1/project/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSummary
     * @name PostProjectSummaryQuestionV1
     * @summary This endpoint is used to ask a question to the AI model, based on the project data (community feed).
     * @request POST:/api/v1/project/summary/question
     * @secure
     */
    postProjectSummaryQuestionV1: (
      data: QuestionRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/project/summary/question`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketSuggestion
     * @name PostTicketsSuggestionV1
     * @request POST:/api/v1/tickets/{ticketId}/suggestion
     * @secure
     */
    postTicketsSuggestionV1: (
      ticketId: string,
      data: TicketResponseSuggestionRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketResponseSuggestionDto, any>({
        path: `/api/v1/tickets/${ticketId}/suggestion`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name GetAdminTicketsDetailsV1
     * @request GET:/api/v1/admin/tickets/{ticketId}
     * @secure
     */
    getAdminTicketsDetailsV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<AdminTicketDetailsDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name DeleteAdminTicketsByIdV1
     * @request DELETE:/api/v1/admin/tickets/{ticketId}
     * @secure
     */
    deleteAdminTicketsByIdV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name GetAdminTicketsActivitiesV1
     * @request GET:/api/v1/admin/tickets/{ticketId}/activities
     * @secure
     */
    getAdminTicketsActivitiesV1: (
      ticketId: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /** @default false */
        sortDescending?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketActivityDtoPaginationResultDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}/activities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PutAdminTicketsAssigneeV1
     * @request PUT:/api/v1/admin/tickets/{ticketId}/assignee
     * @secure
     */
    putAdminTicketsAssigneeV1: (
      ticketId: string,
      data: TicketAssigneeChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}/assignee`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PutAdminTicketsStatusV1
     * @request PUT:/api/v1/admin/tickets/{ticketId}/status
     * @secure
     */
    putAdminTicketsStatusV1: (
      ticketId: string,
      data: TicketStatusChangeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}/status`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PostAdminTicketsMoveToInProgressV1
     * @request POST:/api/v1/admin/tickets/{ticketId}/move-to-in-progress
     * @secure
     */
    postAdminTicketsMoveToInProgressV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}/move-to-in-progress`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PostAdminTicketsRemsSyncV1
     * @request POST:/api/v1/admin/tickets/{ticketId}/rems-sync
     * @secure
     */
    postAdminTicketsRemsSyncV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<RemsStatusDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}/rems-sync`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PostAdminTicketsRemsSendTicketV1
     * @request POST:/api/v1/admin/tickets/{ticketId}/rems-send-ticket
     * @secure
     */
    postAdminTicketsRemsSendTicketV1: (
      ticketId: string,
      data: RemsSyncRequest,
      params: RequestParams = {},
    ) =>
      this.request<RemsStatusDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}/rems-send-ticket`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PostAdminTicketsReminderV1
     * @request POST:/api/v1/admin/tickets/{ticketId}/reminder
     * @secure
     */
    postAdminTicketsReminderV1: (
      ticketId: string,
      data: SetReminderDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}/reminder`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name DeleteAdminTicketsReminderDeleteV1
     * @request DELETE:/api/v1/admin/tickets/{ticketId}/reminder/delete
     * @secure
     */
    deleteAdminTicketsReminderDeleteV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/${ticketId}/reminder/delete`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name GetAdminTicketsResponsibilitySuggestionV1
     * @summary Returns whether the (cost) responsibility for the maintenance should be assigned to the tenant or the landlord. This is based on AI analysis of the ticket content. Null if AI has not (yet) made a suggestion.
     * @request GET:/api/v1/admin/tickets/{ticketId}/responsibility-suggestion
     * @secure
     */
    getAdminTicketsResponsibilitySuggestionV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<TicketResponsibilitySuggestionDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}/responsibility-suggestion`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTicketDetails
     * @name PostAdminTicketsResponsibilitySuggestionV1
     * @summary Rates the suggested responsibility for the maintenance of the ticket. Good results in a response of TicketResponseSuggestionDto, bad results in a response of NoContentResult.
     * @request POST:/api/v1/admin/tickets/{ticketId}/responsibility-suggestion
     * @secure
     */
    postAdminTicketsResponsibilitySuggestionV1: (
      ticketId: string,
      data: ResponsibilitySuggestionRatingRequest,
      params: RequestParams = {},
    ) =>
      this.request<TicketResponseSuggestionDto, any>({
        path: `/api/v1/admin/tickets/${ticketId}/responsibility-suggestion`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name GetAdminTicketsV1
     * @request GET:/api/v1/admin/tickets
     * @secure
     */
    getAdminTicketsV1: (
      query?: {
        StatusIds?: string[];
        CategoryIds?: string[];
        AssigneeIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        Ratings?: number[];
        AddressTypes?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        /** @format date-time */
        RatedFrom?: string;
        /** @format date-time */
        RatedTo?: string;
        /** @format date-time */
        ClosedFrom?: string;
        /** @format date-time */
        ClosedTo?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketDetailedListItemDtoPaginationResultDto, any>({
        path: `/api/v1/admin/tickets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name PostAdminTicketsReadV1
     * @request POST:/api/v1/admin/tickets/read
     * @secure
     */
    postAdminTicketsReadV1: (
      query?: {
        StatusIds?: string[];
        CategoryIds?: string[];
        AssigneeIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        Ratings?: number[];
        AddressTypes?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        /** @format date-time */
        RatedFrom?: string;
        /** @format date-time */
        RatedTo?: string;
        /** @format date-time */
        ClosedFrom?: string;
        /** @format date-time */
        ClosedTo?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/read`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name GetAdminTicketsFiltersV1
     * @request GET:/api/v1/admin/tickets/filters
     * @secure
     */
    getAdminTicketsFiltersV1: (params: RequestParams = {}) =>
      this.request<AdminTicketFiltersDto, any>({
        path: `/api/v1/admin/tickets/filters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name GetAdminTicketsStatsDetailsV1
     * @request GET:/api/v1/admin/tickets/stats/{tab}
     * @secure
     */
    getAdminTicketsStatsDetailsV1: (
      tab: AdminTicketsTabDto,
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketStatsDto, any>({
        path: `/api/v1/admin/tickets/stats/${tab}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name GetAdminTicketsStatsAllTabsV1
     * @request GET:/api/v1/admin/tickets/stats/all-tabs
     * @secure
     */
    getAdminTicketsStatsAllTabsV1: (
      query?: {
        StatusIds?: string[];
        CategoryIds?: string[];
        AssigneeIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        Ratings?: number[];
        AddressTypes?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        /** @format date-time */
        RatedFrom?: string;
        /** @format date-time */
        RatedTo?: string;
        /** @format date-time */
        ClosedFrom?: string;
        /** @format date-time */
        ClosedTo?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketTabsStatsDto, any>({
        path: `/api/v1/admin/tickets/stats/all-tabs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminTickets
     * @name GetAdminTicketsExportV1
     * @request GET:/api/v1/admin/tickets/export
     * @secure
     */
    getAdminTicketsExportV1: (
      query?: {
        StatusIds?: string[];
        CategoryIds?: string[];
        AssigneeIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        Ratings?: number[];
        AddressTypes?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        /** @format date-time */
        RatedFrom?: string;
        /** @format date-time */
        RatedTo?: string;
        /** @format date-time */
        ClosedFrom?: string;
        /** @format date-time */
        ClosedTo?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
        /**
         * @format double
         * @default 0
         */
        utcHourOffset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/tickets/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssistantRuns
     * @name GetAdminAssistantRunsV1
     * @request GET:/api/v1/admin/assistant-runs
     * @secure
     */
    getAdminAssistantRunsV1: (
      query?: {
        /** @format date-time */
        StartedFromUtc?: string;
        /** @format date-time */
        StartedToUtc?: string;
        Status?: string;
        Source?: string;
        UserId?: string;
        ProjectId?: string;
        RequestId?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssistantRunListItemDtoPaginationResultDto, any>({
        path: `/api/v1/admin/assistant-runs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssistantRuns
     * @name GetAdminAssistantRunsDetailsV1
     * @request GET:/api/v1/admin/assistant-runs/{assistantRunId}
     * @secure
     */
    getAdminAssistantRunsDetailsV1: (
      assistantRunId: string,
      params: RequestParams = {},
    ) =>
      this.request<AssistantRunTimelineDto, any>({
        path: `/api/v1/admin/assistant-runs/${assistantRunId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DicoAdminTickets
     * @name PostAdminTicketsDicoV1
     * @summary Sends a ticket to Dico service.
     * @request POST:/api/v1/admin/tickets/{ticketId}/dico
     * @secure
     */
    postAdminTicketsDicoV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<DicoStatusDto, DicoStatusDto>({
        path: `/api/v1/admin/tickets/${ticketId}/dico`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HomeDnaAdminTickets
     * @name PostAdminTicketsHomednaV1
     * @summary Sends a ticket to HomeDNA service.
     * @request POST:/api/v1/admin/tickets/{ticketId}/homedna
     * @secure
     */
    postAdminTicketsHomednaV1: (ticketId: string, params: RequestParams = {}) =>
      this.request<HomeDnaStatusDto, HomeDnaStatusDto>({
        path: `/api/v1/admin/tickets/${ticketId}/homedna`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpTokens
     * @name GetAdminMcpTokensV1
     * @request GET:/api/v1/admin/mcp-tokens
     * @secure
     */
    getAdminMcpTokensV1: (params: RequestParams = {}) =>
      this.request<McpTokenListItem[], any>({
        path: `/api/v1/admin/mcp-tokens`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpTokens
     * @name PostAdminMcpTokensV1
     * @request POST:/api/v1/admin/mcp-tokens
     * @secure
     */
    postAdminMcpTokensV1: (
      data: McpTokenCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<McpTokenCreateResponse, any>({
        path: `/api/v1/admin/mcp-tokens`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags McpTokens
     * @name DeleteAdminMcpTokensByIdV1
     * @request DELETE:/api/v1/admin/mcp-tokens/{tokenId}
     * @secure
     */
    deleteAdminMcpTokensByIdV1: (tokenId: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/admin/mcp-tokens/${tokenId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name GetAdminPortfolioTicketsV1
     * @request GET:/api/v1/admin/portfolio-tickets
     * @secure
     */
    getAdminPortfolioTicketsV1: (
      query?: {
        Ratings?: number[];
        ProjectIds?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        StatusKeys?: string[];
        CategoryNames?: string[];
        AssigneeAccountIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioAdminTicketDtoPaginationResultDto, any>({
        path: `/api/v1/admin/portfolio-tickets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name GetAdminPortfolioTicketsFiltersV1
     * @request GET:/api/v1/admin/portfolio-tickets/filters
     * @secure
     */
    getAdminPortfolioTicketsFiltersV1: (
      query?: {
        ProjectIds?: string[];
        AssigneeSearch?: string;
        SelectedAssigneeAccountIds?: string[];
        /** @format int32 */
        AssigneeLimit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioTicketFilterOptionsDto, any>({
        path: `/api/v1/admin/portfolio-tickets/filters`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name PostAdminPortfolioTicketsReadV1
     * @request POST:/api/v1/admin/portfolio-tickets/read
     * @secure
     */
    postAdminPortfolioTicketsReadV1: (
      query?: {
        Ratings?: number[];
        ProjectIds?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        StatusKeys?: string[];
        CategoryNames?: string[];
        AssigneeAccountIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/admin/portfolio-tickets/read`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name GetAdminPortfolioTicketsStatsDetailsV1
     * @request GET:/api/v1/admin/portfolio-tickets/stats/{tab}
     * @secure
     */
    getAdminPortfolioTicketsStatsDetailsV1: (
      tab: AdminTicketsTabDto,
      query?: {
        Ratings?: number[];
        ProjectIds?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        StatusKeys?: string[];
        CategoryNames?: string[];
        AssigneeAccountIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketStatsDto, any>({
        path: `/api/v1/admin/portfolio-tickets/stats/${tab}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name GetAdminPortfolioTicketsStatsAllTabsV1
     * @request GET:/api/v1/admin/portfolio-tickets/stats/all-tabs
     * @secure
     */
    getAdminPortfolioTicketsStatsAllTabsV1: (
      query?: {
        Ratings?: number[];
        ProjectIds?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        StatusKeys?: string[];
        CategoryNames?: string[];
        AssigneeAccountIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminTicketTabsStatsDto, any>({
        path: `/api/v1/admin/portfolio-tickets/stats/all-tabs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAdminTickets
     * @name GetAdminPortfolioTicketsIdsV1
     * @summary Used for the 'next' button in the ticket details view
     * @request GET:/api/v1/admin/portfolio-tickets/ids
     * @secure
     */
    getAdminPortfolioTicketsIdsV1: (
      query?: {
        Ratings?: number[];
        ProjectIds?: string[];
        UnreadOnly?: boolean;
        Filter?: AdminTicketsVisibilityFilter;
        SortBy?: TicketSortablePropertiesDto;
        Tab?: AdminTicketsTabDto;
        Search?: string;
        ResidentFocusMode?: boolean;
        StatusKeys?: string[];
        CategoryNames?: string[];
        AssigneeAccountIds?: string[];
        AssigneeMode?: TicketAssigneeFilterModeDto;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioMinimalTicketDto[], any>({
        path: `/api/v1/admin/portfolio-tickets/ids`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WunderbricksAdminTickets
     * @name PostAdminTicketsWunderbricksV1
     * @request POST:/api/v1/admin/tickets/{ticketId}/wunderbricks
     * @secure
     */
    postAdminTicketsWunderbricksV1: (
      ticketId: string,
      params: RequestParams = {},
    ) =>
      this.request<WunderbricksStatusDto, WunderbricksStatusDto>({
        path: `/api/v1/admin/tickets/${ticketId}/wunderbricks`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WoonbedrijfConnector
     * @name PostApiPartnersWoonbedrijfNewRelation
     * @request POST:/api/partners/woonbedrijf/new-relation
     */
    postApiPartnersWoonbedrijfNewRelation: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: CreateRelationWoonbedrijfRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/woonbedrijf/new-relation`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WoonbedrijfConnector
     * @name PostApiPartnersWoonbedrijfEndRelation
     * @summary This ends the "contract" between the renter and the address unit. This will result into the renter being removed from the address unit at the specified date.
     * @request POST:/api/partners/woonbedrijf/end-relation
     */
    postApiPartnersWoonbedrijfEndRelation: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: EndRelationWoonbedrijfRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/woonbedrijf/end-relation`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SwoogoWebhook
     * @name PostApiPartnersSwoogoProjectsWebhooks
     * @request POST:/api/partners/swoogo/projects/{projectId}/webhooks/{webhookSecret}
     */
    postApiPartnersSwoogoProjectsWebhooks: (
      projectId: number,
      webhookSecret: string,
      data: JsonElement,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/partners/swoogo/projects/${projectId}/webhooks/${webhookSecret}`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LocoiaConnector
     * @name PostApiPartnersLocoiaNewRelation
     * @request POST:/api/partners/locoia/new-relation
     */
    postApiPartnersLocoiaNewRelation: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: CreateRelationLocoiaRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/locoia/new-relation`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LocoiaConnector
     * @name PostApiPartnersLocoiaEndRelation
     * @summary This ends the "contract" between the renter and the address unit. This will result into the renter being removed from the address unit at the specified date.
     * @request POST:/api/partners/locoia/end-relation
     */
    postApiPartnersLocoiaEndRelation: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: EndRelationLocoiaRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/locoia/end-relation`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HubSpotWebhook
     * @name PostApiPartnersHubspotProjectsWebhooks
     * @request POST:/api/partners/hubspot/projects/{projectId}/webhooks/{webhookSecret}
     */
    postApiPartnersHubspotProjectsWebhooks: (
      projectId: string,
      webhookSecret: string,
      data: JsonElement,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/partners/hubspot/projects/${projectId}/webhooks/${webhookSecret}`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags HomeDnaConnector
     * @name PostApiPartnersHomednaProcess
     * @summary Currently supports processing a request for ACC, AFH, or GER status.
     * @request POST:/api/partners/homedna/{ticketId}/process
     */
    postApiPartnersHomednaProcess: (
      ticketId: string,
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: ProcessRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/homedna/${ticketId}/process`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectApiAccess
     * @name PostApiPartnersGenericMessages
     * @summary Create a new post in the feed
     * @request POST:/api/partners/generic/messages
     */
    postApiPartnersGenericMessages: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: PartnerMessageCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreatedEntityDto, void>({
        path: `/api/partners/generic/messages`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectApiAccess
     * @name PostApiPartnersGenericImages
     * @summary Uploads an image for use in messages.
     * @request POST:/api/partners/generic/images
     */
    postApiPartnersGenericImages: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: {
        projectId: string;
        /** @format binary */
        file: File;
        description?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ImageDto, void>({
        path: `/api/partners/generic/images`,
        method: "POST",
        query: query,
        body: data,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DicoIntegration
     * @name PostApiPartnersDicoSoap
     * @request POST:/api/partners/dico/soap
     */
    postApiPartnersDicoSoap: (
      data: any,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/partners/dico/soap`,
        method: "POST",
        query: query,
        body: data,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DicoIntegration
     * @name PostApiPartnersDicoRest
     * @request POST:/api/partners/dico/rest
     */
    postApiPartnersDicoRest: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: MaintenanceStatus,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/partners/dico/rest`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CloudMailinILoq
     * @name PostApiPartnersCloudmailinIloq
     * @request POST:/api/partners/cloudmailin/iloq
     */
    postApiPartnersCloudmailinIloq: (
      query: {
        "api-version"?: string;
        /** API Key */
        apikey: string;
      },
      data: CloudMailinPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/partners/cloudmailin/iloq`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BringmeParcelWebhook
     * @name PostApiPartnersBringmeWebhooksParcels
     * @request POST:/api/partners/bringme/webhooks/parcels
     */
    postApiPartnersBringmeWebhooksParcels: (
      data: BringmeParcelWebhookRequest,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/partners/bringme/webhooks/parcels`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsEventsReportingV2
     * @summary Event and announcement reporting for the current project and its joined project connections
     * @request GET:/api/v2/analytics/events-reporting
     * @secure
     */
    getAnalyticsEventsReportingV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
        /** @default 0 */
        eventType?: EventAnalyticsEventTypeDto;
        origin?: EventAnalyticsOriginDto;
        category?: EventCategoryTypeDto;
        status?: EventAnalyticsStatusDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventAnalyticsDto, any>({
        path: `/api/v2/analytics/events-reporting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsEventsReportingSummaryV2
     * @summary Safe event headline metrics for the operational calendar.
     * @request GET:/api/v2/analytics/events-reporting/summary
     * @secure
     */
    getAnalyticsEventsReportingSummaryV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<EventOperationalInsightDto, any>({
        path: `/api/v2/analytics/events-reporting/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsTicketsReportingV2
     * @summary Ticket reporting based on the tickets visible to the current project administrator
     * @request GET:/api/v2/analytics/tickets-reporting
     * @secure
     */
    getAnalyticsTicketsReportingV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
        categoryId?: string;
        status?: TicketAnalyticsStatusDto;
        visibility?: TicketAnalyticsVisibilityDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketAnalyticsDto, any>({
        path: `/api/v2/analytics/tickets-reporting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsTicketsReportingSummaryV2
     * @summary Safe ticket headline metrics for the operational ticket list.
     * @request GET:/api/v2/analytics/tickets-reporting/summary
     * @secure
     */
    getAnalyticsTicketsReportingSummaryV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketOperationalInsightDto, any>({
        path: `/api/v2/analytics/tickets-reporting/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsBookingsReportingV2
     * @summary Bookable asset and booking reporting for the current project and its joined project connections
     * @request GET:/api/v2/analytics/bookings-reporting
     * @secure
     */
    getAnalyticsBookingsReportingV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
        assetId?: string;
        status?: BookingAnalyticsStatusDto;
        origin?: BookingAnalyticsOriginDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookingAnalyticsDto, any>({
        path: `/api/v2/analytics/bookings-reporting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsBookingsReportingSummaryV2
     * @summary Safe booking headline metrics for the operational bookings overview.
     * @request GET:/api/v2/analytics/bookings-reporting/summary
     * @secure
     */
    getAnalyticsBookingsReportingSummaryV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<BookingOperationalInsightDto, any>({
        path: `/api/v2/analytics/bookings-reporting/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsCommunityFeedReportingV2
     * @summary Community feed reporting based on content visible to the current project administrator
     * @request GET:/api/v2/analytics/community-feed-reporting
     * @secure
     */
    getAnalyticsCommunityFeedReportingV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
        authorType?: CommunityFeedAnalyticsAuthorTypeDto;
        contentType?: CommunityFeedAnalyticsContentTypeDto;
        groupId?: string;
        origin?: CommunityFeedAnalyticsOriginDto;
        status?: CommunityFeedAnalyticsStatusDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedReportingDto, any>({
        path: `/api/v2/analytics/community-feed-reporting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsCommunityFeedReportingSummaryV2
     * @summary Safe community-feed headline metrics for the operational feed.
     * @request GET:/api/v2/analytics/community-feed-reporting/summary
     * @secure
     */
    getAnalyticsCommunityFeedReportingSummaryV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedOperationalInsightDto, any>({
        path: `/api/v2/analytics/community-feed-reporting/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsEngagedResidentsMonthlyV2
     * @summary The contribution of residents to the project
     * @request GET:/api/v2/analytics/engaged-residents/monthly
     * @secure
     */
    getAnalyticsEngagedResidentsMonthlyV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
        /** @default false */
        withCurrentMonth?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<EngagedResidentsMonthlyPercentageDto, any>({
        path: `/api/v2/analytics/engaged-residents/monthly`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsResidentEngagementDetailsV2
     * @summary The engagement of residents on a monthly basis These numbers are stored on a monthly basis
     * @request GET:/api/v2/analytics/resident-engagement/details
     * @secure
     */
    getAnalyticsResidentEngagementDetailsV2: (
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResidentEngagementMonthlyV2Dto, any>({
        path: `/api/v2/analytics/resident-engagement/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsAdoptionRateDetailsDetailsV2
     * @request GET:/api/v2/analytics/adoption-rate/details/{adoptionRateDetailsGraphType}
     * @secure
     */
    getAnalyticsAdoptionRateDetailsDetailsV2: (
      adoptionRateDetailsGraphType: AdoptionRateDetailsGraphTypeDto,
      query?: {
        /** @default 1 */
        dateRange?: DateRangeDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdoptionRateDetailsDto, any>({
        path: `/api/v2/analytics/adoption-rate/details/${adoptionRateDetailsGraphType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeDetailsV2
     * @request GET:/api/v2/analytics/feeling-at-home/details
     * @secure
     */
    getAnalyticsFeelingAtHomeDetailsV2: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FeelingAtHomeDetailsV2Dto, any>({
        path: `/api/v2/analytics/feeling-at-home/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeDetailsQuestionsSummaryV2
     * @request GET:/api/v2/analytics/feeling-at-home/details/questions/{questionGroupId}/summary
     * @secure
     */
    getAnalyticsFeelingAtHomeDetailsQuestionsSummaryV2: (
      questionGroupId: string,
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyQuestionSummaryDto, any>({
        path: `/api/v2/analytics/feeling-at-home/details/questions/${questionGroupId}/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Analytics
     * @name GetAnalyticsFeelingAtHomeExportV2
     * @request GET:/api/v2/analytics/feeling-at-home/export
     * @secure
     */
    getAnalyticsFeelingAtHomeExportV2: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/analytics/feeling-at-home/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsGroupV2
     * @request POST:/api/v2/chats/group
     * @secure
     */
    postChatsGroupV2: (
      data: CreateGroupChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatDto, any>({
        path: `/api/v2/chats/group`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsPrivateV2
     * @request POST:/api/v2/chats/private
     * @secure
     */
    postChatsPrivateV2: (
      data: CreatePrivateChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatDto, any>({
        path: `/api/v2/chats/private`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsBlocksV2
     * @request POST:/api/v2/chats/blocks/{id}
     * @secure
     */
    postChatsBlocksV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/blocks/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name DeleteChatsBlocksByIdV2
     * @request DELETE:/api/v2/chats/blocks/{id}
     * @secure
     */
    deleteChatsBlocksByIdV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/blocks/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsV2
     * @request GET:/api/v2/chats
     * @secure
     */
    getChatsV2: (
      query?: {
        Search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatDtoPaginationResultDto, any>({
        path: `/api/v2/chats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsDetailsV2
     * @request GET:/api/v2/chats/{id}
     * @secure
     */
    getChatsDetailsV2: (id: string, params: RequestParams = {}) =>
      this.request<ChatDto, any>({
        path: `/api/v2/chats/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name DeleteChatsByIdV2
     * @summary Delete chat from users list, for group chats can only be done after leaving chat.
     * @request DELETE:/api/v2/chats/{id}
     * @secure
     */
    deleteChatsByIdV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsMembersV2
     * @request GET:/api/v2/chats/{id}/members
     * @secure
     */
    getChatsMembersV2: (id: string, params: RequestParams = {}) =>
      this.request<UserExtendedDto[], any>({
        path: `/api/v2/chats/${id}/members`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PutChatsMembersAddV2
     * @summary Adds a list of users to a chat group. If a user is already a member of the chat, they will be ignored.
     * @request PUT:/api/v2/chats/{id}/members/add
     * @secure
     */
    putChatsMembersAddV2: (
      id: string,
      data: AddMemberRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserDto[], any>({
        path: `/api/v2/chats/${id}/members/add`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsMembersLeaveV2
     * @summary Allows the current user to leave a group chat.
     * @request POST:/api/v2/chats/{id}/members/leave
     * @secure
     */
    postChatsMembersLeaveV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/${id}/members/leave`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PutChatsMembersRemoveV2
     * @summary Removes a specified user from a chat group. The user requesting the removal cannot remove themselves from the chat.
     * @request PUT:/api/v2/chats/{id}/members/remove
     * @secure
     */
    putChatsMembersRemoveV2: (
      id: string,
      data: RemoveMemberRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserDto[], any>({
        path: `/api/v2/chats/${id}/members/remove`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsPinV2
     * @request POST:/api/v2/chats/{id}/pin
     * @secure
     */
    postChatsPinV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/${id}/pin`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name DeleteChatsPinV2
     * @request DELETE:/api/v2/chats/{id}/pin
     * @secure
     */
    deleteChatsPinV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/chats/${id}/pin`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PostChatsReplyV2
     * @request POST:/api/v2/chats/{id}/reply
     * @secure
     */
    postChatsReplyV2: (
      id: string,
      data: ChatReplyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatReplyDto, any>({
        path: `/api/v2/chats/${id}/reply`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsRepliesV2
     * @request GET:/api/v2/chats/{id}/replies
     * @secure
     */
    getChatsRepliesV2: (
      id: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatReplyDtoPaginationResultDto, any>({
        path: `/api/v2/chats/${id}/replies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name PutChatsGroupV2
     * @request PUT:/api/v2/chats/group/{id}
     * @secure
     */
    putChatsGroupV2: (
      id: string,
      data: UpdateGroupChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/chats/group/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chats
     * @name GetChatsUserDetailsV2
     * @summary Gets the private chat with the specified user, including the latest reply.
     * @request GET:/api/v2/chats/user/{id}
     * @secure
     */
    getChatsUserDetailsV2: (id: string, params: RequestParams = {}) =>
      this.request<ChatDto, any>({
        path: `/api/v2/chats/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pagination applies to the combined feed items across messages, polls, and surveys.
     *
     * @tags CommunityFeed
     * @name GetCommunityFeedV2
     * @request GET:/api/v2/community-feed
     * @secure
     */
    getCommunityFeedV2: (
      query?: {
        Query?: string;
        PosterId?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        GroupIds?: string[];
        Tab?: CommunityFeedTabsDto;
        Connection?: CommunityFeedConnectionFilterDto;
        ExcludeArchivedPosts?: boolean;
        FeedTypes?: CommunityFeedType[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedItemV2DtoPaginationResultDto, any>({
        path: `/api/v2/community-feed`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunityFeed
     * @name GetCommunityFeedAudienceV2
     * @request GET:/api/v2/community-feed/audience
     * @secure
     */
    getCommunityFeedAudienceV2: (
      query?: {
        /** Whether the endpoint returns only the groups you can create project posts in. */
        ExcludeProjectConnections?: boolean;
        GroupId?: string;
        Type?: AudienceMessageTypeFilterDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityFeedAudienceV2Dto, any>({
        path: `/api/v2/community-feed/audience`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommunityFeed
     * @name PostCommunityFeedViewV2
     * @request POST:/api/v2/community-feed/view
     * @secure
     */
    postCommunityFeedViewV2: (
      data: CommunityFeedBulkViewRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/community-feed/view`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Events
     * @name PostEventsV2
     * @request POST:/api/v2/events
     * @secure
     */
    postEventsV2: (data: CreateEventsRequest, params: RequestParams = {}) =>
      this.request<EventsCreatedDto, any>({
        path: `/api/v2/events`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupsV2
     * @request GET:/api/v2/groups
     * @secure
     */
    getGroupsV2: (
      query?: {
        groupTypes?: CommunityGroupTypeDto[];
        search?: string;
        includeDisabled?: boolean;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupV2DtoPaginationResultDto, any>({
        path: `/api/v2/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PostGroupsV2
     * @request POST:/api/v2/groups
     * @secure
     */
    postGroupsV2: (
      data: CommunityGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsV2Dto, any>({
        path: `/api/v2/groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name GetGroupsDetailsV2
     * @request GET:/api/v2/groups/{id}
     * @secure
     */
    getGroupsDetailsV2: (id: string, params: RequestParams = {}) =>
      this.request<CommunityGroupDetailsV2Dto, any>({
        path: `/api/v2/groups/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups
     * @name PutGroupsV2
     * @request PUT:/api/v2/groups/{id}
     * @secure
     */
    putGroupsV2: (
      id: string,
      data: CommunityGroupEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsV2Dto, any>({
        path: `/api/v2/groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name GetLanguagesV2
     * @request GET:/api/v2/languages
     */
    getLanguagesV2: (params: RequestParams = {}) =>
      this.request<LanguageDto[], any>({
        path: `/api/v2/languages`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polls
     * @name GetPollsTranslationsDetailsV2
     * @request GET:/api/v2/polls/{id}/translations/{isoCode}
     * @secure
     */
    getPollsTranslationsDetailsV2: (
      id: string,
      isoCode: string,
      params: RequestParams = {},
    ) =>
      this.request<PollTranslationDto, any>({
        path: `/api/v2/polls/${id}/translations/${isoCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PostPortfolioChatsGroupV2
     * @request POST:/api/v2/portfolio-chats/group
     * @secure
     */
    postPortfolioChatsGroupV2: (
      data: CreateGroupChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioChatDto, any>({
        path: `/api/v2/portfolio-chats/group`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PostPortfolioChatsPrivateV2
     * @request POST:/api/v2/portfolio-chats/private
     * @secure
     */
    postPortfolioChatsPrivateV2: (
      data: CreatePrivateChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioChatDto, any>({
        path: `/api/v2/portfolio-chats/private`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PostPortfolioChatsBlocksV2
     * @request POST:/api/v2/portfolio-chats/blocks/{id}
     * @secure
     */
    postPortfolioChatsBlocksV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/blocks/${id}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name DeletePortfolioChatsBlocksByIdV2
     * @request DELETE:/api/v2/portfolio-chats/blocks/{id}
     * @secure
     */
    deletePortfolioChatsBlocksByIdV2: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/blocks/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsAvailableUsersV2
     * @request GET:/api/v2/portfolio-chats/available-users
     * @secure
     */
    getPortfolioChatsAvailableUsersV2: (
      query?: {
        UnreadOnly?: boolean;
        ProjectIds?: string[];
        ProjectName?: string;
        ProjectOwner?: string;
        ProjectManager?: string;
        City?: string;
        Search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioUserDtoPaginationResultDto, any>({
        path: `/api/v2/portfolio-chats/available-users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Results are ordered by the latest visible reply across all connected projects. To receive realtime updates for this list, connect to the SignalR global hub at `/hubs/global-hub` with the signed-in portfolio user. The connection is automatically added to the account-level portfolio group. Clients can subscribe to `NewPortfolioChatMessageNotification` for new replies and `NewPortfolioGroupChatCreatedNotification` for new group chats. Both event payloads match `ChatMessageNotification`.
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsV2
     * @summary Lists portfolio chats for the signed-in account.
     * @request GET:/api/v2/portfolio-chats
     * @secure
     */
    getPortfolioChatsV2: (
      query?: {
        UnreadOnly?: boolean;
        ProjectIds?: string[];
        ProjectName?: string;
        ProjectOwner?: string;
        ProjectManager?: string;
        City?: string;
        Search?: string;
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioChatDtoPaginationResultDto, any>({
        path: `/api/v2/portfolio-chats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsDetailsV2
     * @request GET:/api/v2/portfolio-chats/{id}
     * @secure
     */
    getPortfolioChatsDetailsV2: (id: string, params: RequestParams = {}) =>
      this.request<PortfolioChatDto, any>({
        path: `/api/v2/portfolio-chats/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name DeletePortfolioChatsByIdV2
     * @request DELETE:/api/v2/portfolio-chats/{id}
     * @secure
     */
    deletePortfolioChatsByIdV2: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsMembersV2
     * @request GET:/api/v2/portfolio-chats/{id}/members
     * @secure
     */
    getPortfolioChatsMembersV2: (id: string, params: RequestParams = {}) =>
      this.request<PortfolioUserDto[], any>({
        path: `/api/v2/portfolio-chats/${id}/members`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PutPortfolioChatsMembersAddV2
     * @request PUT:/api/v2/portfolio-chats/{id}/members/add
     * @secure
     */
    putPortfolioChatsMembersAddV2: (
      id: string,
      data: AddMemberRequest,
      params: RequestParams = {},
    ) =>
      this.request<PortfolioUserDto[], any>({
        path: `/api/v2/portfolio-chats/${id}/members/add`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PostPortfolioChatsMembersLeaveV2
     * @request POST:/api/v2/portfolio-chats/{id}/members/leave
     * @secure
     */
    postPortfolioChatsMembersLeaveV2: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/${id}/members/leave`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PostPortfolioChatsReplyV2
     * @request POST:/api/v2/portfolio-chats/{id}/reply
     * @secure
     */
    postPortfolioChatsReplyV2: (
      id: string,
      data: ChatReplyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatReplyDto, any>({
        path: `/api/v2/portfolio-chats/${id}/reply`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsRepliesV2
     * @request GET:/api/v2/portfolio-chats/{id}/replies
     * @secure
     */
    getPortfolioChatsRepliesV2: (
      id: string,
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatReplyDtoPaginationResultDto, any>({
        path: `/api/v2/portfolio-chats/${id}/replies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PutPortfolioChatsGroupV2
     * @request PUT:/api/v2/portfolio-chats/group/{id}
     * @secure
     */
    putPortfolioChatsGroupV2: (
      id: string,
      data: UpdateGroupChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/group/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name GetPortfolioChatsUserDetailsV2
     * @request GET:/api/v2/portfolio-chats/user/{id}
     * @secure
     */
    getPortfolioChatsUserDetailsV2: (id: string, params: RequestParams = {}) =>
      this.request<PortfolioChatDto, any>({
        path: `/api/v2/portfolio-chats/user/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioChats
     * @name PutPortfolioChatsPermissionV2
     * @request PUT:/api/v2/portfolio-chats/permission
     * @secure
     */
    putPortfolioChatsPermissionV2: (
      data: PortfolioChatPermissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/portfolio-chats/permission`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuickReplyMessage
     * @name PostQuickReplyMessageCreateTokenV2
     * @request POST:/api/v2/quick-reply-message/create-token
     * @secure
     */
    postQuickReplyMessageCreateTokenV2: (
      data: QuickReplyMessageCreateTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v2/quick-reply-message/create-token`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuickReplyTicket
     * @name PostQuickReplyTicketCreateTokenV2
     * @request POST:/api/v2/quick-reply-ticket/create-token
     * @secure
     */
    postQuickReplyTicketCreateTokenV2: (
      data: QuickReplyTicketCreateTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v2/quick-reply-ticket/create-token`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Registration
     * @name PostRegistrationConnectV2
     * @request POST:/api/v2/registration/connect
     * @secure
     */
    postRegistrationConnectV2: (
      data: RegistrationRequestV2,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationConnectDto, any>({
        path: `/api/v2/registration/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentGroups
     * @name PostResidentGroupsV2
     * @request POST:/api/v2/resident-groups
     * @secure
     */
    postResidentGroupsV2: (
      data: ResidentGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsV2Dto, any>({
        path: `/api/v2/resident-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentGroups
     * @name PutResidentGroupsV2
     * @request PUT:/api/v2/resident-groups/{id}
     * @secure
     */
    putResidentGroupsV2: (
      id: string,
      data: ResidentGroupEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupDetailsV2Dto, any>({
        path: `/api/v2/resident-groups/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name GetResidentNotificationsV2
     * @request GET:/api/v2/resident-notifications
     * @secure
     */
    getResidentNotificationsV2: (
      query?: {
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResidentNotificationDtoPaginationResultDto, any>({
        path: `/api/v2/resident-notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name GetResidentNotificationsStatusV2
     * @request GET:/api/v2/resident-notifications/status
     * @secure
     */
    getResidentNotificationsStatusV2: (params: RequestParams = {}) =>
      this.request<UnreadStatusDto, any>({
        path: `/api/v2/resident-notifications/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name GetSelfV2
     * @request GET:/api/v2/self
     * @secure
     */
    getSelfV2: (params: RequestParams = {}) =>
      this.request<SelfDto, any>({
        path: `/api/v2/self`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PutSelfV2
     * @request PUT:/api/v2/self
     * @secure
     */
    putSelfV2: (data: SelfUpdateRequest, params: RequestParams = {}) =>
      this.request<SelfDto, void>({
        path: `/api/v2/self`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetTicketCategoriesCreatableV2
     * @request GET:/api/v2/ticket-categories/creatable
     * @secure
     */
    getTicketCategoriesCreatableV2: (
      query?: {
        forUserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreatableTicketTreeDto, any>({
        path: `/api/v2/ticket-categories/creatable`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TicketCategories
     * @name GetTicketCategoriesCreatableDetailsV2
     * @request GET:/api/v2/ticket-categories/creatable/{categoryId}
     * @secure
     */
    getTicketCategoriesCreatableDetailsV2: (
      categoryId: string,
      query?: {
        location?: TicketCategoryLocationTypeDto;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CreatableTicketCategorySearchNodeDto[], any>({
        path: `/api/v2/ticket-categories/creatable/${categoryId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUsersGroupsV2
     * @request GET:/api/v2/users/{userId}/groups
     * @secure
     */
    getUsersGroupsV2: (
      userId: string,
      query?: {
        groupTypes?: CommunityGroupTypeDto[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityGroupV2DtoPaginationResultDto, any>({
        path: `/api/v2/users/${userId}/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name PostUsersDeleteV2
     * @request POST:/api/v2/users/{id}/delete
     * @secure
     */
    postUsersDeleteV2: (
      id: string,
      data: UserBulkDeleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/users/${id}/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyCategories
     * @name GetSurveyCategoriesAverageRatingsV2
     * @request GET:/api/v2/survey-categories/{surveyCategory}/average-ratings
     * @secure
     */
    getSurveyCategoriesAverageRatingsV2: (
      surveyCategory: SurveyCategoryDto,
      params: RequestParams = {},
    ) =>
      this.request<FeelingAtHomeWidgetDto, any>({
        path: `/api/v2/survey-categories/${surveyCategory}/average-ratings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysDetailsV2
     * @request GET:/api/v2/surveys/{id}
     * @secure
     */
    getSurveysDetailsV2: (
      id: string,
      query?: {
        /** @default false */
        includeRankingQuestion?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<SurveyDetailsV2Dto, any>({
        path: `/api/v2/surveys/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name GetSurveysExportV2
     * @request GET:/api/v2/surveys/{id}/export
     * @secure
     */
    getSurveysExportV2: (
      id: string,
      query?: {
        /** @default false */
        includeBulkResults?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/surveys/${id}/export`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageComments
     * @name GetMessagesCommentsTranslationsDetailsV2
     * @request GET:/api/v2/messages/{messageId}/comments/{commentId}/translations/{isoCode}
     * @secure
     */
    getMessagesCommentsTranslationsDetailsV2: (
      messageId: string,
      commentId: string,
      isoCode: string,
      params: RequestParams = {},
    ) =>
      this.request<CommentTranslationDto, any>({
        path: `/api/v2/messages/${messageId}/comments/${commentId}/translations/${isoCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name GetMessagesTranslationsDetailsV2
     * @request GET:/api/v2/messages/{messageId}/translations/{isoCode}
     * @secure
     */
    getMessagesTranslationsDetailsV2: (
      messageId: string,
      isoCode: string,
      params: RequestParams = {},
    ) =>
      this.request<MessageTranslationDto, any>({
        path: `/api/v2/messages/${messageId}/translations/${isoCode}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name GetMessagesDetailsV2
     * @request GET:/api/v2/messages/{messageId}
     * @secure
     */
    getMessagesDetailsV2: (messageId: string, params: RequestParams = {}) =>
      this.request<MessageDetailV2Dto, any>({
        path: `/api/v2/messages/${messageId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MessageDetails
     * @name PostMessagesChangeStatusV2
     * @request POST:/api/v2/messages/{messageId}/change-status
     * @secure
     */
    postMessagesChangeStatusV2: (
      messageId: string,
      data: MessageStatusChangeRequestV2,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v2/messages/${messageId}/change-status`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messages
     * @name GetMessagesV2
     * @request GET:/api/v2/messages
     * @secure
     */
    getMessagesV2: (
      query?: {
        Query?: string;
        PosterId?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        GroupIds?: string[];
        Tab?: CommunityFeedTabsDto;
        Connection?: CommunityFeedConnectionFilterDto;
        ExcludeArchivedPosts?: boolean;
        FeedTypes?: CommunityFeedType[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageV2DtoPaginationResultDto, any>({
        path: `/api/v2/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectSummary
     * @name GetProjectSummaryV2
     * @request GET:/api/v2/project/summary
     * @secure
     */
    getProjectSummaryV2: (
      query?: {
        /**
         * Date from when posts should be used to load a summary
         * @format date-time
         */
        from?: string;
        /**
         * Date to when posts should be used to load a summary
         * @format date-time
         */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TextStream[], any>({
        path: `/api/v2/project/summary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsTicketsRatingsV3
     * @summary Get ticket satisfaction ratings across portfolio
     * @request GET:/api/v3/portfolio-analytics/tickets/ratings
     * @secure
     */
    getPortfolioAnalyticsTicketsRatingsV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketsSatisfactionDto, any>({
        path: `/api/v3/portfolio-analytics/tickets/ratings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsFeelingAtHomeV3
     * @summary Get feeling at home scores across portfolio
     * @request GET:/api/v3/portfolio-analytics/feeling-at-home
     * @secure
     */
    getPortfolioAnalyticsFeelingAtHomeV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PortfolioFeelingAtHomeDto, any>({
        path: `/api/v3/portfolio-analytics/feeling-at-home`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsCommunitySupportV3
     * @summary Get community help request statistics
     * @request GET:/api/v3/portfolio-analytics/community-support
     * @secure
     */
    getPortfolioAnalyticsCommunitySupportV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunitySupportDto, any>({
        path: `/api/v3/portfolio-analytics/community-support`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsCommunityPillarsV3
     * @summary Get community pillar scores
     * @request GET:/api/v3/portfolio-analytics/community-pillars
     * @secure
     */
    getPortfolioAnalyticsCommunityPillarsV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommunityPillarsDto, any>({
        path: `/api/v3/portfolio-analytics/community-pillars`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsPlatformReachV3
     * @summary Get platform reach statistics
     * @request GET:/api/v3/portfolio-analytics/platform-reach
     * @secure
     */
    getPortfolioAnalyticsPlatformReachV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlatformReachDto, any>({
        path: `/api/v3/portfolio-analytics/platform-reach`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsPlatformResidentsV3
     * @summary Get platform resident engagement metrics
     * @request GET:/api/v3/portfolio-analytics/platform-residents
     * @secure
     */
    getPortfolioAnalyticsPlatformResidentsV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PlatformResidentsDto, any>({
        path: `/api/v3/portfolio-analytics/platform-residents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PortfolioAnalytics
     * @name GetPortfolioAnalyticsTicketsResolutionTimeV3
     * @summary Get ticket resolution time statistics
     * @request GET:/api/v3/portfolio-analytics/tickets-resolution-time
     * @secure
     */
    getPortfolioAnalyticsTicketsResolutionTimeV3: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TicketsResolutionTimeDto, any>({
        path: `/api/v3/portfolio-analytics/tickets-resolution-time`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ResidentNotifications
     * @name GetResidentNotificationsV3
     * @request GET:/api/v3/resident-notifications
     * @secure
     */
    getResidentNotificationsV3: (
      query?: {
        types?: DashboardNotificationEntityTypeDto[];
        /** @format int32 */
        Offset?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResidentNotificationResultDto, any>({
        path: `/api/v3/resident-notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Self
     * @name PutSelfV3
     * @request PUT:/api/v3/self
     * @secure
     */
    putSelfV3: (data: SelfUpdateRequest, params: RequestParams = {}) =>
      this.request<SelfDto, void>({
        path: `/api/v3/self`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  internal = {
    /**
     * No description
     *
     * @tags SignalRBroadcast
     * @name PostInternalSignalrBroadcast
     * @request POST:/internal/signalr/broadcast
     */
    postInternalSignalrBroadcast: (
      data: SignalRBroadcastRequest,
      query?: {
        "api-version"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/internal/signalr/broadcast`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        ...params,
      }),
  };
}
